var Ml = Object.defineProperty;
var Al = (i, r, n) => r in i ? Ml(i, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : i[r] = n;
var Zt = (i, r, n) => (Al(i, typeof r != "symbol" ? r + "" : r, n), n);
var Kl = Object.defineProperty, jl = (i, r, n) => r in i ? Kl(i, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : i[r] = n, Ke = (i, r, n) => (jl(i, typeof r != "symbol" ? r + "" : r, n), n);
function zl() {
  return new Promise((i, r) => {
    typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? r("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : i();
  });
}
class er {
}
Ke(er, "updates", {
  transformer_new: "New transformer",
  transformer_null: "Null transformer"
}), Ke(er, "errors", {
  transformer_none: "No transformers provided",
  transformer_start: "Cannot start transformer",
  transformer_transform: "Cannot transform frame",
  transformer_flush: "Cannot flush transformer",
  readable_null: "Readable is null",
  writable_null: "Writable is null"
});
const rr = /* @__PURE__ */ new WeakMap(), si = /* @__PURE__ */ new WeakMap(), Nr = /* @__PURE__ */ new WeakMap(), eo = Symbol("anyProducer"), Qo = Promise.resolve(), hi = Symbol("listenerAdded"), fi = Symbol("listenerRemoved");
let ji = !1;
function Wr(i) {
  if (typeof i != "string" && typeof i != "symbol")
    throw new TypeError("eventName must be a string or a symbol");
}
function Qr(i) {
  if (typeof i != "function")
    throw new TypeError("listener must be a function");
}
function Vr(i, r) {
  const n = si.get(i);
  return n.has(r) || n.set(r, /* @__PURE__ */ new Set()), n.get(r);
}
function Jr(i, r) {
  const n = typeof r == "string" || typeof r == "symbol" ? r : eo, m = Nr.get(i);
  return m.has(n) || m.set(n, /* @__PURE__ */ new Set()), m.get(n);
}
function Ol(i, r, n) {
  const m = Nr.get(i);
  if (m.has(r))
    for (const X of m.get(r))
      X.enqueue(n);
  if (m.has(eo)) {
    const X = Promise.all([r, n]);
    for (const S of m.get(eo))
      S.enqueue(X);
  }
}
function Do(i, r) {
  r = Array.isArray(r) ? r : [r];
  let n = !1, m = () => {
  }, X = [];
  const S = {
    enqueue(C) {
      X.push(C), m();
    },
    finish() {
      n = !0, m();
    }
  };
  for (const C of r)
    Jr(i, C).add(S);
  return {
    async next() {
      return X ? X.length === 0 ? n ? (X = void 0, this.next()) : (await new Promise((C) => {
        m = C;
      }), this.next()) : {
        done: !1,
        value: await X.shift()
      } : { done: !0 };
    },
    async return(C) {
      X = void 0;
      for (const T of r)
        Jr(i, T).delete(S);
      return m(), arguments.length > 0 ? { done: !0, value: await C } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function $o(i) {
  if (i === void 0)
    return qo;
  if (!Array.isArray(i))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const r of i)
    if (!qo.includes(r))
      throw typeof r != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${r} is not Emittery method`);
  return i;
}
const zi = (i) => i === hi || i === fi;
class gr {
  static mixin(r, n) {
    return n = $o(n), (m) => {
      if (typeof m != "function")
        throw new TypeError("`target` must be function");
      for (const C of n)
        if (m.prototype[C] !== void 0)
          throw new Error(`The property \`${C}\` already exists on \`target\``);
      function X() {
        return Object.defineProperty(this, r, {
          enumerable: !1,
          value: new gr()
        }), this[r];
      }
      Object.defineProperty(m.prototype, r, {
        enumerable: !1,
        get: X
      });
      const S = (C) => function(...T) {
        return this[r][C](...T);
      };
      for (const C of n)
        Object.defineProperty(m.prototype, C, {
          enumerable: !1,
          value: S(C)
        });
      return m;
    };
  }
  static get isDebugEnabled() {
    if (typeof process != "object")
      return ji;
    const { env: r } = process || { env: {} };
    return r.DEBUG === "emittery" || r.DEBUG === "*" || ji;
  }
  static set isDebugEnabled(r) {
    ji = r;
  }
  constructor(r = {}) {
    rr.set(this, /* @__PURE__ */ new Set()), si.set(this, /* @__PURE__ */ new Map()), Nr.set(this, /* @__PURE__ */ new Map()), this.debug = r.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (n, m, X, S) => {
      try {
        S = JSON.stringify(S);
      } catch {
        S = `Object with the following keys failed to stringify: ${Object.keys(S).join(",")}`;
      }
      typeof X == "symbol" && (X = X.toString());
      const C = new Date(), T = `${C.getHours()}:${C.getMinutes()}:${C.getSeconds()}.${C.getMilliseconds()}`;
      console.log(`[${T}][emittery:${n}][${m}] Event Name: ${X}
	data: ${S}`);
    });
  }
  logIfDebugEnabled(r, n, m) {
    (gr.isDebugEnabled || this.debug.enabled) && this.debug.logger(r, this.debug.name, n, m);
  }
  on(r, n) {
    Qr(n), r = Array.isArray(r) ? r : [r];
    for (const m of r)
      Wr(m), Vr(this, m).add(n), this.logIfDebugEnabled("subscribe", m, void 0), zi(m) || this.emit(hi, { eventName: m, listener: n });
    return this.off.bind(this, r, n);
  }
  off(r, n) {
    Qr(n), r = Array.isArray(r) ? r : [r];
    for (const m of r)
      Wr(m), Vr(this, m).delete(n), this.logIfDebugEnabled("unsubscribe", m, void 0), zi(m) || this.emit(fi, { eventName: m, listener: n });
  }
  once(r) {
    return new Promise((n) => {
      const m = this.on(r, (X) => {
        m(), n(X);
      });
    });
  }
  events(r) {
    r = Array.isArray(r) ? r : [r];
    for (const n of r)
      Wr(n);
    return Do(this, r);
  }
  async emit(r, n) {
    Wr(r), this.logIfDebugEnabled("emit", r, n), Ol(this, r, n);
    const m = Vr(this, r), X = rr.get(this), S = [...m], C = zi(r) ? [] : [...X];
    await Qo, await Promise.all([
      ...S.map(async (T) => {
        if (m.has(T))
          return T(n);
      }),
      ...C.map(async (T) => {
        if (X.has(T))
          return T(r, n);
      })
    ]);
  }
  async emitSerial(r, n) {
    Wr(r), this.logIfDebugEnabled("emitSerial", r, n);
    const m = Vr(this, r), X = rr.get(this), S = [...m], C = [...X];
    await Qo;
    for (const T of S)
      m.has(T) && await T(n);
    for (const T of C)
      X.has(T) && await T(r, n);
  }
  onAny(r) {
    return Qr(r), this.logIfDebugEnabled("subscribeAny", void 0, void 0), rr.get(this).add(r), this.emit(hi, { listener: r }), this.offAny.bind(this, r);
  }
  anyEvent() {
    return Do(this);
  }
  offAny(r) {
    Qr(r), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(fi, { listener: r }), rr.get(this).delete(r);
  }
  clearListeners(r) {
    r = Array.isArray(r) ? r : [r];
    for (const n of r)
      if (this.logIfDebugEnabled("clear", n, void 0), typeof n == "string" || typeof n == "symbol") {
        Vr(this, n).clear();
        const m = Jr(this, n);
        for (const X of m)
          X.finish();
        m.clear();
      } else {
        rr.get(this).clear();
        for (const m of si.get(this).values())
          m.clear();
        for (const m of Nr.get(this).values()) {
          for (const X of m)
            X.finish();
          m.clear();
        }
      }
  }
  listenerCount(r) {
    r = Array.isArray(r) ? r : [r];
    let n = 0;
    for (const m of r) {
      if (typeof m == "string") {
        n += rr.get(this).size + Vr(this, m).size + Jr(this, m).size + Jr(this).size;
        continue;
      }
      typeof m < "u" && Wr(m), n += rr.get(this).size;
      for (const X of si.get(this).values())
        n += X.size;
      for (const X of Nr.get(this).values())
        n += X.size;
    }
    return n;
  }
  bindMethods(r, n) {
    if (typeof r != "object" || r === null)
      throw new TypeError("`target` must be an object");
    n = $o(n);
    for (const m of n) {
      if (r[m] !== void 0)
        throw new Error(`The property \`${m}\` already exists on \`target\``);
      Object.defineProperty(r, m, {
        enumerable: !1,
        value: this[m].bind(this)
      });
    }
  }
}
const qo = Object.getOwnPropertyNames(gr.prototype).filter((i) => i !== "constructor");
Object.defineProperty(gr, "listenerAdded", {
  value: hi,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(gr, "listenerRemoved", {
  value: fi,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var po = gr;
function Pl(i) {
  return typeof i == "object" && i !== null && "message" in i && typeof i.message == "string";
}
function _l(i) {
  if (Pl(i))
    return i;
  try {
    return new Error(JSON.stringify(i));
  } catch {
    return new Error(String(i));
  }
}
function Oi(i) {
  return _l(i).message;
}
var Ql = Object.defineProperty, Dl = (i, r, n) => r in i ? Ql(i, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : i[r] = n, $l = (i, r, n) => (Dl(i, typeof r != "symbol" ? r + "" : r, n), n);
const ql = "hlg.tokbox.com/prod/logging/vcp_webrtc", t2 = "https://", e2 = 1e4;
let Dr;
const n2 = new Uint8Array(16);
function r2() {
  if (!Dr && (Dr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Dr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Dr(n2);
}
const Bn = [];
for (let i = 0; i < 256; ++i)
  Bn.push((i + 256).toString(16).slice(1));
function i2(i, r = 0) {
  return (Bn[i[r + 0]] + Bn[i[r + 1]] + Bn[i[r + 2]] + Bn[i[r + 3]] + "-" + Bn[i[r + 4]] + Bn[i[r + 5]] + "-" + Bn[i[r + 6]] + Bn[i[r + 7]] + "-" + Bn[i[r + 8]] + Bn[i[r + 9]] + "-" + Bn[i[r + 10]] + Bn[i[r + 11]] + Bn[i[r + 12]] + Bn[i[r + 13]] + Bn[i[r + 14]] + Bn[i[r + 15]]).toLowerCase();
}
const o2 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ts = {
  randomUUID: o2
};
function s2(i, r, n) {
  if (ts.randomUUID && !r && !i)
    return ts.randomUUID();
  i = i || {};
  const m = i.random || (i.rng || r2)();
  if (m[6] = m[6] & 15 | 64, m[8] = m[8] & 63 | 128, r) {
    n = n || 0;
    for (let X = 0; X < 16; ++X)
      r[n + X] = m[X];
    return r;
  }
  return i2(m);
}
function bo(i, r) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let n = globalThis.vonage.workerizer;
  return n[i] || (n[i] = r), n[i];
}
const sr = bo(
  "globals",
  {}
);
var pr = /* @__PURE__ */ ((i) => (i.INIT = "INIT", i.FORWARD = "FORWARD", i.TERMINATE = "TERMINATE", i.GLOBALS_SYNC = "GLOBALS_SYNC", i))(pr || {});
function Rs(i) {
  return [ImageBitmap, ReadableStream, WritableStream].some((r) => i instanceof r);
}
let l2 = 0;
function c2(i, r, n, m, X) {
  const S = l2++;
  return i.postMessage(
    {
      id: S,
      type: r,
      functionName: n,
      args: m
    },
    m.filter((C) => Rs(C))
  ), new Promise((C) => {
    X == null || X.set(S, C);
  });
}
function Kr(i, r) {
  const { id: n, type: m } = i, X = Array.isArray(r) ? r : [r];
  postMessage(
    {
      id: n,
      type: m,
      result: r
    },
    X.filter((S) => Rs(S))
  );
}
const es = bo("workerized", {});
function xs() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function u2() {
  if (xs())
    Kr({ type: pr.GLOBALS_SYNC }, sr);
  else {
    const i = [];
    for (const r in es) {
      const { worker: n, resolvers: m } = es[r].workerContext;
      n && i.push(
        c2(
          n,
          pr.GLOBALS_SYNC,
          "",
          [sr],
          m
        )
      );
    }
    await Promise.all(i);
  }
}
function mi(i, r) {
  if (Array.isArray(r))
    r.splice(0, r.length);
  else if (typeof r == "object")
    for (const n in r)
      delete r[n];
  for (const n in i)
    Array.isArray(i[n]) ? (r[n] = [], mi(i[n], r[n])) : typeof i[n] == "object" ? (r[n] = {}, mi(i[n], r[n])) : r[n] = i[n];
}
async function a2(i, r) {
  const { functionName: n, args: m } = i;
  if (!r.instance)
    throw "instance not initialized";
  if (!n)
    throw "missing function name to call";
  if (!r.instance[n])
    throw `undefined function [${n}] in class ${r.instance.constructor.workerId}`;
  Kr(i, await r.instance[n](...m != null ? m : []));
}
const d2 = bo("registeredWorkers", {});
function h2(i, r) {
  if (!i.args)
    throw "Missing className while initializing worker";
  const [n, m] = i.args, X = d2[n];
  if (X)
    r.instance = new X(i.args.slice(1));
  else
    throw `unknown worker class ${n}`;
  mi(m, sr), Kr(i, typeof r.instance !== void 0);
}
async function f2(i, r) {
  const { args: n } = i;
  if (!r.instance)
    throw "instance not initialized";
  let m;
  r.instance.terminate && (m = await r.instance.terminate(...n != null ? n : [])), Kr(i, m);
}
function m2(i) {
  if (!i.args)
    throw "Missing globals while syncing";
  mi(i.args[0], sr), Kr(i, {});
}
function p2() {
  const i = {};
  onmessage = async (r) => {
    const n = r.data;
    switch (n.type) {
      case pr.INIT:
        h2(n, i);
        break;
      case pr.FORWARD:
        a2(n, i);
        break;
      case pr.TERMINATE:
        f2(n, i);
        break;
      case pr.GLOBALS_SYNC:
        m2(n);
        break;
    }
  };
}
xs() && p2();
function b2(i, r) {
  return sr[i] || (sr[i] = r), [
    () => sr[i],
    async (n) => {
      sr[i] = n, await u2();
    }
  ];
}
function y2(i, r) {
  return b2(i, r);
}
const [g2, Z2] = y2("metadata");
function v2(i) {
  Z2(i);
}
function li() {
  return g2();
}
class yo {
  constructor(r) {
    $l(this, "uuid", s2()), this.config = r;
  }
  async send(r) {
    var n, m, X;
    const { appId: S, sourceType: C } = (n = li()) != null ? n : {};
    if (!S || !C)
      return "metadata missing";
    const T = new AbortController(), B = setTimeout(() => T.abort(), e2);
    return await ((X = (m = this.config) == null ? void 0 : m.fetch) != null ? X : fetch)(this.getUrl(), {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(this.buildReport(r)),
      signal: T.signal
    }), clearTimeout(B), "success";
  }
  getUrl() {
    var r;
    let n = (r = li().proxyUrl) != null ? r : t2;
    return n += (n.at(-1) === "/" ? "" : "/") + ql, n;
  }
  getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  }
  buildReport(r) {
    const n = li();
    return {
      guid: this.uuid,
      ...r,
      applicationId: n.appId,
      timestamp: Date.now(),
      proxyUrl: n.proxyUrl,
      source: n.sourceType
    };
  }
}
const ci = "2.0.3";
class G2 {
  constructor(r) {
    Ke(this, "frameTransformedCount", 0), Ke(this, "frameFromSourceCount", 0), Ke(this, "startAt", 0), Ke(this, "reporter"), this.config = r, this.reporter = new yo(r);
  }
  async onFrameFromSource() {
    this.frameFromSourceCount++;
  }
  get fps() {
    const { startAt: r, frameFromSourceCount: n } = this, m = (Date.now() - r) / 1e3;
    return n / m;
  }
  async onFrameTransformed(r = {}, n = !1) {
    this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
    const { startAt: m, frameTransformedCount: X, frameFromSourceCount: S } = this, C = Date.now(), T = (C - m) / 1e3, B = X / T, nt = S / T;
    return n || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = C, this.reporter.config = this.config, this.reporter.send({
      ...this.config.report,
      variation: "QoS",
      fps: nt,
      transformedFps: B,
      framesTransformed: X,
      ...r
    })) : "success";
  }
}
var X2 = /* @__PURE__ */ ((i) => (i.FPS_DROP = "fps_drop", i))(X2 || {}), W2 = /* @__PURE__ */ ((i) => (i.start = "start", i.transform = "transform", i.flush = "flush", i))(W2 || {}), no = /* @__PURE__ */ ((i) => (i.pipeline_ended = "pipeline_ended", i.pipeline_ended_with_error = "pipeline_ended_with_error", i.pipeline_started = "pipeline_started", i.pipeline_started_with_error = "pipeline_started_with_error", i.pipeline_restarted = "pipeline_restarted", i.pipeline_restarted_with_error = "pipeline_restarted_with_error", i))(no || {});
const V2 = 500, R2 = 0.8;
class x2 extends po {
  constructor(r, n) {
    super(), Ke(this, "reporter_", new yo()), Ke(this, "reporterQos_", new G2({
      loggingIntervalFrameCount: V2,
      report: {
        version: ci
      }
    })), Ke(this, "transformerType_"), Ke(this, "transformer_"), Ke(this, "shouldStop_"), Ke(this, "isFlashed_"), Ke(this, "mediaTransformerQosReportStartTimestamp_"), Ke(this, "videoHeight_"), Ke(this, "videoWidth_"), Ke(this, "trackExpectedRate_"), Ke(this, "index_"), Ke(this, "controller_"), this.index_ = n, this.transformer_ = r, this.shouldStop_ = !1, this.isFlashed_ = !1, this.mediaTransformerQosReportStartTimestamp_ = 0, this.videoHeight_ = 0, this.videoWidth_ = 0, this.trackExpectedRate_ = -1, this.transformerType_ = "Custom", "getTransformerType" in r && (this.transformerType_ = r.getTransformerType()), this.report({
      variation: "Create"
    });
  }
  setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r;
  }
  async start(r) {
    if (this.controller_ = r, this.transformer_ && typeof this.transformer_.start == "function")
      try {
        await this.transformer_.start(r);
      } catch (n) {
        this.report({
          message: er.errors.transformer_start,
          variation: "Error",
          error: Oi(n)
        });
        const m = { eventMetaData: { transformerIndex: this.index_ }, error: n, function: "start" };
        this.emit("error", m);
      }
  }
  async transform(r, n) {
    var m, X, S, C;
    if (this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), r instanceof VideoFrame && (this.videoHeight_ = (m = r == null ? void 0 : r.displayHeight) != null ? m : 0, this.videoWidth_ = (X = r == null ? void 0 : r.displayWidth) != null ? X : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)
      if (this.shouldStop_)
        console.warn("[Pipeline] flush from transform"), r.close(), this.flush(n), n.terminate();
      else {
        try {
          await ((C = (S = this.transformer_).transform) == null ? void 0 : C.call(S, r, n)), this.reportQos();
        } catch (T) {
          this.report({
            message: er.errors.transformer_transform,
            variation: "Error",
            error: Oi(T)
          });
          const B = { eventMetaData: { transformerIndex: this.index_ }, error: T, function: "transform" };
          this.emit("error", B);
        }
        if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * R2 > this.reporterQos_.fps) {
          const T = {
            eventMetaData: {
              transformerIndex: this.index_
            },
            warningType: "fps_drop",
            dropInfo: {
              requested: this.trackExpectedRate_,
              current: this.reporterQos_.fps
            }
          };
          this.emit("warn", T);
        }
      }
  }
  async flush(r) {
    if (this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_) {
      this.isFlashed_ = !0;
      try {
        await this.transformer_.flush(r);
      } catch (n) {
        this.report({
          message: er.errors.transformer_flush,
          variation: "Error",
          error: Oi(n)
        });
        const m = { eventMetaData: { transformerIndex: this.index_ }, error: n, function: "flush" };
        this.emit("error", m);
      }
    }
    this.reportQos(!0), this.report({
      variation: "Delete"
    });
  }
  stop() {
    console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
  }
  report(r) {
    this.reporter_.send({
      version: ci,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      ...r
    });
  }
  reportQos(r = !1) {
    this.reporterQos_.config = {
      ...this.reporterQos_.config
    }, this.reporterQos_.onFrameTransformed({
      version: ci,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      videoWidth: this.videoWidth_,
      videoHeight: this.videoHeight_
    }, r);
  }
}
class I2 extends po {
  constructor(r) {
    super(), Ke(this, "transformers_"), Ke(this, "trackExpectedRate_"), this.transformers_ = [], this.trackExpectedRate_ = -1;
    for (let n = 0; n < r.length; n++) {
      let m = new x2(r[n], n);
      m.on("error", (X) => {
        this.emit("error", X);
      }), m.on("warn", (X) => {
        this.emit("warn", X);
      }), this.transformers_.push(m);
    }
  }
  setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r;
    for (let n of this.transformers_)
      n.setTrackExpectedRate(this.trackExpectedRate_);
  }
  async start(r, n) {
    if (!this.transformers_ || this.transformers_.length === 0) {
      console.log("[Pipeline] No transformers.");
      return;
    }
    try {
      let m = r;
      for (let X of this.transformers_)
        r = r.pipeThrough(new TransformStream(X));
      r.pipeTo(n).then(async () => {
        console.log("[Pipeline] Setup."), await n.abort(), await m.cancel(), this.emit("pipelineInfo", "pipeline_ended");
      }).catch(async (X) => {
        r.cancel().then(() => {
          console.log("[Pipeline] Shutting down streams after abort.");
        }).catch((S) => {
          console.error("[Pipeline] Error from stream transform:", S);
        }), await n.abort(X), await m.cancel(X), this.emit("pipelineInfo", "pipeline_ended_with_error");
      });
    } catch {
      this.emit("pipelineInfo", "pipeline_started_with_error"), this.destroy();
      return;
    }
    this.emit("pipelineInfo", "pipeline_started"), console.log("[Pipeline] Pipeline started.");
  }
  async destroy() {
    console.log("[Pipeline] Destroying Pipeline.");
    for (let r of this.transformers_)
      r.stop();
  }
}
class S2 extends po {
  constructor() {
    super(), Ke(this, "reporter_"), Ke(this, "pipeline_"), Ke(this, "transformers_"), Ke(this, "readable_"), Ke(this, "writable_"), Ke(this, "trackExpectedRate_"), this.reporter_ = new yo(), this.trackExpectedRate_ = -1, this.report({
      variation: "Create"
    });
  }
  setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
  }
  transform(r, n) {
    return this.readable_ = r, this.writable_ = n, this.transformInternal();
  }
  transformInternal() {
    return new Promise(async (r, n) => {
      if (!this.transformers_ || this.transformers_.length === 0) {
        this.report({
          message: er.errors.transformer_none,
          variation: "Error"
        }), n("[MediaProcessor] Need to set transformers.");
        return;
      }
      if (!this.readable_) {
        this.report({
          variation: "Error",
          message: er.errors.readable_null
        }), n("[MediaProcessor] Readable is null.");
        return;
      }
      if (!this.writable_) {
        this.report({
          variation: "Error",
          message: er.errors.writable_null
        }), n("[MediaProcessor] Writable is null.");
        return;
      }
      let m = !1;
      this.pipeline_ && (m = !0, this.pipeline_.clearListeners(), this.pipeline_.destroy()), this.pipeline_ = new I2(this.transformers_), this.pipeline_.on("warn", (X) => {
        this.emit("warn", X);
      }), this.pipeline_.on("error", (X) => {
        this.emit("error", X);
      }), this.pipeline_.on("pipelineInfo", (X) => {
        m && (X === "pipeline_started" ? X = no.pipeline_restarted : X === "pipeline_started_with_error" && (X = no.pipeline_restarted_with_error)), this.emit("pipelineInfo", X);
      }), this.trackExpectedRate_ != -1 && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_), this.pipeline_.start(this.readable_, this.writable_).then(() => {
        r();
      }).catch((X) => {
        n(X);
      });
    });
  }
  setTransformers(r) {
    return this.report({
      variation: "Update",
      message: er.updates.transformer_new
    }), this.transformers_ = r, this.readable_ && this.writable_ ? this.transformInternal() : Promise.resolve();
  }
  destroy() {
    return new Promise(async (r) => {
      this.pipeline_ && this.pipeline_.destroy(), this.report({ variation: "Delete" }), r();
    });
  }
  report(r) {
    this.reporter_.send({
      version: ci,
      action: "MediaProcessor",
      ...r
    });
  }
}
class w2 {
  constructor() {
    Ke(this, "processor_"), Ke(this, "generator_"), this.processor_ = null, this.generator_ = null;
  }
  init(r) {
    return new Promise((n, m) => {
      try {
        this.processor_ = new MediaStreamTrackProcessor(r);
      } catch (X) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${X}`), m(X);
      }
      try {
        r.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "audio" }) : r.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "video" }) : m("kind not supported");
      } catch (X) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${X}`), m(X);
      }
      n();
    });
  }
  getReadable() {
    return this.processor_.readable;
  }
  getWriteable() {
    return this.generator_.writable;
  }
  getProccesorTrack() {
    return this.generator_;
  }
}
class Y2 {
  constructor(r) {
    Ke(this, "insertableStreamHelper_"), Ke(this, "mediaProcessor_"), this.insertableStreamHelper_ = new w2(), this.mediaProcessor_ = r;
  }
  setTrack(r) {
    return new Promise((n, m) => {
      this.insertableStreamHelper_.init(r).then(() => {
        this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
          n(this.insertableStreamHelper_.getProccesorTrack());
        }).catch((X) => {
          m(X);
        });
      }).catch((X) => {
        m(X);
      });
    });
  }
  destroy() {
    return new Promise((r, n) => {
      this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
        r();
      }).catch((m) => {
        n(m);
      }) : n("no processor");
    });
  }
}
var ui = /* @__PURE__ */ ((i) => (i.Low = "Low", i.High = "High", i))(ui || {}), T2 = /* @__PURE__ */ ((i) => (i.BackgroundBlur = "BackgroundBlur", i.VirtualBackground = "VirtualBackground", i.VideoBackground = "VideoBackground", i.SilhouetteBlur = "SilhouetteBlur", i))(T2 || {}), ro = /* @__PURE__ */ ((i) => (i.FAST = "FAST", i.PRECISE = "PRECISE", i))(ro || {}), pi = /* @__PURE__ */ ((i) => (i.CANVAS = "CANVAS", i.WEBGL = "WEBGL", i))(pi || {});
const F2 = async () => WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
var H2 = function() {
  var i = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return function(r) {
    r = r || {};
    var n = typeof r < "u" ? r : {}, m, X;
    n.ready = new Promise(function(tt, it) {
      m = tt, X = it;
    });
    var S = {}, C;
    for (C in n)
      n.hasOwnProperty(C) && (S[C] = n[C]);
    var T = "./this.program", B = function(tt, it) {
      throw it;
    }, nt = !0, ut = "";
    function pt(tt) {
      return n.locateFile ? n.locateFile(tt, ut) : ut + tt;
    }
    var Tt;
    typeof document < "u" && document.currentScript && (ut = document.currentScript.src), i && (ut = i), ut.indexOf("blob:") !== 0 ? ut = ut.substr(0, ut.replace(/[?#].*/, "").lastIndexOf("/") + 1) : ut = "";
    var Ht = n.print || console.log.bind(console), at = n.printErr || console.warn.bind(console);
    for (C in S)
      S.hasOwnProperty(C) && (n[C] = S[C]);
    S = null, n.arguments && n.arguments, n.thisProgram && (T = n.thisProgram), n.quit && (B = n.quit);
    var mt;
    n.wasmBinary && (mt = n.wasmBinary);
    var Bt = n.noExitRuntime || !0;
    typeof WebAssembly != "object" && he("no native wasm support detected");
    var kt, ee = !1, P = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function De(tt, it, ct) {
      for (var _t = it + ct, de = it; tt[de] && !(de >= _t); )
        ++de;
      if (de - it > 16 && tt.subarray && P)
        return P.decode(tt.subarray(it, de));
      for (var ue = ""; it < de; ) {
        var St = tt[it++];
        if (!(St & 128)) {
          ue += String.fromCharCode(St);
          continue;
        }
        var me = tt[it++] & 63;
        if ((St & 224) == 192) {
          ue += String.fromCharCode((St & 31) << 6 | me);
          continue;
        }
        var Ce = tt[it++] & 63;
        if ((St & 240) == 224 ? St = (St & 15) << 12 | me << 6 | Ce : St = (St & 7) << 18 | me << 12 | Ce << 6 | tt[it++] & 63, St < 65536)
          ue += String.fromCharCode(St);
        else {
          var tn = St - 65536;
          ue += String.fromCharCode(55296 | tn >> 10, 56320 | tn & 1023);
        }
      }
      return ue;
    }
    function je(tt, it) {
      return tt ? De(gt, tt, it) : "";
    }
    function We(tt, it, ct) {
      for (var _t = 0; _t < tt.length; ++_t)
        ne[it++ >> 0] = tt.charCodeAt(_t);
      ct || (ne[it >> 0] = 0);
    }
    function jt(tt, it) {
      return tt % it > 0 && (tt += it - tt % it), tt;
    }
    var Cn, ne, gt, $e;
    function An(tt) {
      Cn = tt, n.HEAP8 = ne = new Int8Array(tt), n.HEAP16 = new Int16Array(tt), n.HEAP32 = $e = new Int32Array(tt), n.HEAPU8 = gt = new Uint8Array(tt), n.HEAPU16 = new Uint16Array(tt), n.HEAPU32 = new Uint32Array(tt), n.HEAPF32 = new Float32Array(tt), n.HEAPF64 = new Float64Array(tt);
    }
    n.INITIAL_MEMORY;
    var Re, Ct = [], we = [], sn = [], vn = 0;
    function Tn() {
      return Bt || vn > 0;
    }
    function Rn() {
      if (n.preRun)
        for (typeof n.preRun == "function" && (n.preRun = [n.preRun]); n.preRun.length; )
          mn(n.preRun.shift());
      Qt(Ct);
    }
    function Nn() {
      Qt(we);
    }
    function dn() {
      if (n.postRun)
        for (typeof n.postRun == "function" && (n.postRun = [n.postRun]); n.postRun.length; )
          Fn(n.postRun.shift());
      Qt(sn);
    }
    function mn(tt) {
      Ct.unshift(tt);
    }
    function kn(tt) {
      we.unshift(tt);
    }
    function Fn(tt) {
      sn.unshift(tt);
    }
    var ze = 0, Me = null;
    function xn(tt) {
      ze++, n.monitorRunDependencies && n.monitorRunDependencies(ze);
    }
    function Gn(tt) {
      if (ze--, n.monitorRunDependencies && n.monitorRunDependencies(ze), ze == 0 && Me) {
        var it = Me;
        Me = null, it();
      }
    }
    n.preloadedImages = {}, n.preloadedAudios = {};
    function he(tt) {
      n.onAbort && n.onAbort(tt), tt = "Aborted(" + tt + ")", at(tt), ee = !0, tt += ". Build with -s ASSERTIONS=1 for more info.";
      var it = new WebAssembly.RuntimeError(tt);
      throw X(it), it;
    }
    var Se = "data:application/octet-stream;base64,";
    function Oe(tt) {
      return tt.startsWith(Se);
    }
    var re;
    re = "tflite-simd.wasm", Oe(re) || (re = pt(re));
    function Ve(tt) {
      try {
        if (tt == re && mt)
          return new Uint8Array(mt);
        if (!Tt)
          throw "both async and sync fetching of the wasm failed";
      } catch (it) {
        he(it);
      }
    }
    function ln() {
      return !mt && nt && typeof fetch == "function" ? fetch(re, { credentials: "same-origin" }).then(function(tt) {
        if (!tt.ok)
          throw "failed to load wasm binary file at '" + re + "'";
        return tt.arrayBuffer();
      }).catch(function() {
        return Ve(re);
      }) : Promise.resolve().then(function() {
        return Ve(re);
      });
    }
    function Ee() {
      var tt = { a: fe };
      function it(St, me) {
        var Ce = St.exports;
        n.asm = Ce, kt = n.asm.q, An(kt.buffer), Re = n.asm.E, kn(n.asm.r), Gn();
      }
      xn();
      function ct(St) {
        it(St.instance);
      }
      function _t(St) {
        return ln().then(function(me) {
          return WebAssembly.instantiate(me, tt);
        }).then(function(me) {
          return me;
        }).then(St, function(me) {
          at("failed to asynchronously prepare wasm: " + me), he(me);
        });
      }
      function de() {
        return !mt && typeof WebAssembly.instantiateStreaming == "function" && !Oe(re) && typeof fetch == "function" ? fetch(re, { credentials: "same-origin" }).then(function(St) {
          var me = WebAssembly.instantiateStreaming(St, tt);
          return me.then(ct, function(Ce) {
            return at("wasm streaming compile failed: " + Ce), at("falling back to ArrayBuffer instantiation"), _t(ct);
          });
        }) : _t(ct);
      }
      if (n.instantiateWasm)
        try {
          var ue = n.instantiateWasm(tt, it);
          return ue;
        } catch (St) {
          return at("Module.instantiateWasm callback failed with error: " + St), !1;
        }
      return de().catch(X), {};
    }
    function Qt(tt) {
      for (; tt.length > 0; ) {
        var it = tt.shift();
        if (typeof it == "function") {
          it(n);
          continue;
        }
        var ct = it.func;
        typeof ct == "number" ? it.arg === void 0 ? Re.get(ct)() : Re.get(ct)(it.arg) : ct(it.arg === void 0 ? null : it.arg);
      }
    }
    function Ze(tt, it, ct, _t) {
      he("Assertion failed: " + je(tt) + ", at: " + [it ? je(it) : "unknown filename", ct, _t ? je(_t) : "unknown function"]);
    }
    function Le(tt, it) {
      he("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function At(tt, it) {
      he("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function xe() {
      he("");
    }
    var zt;
    zt = function() {
      return performance.now();
    };
    var be = !0;
    function Ye(tt) {
      return $e[Lt() >> 2] = tt, tt;
    }
    function qe(tt, it) {
      var ct;
      if (tt === 0)
        ct = Date.now();
      else if ((tt === 1 || tt === 4) && be)
        ct = zt();
      else
        return Ye(28), -1;
      return $e[it >> 2] = ct / 1e3 | 0, $e[it + 4 >> 2] = ct % 1e3 * 1e3 * 1e3 | 0, 0;
    }
    function Xe() {
      return 2147483648;
    }
    function Ot(tt, it, ct) {
      gt.copyWithin(tt, it, it + ct);
    }
    function Ae(tt) {
      try {
        return kt.grow(tt - Cn.byteLength + 65535 >>> 16), An(kt.buffer), 1;
      } catch {
      }
    }
    function Pe(tt) {
      var it = gt.length;
      tt = tt >>> 0;
      var ct = 2147483648;
      if (tt > ct)
        return !1;
      for (var _t = 1; _t <= 4; _t *= 2) {
        var de = it * (1 + 0.2 / _t);
        de = Math.min(de, tt + 100663296);
        var ue = Math.min(ct, jt(Math.max(tt, de), 65536)), St = Ae(ue);
        if (St)
          return !0;
      }
      return !1;
    }
    function Ie(tt) {
      for (var it = zt(); zt() - it < tt; )
        ;
    }
    var Xn = {};
    function cn() {
      return T || "./this.program";
    }
    function _e() {
      if (!_e.strings) {
        var tt = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", it = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: tt, _: cn() };
        for (var ct in Xn)
          Xn[ct] === void 0 ? delete it[ct] : it[ct] = Xn[ct];
        var _t = [];
        for (var ct in it)
          _t.push(ct + "=" + it[ct]);
        _e.strings = _t;
      }
      return _e.strings;
    }
    var un = { mappings: {}, buffers: [null, [], []], printChar: function(tt, it) {
      var ct = un.buffers[tt];
      it === 0 || it === 10 ? ((tt === 1 ? Ht : at)(De(ct, 0)), ct.length = 0) : ct.push(it);
    }, varargs: void 0, get: function() {
      un.varargs += 4;
      var tt = $e[un.varargs - 4 >> 2];
      return tt;
    }, getStr: function(tt) {
      var it = je(tt);
      return it;
    }, get64: function(tt, it) {
      return tt;
    } };
    function ve(tt, it) {
      var ct = 0;
      return _e().forEach(function(_t, de) {
        var ue = it + ct;
        $e[tt + de * 4 >> 2] = ue, We(_t, ue), ct += _t.length + 1;
      }), 0;
    }
    function Te(tt, it) {
      var ct = _e();
      $e[tt >> 2] = ct.length;
      var _t = 0;
      return ct.forEach(function(de) {
        _t += de.length + 1;
      }), $e[it >> 2] = _t, 0;
    }
    function Ge(tt) {
      te(tt);
    }
    function ie(tt) {
      return 0;
    }
    function Qe(tt, it, ct, _t, de) {
    }
    function qt(tt, it, ct, _t) {
      for (var de = 0, ue = 0; ue < ct; ue++) {
        for (var St = $e[it + ue * 8 >> 2], me = $e[it + (ue * 8 + 4) >> 2], Ce = 0; Ce < me; Ce++)
          un.printChar(tt, gt[St + Ce]);
        de += me;
      }
      return $e[_t >> 2] = de, 0;
    }
    function Pt() {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") {
        var tt = new Uint8Array(1);
        return function() {
          return crypto.getRandomValues(tt), tt[0];
        };
      } else
        return function() {
          he("randomDevice");
        };
    }
    function hn(tt, it) {
      hn.randomDevice || (hn.randomDevice = Pt());
      for (var ct = 0; ct < it; ct++)
        ne[tt + ct >> 0] = hn.randomDevice();
      return 0;
    }
    var fe = { a: Ze, e: Le, d: At, b: xe, n: qe, h: Xe, l: Ot, m: Pe, p: Ie, f: ve, g: Te, j: Ge, i: ie, k: Qe, c: qt, o: hn };
    Ee(), n.___wasm_call_ctors = function() {
      return (n.___wasm_call_ctors = n.asm.r).apply(null, arguments);
    }, n._getModelBufferMemoryOffset = function() {
      return (n._getModelBufferMemoryOffset = n.asm.s).apply(null, arguments);
    }, n._getInputMemoryOffset = function() {
      return (n._getInputMemoryOffset = n.asm.t).apply(null, arguments);
    }, n._getInputHeight = function() {
      return (n._getInputHeight = n.asm.u).apply(null, arguments);
    }, n._getInputWidth = function() {
      return (n._getInputWidth = n.asm.v).apply(null, arguments);
    }, n._getInputChannelCount = function() {
      return (n._getInputChannelCount = n.asm.w).apply(null, arguments);
    }, n._getOutputMemoryOffset = function() {
      return (n._getOutputMemoryOffset = n.asm.x).apply(null, arguments);
    }, n._getOutputHeight = function() {
      return (n._getOutputHeight = n.asm.y).apply(null, arguments);
    }, n._getOutputWidth = function() {
      return (n._getOutputWidth = n.asm.z).apply(null, arguments);
    }, n._getOutputChannelCount = function() {
      return (n._getOutputChannelCount = n.asm.A).apply(null, arguments);
    }, n._loadModel = function() {
      return (n._loadModel = n.asm.B).apply(null, arguments);
    }, n._runInference = function() {
      return (n._runInference = n.asm.C).apply(null, arguments);
    }, n._isGPUEnabled = function() {
      return (n._isGPUEnabled = n.asm.D).apply(null, arguments);
    };
    var Lt = n.___errno_location = function() {
      return (Lt = n.___errno_location = n.asm.F).apply(null, arguments);
    }, Vt;
    function oe(tt) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + tt + ")", this.status = tt;
    }
    Me = function tt() {
      Vt || Fe(), Vt || (Me = tt);
    };
    function Fe(tt) {
      if (ze > 0 || (Rn(), ze > 0))
        return;
      function it() {
        Vt || (Vt = !0, n.calledRun = !0, !ee && (Nn(), m(n), n.onRuntimeInitialized && n.onRuntimeInitialized(), dn()));
      }
      n.setStatus ? (n.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          n.setStatus("");
        }, 1), it();
      }, 1)) : it();
    }
    n.run = Fe;
    function te(tt, it) {
      se(tt);
    }
    function se(tt) {
      Tn() || (n.onExit && n.onExit(tt), ee = !0), B(tt, new oe(tt));
    }
    if (n.preInit)
      for (typeof n.preInit == "function" && (n.preInit = [n.preInit]); n.preInit.length > 0; )
        n.preInit.pop()();
    return Fe(), r.ready;
  };
}();
class L2 {
  constructor() {
    Zt(this, "selectedTFLite");
    Zt(this, "isSIMDSupported", !1);
    Zt(this, "isThreadsSupported", !1);
    Zt(this, "inputWidth", 0);
    Zt(this, "inputHeight", 0);
    Zt(this, "inputChannelCount", 0);
    Zt(this, "inputMemoryOffset", 0);
    Zt(this, "outputWidth", 0);
    Zt(this, "outputHeight", 0);
    Zt(this, "outputChannelCount", 0);
    Zt(this, "outputMemoryOffset", 0);
  }
}
const C2 = "https://d3opqjmqzxf057.cloudfront.net/vonage-tensorflow-wasm/tflite-simd-wasm/1.1.3/", N2 = "https://d3opqjmqzxf057.cloudfront.net/ml/selfie_segmentation/4.0.0/";
async function J2(i = C2, r = N2) {
  let n = new L2();
  var m = new Promise(function(X, S) {
    async function C() {
      return H2({
        locateFile: function(nt) {
          return i + nt;
        }
      });
    }
    async function T(B) {
      return new Promise(async (nt, ut) => {
        const pt = B;
        if (typeof pt > "u")
          return ut("TFLite backend unavailable: wasmSimd");
        const Tt = "selfie_segmentation_landscape";
        console.log("Loading tflite model:", Tt);
        let Ht = r + `${Tt}.tflite`;
        console.log("TFLite modelUrl: " + Ht);
        try {
          const mt = await (await fetch(Ht)).arrayBuffer();
          console.log("Model buffer size:", mt.byteLength);
          const Bt = pt._getModelBufferMemoryOffset();
          console.log(
            "Model buffer memory offset:",
            Bt
          ), console.log("Loading model buffer..."), pt.HEAPU8.set(
            new Uint8Array(mt),
            Bt
          );
          const kt = pt._loadModel(
            mt.byteLength
          );
          if (console.log("Load model result:", kt), kt !== 0) {
            ut("Cannot load model");
            return;
          }
          n.inputWidth = pt._getInputWidth(), n.inputHeight = pt._getInputHeight(), n.inputChannelCount = pt._getInputChannelCount(), n.inputMemoryOffset = pt._getInputMemoryOffset(), console.log(
            "Input memory offset:",
            n.inputMemoryOffset
          ), console.log("Input height:", n.inputHeight), console.log("Input width:", n.inputWidth), console.log(
            "Input channels:",
            n.inputChannelCount
          ), n.outputMemoryOffset = pt._getOutputMemoryOffset(), n.outputWidth = pt._getOutputWidth(), n.outputHeight = pt._getOutputHeight(), n.outputChannelCount = pt._getOutputChannelCount(), console.log(
            "Output memory offset:",
            n.outputMemoryOffset
          ), console.log("Output height:", n.outputHeight), console.log("Output width:", n.outputWidth), console.log(
            "Output channels:",
            n.outputChannelCount
          ), n.selectedTFLite = pt;
        } catch (at) {
          ut(at);
          return;
        }
        nt();
      });
    }
    C().then((B) => {
      if (B === null)
        throw console.error("loadTFLite null"), "loadTFLite null";
      T(B).then((nt) => {
        X(n);
      }).catch((nt) => {
        console.error("loadTFLiteModel error"), S("loadTFLiteModel error");
      });
    }).catch((B) => {
      console.error("loadTFLite error:", B), S("loadTFLite error:" + B);
    });
  });
  return m;
}
class Is {
  constructor() {
    Zt(this, "canvas", new OffscreenCanvas(0, 0));
    Zt(this, "context", this.canvas.getContext(
      "2d",
      {
        willReadFrequently: !0
      }
    ));
    Zt(this, "pixelCount", 0);
    Zt(this, "inputOffset", 0);
    Zt(this, "outputOffset", 0);
    Zt(this, "infos");
    Zt(this, "mask");
  }
  async init(r, n) {
    await this.initWasm(r, n), this.infos && (this.canvas.width = this.infos.inputWidth, this.canvas.height = this.infos.inputHeight, this.pixelCount = this.infos.inputWidth * this.infos.inputHeight, this.mask = new ImageData(
      this.infos.inputWidth,
      this.infos.inputHeight
    ), this.inputOffset = this.infos.inputMemoryOffset / 4, this.outputOffset = this.infos.outputMemoryOffset / 4);
  }
  async initWasm(r, n) {
    this.infos = await J2(
      r,
      n
    );
  }
  getOutputDimensions() {
    var r, n, m, X;
    return {
      width: (n = (r = this.infos) == null ? void 0 : r.outputWidth) != null ? n : 0,
      height: (X = (m = this.infos) == null ? void 0 : m.outputHeight) != null ? X : 0
    };
  }
  async process(r) {
    if (!this.mask || !this.infos)
      return;
    const n = this.infos.inputWidth, m = this.infos.inputHeight;
    this.context.drawImage(
      r,
      0,
      0,
      r.width,
      r.height,
      0,
      0,
      n,
      m
    );
    const X = this.context.getImageData(0, 0, n, m), S = this.infos.selectedTFLite.HEAPF32;
    for (let C = 0; C < this.pixelCount; C++) {
      const T = this.inputOffset + C * 3;
      S[T] = X.data[C * 4] / 255, S[T + 1] = X.data[C * 4 + 1] / 255, S[T + 2] = X.data[C * 4 + 2] / 255;
    }
    this.infos.selectedTFLite._runInference();
    for (let C = 0; C < this.pixelCount; C++) {
      const T = this.infos.selectedTFLite.HEAPF32[this.outputOffset + C];
      this.mask.data[C * 4] = this.mask.data[C * 4 + 3] = 255 * T;
    }
    return createImageBitmap(this.mask);
  }
  isGpuSupported() {
    var r, n, m;
    return (m = (n = (r = this.infos) == null ? void 0 : r.selectedTFLite) == null ? void 0 : n._isGPUEnabled()) != null ? m : !1;
  }
}
async function g3(i, r) {
  const { wasm: n, insertableStreams: m, simd: X, webgl: S } = await k2(i, r);
  if (!n.supported)
    throw n.message;
  if (!m.supported)
    throw m.message;
  if (!X.supported)
    throw X.message;
  if (!S.supported)
    throw S.message;
}
async function k2(i, r) {
  const n = new Is();
  await n.initWasm(i, r);
  const m = {
    wasm: {
      supported: typeof WebAssembly == "object" && typeof WebAssembly.instantiate == "function",
      message: "Your browser does not support WebAssembly features."
    },
    simd: {
      supported: await F2(),
      message: "Your browser does not support simd features."
    },
    insertableStreams: { supported: !0 },
    gpu: {
      supported: n.isGpuSupported(),
      message: "Your browser does not support gpu features."
    },
    webgl: U2(),
    performance: Ss()
  };
  try {
    await zl();
  } catch (X) {
    m.insertableStreams.supported = !1, m.insertableStreams.message = X;
  }
  return m;
}
function U2() {
  return OffscreenCanvas ? new OffscreenCanvas(0, 0).getContext("webgl2") ? { supported: !0 } : {
    supported: !1,
    message: "Your browser does not support webgl 2"
  } : {
    supported: !1,
    message: "Your browser does not support offscreen canvas"
  };
}
function Ss() {
  return new OffscreenCanvas(0, 0).getContext("webgl2", {
    failIfMajorPerformanceCaveat: !0
  }) ? { supported: !0 } : {
    supported: !1,
    message: "Your hardware does not perform good enough to run the library efficiently"
  };
}
const bi = {};
(function() {
  var i;
  function r(p) {
    var W = 0;
    return function() {
      return W < p.length ? { done: !1, value: p[W++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(p, W, V) {
    return p == Array.prototype || p == Object.prototype || (p[W] = V.value), p;
  };
  function m(p) {
    p = [typeof globalThis == "object" && globalThis, p, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var W = 0; W < p.length; ++W) {
      var V = p[W];
      if (V && V.Math == Math)
        return V;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(p, W) {
    if (W)
      t: {
        var V = X;
        p = p.split(".");
        for (var k = 0; k < p.length - 1; k++) {
          var O = p[k];
          if (!(O in V))
            break t;
          V = V[O];
        }
        p = p[p.length - 1], k = V[p], W = W(k), W != k && W != null && n(V, p, { configurable: !0, writable: !0, value: W });
      }
  }
  S("Symbol", function(p) {
    function W(ot) {
      if (this instanceof W)
        throw new TypeError("Symbol is not a constructor");
      return new V(k + (ot || "") + "_" + O++, ot);
    }
    function V(ot, z) {
      this.g = ot, n(this, "description", { configurable: !0, writable: !0, value: z });
    }
    if (p)
      return p;
    V.prototype.toString = function() {
      return this.g;
    };
    var k = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", O = 0;
    return W;
  }), S("Symbol.iterator", function(p) {
    if (p)
      return p;
    p = Symbol("Symbol.iterator");
    for (var W = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), V = 0; V < W.length; V++) {
      var k = X[W[V]];
      typeof k == "function" && typeof k.prototype[p] != "function" && n(k.prototype, p, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return p;
  });
  function C(p) {
    return p = { next: p }, p[Symbol.iterator] = function() {
      return this;
    }, p;
  }
  function T(p) {
    var W = typeof Symbol < "u" && Symbol.iterator && p[Symbol.iterator];
    return W ? W.call(p) : { next: r(p) };
  }
  function B(p) {
    if (!(p instanceof Array)) {
      p = T(p);
      for (var W, V = []; !(W = p.next()).done; )
        V.push(W.value);
      p = V;
    }
    return p;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(p) {
    function W() {
    }
    return W.prototype = p, new W();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(p, W) {
      if (p.__proto__ = W, p.__proto__ !== W)
        throw new TypeError(p + " is not extensible");
      return p;
    } : null;
  }
  var at = ut;
  function mt(p, W) {
    if (p.prototype = nt(W.prototype), p.prototype.constructor = p, at)
      at(p, W);
    else
      for (var V in W)
        if (V != "prototype")
          if (Object.defineProperties) {
            var k = Object.getOwnPropertyDescriptor(W, V);
            k && Object.defineProperty(p, V, k);
          } else
            p[V] = W[V];
    p.ea = W.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
  }
  function kt(p) {
    if (p.l)
      throw new TypeError("Generator is already running");
    p.l = !0;
  }
  Bt.prototype.o = function(p) {
    this.h = p;
  };
  function ee(p, W) {
    p.j = { U: W, V: !0 }, p.g = p.m || p.s;
  }
  Bt.prototype.return = function(p) {
    this.j = { return: p }, this.g = this.s;
  };
  function P(p, W, V) {
    return p.g = V, { value: W };
  }
  function De(p) {
    this.g = new Bt(), this.h = p;
  }
  function je(p, W) {
    kt(p.g);
    var V = p.g.i;
    return V ? We(p, "return" in V ? V.return : function(k) {
      return { value: k, done: !0 };
    }, W, p.g.return) : (p.g.return(W), jt(p));
  }
  function We(p, W, V, k) {
    try {
      var O = W.call(p.g.i, V);
      if (!(O instanceof Object))
        throw new TypeError("Iterator result " + O + " is not an object");
      if (!O.done)
        return p.g.l = !1, O;
      var ot = O.value;
    } catch (z) {
      return p.g.i = null, ee(p.g, z), jt(p);
    }
    return p.g.i = null, k.call(p.g, ot), jt(p);
  }
  function jt(p) {
    for (; p.g.g; )
      try {
        var W = p.h(p.g);
        if (W)
          return p.g.l = !1, { value: W.value, done: !1 };
      } catch (V) {
        p.g.h = void 0, ee(p.g, V);
      }
    if (p.g.l = !1, p.g.j) {
      if (W = p.g.j, p.g.j = null, W.V)
        throw W.U;
      return { value: W.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(p) {
    this.next = function(W) {
      return kt(p.g), p.g.i ? W = We(p, p.g.i.next, W, p.g.o) : (p.g.o(W), W = jt(p)), W;
    }, this.throw = function(W) {
      return kt(p.g), p.g.i ? W = We(p, p.g.i.throw, W, p.g.o) : (ee(p.g, W), W = jt(p)), W;
    }, this.return = function(W) {
      return je(p, W);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(p, W) {
    return W = new Cn(new De(W)), at && p.prototype && at(W, p.prototype), W;
  }
  function gt(p, W) {
    p instanceof String && (p += "");
    var V = 0, k = !1, O = { next: function() {
      if (!k && V < p.length) {
        var ot = V++;
        return { value: W(ot, p[ot]), done: !1 };
      }
      return k = !0, { done: !0, value: void 0 };
    } };
    return O[Symbol.iterator] = function() {
      return O;
    }, O;
  }
  var $e = typeof Object.assign == "function" ? Object.assign : function(p, W) {
    for (var V = 1; V < arguments.length; V++) {
      var k = arguments[V];
      if (k)
        for (var O in k)
          Object.prototype.hasOwnProperty.call(k, O) && (p[O] = k[O]);
    }
    return p;
  };
  S("Object.assign", function(p) {
    return p || $e;
  }), S("Promise", function(p) {
    function W(z) {
      this.h = 0, this.i = void 0, this.g = [], this.o = !1;
      var rt = this.j();
      try {
        z(rt.resolve, rt.reject);
      } catch (bt) {
        rt.reject(bt);
      }
    }
    function V() {
      this.g = null;
    }
    function k(z) {
      return z instanceof W ? z : new W(function(rt) {
        rt(z);
      });
    }
    if (p)
      return p;
    V.prototype.h = function(z) {
      if (this.g == null) {
        this.g = [];
        var rt = this;
        this.i(function() {
          rt.l();
        });
      }
      this.g.push(z);
    };
    var O = X.setTimeout;
    V.prototype.i = function(z) {
      O(z, 0);
    }, V.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var z = this.g;
        this.g = [];
        for (var rt = 0; rt < z.length; ++rt) {
          var bt = z[rt];
          z[rt] = null;
          try {
            bt();
          } catch (Rt) {
            this.j(Rt);
          }
        }
      }
      this.g = null;
    }, V.prototype.j = function(z) {
      this.i(function() {
        throw z;
      });
    }, W.prototype.j = function() {
      function z(Rt) {
        return function(Et) {
          bt || (bt = !0, Rt.call(rt, Et));
        };
      }
      var rt = this, bt = !1;
      return { resolve: z(this.C), reject: z(this.l) };
    }, W.prototype.C = function(z) {
      if (z === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (z instanceof W)
        this.F(z);
      else {
        t:
          switch (typeof z) {
            case "object":
              var rt = z != null;
              break t;
            case "function":
              rt = !0;
              break t;
            default:
              rt = !1;
          }
        rt ? this.u(z) : this.m(z);
      }
    }, W.prototype.u = function(z) {
      var rt = void 0;
      try {
        rt = z.then;
      } catch (bt) {
        this.l(bt);
        return;
      }
      typeof rt == "function" ? this.G(rt, z) : this.m(z);
    }, W.prototype.l = function(z) {
      this.s(2, z);
    }, W.prototype.m = function(z) {
      this.s(1, z);
    }, W.prototype.s = function(z, rt) {
      if (this.h != 0)
        throw Error("Cannot settle(" + z + ", " + rt + "): Promise already settled in state" + this.h);
      this.h = z, this.i = rt, this.h === 2 && this.D(), this.A();
    }, W.prototype.D = function() {
      var z = this;
      O(function() {
        if (z.B()) {
          var rt = X.console;
          typeof rt < "u" && rt.error(z.i);
        }
      }, 1);
    }, W.prototype.B = function() {
      if (this.o)
        return !1;
      var z = X.CustomEvent, rt = X.Event, bt = X.dispatchEvent;
      return typeof bt > "u" ? !0 : (typeof z == "function" ? z = new z("unhandledrejection", { cancelable: !0 }) : typeof rt == "function" ? z = new rt("unhandledrejection", { cancelable: !0 }) : (z = X.document.createEvent("CustomEvent"), z.initCustomEvent("unhandledrejection", !1, !0, z)), z.promise = this, z.reason = this.i, bt(z));
    }, W.prototype.A = function() {
      if (this.g != null) {
        for (var z = 0; z < this.g.length; ++z)
          ot.h(this.g[z]);
        this.g = null;
      }
    };
    var ot = new V();
    return W.prototype.F = function(z) {
      var rt = this.j();
      z.J(rt.resolve, rt.reject);
    }, W.prototype.G = function(z, rt) {
      var bt = this.j();
      try {
        z.call(rt, bt.resolve, bt.reject);
      } catch (Rt) {
        bt.reject(Rt);
      }
    }, W.prototype.then = function(z, rt) {
      function bt($t, Jt) {
        return typeof $t == "function" ? function(wt) {
          try {
            Rt($t(wt));
          } catch (Ut) {
            Et(Ut);
          }
        } : Jt;
      }
      var Rt, Et, Nt = new W(function($t, Jt) {
        Rt = $t, Et = Jt;
      });
      return this.J(bt(z, Rt), bt(rt, Et)), Nt;
    }, W.prototype.catch = function(z) {
      return this.then(void 0, z);
    }, W.prototype.J = function(z, rt) {
      function bt() {
        switch (Rt.h) {
          case 1:
            z(Rt.i);
            break;
          case 2:
            rt(Rt.i);
            break;
          default:
            throw Error("Unexpected state: " + Rt.h);
        }
      }
      var Rt = this;
      this.g == null ? ot.h(bt) : this.g.push(bt), this.o = !0;
    }, W.resolve = k, W.reject = function(z) {
      return new W(function(rt, bt) {
        bt(z);
      });
    }, W.race = function(z) {
      return new W(function(rt, bt) {
        for (var Rt = T(z), Et = Rt.next(); !Et.done; Et = Rt.next())
          k(Et.value).J(rt, bt);
      });
    }, W.all = function(z) {
      var rt = T(z), bt = rt.next();
      return bt.done ? k([]) : new W(function(Rt, Et) {
        function Nt(wt) {
          return function(Ut) {
            $t[wt] = Ut, Jt--, Jt == 0 && Rt($t);
          };
        }
        var $t = [], Jt = 0;
        do
          $t.push(void 0), Jt++, k(bt.value).J(Nt($t.length - 1), Et), bt = rt.next();
        while (!bt.done);
      });
    }, W;
  }), S("Object.is", function(p) {
    return p || function(W, V) {
      return W === V ? W !== 0 || 1 / W === 1 / V : W !== W && V !== V;
    };
  }), S("Array.prototype.includes", function(p) {
    return p || function(W, V) {
      var k = this;
      k instanceof String && (k = String(k));
      var O = k.length;
      for (V = V || 0, 0 > V && (V = Math.max(V + O, 0)); V < O; V++) {
        var ot = k[V];
        if (ot === W || Object.is(ot, W))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(p) {
    return p || function(W, V) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (W instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(W, V || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(p) {
    return p || function() {
      return gt(this, function(W) {
        return W;
      });
    };
  });
  var An = this || self;
  function Re(p, W) {
    p = p.split(".");
    var V = An;
    p[0] in V || typeof V.execScript > "u" || V.execScript("var " + p[0]);
    for (var k; p.length && (k = p.shift()); )
      p.length || W === void 0 ? V[k] && V[k] !== Object.prototype[k] ? V = V[k] : V = V[k] = {} : V[k] = W;
  }
  function Ct(p, W) {
    return W = String.fromCharCode.apply(null, W), p == null ? W : p + W;
  }
  var we, sn = typeof TextDecoder < "u", vn, Tn = typeof TextEncoder < "u";
  function Rn(p) {
    if (Tn)
      p = (vn || (vn = new TextEncoder())).encode(p);
    else {
      var W = void 0;
      W = W === void 0 ? !1 : W;
      for (var V = 0, k = new Uint8Array(3 * p.length), O = 0; O < p.length; O++) {
        var ot = p.charCodeAt(O);
        if (128 > ot)
          k[V++] = ot;
        else {
          if (2048 > ot)
            k[V++] = ot >> 6 | 192;
          else {
            if (55296 <= ot && 57343 >= ot) {
              if (56319 >= ot && O < p.length) {
                var z = p.charCodeAt(++O);
                if (56320 <= z && 57343 >= z) {
                  ot = 1024 * (ot - 55296) + z - 56320 + 65536, k[V++] = ot >> 18 | 240, k[V++] = ot >> 12 & 63 | 128, k[V++] = ot >> 6 & 63 | 128, k[V++] = ot & 63 | 128;
                  continue;
                } else
                  O--;
              }
              if (W)
                throw Error("Found an unpaired surrogate");
              ot = 65533;
            }
            k[V++] = ot >> 12 | 224, k[V++] = ot >> 6 & 63 | 128;
          }
          k[V++] = ot & 63 | 128;
        }
      }
      p = k.subarray(0, V);
    }
    return p;
  }
  var Nn = {}, dn = null;
  function mn(p, W) {
    W === void 0 && (W = 0), ze(), W = Nn[W];
    for (var V = Array(Math.floor(p.length / 3)), k = W[64] || "", O = 0, ot = 0; O < p.length - 2; O += 3) {
      var z = p[O], rt = p[O + 1], bt = p[O + 2], Rt = W[z >> 2];
      z = W[(z & 3) << 4 | rt >> 4], rt = W[(rt & 15) << 2 | bt >> 6], bt = W[bt & 63], V[ot++] = Rt + z + rt + bt;
    }
    switch (Rt = 0, bt = k, p.length - O) {
      case 2:
        Rt = p[O + 1], bt = W[(Rt & 15) << 2] || k;
      case 1:
        p = p[O], V[ot] = W[p >> 2] + W[(p & 3) << 4 | Rt >> 4] + bt + k;
    }
    return V.join("");
  }
  function kn(p) {
    var W = p.length, V = 3 * W / 4;
    V % 3 ? V = Math.floor(V) : "=.".indexOf(p[W - 1]) != -1 && (V = "=.".indexOf(p[W - 2]) != -1 ? V - 2 : V - 1);
    var k = new Uint8Array(V), O = 0;
    return Fn(p, function(ot) {
      k[O++] = ot;
    }), k.subarray(0, O);
  }
  function Fn(p, W) {
    function V(bt) {
      for (; k < p.length; ) {
        var Rt = p.charAt(k++), Et = dn[Rt];
        if (Et != null)
          return Et;
        if (!/^[\s\xa0]*$/.test(Rt))
          throw Error("Unknown base64 encoding at char: " + Rt);
      }
      return bt;
    }
    ze();
    for (var k = 0; ; ) {
      var O = V(-1), ot = V(0), z = V(64), rt = V(64);
      if (rt === 64 && O === -1)
        break;
      W(O << 2 | ot >> 4), z != 64 && (W(ot << 4 & 240 | z >> 2), rt != 64 && W(z << 6 & 192 | rt));
    }
  }
  function ze() {
    if (!dn) {
      dn = {};
      for (var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), W = ["+/=", "+/", "-_=", "-_.", "-_"], V = 0; 5 > V; V++) {
        var k = p.concat(W[V].split(""));
        Nn[V] = k;
        for (var O = 0; O < k.length; O++) {
          var ot = k[O];
          dn[ot] === void 0 && (dn[ot] = O);
        }
      }
    }
  }
  var Me = typeof Uint8Array.prototype.slice == "function", xn;
  function Gn(p, W, V) {
    return W === V ? xn || (xn = new Uint8Array(0)) : Me ? p.slice(W, V) : new Uint8Array(p.subarray(W, V));
  }
  var he = 0, Se = 0;
  function Oe(p, W) {
    W = W === void 0 ? {} : W, W = W.v === void 0 ? !1 : W.v, this.h = null, this.g = this.i = this.j = 0, this.l = !1, this.v = W, p && re(this, p);
  }
  function re(p, W) {
    W = W.constructor === Uint8Array ? W : W.constructor === ArrayBuffer ? new Uint8Array(W) : W.constructor === Array ? new Uint8Array(W) : W.constructor === String ? kn(W) : W instanceof Uint8Array ? new Uint8Array(W.buffer, W.byteOffset, W.byteLength) : new Uint8Array(0), p.h = W, p.j = 0, p.i = p.h.length, p.g = p.j;
  }
  Oe.prototype.reset = function() {
    this.g = this.j;
  };
  function Ve(p) {
    var W = p.h, V = W[p.g], k = V & 127;
    return 128 > V ? (p.g += 1, k) : (V = W[p.g + 1], k |= (V & 127) << 7, 128 > V ? (p.g += 2, k) : (V = W[p.g + 2], k |= (V & 127) << 14, 128 > V ? (p.g += 3, k) : (V = W[p.g + 3], k |= (V & 127) << 21, 128 > V ? (p.g += 4, k) : (V = W[p.g + 4], k |= (V & 15) << 28, 128 > V ? (p.g += 5, k >>> 0) : (p.g += 5, 128 <= W[p.g++] && 128 <= W[p.g++] && 128 <= W[p.g++] && 128 <= W[p.g++] && p.g++, k)))));
  }
  function ln(p) {
    var W = p.h[p.g], V = p.h[p.g + 1], k = p.h[p.g + 2], O = p.h[p.g + 3];
    return p.g += 4, V = (W << 0 | V << 8 | k << 16 | O << 24) >>> 0, p = 2 * (V >> 31) + 1, W = V >>> 23 & 255, V &= 8388607, W == 255 ? V ? NaN : 1 / 0 * p : W == 0 ? p * Math.pow(2, -149) * V : p * Math.pow(2, W - 150) * (V + Math.pow(2, 23));
  }
  var Ee = [];
  function Qt() {
    this.g = new Uint8Array(64), this.h = 0;
  }
  Qt.prototype.push = function(p) {
    if (!(this.h + 1 < this.g.length)) {
      var W = this.g;
      this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length)), this.g.set(W);
    }
    this.g[this.h++] = p;
  }, Qt.prototype.length = function() {
    return this.h;
  }, Qt.prototype.end = function() {
    var p = this.g, W = this.h;
    return this.h = 0, Gn(p, 0, W);
  };
  function Ze(p, W) {
    for (; 127 < W; )
      p.push(W & 127 | 128), W >>>= 7;
    p.push(W);
  }
  function Le(p) {
    var W = {}, V = W.N === void 0 ? !1 : W.N;
    this.o = { v: W.v === void 0 ? !1 : W.v }, this.N = V, W = this.o, Ee.length ? (V = Ee.pop(), W && (V.v = W.v), p && re(V, p), p = V) : p = new Oe(p, W), this.g = p, this.m = this.g.g, this.h = this.i = this.l = -1, this.j = !1;
  }
  Le.prototype.reset = function() {
    this.g.reset(), this.h = this.l = -1;
  };
  function At(p) {
    var W = p.g;
    if ((W = W.g == W.i) || (W = p.j) || (W = p.g, W = W.l || 0 > W.g || W.g > W.i), W)
      return !1;
    p.m = p.g.g, W = Ve(p.g);
    var V = W & 7;
    return V != 0 && V != 5 && V != 1 && V != 2 && V != 3 && V != 4 ? (p.j = !0, !1) : (p.i = W, p.l = W >>> 3, p.h = V, !0);
  }
  function xe(p) {
    switch (p.h) {
      case 0:
        if (p.h != 0)
          xe(p);
        else {
          for (p = p.g; p.h[p.g] & 128; )
            p.g++;
          p.g++;
        }
        break;
      case 1:
        p.h != 1 ? xe(p) : (p = p.g, p.g += 8);
        break;
      case 2:
        if (p.h != 2)
          xe(p);
        else {
          var W = Ve(p.g);
          p = p.g, p.g += W;
        }
        break;
      case 5:
        p.h != 5 ? xe(p) : (p = p.g, p.g += 4);
        break;
      case 3:
        W = p.l;
        do {
          if (!At(p)) {
            p.j = !0;
            break;
          }
          if (p.h == 4) {
            p.l != W && (p.j = !0);
            break;
          }
          xe(p);
        } while (1);
        break;
      default:
        p.j = !0;
    }
  }
  function zt(p, W, V) {
    var k = p.g.i, O = Ve(p.g);
    return O = p.g.g + O, p.g.i = O, V(W, p), p.g.g = O, p.g.i = k, W;
  }
  function be(p) {
    var W = Ve(p.g);
    p = p.g;
    var V = p.g;
    p.g += W, p = p.h;
    var k;
    if (sn)
      (k = we) || (k = we = new TextDecoder("utf-8", { fatal: !1 })), k = k.decode(p.subarray(V, V + W));
    else {
      W = V + W;
      for (var O = [], ot = null, z, rt, bt; V < W; )
        z = p[V++], 128 > z ? O.push(z) : 224 > z ? V >= W ? O.push(65533) : (rt = p[V++], 194 > z || (rt & 192) !== 128 ? (V--, O.push(65533)) : O.push((z & 31) << 6 | rt & 63)) : 240 > z ? V >= W - 1 ? O.push(65533) : (rt = p[V++], (rt & 192) !== 128 || z === 224 && 160 > rt || z === 237 && 160 <= rt || ((k = p[V++]) & 192) !== 128 ? (V--, O.push(65533)) : O.push((z & 15) << 12 | (rt & 63) << 6 | k & 63)) : 244 >= z ? V >= W - 2 ? O.push(65533) : (rt = p[V++], (rt & 192) !== 128 || (z << 28) + (rt - 144) >> 30 !== 0 || ((k = p[V++]) & 192) !== 128 || ((bt = p[V++]) & 192) !== 128 ? (V--, O.push(65533)) : (z = (z & 7) << 18 | (rt & 63) << 12 | (k & 63) << 6 | bt & 63, z -= 65536, O.push((z >> 10 & 1023) + 55296, (z & 1023) + 56320))) : O.push(65533), 8192 <= O.length && (ot = Ct(ot, O), O.length = 0);
      k = Ct(ot, O);
    }
    return k;
  }
  function Ye() {
    this.h = [], this.i = 0, this.g = new Qt();
  }
  function qe(p, W) {
    W.length !== 0 && (p.h.push(W), p.i += W.length);
  }
  function Xe(p) {
    var W = p.i + p.g.length();
    if (W === 0)
      return new Uint8Array(0);
    W = new Uint8Array(W);
    for (var V = p.h, k = V.length, O = 0, ot = 0; ot < k; ot++) {
      var z = V[ot];
      z.length !== 0 && (W.set(z, O), O += z.length);
    }
    return V = p.g, k = V.h, k !== 0 && (W.set(V.g.subarray(0, k), O), V.h = 0), p.h = [W], W;
  }
  function Ot(p, W, V) {
    if (V != null) {
      Ze(p.g, 8 * W + 5), p = p.g;
      var k = V;
      k = (V = 0 > k ? 1 : 0) ? -k : k, k === 0 ? 0 < 1 / k ? he = Se = 0 : (Se = 0, he = 2147483648) : isNaN(k) ? (Se = 0, he = 2147483647) : 34028234663852886e22 < k ? (Se = 0, he = (V << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > k ? (k = Math.round(k / Math.pow(2, -149)), Se = 0, he = (V << 31 | k) >>> 0) : (W = Math.floor(Math.log(k) / Math.LN2), k *= Math.pow(2, -W), k = Math.round(8388608 * k) & 8388607, Se = 0, he = (V << 31 | W + 127 << 23 | k) >>> 0), V = he, p.push(V >>> 0 & 255), p.push(V >>> 8 & 255), p.push(V >>> 16 & 255), p.push(V >>> 24 & 255);
    }
  }
  var Ae = typeof Uint8Array == "function";
  function Pe(p, W, V) {
    if (p != null)
      return typeof p == "object" ? Ae && p instanceof Uint8Array ? V(p) : Ie(p, W, V) : W(p);
  }
  function Ie(p, W, V) {
    if (Array.isArray(p)) {
      for (var k = Array(p.length), O = 0; O < p.length; O++)
        k[O] = Pe(p[O], W, V);
      return Array.isArray(p) && p.W && _e(k), k;
    }
    k = {};
    for (O in p)
      k[O] = Pe(p[O], W, V);
    return k;
  }
  function Xn(p) {
    return typeof p == "number" ? isFinite(p) ? p : String(p) : p;
  }
  var cn = { W: { value: !0, configurable: !0 } };
  function _e(p) {
    return Array.isArray(p) && !Object.isFrozen(p) && Object.defineProperties(p, cn), p;
  }
  var un;
  function ve(p, W, V) {
    var k = un;
    un = null, p || (p = k), k = this.constructor.ca, p || (p = k ? [k] : []), this.j = k ? 0 : -1, this.i = null, this.g = p;
    t: {
      if (k = this.g.length, p = k - 1, k && (k = this.g[p], k !== null && typeof k == "object" && k.constructor === Object)) {
        this.l = p - this.j, this.h = k;
        break t;
      }
      W !== void 0 && -1 < W ? (this.l = Math.max(W, p + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
    }
    if (V)
      for (W = 0; W < V.length; W++)
        p = V[W], p < this.l ? (p += this.j, (k = this.g[p]) ? _e(k) : this.g[p] = Te) : (Ge(this), (k = this.h[p]) ? _e(k) : this.h[p] = Te);
  }
  var Te = Object.freeze(_e([]));
  function Ge(p) {
    var W = p.l + p.j;
    p.g[W] || (p.h = p.g[W] = {});
  }
  function ie(p, W, V) {
    return W === -1 ? null : (V === void 0 ? 0 : V) || W >= p.l ? p.h ? p.h[W] : void 0 : p.g[W + p.j];
  }
  function Qe(p) {
    var W = W === void 0 ? !1 : W, V = ie(p, 1, W);
    return V == null && (V = Te), V === Te && (V = _e([]), Pt(p, 1, V, W)), V;
  }
  function qt(p, W, V) {
    return p = ie(p, W), p = p == null ? p : +p, p == null ? V === void 0 ? 0 : V : p;
  }
  function Pt(p, W, V, k) {
    (k === void 0 ? 0 : k) || W >= p.l ? (Ge(p), p.h[W] = V) : p.g[W + p.j] = V;
  }
  function hn(p, W) {
    p.i || (p.i = {});
    var V = p.i[1];
    if (!V) {
      var k = Qe(p);
      V = [];
      for (var O = 0; O < k.length; O++)
        V[O] = new W(k[O]);
      p.i[1] = V;
    }
    return V;
  }
  function fe(p, W, V, k) {
    var O = hn(p, V);
    W = W || new V(), p = Qe(p), k != null ? (O.splice(k, 0, W), p.splice(k, 0, Lt(W))) : (O.push(W), p.push(Lt(W)));
  }
  ve.prototype.toJSON = function() {
    var p = Lt(this);
    return Ie(p, Xn, mn);
  };
  function Lt(p, W) {
    if (p.i)
      for (var V in p.i) {
        var k = p.i[V];
        if (Array.isArray(k))
          for (var O = 0; O < k.length; O++)
            k[O] && Lt(k[O]);
        else
          k && Lt(k);
      }
    return p.g;
  }
  ve.prototype.toString = function() {
    return Lt(this).toString();
  };
  function Vt(p, W) {
    return p = ie(p, W), p == null ? 0 : p;
  }
  function oe(p, W) {
    return p = ie(p, W), p == null ? "" : p;
  }
  function Fe(p, W) {
    if (p = p.m) {
      qe(W, W.g.end());
      for (var V = 0; V < p.length; V++)
        qe(W, p[V]);
    }
  }
  function te(p, W) {
    if (W.h == 4)
      return !1;
    var V = W.m;
    return xe(W), W.N || (W = Gn(W.g.h, V, W.g.g), (V = p.m) ? V.push(W) : p.m = [W]), !0;
  }
  function se(p, W) {
    var V = void 0;
    return new (V || (V = Promise))(function(k, O) {
      function ot(bt) {
        try {
          rt(W.next(bt));
        } catch (Rt) {
          O(Rt);
        }
      }
      function z(bt) {
        try {
          rt(W.throw(bt));
        } catch (Rt) {
          O(Rt);
        }
      }
      function rt(bt) {
        bt.done ? k(bt.value) : new V(function(Rt) {
          Rt(bt.value);
        }).then(ot, z);
      }
      rt((W = W.apply(p, void 0)).next());
    });
  }
  function tt(p) {
    ve.call(this, p);
  }
  mt(tt, ve);
  function it(p, W) {
    for (; At(W); )
      switch (W.i) {
        case 8:
          var V = Ve(W.g);
          Pt(p, 1, V);
          break;
        case 21:
          V = ln(W.g), Pt(p, 2, V);
          break;
        case 26:
          V = be(W), Pt(p, 3, V);
          break;
        case 34:
          V = be(W), Pt(p, 4, V);
          break;
        default:
          if (!te(p, W))
            return p;
      }
    return p;
  }
  function ct(p) {
    ve.call(this, p, -1, _t);
  }
  mt(ct, ve), ct.prototype.addClassification = function(p, W) {
    fe(this, p, tt, W);
  };
  var _t = [1];
  function de(p) {
    ve.call(this, p);
  }
  mt(de, ve);
  function ue(p, W) {
    for (; At(W); )
      switch (W.i) {
        case 13:
          var V = ln(W.g);
          Pt(p, 1, V);
          break;
        case 21:
          V = ln(W.g), Pt(p, 2, V);
          break;
        case 29:
          V = ln(W.g), Pt(p, 3, V);
          break;
        case 37:
          V = ln(W.g), Pt(p, 4, V);
          break;
        case 45:
          V = ln(W.g), Pt(p, 5, V);
          break;
        default:
          if (!te(p, W))
            return p;
      }
    return p;
  }
  function St(p) {
    ve.call(this, p, -1, me);
  }
  mt(St, ve);
  var me = [1];
  function Ce(p) {
    ve.call(this, p);
  }
  mt(Ce, ve);
  function tn(p, W, V) {
    if (V = p.createShader(V === 0 ? p.VERTEX_SHADER : p.FRAGMENT_SHADER), p.shaderSource(V, W), p.compileShader(V), !p.getShaderParameter(V, p.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + p.getShaderInfoLog(V));
    return V;
  }
  function en(p) {
    return hn(p, tt).map(function(W) {
      return { index: Vt(W, 1), Y: qt(W, 2), label: ie(W, 3) != null ? oe(W, 3) : void 0, displayName: ie(W, 4) != null ? oe(W, 4) : void 0 };
    });
  }
  function fn(p) {
    return { x: qt(p, 1), y: qt(p, 2), z: qt(p, 3), visibility: ie(p, 4) != null ? qt(p, 4) : void 0 };
  }
  function pn(p, W) {
    this.h = p, this.g = W, this.l = 0;
  }
  function He(p, W, V) {
    return nn(p, W), typeof p.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(p.g.canvas.transferToImageBitmap()) : V ? Promise.resolve(p.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(p.g.canvas) : (p.i === void 0 && (p.i = document.createElement("canvas")), new Promise(function(k) {
      p.i.height = p.g.canvas.height, p.i.width = p.g.canvas.width, p.i.getContext("2d", {}).drawImage(p.g.canvas, 0, 0, p.g.canvas.width, p.g.canvas.height), k(p.i);
    }));
  }
  function nn(p, W) {
    var V = p.g;
    if (p.m === void 0) {
      var k = tn(V, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), O = tn(V, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), ot = V.createProgram();
      if (V.attachShader(ot, k), V.attachShader(ot, O), V.linkProgram(ot), !V.getProgramParameter(ot, V.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + V.getProgramInfoLog(ot));
      k = p.m = ot, V.useProgram(k), O = V.getUniformLocation(k, "sampler0"), p.j = { I: V.getAttribLocation(k, "aVertex"), H: V.getAttribLocation(k, "aTex"), da: O }, p.s = V.createBuffer(), V.bindBuffer(V.ARRAY_BUFFER, p.s), V.enableVertexAttribArray(p.j.I), V.vertexAttribPointer(p.j.I, 2, V.FLOAT, !1, 0, 0), V.bufferData(V.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), V.STATIC_DRAW), V.bindBuffer(V.ARRAY_BUFFER, null), p.o = V.createBuffer(), V.bindBuffer(V.ARRAY_BUFFER, p.o), V.enableVertexAttribArray(p.j.H), V.vertexAttribPointer(
        p.j.H,
        2,
        V.FLOAT,
        !1,
        0,
        0
      ), V.bufferData(V.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), V.STATIC_DRAW), V.bindBuffer(V.ARRAY_BUFFER, null), V.uniform1i(O, 0);
    }
    k = p.j, V.useProgram(p.m), V.canvas.width = W.width, V.canvas.height = W.height, V.viewport(0, 0, W.width, W.height), V.activeTexture(V.TEXTURE0), p.h.bindTexture2d(W.glName), V.enableVertexAttribArray(k.I), V.bindBuffer(V.ARRAY_BUFFER, p.s), V.vertexAttribPointer(k.I, 2, V.FLOAT, !1, 0, 0), V.enableVertexAttribArray(k.H), V.bindBuffer(V.ARRAY_BUFFER, p.o), V.vertexAttribPointer(
      k.H,
      2,
      V.FLOAT,
      !1,
      0,
      0
    ), V.bindFramebuffer(V.DRAW_FRAMEBUFFER ? V.DRAW_FRAMEBUFFER : V.FRAMEBUFFER, null), V.clearColor(0, 0, 0, 0), V.clear(V.COLOR_BUFFER_BIT), V.colorMask(!0, !0, !0, !0), V.drawArrays(V.TRIANGLE_FAN, 0, 4), V.disableVertexAttribArray(k.I), V.disableVertexAttribArray(k.H), V.bindBuffer(V.ARRAY_BUFFER, null), p.h.bindTexture2d(0);
  }
  function Kn(p) {
    this.g = p;
  }
  var rn = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Ne(p, W) {
    return W + p;
  }
  function yn(p, W) {
    window[p] = W;
  }
  function In(p) {
    var W = document.createElement("script");
    return W.setAttribute("src", p), W.setAttribute("crossorigin", "anonymous"), new Promise(function(V) {
      W.addEventListener("load", function() {
        V();
      }, !1), W.addEventListener("error", function() {
        V();
      }, !1), document.body.appendChild(W);
    });
  }
  function Be() {
    return se(this, function p() {
      return ne(p, function(W) {
        switch (W.g) {
          case 1:
            return W.m = 2, P(W, WebAssembly.instantiate(rn), 4);
          case 4:
            W.g = 3, W.m = 0;
            break;
          case 2:
            return W.m = 0, W.j = null, W.return(!1);
          case 3:
            return W.return(!0);
        }
      });
    });
  }
  function Un(p) {
    if (this.g = p, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = Promise.resolve(), this.P = "", this.B = {}, this.locateFile = p && p.locateFile || Ne, typeof window == "object")
      var W = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      W = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.S = W, p.options) {
      W = T(Object.keys(p.options));
      for (var V = W.next(); !V.done; V = W.next()) {
        V = V.value;
        var k = p.options[V].default;
        k !== void 0 && (this.j[V] = typeof k == "function" ? k() : k);
      }
    }
  }
  i = Un.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function on(p, W) {
    return p.g.files === void 0 ? [] : typeof p.g.files == "function" ? p.g.files(W) : p.g.files;
  }
  function gn(p) {
    return se(p, function W() {
      var V = this, k, O, ot, z, rt, bt, Rt, Et, Nt, $t, Jt;
      return ne(W, function(wt) {
        switch (wt.g) {
          case 1:
            return k = V, V.R ? (O = on(V, V.j), P(wt, Be(), 2)) : wt.return();
          case 2:
            if (ot = wt.h, typeof window == "object")
              return yn("createMediapipeSolutionsWasm", { locateFile: V.locateFile }), yn("createMediapipeSolutionsPackedAssets", { locateFile: V.locateFile }), bt = O.filter(function(Ut) {
                return Ut.data !== void 0;
              }), Rt = O.filter(function(Ut) {
                return Ut.data === void 0;
              }), Et = Promise.all(bt.map(function(Ut) {
                var Dt = an(k, Ut.url);
                if (Ut.path !== void 0) {
                  var ae = Ut.path;
                  Dt = Dt.then(function(pe) {
                    return k.overrideFile(ae, pe), Promise.resolve(pe);
                  });
                }
                return Dt;
              })), Nt = Promise.all(Rt.map(function(Ut) {
                return Ut.simd === void 0 || Ut.simd && ot || !Ut.simd && !ot ? In(k.locateFile(Ut.url, k.S)) : Promise.resolve();
              })).then(function() {
                return se(k, function Ut() {
                  var Dt, ae, pe = this;
                  return ne(Ut, function(ye) {
                    if (ye.g == 1)
                      return Dt = window.createMediapipeSolutionsWasm, ae = window.createMediapipeSolutionsPackedAssets, P(ye, Dt(ae), 2);
                    pe.h = ye.h, ye.g = 0;
                  });
                });
              }), $t = function() {
                return se(k, function Ut() {
                  var Dt = this;
                  return ne(Ut, function(ae) {
                    return Dt.g.graph && Dt.g.graph.url ? ae = P(ae, an(Dt, Dt.g.graph.url), 0) : (ae.g = 0, ae = void 0), ae;
                  });
                });
              }(), P(wt, Promise.all([Nt, Et, $t]), 7);
            if (typeof importScripts != "function")
              throw Error("solutions can only be loaded on a web page or in a web worker");
            return z = O.filter(function(Ut) {
              return Ut.simd === void 0 || Ut.simd && ot || !Ut.simd && !ot;
            }).map(function(Ut) {
              return k.locateFile(Ut.url, k.S);
            }), importScripts.apply(null, B(z)), P(wt, createMediapipeSolutionsWasm(Module), 6);
          case 6:
            V.h = wt.h, V.l = new OffscreenCanvas(1, 1), V.h.canvas = V.l, rt = V.h.GL.createContext(
              V.l,
              { antialias: !1, alpha: !1, ba: typeof WebGL2RenderingContext < "u" ? 2 : 1 }
            ), V.h.GL.makeContextCurrent(rt), wt.g = 4;
            break;
          case 7:
            if (V.l = document.createElement("canvas"), Jt = V.l.getContext("webgl2", {}), !Jt && (Jt = V.l.getContext("webgl", {}), !Jt))
              return alert("Failed to create WebGL canvas context when passing video frame."), wt.return();
            V.D = Jt, V.h.canvas = V.l, V.h.createContext(V.l, !0, !0, {});
          case 4:
            V.i = new V.h.SolutionWasm(), V.R = !1, wt.g = 0;
        }
      });
    });
  }
  function Sn(p) {
    return se(p, function W() {
      var V = this, k, O, ot, z, rt, bt, Rt, Et;
      return ne(W, function(Nt) {
        if (Nt.g == 1) {
          if (V.g.graph && V.g.graph.url && V.P === V.g.graph.url)
            return Nt.return();
          if (V.o = !0, !V.g.graph || !V.g.graph.url) {
            Nt.g = 2;
            return;
          }
          return V.P = V.g.graph.url, P(Nt, an(V, V.g.graph.url), 3);
        }
        for (Nt.g != 2 && (k = Nt.h, V.i.loadGraph(k)), O = T(Object.keys(V.B)), ot = O.next(); !ot.done; ot = O.next())
          z = ot.value, V.i.overrideFile(z, V.B[z]);
        if (V.B = {}, V.g.listeners)
          for (rt = T(V.g.listeners), bt = rt.next(); !bt.done; bt = rt.next())
            Rt = bt.value, _n(V, Rt);
        Et = V.j, V.j = {}, V.setOptions(Et), Nt.g = 0;
      });
    });
  }
  i.reset = function() {
    return se(this, function p() {
      var W = this;
      return ne(p, function(V) {
        W.i && (W.i.reset(), W.m = {}, W.s = {}), V.g = 0;
      });
    });
  }, i.setOptions = function(p, W) {
    var V = this;
    if (W = W || this.g.options) {
      for (var k = [], O = [], ot = {}, z = T(Object.keys(p)), rt = z.next(); !rt.done; ot = { K: ot.K, L: ot.L }, rt = z.next()) {
        var bt = rt.value;
        bt in this.j && this.j[bt] === p[bt] || (this.j[bt] = p[bt], rt = W[bt], rt !== void 0 && (rt.onChange && (ot.K = rt.onChange, ot.L = p[bt], k.push(function(Rt) {
          return function() {
            return se(V, function Et() {
              var Nt, $t = this;
              return ne(Et, function(Jt) {
                if (Jt.g == 1)
                  return P(Jt, Rt.K(Rt.L), 2);
                Nt = Jt.h, Nt === !0 && ($t.o = !0), Jt.g = 0;
              });
            });
          };
        }(ot))), rt.graphOptionXref && (bt = { valueNumber: rt.type === 1 ? p[bt] : 0, valueBoolean: rt.type === 0 ? p[bt] : !1, valueString: rt.type === 2 ? p[bt] : "" }, rt = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), rt.graphOptionXref), bt), O.push(rt))));
      }
      (k.length !== 0 || O.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(O), this.u = (this.u === void 0 ? [] : this.u).concat(k));
    }
  };
  function En(p) {
    return se(p, function W() {
      var V = this, k, O, ot, z, rt, bt, Rt;
      return ne(W, function(Et) {
        switch (Et.g) {
          case 1:
            if (!V.o)
              return Et.return();
            if (!V.u) {
              Et.g = 2;
              break;
            }
            k = T(V.u), O = k.next();
          case 3:
            if (O.done) {
              Et.g = 5;
              break;
            }
            return ot = O.value, P(Et, ot(), 4);
          case 4:
            O = k.next(), Et.g = 3;
            break;
          case 5:
            V.u = void 0;
          case 2:
            if (V.A) {
              for (z = new V.h.GraphOptionChangeRequestList(), rt = T(V.A), bt = rt.next(); !bt.done; bt = rt.next())
                Rt = bt.value, z.push_back(Rt);
              V.i.changeOptions(z), z.delete(), V.A = void 0;
            }
            V.o = !1, Et.g = 0;
        }
      });
    });
  }
  i.initialize = function() {
    return se(this, function p() {
      var W = this;
      return ne(p, function(V) {
        return V.g == 1 ? P(V, gn(W), 2) : V.g != 3 ? P(V, Sn(W), 3) : P(V, En(W), 0);
      });
    });
  };
  function an(p, W) {
    return se(p, function V() {
      var k = this, O, ot;
      return ne(V, function(z) {
        return W in k.F ? z.return(k.F[W]) : (O = k.locateFile(W, ""), ot = fetch(O).then(function(rt) {
          return rt.arrayBuffer();
        }), k.F[W] = ot, z.return(ot));
      });
    });
  }
  i.overrideFile = function(p, W) {
    this.i ? this.i.overrideFile(p, W) : this.B[p] = W;
  }, i.clearOverriddenFiles = function() {
    this.B = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(p, W) {
    return se(this, function V() {
      var k = this, O, ot, z, rt, bt, Rt, Et, Nt, $t;
      return ne(V, function(Jt) {
        switch (Jt.g) {
          case 1:
            return k.g.inputs ? (O = 1e3 * (W == null ? performance.now() : W), P(Jt, k.C, 2)) : Jt.return();
          case 2:
            return P(Jt, k.initialize(), 3);
          case 3:
            for (ot = new k.h.PacketDataList(), z = T(Object.keys(p)), rt = z.next(); !rt.done; rt = z.next())
              if (bt = rt.value, Rt = k.g.inputs[bt]) {
                t: {
                  var wt = k, Ut = p[bt];
                  switch (Rt.type) {
                    case "video":
                      var Dt = wt.m[Rt.stream];
                      if (Dt || (Dt = new pn(wt.h, wt.D), wt.m[Rt.stream] = Dt), wt = Dt, wt.l === 0 && (wt.l = wt.h.createTexture()), typeof HTMLVideoElement < "u" && Ut instanceof HTMLVideoElement) {
                        var ae = Ut.videoWidth;
                        Dt = Ut.videoHeight;
                      } else
                        typeof HTMLImageElement < "u" && Ut instanceof HTMLImageElement ? (ae = Ut.naturalWidth, Dt = Ut.naturalHeight) : (ae = Ut.width, Dt = Ut.height);
                      Dt = { glName: wt.l, width: ae, height: Dt }, ae = wt.g, ae.canvas.width = Dt.width, ae.canvas.height = Dt.height, ae.activeTexture(ae.TEXTURE0), wt.h.bindTexture2d(wt.l), ae.texImage2D(ae.TEXTURE_2D, 0, ae.RGBA, ae.RGBA, ae.UNSIGNED_BYTE, Ut), wt.h.bindTexture2d(0), wt = Dt;
                      break t;
                    case "detections":
                      for (Dt = wt.m[Rt.stream], Dt || (Dt = new Kn(wt.h), wt.m[Rt.stream] = Dt), wt = Dt, wt.data || (wt.data = new wt.g.DetectionListData()), wt.data.reset(Ut.length), Dt = 0; Dt < Ut.length; ++Dt) {
                        ae = Ut[Dt];
                        var pe = wt.data, ye = pe.setBoundingBox, Je = Dt, h = ae.T, y = new Ce();
                        Pt(y, 1, h.Z), Pt(y, 2, h.$), Pt(y, 3, h.height), Pt(y, 4, h.width), Pt(y, 5, h.rotation), Pt(y, 6, h.X);
                        var v = h = new Ye();
                        Ot(v, 1, ie(y, 1)), Ot(v, 2, ie(y, 2)), Ot(v, 3, ie(y, 3)), Ot(v, 4, ie(y, 4)), Ot(v, 5, ie(y, 5));
                        var L = ie(y, 6);
                        if (L != null && L != null) {
                          Ze(v.g, 48);
                          var M = v.g, _ = L;
                          L = 0 > _, _ = Math.abs(_);
                          var A = _ >>> 0;
                          for (_ = Math.floor((_ - A) / 4294967296), _ >>>= 0, L && (_ = ~_ >>> 0, A = (~A >>> 0) + 1, 4294967295 < A && (A = 0, _++, 4294967295 < _ && (_ = 0))), he = A, Se = _, L = he, A = Se; 0 < A || 127 < L; )
                            M.push(L & 127 | 128), L = (L >>> 7 | A << 25) >>> 0, A >>>= 7;
                          M.push(L);
                        }
                        if (Fe(y, v), h = Xe(h), ye.call(pe, Je, h), ae.O)
                          for (pe = 0; pe < ae.O.length; ++pe)
                            y = ae.O[pe], v = !!y.visibility, ye = wt.data, Je = ye.addNormalizedLandmark, h = Dt, y = Object.assign(Object.assign({}, y), { visibility: v ? y.visibility : 0 }), v = new de(), Pt(v, 1, y.x), Pt(v, 2, y.y), Pt(v, 3, y.z), y.visibility && Pt(v, 4, y.visibility), M = y = new Ye(), Ot(M, 1, ie(v, 1)), Ot(M, 2, ie(v, 2)), Ot(M, 3, ie(v, 3)), Ot(M, 4, ie(v, 4)), Ot(M, 5, ie(v, 5)), Fe(v, M), y = Xe(y), Je.call(ye, h, y);
                        if (ae.M)
                          for (pe = 0; pe < ae.M.length; ++pe) {
                            if (ye = wt.data, Je = ye.addClassification, h = Dt, y = ae.M[pe], v = new tt(), Pt(v, 2, y.Y), y.index && Pt(v, 1, y.index), y.label && Pt(v, 3, y.label), y.displayName && Pt(v, 4, y.displayName), M = y = new Ye(), A = ie(v, 1), A != null && A != null)
                              if (Ze(M.g, 8), L = M.g, 0 <= A)
                                Ze(L, A);
                              else {
                                for (_ = 0; 9 > _; _++)
                                  L.push(A & 127 | 128), A >>= 7;
                                L.push(1);
                              }
                            Ot(M, 2, ie(v, 2)), L = ie(v, 3), L != null && (L = Rn(L), Ze(M.g, 26), Ze(M.g, L.length), qe(M, M.g.end()), qe(M, L)), L = ie(v, 4), L != null && (L = Rn(L), Ze(M.g, 34), Ze(M.g, L.length), qe(M, M.g.end()), qe(
                              M,
                              L
                            )), Fe(v, M), y = Xe(y), Je.call(ye, h, y);
                          }
                      }
                      wt = wt.data;
                      break t;
                    default:
                      wt = {};
                  }
                }
                switch (Et = wt, Nt = Rt.stream, Rt.type) {
                  case "video":
                    ot.pushTexture2d(Object.assign(Object.assign({}, Et), { stream: Nt, timestamp: O }));
                    break;
                  case "detections":
                    $t = Et, $t.stream = Nt, $t.timestamp = O, ot.pushDetectionList($t);
                    break;
                  default:
                    throw Error("Unknown input config type: '" + Rt.type + "'");
                }
              }
            return k.i.send(ot), P(Jt, k.C, 4);
          case 4:
            ot.delete(), Jt.g = 0;
        }
      });
    });
  };
  function wn(p, W, V) {
    return se(p, function k() {
      var O, ot, z, rt, bt, Rt, Et = this, Nt, $t, Jt, wt, Ut, Dt, ae, pe;
      return ne(k, function(ye) {
        switch (ye.g) {
          case 1:
            if (!V)
              return ye.return(W);
            for (O = {}, ot = 0, z = T(Object.keys(V)), rt = z.next(); !rt.done; rt = z.next())
              bt = rt.value, Rt = V[bt], typeof Rt != "string" && Rt.type === "texture" && W[Rt.stream] !== void 0 && ++ot;
            1 < ot && (Et.G = !1), Nt = T(Object.keys(V)), rt = Nt.next();
          case 2:
            if (rt.done) {
              ye.g = 4;
              break;
            }
            if ($t = rt.value, Jt = V[$t], typeof Jt == "string")
              return ae = O, pe = $t, P(ye, Pn(Et, $t, W[Jt]), 14);
            if (wt = W[Jt.stream], Jt.type === "detection_list") {
              if (wt) {
                for (var Je = wt.getRectList(), h = wt.getLandmarksList(), y = wt.getClassificationsList(), v = [], L = 0; L < Je.size(); ++L) {
                  var M = Je.get(L);
                  t: {
                    var _ = new Ce();
                    for (M = new Le(M); At(M); )
                      switch (M.i) {
                        case 13:
                          var A = ln(M.g);
                          Pt(_, 1, A);
                          break;
                        case 21:
                          A = ln(M.g), Pt(_, 2, A);
                          break;
                        case 29:
                          A = ln(M.g), Pt(_, 3, A);
                          break;
                        case 37:
                          A = ln(M.g), Pt(_, 4, A);
                          break;
                        case 45:
                          A = ln(M.g), Pt(_, 5, A);
                          break;
                        case 48:
                          for (var q = M.g, lt = 128, s = 0, G = A = 0; 4 > G && 128 <= lt; G++)
                            lt = q.h[q.g++], s |= (lt & 127) << 7 * G;
                          if (128 <= lt && (lt = q.h[q.g++], s |= (lt & 127) << 28, A |= (lt & 127) >> 4), 128 <= lt)
                            for (G = 0; 5 > G && 128 <= lt; G++)
                              lt = q.h[q.g++], A |= (lt & 127) << 7 * G + 3;
                          128 > lt ? (q = s >>> 0, lt = A >>> 0, (A = lt & 2147483648) && (q = ~q + 1 >>> 0, lt = ~lt >>> 0, q == 0 && (lt = lt + 1 >>> 0)), q = 4294967296 * lt + (q >>> 0), A = A ? -q : q) : (q.l = !0, A = void 0), Pt(_, 6, A);
                          break;
                        default:
                          if (!te(_, M))
                            break t;
                      }
                  }
                  _ = { Z: qt(_, 1), $: qt(_, 2), height: qt(_, 3), width: qt(_, 4), rotation: qt(_, 5, 0), X: Vt(_, 6) }, A = h.get(L);
                  t:
                    for (M = new St(), A = new Le(A); At(A); )
                      switch (A.i) {
                        case 10:
                          q = zt(A, new de(), ue), fe(M, q, de, void 0);
                          break;
                        default:
                          if (!te(M, A))
                            break t;
                      }
                  M = hn(M, de).map(fn), q = y.get(L);
                  t:
                    for (A = new ct(), q = new Le(q); At(q); )
                      switch (q.i) {
                        case 10:
                          A.addClassification(zt(
                            q,
                            new tt(),
                            it
                          ));
                          break;
                        default:
                          if (!te(A, q))
                            break t;
                      }
                  _ = { T: _, O: M, M: en(A) }, v.push(_);
                }
                Je = v;
              } else
                Je = [];
              O[$t] = Je, ye.g = 7;
              break;
            }
            if (Jt.type === "proto_list") {
              if (wt) {
                for (Je = Array(wt.size()), h = 0; h < wt.size(); h++)
                  Je[h] = wt.get(h);
                wt.delete();
              } else
                Je = [];
              O[$t] = Je, ye.g = 7;
              break;
            }
            if (wt === void 0) {
              ye.g = 3;
              break;
            }
            if (Jt.type === "float_list") {
              O[$t] = wt, ye.g = 7;
              break;
            }
            if (Jt.type === "proto") {
              O[$t] = wt, ye.g = 7;
              break;
            }
            if (Jt.type !== "texture")
              throw Error("Unknown output config type: '" + Jt.type + "'");
            return Ut = Et.s[$t], Ut || (Ut = new pn(Et.h, Et.D), Et.s[$t] = Ut), P(ye, He(Ut, wt, Et.G), 13);
          case 13:
            Dt = ye.h, O[$t] = Dt;
          case 7:
            Jt.transform && O[$t] && (O[$t] = Jt.transform(O[$t])), ye.g = 3;
            break;
          case 14:
            ae[pe] = ye.h;
          case 3:
            rt = Nt.next(), ye.g = 2;
            break;
          case 4:
            return ye.return(O);
        }
      });
    });
  }
  function Pn(p, W, V) {
    return se(p, function k() {
      var O = this, ot;
      return ne(k, function(z) {
        return typeof V == "number" || V instanceof Uint8Array || V instanceof O.h.Uint8BlobList ? z.return(V) : V instanceof O.h.Texture2dDataOut ? (ot = O.s[W], ot || (ot = new pn(O.h, O.D), O.s[W] = ot), z.return(He(ot, V, O.G))) : z.return(void 0);
      });
    });
  }
  function _n(p, W) {
    for (var V = W.name || "$", k = [].concat(B(W.wants)), O = new p.h.StringList(), ot = T(W.wants), z = ot.next(); !z.done; z = ot.next())
      O.push_back(z.value);
    ot = p.h.PacketListener.implement({ onResults: function(rt) {
      for (var bt = {}, Rt = 0; Rt < W.wants.length; ++Rt)
        bt[k[Rt]] = rt.get(Rt);
      var Et = p.listeners[V];
      Et && (p.C = wn(p, bt, W.outs).then(function(Nt) {
        Nt = Et(Nt);
        for (var $t = 0; $t < W.wants.length; ++$t) {
          var Jt = bt[k[$t]];
          typeof Jt == "object" && Jt.hasOwnProperty && Jt.hasOwnProperty("delete") && Jt.delete();
        }
        Nt && (p.C = Nt);
      }));
    } }), p.i.attachMultiListener(O, ot), O.delete();
  }
  i.onResults = function(p, W) {
    this.listeners[W || "$"] = p;
  }, Re("Solution", Un), Re("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Yn(p) {
    switch (p === void 0 && (p = 0), p) {
      case 1:
        return "selfie_segmentation_landscape.tflite";
      default:
        return "selfie_segmentation.tflite";
    }
  }
  function Hn(p) {
    var W = this;
    p = p || {}, this.g = new Un({ locateFile: p.locateFile, files: function(V) {
      return [{ simd: !0, url: "selfie_segmentation_solution_simd_wasm_bin.js" }, { simd: !1, url: "selfie_segmentation_solution_wasm_bin.js" }, { data: !0, url: Yn(V.modelSelection) }];
    }, graph: { url: "selfie_segmentation.binarypb" }, listeners: [{ wants: ["segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: {
      type: "video",
      stream: "input_frames_gpu"
    } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, modelSelection: { type: 1, graphOptionXref: {
      calculatorType: "ConstantSidePacketCalculator",
      calculatorName: "ConstantSidePacketCalculatorModelSelection",
      fieldName: "int_value"
    }, onChange: function(V) {
      return se(W, function k() {
        var O, ot, z = this, rt;
        return ne(k, function(bt) {
          return bt.g == 1 ? (O = Yn(V), ot = "third_party/mediapipe/modules/selfie_segmentation/" + O, P(bt, an(z.g, O), 2)) : (rt = bt.h, z.g.overrideFile(ot, rt), bt.return(!0));
        });
      });
    } } } });
  }
  i = Hn.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(p) {
    this.g.onResults(p);
  }, i.initialize = function() {
    return se(this, function p() {
      var W = this;
      return ne(p, function(V) {
        return P(V, W.g.initialize(), 0);
      });
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(p) {
    return se(this, function W() {
      var V = this;
      return ne(W, function(k) {
        return P(k, V.g.send(p), 0);
      });
    });
  }, i.setOptions = function(p) {
    this.g.setOptions(p);
  }, Re("SelfieSegmentation", Hn), Re("VERSION", "0.1.1632777926");
}).call(bi);
const yi = {};
(function() {
  var i;
  function r(l) {
    var Z = 0;
    return function() {
      return Z < l.length ? { done: !1, value: l[Z++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(l, Z, x) {
    return l == Array.prototype || l == Object.prototype || (l[Z] = x.value), l;
  };
  function m(l) {
    l = [typeof globalThis == "object" && globalThis, l, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var Z = 0; Z < l.length; ++Z) {
      var x = l[Z];
      if (x && x.Math == Math)
        return x;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(l, Z) {
    if (Z)
      t: {
        var x = X;
        l = l.split(".");
        for (var w = 0; w < l.length - 1; w++) {
          var J = l[w];
          if (!(J in x))
            break t;
          x = x[J];
        }
        l = l[l.length - 1], w = x[l], Z = Z(w), Z != w && Z != null && n(x, l, { configurable: !0, writable: !0, value: Z });
      }
  }
  S("Symbol", function(l) {
    function Z(o) {
      if (this instanceof Z)
        throw new TypeError("Symbol is not a constructor");
      return new x(w + (o || "") + "_" + J++, o);
    }
    function x(o, d) {
      this.g = o, n(this, "description", { configurable: !0, writable: !0, value: d });
    }
    if (l)
      return l;
    x.prototype.toString = function() {
      return this.g;
    };
    var w = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", J = 0;
    return Z;
  }), S("Symbol.iterator", function(l) {
    if (l)
      return l;
    l = Symbol("Symbol.iterator");
    for (var Z = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), x = 0; x < Z.length; x++) {
      var w = X[Z[x]];
      typeof w == "function" && typeof w.prototype[l] != "function" && n(w.prototype, l, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return l;
  });
  function C(l) {
    return l = { next: l }, l[Symbol.iterator] = function() {
      return this;
    }, l;
  }
  function T(l) {
    var Z = typeof Symbol < "u" && Symbol.iterator && l[Symbol.iterator];
    return Z ? Z.call(l) : { next: r(l) };
  }
  function B(l) {
    if (!(l instanceof Array)) {
      l = T(l);
      for (var Z, x = []; !(Z = l.next()).done; )
        x.push(Z.value);
      l = x;
    }
    return l;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(l) {
    function Z() {
    }
    return Z.prototype = l, new Z();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(l, Z) {
      if (l.__proto__ = Z, l.__proto__ !== Z)
        throw new TypeError(l + " is not extensible");
      return l;
    } : null;
  }
  var at = ut;
  function mt(l, Z) {
    if (l.prototype = nt(Z.prototype), l.prototype.constructor = l, at)
      at(l, Z);
    else
      for (var x in Z)
        if (x != "prototype")
          if (Object.defineProperties) {
            var w = Object.getOwnPropertyDescriptor(Z, x);
            w && Object.defineProperty(l, x, w);
          } else
            l[x] = Z[x];
    l.ra = Z.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.u = this.o = 0, this.j = null;
  }
  function kt(l) {
    if (l.l)
      throw new TypeError("Generator is already running");
    l.l = !0;
  }
  Bt.prototype.s = function(l) {
    this.h = l;
  };
  function ee(l, Z) {
    l.j = { fa: Z, ga: !0 }, l.g = l.o || l.u;
  }
  Bt.prototype.return = function(l) {
    this.j = { return: l }, this.g = this.u;
  };
  function P(l, Z, x) {
    return l.g = x, { value: Z };
  }
  function De(l) {
    this.g = new Bt(), this.h = l;
  }
  function je(l, Z) {
    kt(l.g);
    var x = l.g.i;
    return x ? We(l, "return" in x ? x.return : function(w) {
      return { value: w, done: !0 };
    }, Z, l.g.return) : (l.g.return(Z), jt(l));
  }
  function We(l, Z, x, w) {
    try {
      var J = Z.call(l.g.i, x);
      if (!(J instanceof Object))
        throw new TypeError("Iterator result " + J + " is not an object");
      if (!J.done)
        return l.g.l = !1, J;
      var o = J.value;
    } catch (d) {
      return l.g.i = null, ee(l.g, d), jt(l);
    }
    return l.g.i = null, w.call(l.g, o), jt(l);
  }
  function jt(l) {
    for (; l.g.g; )
      try {
        var Z = l.h(l.g);
        if (Z)
          return l.g.l = !1, { value: Z.value, done: !1 };
      } catch (x) {
        l.g.h = void 0, ee(l.g, x);
      }
    if (l.g.l = !1, l.g.j) {
      if (Z = l.g.j, l.g.j = null, Z.ga)
        throw Z.fa;
      return { value: Z.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(l) {
    this.next = function(Z) {
      return kt(l.g), l.g.i ? Z = We(l, l.g.i.next, Z, l.g.s) : (l.g.s(Z), Z = jt(l)), Z;
    }, this.throw = function(Z) {
      return kt(l.g), l.g.i ? Z = We(l, l.g.i.throw, Z, l.g.s) : (ee(l.g, Z), Z = jt(l)), Z;
    }, this.return = function(Z) {
      return je(l, Z);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(l) {
    function Z(w) {
      return l.next(w);
    }
    function x(w) {
      return l.throw(w);
    }
    return new Promise(function(w, J) {
      function o(d) {
        d.done ? w(d.value) : Promise.resolve(d.value).then(Z, x).then(o, J);
      }
      o(l.next());
    });
  }
  function gt(l) {
    return ne(new Cn(new De(l)));
  }
  S("Promise", function(l) {
    function Z(d) {
      this.h = 0, this.i = void 0, this.g = [], this.s = !1;
      var g = this.j();
      try {
        d(g.resolve, g.reject);
      } catch (e) {
        g.reject(e);
      }
    }
    function x() {
      this.g = null;
    }
    function w(d) {
      return d instanceof Z ? d : new Z(function(g) {
        g(d);
      });
    }
    if (l)
      return l;
    x.prototype.h = function(d) {
      if (this.g == null) {
        this.g = [];
        var g = this;
        this.i(function() {
          g.l();
        });
      }
      this.g.push(d);
    };
    var J = X.setTimeout;
    x.prototype.i = function(d) {
      J(d, 0);
    }, x.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var d = this.g;
        this.g = [];
        for (var g = 0; g < d.length; ++g) {
          var e = d[g];
          d[g] = null;
          try {
            e();
          } catch (u) {
            this.j(u);
          }
        }
      }
      this.g = null;
    }, x.prototype.j = function(d) {
      this.i(function() {
        throw d;
      });
    }, Z.prototype.j = function() {
      function d(u) {
        return function(f) {
          e || (e = !0, u.call(g, f));
        };
      }
      var g = this, e = !1;
      return { resolve: d(this.D), reject: d(this.l) };
    }, Z.prototype.D = function(d) {
      if (d === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (d instanceof Z)
        this.H(d);
      else {
        t:
          switch (typeof d) {
            case "object":
              var g = d != null;
              break t;
            case "function":
              g = !0;
              break t;
            default:
              g = !1;
          }
        g ? this.A(d) : this.o(d);
      }
    }, Z.prototype.A = function(d) {
      var g = void 0;
      try {
        g = d.then;
      } catch (e) {
        this.l(e);
        return;
      }
      typeof g == "function" ? this.I(g, d) : this.o(d);
    }, Z.prototype.l = function(d) {
      this.u(2, d);
    }, Z.prototype.o = function(d) {
      this.u(1, d);
    }, Z.prototype.u = function(d, g) {
      if (this.h != 0)
        throw Error("Cannot settle(" + d + ", " + g + "): Promise already settled in state" + this.h);
      this.h = d, this.i = g, this.h === 2 && this.G(), this.B();
    }, Z.prototype.G = function() {
      var d = this;
      J(function() {
        if (d.C()) {
          var g = X.console;
          typeof g < "u" && g.error(d.i);
        }
      }, 1);
    }, Z.prototype.C = function() {
      if (this.s)
        return !1;
      var d = X.CustomEvent, g = X.Event, e = X.dispatchEvent;
      return typeof e > "u" ? !0 : (typeof d == "function" ? d = new d("unhandledrejection", { cancelable: !0 }) : typeof g == "function" ? d = new g("unhandledrejection", { cancelable: !0 }) : (d = X.document.createEvent("CustomEvent"), d.initCustomEvent("unhandledrejection", !1, !0, d)), d.promise = this, d.reason = this.i, e(d));
    }, Z.prototype.B = function() {
      if (this.g != null) {
        for (var d = 0; d < this.g.length; ++d)
          o.h(this.g[d]);
        this.g = null;
      }
    };
    var o = new x();
    return Z.prototype.H = function(d) {
      var g = this.j();
      d.M(g.resolve, g.reject);
    }, Z.prototype.I = function(d, g) {
      var e = this.j();
      try {
        d.call(g, e.resolve, e.reject);
      } catch (u) {
        e.reject(u);
      }
    }, Z.prototype.then = function(d, g) {
      function e(c, a) {
        return typeof c == "function" ? function(b) {
          try {
            u(c(b));
          } catch (I) {
            f(I);
          }
        } : a;
      }
      var u, f, t = new Z(function(c, a) {
        u = c, f = a;
      });
      return this.M(e(d, u), e(g, f)), t;
    }, Z.prototype.catch = function(d) {
      return this.then(void 0, d);
    }, Z.prototype.M = function(d, g) {
      function e() {
        switch (u.h) {
          case 1:
            d(u.i);
            break;
          case 2:
            g(u.i);
            break;
          default:
            throw Error("Unexpected state: " + u.h);
        }
      }
      var u = this;
      this.g == null ? o.h(e) : this.g.push(e), this.s = !0;
    }, Z.resolve = w, Z.reject = function(d) {
      return new Z(function(g, e) {
        e(d);
      });
    }, Z.race = function(d) {
      return new Z(function(g, e) {
        for (var u = T(d), f = u.next(); !f.done; f = u.next())
          w(f.value).M(g, e);
      });
    }, Z.all = function(d) {
      var g = T(d), e = g.next();
      return e.done ? w([]) : new Z(function(u, f) {
        function t(b) {
          return function(I) {
            c[b] = I, a--, a == 0 && u(c);
          };
        }
        var c = [], a = 0;
        do
          c.push(void 0), a++, w(e.value).M(t(c.length - 1), f), e = g.next();
        while (!e.done);
      });
    }, Z;
  });
  function $e(l, Z) {
    l instanceof String && (l += "");
    var x = 0, w = !1, J = { next: function() {
      if (!w && x < l.length) {
        var o = x++;
        return { value: Z(o, l[o]), done: !1 };
      }
      return w = !0, { done: !0, value: void 0 };
    } };
    return J[Symbol.iterator] = function() {
      return J;
    }, J;
  }
  var An = typeof Object.assign == "function" ? Object.assign : function(l, Z) {
    for (var x = 1; x < arguments.length; x++) {
      var w = arguments[x];
      if (w)
        for (var J in w)
          Object.prototype.hasOwnProperty.call(w, J) && (l[J] = w[J]);
    }
    return l;
  };
  S("Object.assign", function(l) {
    return l || An;
  }), S("Object.is", function(l) {
    return l || function(Z, x) {
      return Z === x ? Z !== 0 || 1 / Z === 1 / x : Z !== Z && x !== x;
    };
  }), S("Array.prototype.includes", function(l) {
    return l || function(Z, x) {
      var w = this;
      w instanceof String && (w = String(w));
      var J = w.length;
      for (x = x || 0, 0 > x && (x = Math.max(x + J, 0)); x < J; x++) {
        var o = w[x];
        if (o === Z || Object.is(o, Z))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(l) {
    return l || function(Z, x) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (Z instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(Z, x || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(l) {
    return l || function() {
      return $e(this, function(Z) {
        return Z;
      });
    };
  });
  var Re = this || self;
  function Ct(l, Z) {
    l = l.split(".");
    var x = Re;
    l[0] in x || typeof x.execScript > "u" || x.execScript("var " + l[0]);
    for (var w; l.length && (w = l.shift()); )
      l.length || Z === void 0 ? x[w] && x[w] !== Object.prototype[w] ? x = x[w] : x = x[w] = {} : x[w] = Z;
  }
  function we() {
    throw Error("Invalid UTF8");
  }
  function sn(l, Z) {
    return Z = String.fromCharCode.apply(null, Z), l == null ? Z : l + Z;
  }
  var vn, Tn = typeof TextDecoder < "u", Rn, Nn = typeof TextEncoder < "u", dn = {}, mn = null;
  function kn(l) {
    var Z;
    Z === void 0 && (Z = 0), Me(), Z = dn[Z];
    for (var x = Array(Math.floor(l.length / 3)), w = Z[64] || "", J = 0, o = 0; J < l.length - 2; J += 3) {
      var d = l[J], g = l[J + 1], e = l[J + 2], u = Z[d >> 2];
      d = Z[(d & 3) << 4 | g >> 4], g = Z[(g & 15) << 2 | e >> 6], e = Z[e & 63], x[o++] = u + d + g + e;
    }
    switch (u = 0, e = w, l.length - J) {
      case 2:
        u = l[J + 1], e = Z[(u & 15) << 2] || w;
      case 1:
        l = l[J], x[o] = Z[l >> 2] + Z[(l & 3) << 4 | u >> 4] + e + w;
    }
    return x.join("");
  }
  function Fn(l) {
    var Z = l.length, x = 3 * Z / 4;
    x % 3 ? x = Math.floor(x) : "=.".indexOf(l[Z - 1]) != -1 && (x = "=.".indexOf(l[Z - 2]) != -1 ? x - 2 : x - 1);
    var w = new Uint8Array(x), J = 0;
    return ze(l, function(o) {
      w[J++] = o;
    }), J !== x ? w.subarray(0, J) : w;
  }
  function ze(l, Z) {
    function x(e) {
      for (; w < l.length; ) {
        var u = l.charAt(w++), f = mn[u];
        if (f != null)
          return f;
        if (!/^[\s\xa0]*$/.test(u))
          throw Error("Unknown base64 encoding at char: " + u);
      }
      return e;
    }
    Me();
    for (var w = 0; ; ) {
      var J = x(-1), o = x(0), d = x(64), g = x(64);
      if (g === 64 && J === -1)
        break;
      Z(J << 2 | o >> 4), d != 64 && (Z(o << 4 & 240 | d >> 2), g != 64 && Z(d << 6 & 192 | g));
    }
  }
  function Me() {
    if (!mn) {
      mn = {};
      for (var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), Z = ["+/=", "+/", "-_=", "-_.", "-_"], x = 0; 5 > x; x++) {
        var w = l.concat(Z[x].split(""));
        dn[x] = w;
        for (var J = 0; J < w.length; J++) {
          var o = w[J];
          mn[o] === void 0 && (mn[o] = J);
        }
      }
    }
  }
  var xn = typeof Uint8Array == "function";
  function Gn(l) {
    return xn && l != null && l instanceof Uint8Array;
  }
  var he;
  function Se(l) {
    if (this.L = l, l !== null && l.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var Oe = typeof Uint8Array.prototype.slice == "function", re = 0, Ve = 0;
  function ln(l, Z) {
    if (l.constructor === Uint8Array)
      return l;
    if (l.constructor === ArrayBuffer)
      return new Uint8Array(l);
    if (l.constructor === Array)
      return new Uint8Array(l);
    if (l.constructor === String)
      return Fn(l);
    if (l.constructor === Se)
      return !Z && (Z = l.L) && Z.constructor === Uint8Array ? Z : (Z = l.L, Z = Z == null || Gn(Z) ? Z : typeof Z == "string" ? Fn(Z) : null, (l = l.L = Z) ? new Uint8Array(l) : he || (he = new Uint8Array(0)));
    if (l instanceof Uint8Array)
      return new Uint8Array(l.buffer, l.byteOffset, l.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ee(l, Z) {
    return Error("Invalid wire type: " + l + " (at position " + Z + ")");
  }
  function Qt() {
    return Error("Failed to read varint, encoding is invalid.");
  }
  function Ze(l, Z) {
    Z = Z === void 0 ? {} : Z, Z = Z.v === void 0 ? !1 : Z.v, this.h = null, this.g = this.i = this.j = 0, this.v = Z, l && Le(this, l);
  }
  function Le(l, Z) {
    l.h = ln(Z, l.v), l.j = 0, l.i = l.h.length, l.g = l.j;
  }
  Ze.prototype.reset = function() {
    this.g = this.j;
  };
  function At(l) {
    if (l.g > l.i)
      throw Error("Tried to read past the end of the data " + l.g + " > " + l.i);
  }
  function xe(l) {
    var Z = l.h, x = Z[l.g], w = x & 127;
    if (128 > x)
      return l.g += 1, At(l), w;
    if (x = Z[l.g + 1], w |= (x & 127) << 7, 128 > x)
      return l.g += 2, At(l), w;
    if (x = Z[l.g + 2], w |= (x & 127) << 14, 128 > x)
      return l.g += 3, At(l), w;
    if (x = Z[l.g + 3], w |= (x & 127) << 21, 128 > x)
      return l.g += 4, At(l), w;
    if (x = Z[l.g + 4], l.g += 5, w |= (x & 15) << 28, 128 > x)
      return At(l), w;
    if (128 <= Z[l.g++] && 128 <= Z[l.g++] && 128 <= Z[l.g++] && 128 <= Z[l.g++] && 128 <= Z[l.g++])
      throw Qt();
    return At(l), w;
  }
  var zt = [];
  function be() {
    this.g = [];
  }
  be.prototype.length = function() {
    return this.g.length;
  }, be.prototype.end = function() {
    var l = this.g;
    return this.g = [], l;
  };
  function Ye(l, Z) {
    for (; 127 < Z; )
      l.g.push(Z & 127 | 128), Z >>>= 7;
    l.g.push(Z);
  }
  function qe(l) {
    var Z = {}, x = Z.W === void 0 ? !1 : Z.W;
    this.l = { v: Z.v === void 0 ? !1 : Z.v }, this.W = x, Z = this.l, zt.length ? (x = zt.pop(), Z && (x.v = Z.v), l && Le(x, l), l = x) : l = new Ze(l, Z), this.g = l, this.j = this.g.g, this.h = this.i = -1;
  }
  qe.prototype.reset = function() {
    this.g.reset(), this.j = this.g.g, this.h = this.i = -1;
  };
  function Xe(l) {
    var Z = l.g;
    if (Z.g == Z.i)
      return !1;
    l.j = l.g.g;
    var x = xe(l.g) >>> 0;
    if (Z = x >>> 3, x &= 7, !(0 <= x && 5 >= x))
      throw Ee(x, l.j);
    if (1 > Z)
      throw Error("Invalid field number: " + Z + " (at position " + l.j + ")");
    return l.i = Z, l.h = x, !0;
  }
  function Ot(l) {
    switch (l.h) {
      case 0:
        if (l.h != 0)
          Ot(l);
        else
          t: {
            l = l.g;
            for (var Z = l.g, x = Z + 10; Z < x; )
              if ((l.h[Z++] & 128) === 0) {
                l.g = Z, At(l);
                break t;
              }
            throw Qt();
          }
        break;
      case 1:
        l = l.g, l.g += 8, At(l);
        break;
      case 2:
        l.h != 2 ? Ot(l) : (Z = xe(l.g) >>> 0, l = l.g, l.g += Z, At(l));
        break;
      case 5:
        l = l.g, l.g += 4, At(l);
        break;
      case 3:
        Z = l.i;
        do {
          if (!Xe(l))
            throw Error("Unmatched start-group tag: stream EOF");
          if (l.h == 4) {
            if (l.i != Z)
              throw Error("Unmatched end-group tag");
            break;
          }
          Ot(l);
        } while (1);
        break;
      default:
        throw Ee(l.h, l.j);
    }
  }
  var Ae = [];
  function Pe() {
    this.i = [], this.h = 0, this.g = new be();
  }
  function Ie(l, Z) {
    Z.length !== 0 && (l.i.push(Z), l.h += Z.length);
  }
  function Xn(l, Z) {
    if (Z = Z.ca) {
      Ie(l, l.g.end());
      for (var x = 0; x < Z.length; x++)
        Ie(l, Z[x]);
    }
  }
  var cn = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
  function _e(l, Z) {
    Object.isFrozen(l) || (cn ? l[cn] |= Z : l.N !== void 0 ? l.N |= Z : Object.defineProperties(l, { N: { value: Z, configurable: !0, writable: !0, enumerable: !1 } }));
  }
  function un(l) {
    var Z;
    return cn ? Z = l[cn] : Z = l.N, Z == null ? 0 : Z;
  }
  function ve(l) {
    return _e(l, 1), l;
  }
  function Te(l) {
    return Array.isArray(l) ? !!(un(l) & 2) : !1;
  }
  function Ge(l) {
    if (!Array.isArray(l))
      throw Error("cannot mark non-array as immutable");
    _e(l, 2);
  }
  function ie(l) {
    return l !== null && typeof l == "object" && !Array.isArray(l) && l.constructor === Object;
  }
  var Qe = Object.freeze(ve([]));
  function qt(l) {
    if (Te(l.m))
      throw Error("Cannot mutate an immutable Message");
  }
  var Pt = typeof Symbol < "u" && typeof Symbol.hasInstance < "u";
  function hn(l) {
    return { value: l, configurable: !1, writable: !1, enumerable: !1 };
  }
  function fe(l, Z, x) {
    return Z === -1 ? null : Z >= l.i ? l.g ? l.g[Z] : void 0 : (x === void 0 ? 0 : x) && l.g && (x = l.g[Z], x != null) ? x : l.m[Z + l.h];
  }
  function Lt(l, Z, x, w) {
    w = w === void 0 ? !1 : w, qt(l), Z < l.i && !w ? l.m[Z + l.h] = x : (l.g || (l.g = l.m[l.i + l.h] = {}))[Z] = x;
  }
  function Vt(l, Z, x, w) {
    x = x === void 0 ? !0 : x, w = w === void 0 ? !1 : w;
    var J = fe(l, Z, w);
    return J == null && (J = Qe), Te(l.m) ? x && (Ge(J), Object.freeze(J)) : (J === Qe || Te(J)) && (J = ve(J.slice()), Lt(l, Z, J, w)), J;
  }
  function oe(l, Z, x) {
    return l = fe(l, Z), l = l == null ? l : +l, l == null ? x === void 0 ? 0 : x : l;
  }
  function Fe(l, Z, x, w) {
    l.j || (l.j = {});
    var J = Te(l.m), o = l.j[x];
    if (!o) {
      w = Vt(l, x, !0, w === void 0 ? !1 : w), o = [], J = J || Te(w);
      for (var d = 0; d < w.length; d++)
        o[d] = new Z(w[d]), J && Ge(o[d].m);
      J && (Ge(o), Object.freeze(o)), l.j[x] = o;
    }
    return o;
  }
  function te(l, Z, x, w, J) {
    var o = o === void 0 ? !1 : o;
    return qt(l), o = Fe(l, x, Z, o), x = w || new x(), l = Vt(l, Z), J != null ? (o.splice(J, 0, x), l.splice(J, 0, x.m)) : (o.push(x), l.push(x.m)), x;
  }
  function se(l, Z) {
    return l = fe(l, Z), l == null ? 0 : l;
  }
  function tt(l, Z) {
    return l = fe(l, Z), l == null ? "" : l;
  }
  function it(l) {
    switch (typeof l) {
      case "number":
        return isFinite(l) ? l : String(l);
      case "object":
        if (l && !Array.isArray(l)) {
          if (Gn(l))
            return kn(l);
          if (l instanceof Se) {
            var Z = l.L;
            return Z = Z == null || typeof Z == "string" ? Z : xn && Z instanceof Uint8Array ? kn(Z) : null, (l.L = Z) || "";
          }
        }
    }
    return l;
  }
  function ct(l) {
    var Z = ue;
    return Z = Z === void 0 ? St : Z, de(l, Z);
  }
  function _t(l, Z) {
    if (l != null) {
      if (Array.isArray(l))
        l = de(l, Z);
      else if (ie(l)) {
        var x = {}, w;
        for (w in l)
          x[w] = _t(l[w], Z);
        l = x;
      } else
        l = Z(l);
      return l;
    }
  }
  function de(l, Z) {
    for (var x = l.slice(), w = 0; w < x.length; w++)
      x[w] = _t(x[w], Z);
    return Array.isArray(l) && un(l) & 1 && ve(x), x;
  }
  function ue(l) {
    return l && typeof l == "object" && l.toJSON ? l.toJSON() : (l = it(l), Array.isArray(l) ? ct(l) : l);
  }
  function St(l) {
    return Gn(l) ? new Uint8Array(l) : l;
  }
  function me(l, Z, x) {
    l || (l = Ce), Ce = null;
    var w = this.constructor.h;
    l || (l = w ? [w] : []), this.h = (w ? 0 : -1) - (this.constructor.g || 0), this.j = void 0, this.m = l;
    t: {
      if (w = this.m.length, l = w - 1, w && (w = this.m[l], ie(w))) {
        this.i = l - this.h, this.g = w;
        break t;
      }
      Z !== void 0 && -1 < Z ? (this.i = Math.max(Z, l + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
    }
    if (x)
      for (Z = 0; Z < x.length; Z++)
        if (l = x[Z], l < this.i)
          l += this.h, (w = this.m[l]) ? Array.isArray(w) && ve(w) : this.m[l] = Qe;
        else {
          w = this.g || (this.g = this.m[this.i + this.h] = {});
          var J = w[l];
          J ? Array.isArray(J) && ve(J) : w[l] = Qe;
        }
  }
  me.prototype.toJSON = function() {
    return ct(this.m);
  }, me.prototype.toString = function() {
    return this.m.toString();
  };
  var Ce;
  function tn() {
    me.apply(this, arguments);
  }
  if (mt(tn, me), Pt) {
    var en = {};
    Object.defineProperties(tn, (en[Symbol.hasInstance] = hn(function() {
      throw Error("Cannot perform instanceof checks for MutableMessage");
    }), en));
  }
  function fn(l, Z, x) {
    if (x) {
      var w = {}, J;
      for (J in x) {
        var o = x[J], d = o.ja;
        d || (w.F = o.pa || o.ha.P, o.ba ? (w.U = In(o.ba), d = function(g) {
          return function(e, u, f) {
            return g.F(e, u, f, g.U);
          };
        }(w)) : o.da ? (w.T = Be(o.X.g, o.da), d = function(g) {
          return function(e, u, f) {
            return g.F(e, u, f, g.T);
          };
        }(w)) : d = w.F, o.ja = d), d(Z, l, o.X), w = { F: w.F, U: w.U, T: w.T };
      }
    }
    Xn(Z, l);
  }
  var pn = Symbol();
  function He(l, Z, x) {
    return l[pn] || (l[pn] = function(w, J) {
      return Z(w, J, x);
    });
  }
  function nn(l) {
    var Z = l[pn];
    if (!Z) {
      var x = p(l);
      Z = function(w, J) {
        return W(w, J, x);
      }, l[pn] = Z;
    }
    return Z;
  }
  function Kn(l) {
    var Z = l.ba;
    if (Z)
      return nn(Z);
    if (Z = l.oa)
      return He(l.X.g, Z, l.da);
  }
  function rn(l) {
    var Z = Kn(l), x = l.X, w = l.ha.O;
    return Z ? function(J, o) {
      return w(J, o, x, Z);
    } : function(J, o) {
      return w(J, o, x);
    };
  }
  function Ne(l, Z, x, w, J, o) {
    l = l();
    var d = 0;
    for (l.length && typeof l[0] != "number" && (x(Z, l[0]), d++); d < l.length; ) {
      x = l[d++];
      for (var g = d + 1; g < l.length && typeof l[g] != "number"; )
        g++;
      var e = l[d++];
      switch (g -= d, g) {
        case 0:
          w(Z, x, e);
          break;
        case 1:
          w(Z, x, e, l[d++]);
          break;
        case 2:
          J(Z, x, e, l[d++], l[d++]);
          break;
        case 3:
          g = l[d++];
          var u = l[d++], f = l[d++];
          Array.isArray(f) ? J(Z, x, e, g, u, f) : o(Z, x, e, g, u, f);
          break;
        case 4:
          o(Z, x, e, l[d++], l[d++], l[d++], l[d++]);
          break;
        default:
          throw Error("unexpected number of binary field arguments: " + g);
      }
    }
    return Z;
  }
  var yn = Symbol();
  function In(l) {
    var Z = l[yn];
    if (!Z) {
      var x = an(l);
      Z = function(w, J) {
        return k(w, J, x);
      }, l[yn] = Z;
    }
    return Z;
  }
  function Be(l, Z) {
    var x = l[yn];
    return x || (x = function(w, J) {
      return fn(w, J, Z);
    }, l[yn] = x), x;
  }
  var Un = Symbol();
  function on(l, Z) {
    l.push(Z);
  }
  function gn(l, Z, x) {
    l.push(Z, x.P);
  }
  function Sn(l, Z, x, w, J) {
    var o = In(J), d = x.P;
    l.push(Z, function(g, e, u) {
      return d(g, e, u, w, o);
    });
  }
  function En(l, Z, x, w, J, o) {
    var d = Be(w, o), g = x.P;
    l.push(Z, function(e, u, f) {
      return g(e, u, f, w, d);
    });
  }
  function an(l) {
    var Z = l[Un];
    return Z || Ne(l, l[Un] = [], on, gn, Sn, En);
  }
  var wn = Symbol();
  function Pn(l, Z) {
    l[0] = Z;
  }
  function _n(l, Z, x, w) {
    var J = x.O;
    l[Z] = w ? function(o, d, g) {
      return J(o, d, g, w);
    } : J;
  }
  function Yn(l, Z, x, w, J, o) {
    var d = x.O, g = nn(J);
    l[Z] = function(e, u, f) {
      return d(e, u, f, w, g, o);
    };
  }
  function Hn(l, Z, x, w, J, o, d) {
    var g = x.O, e = He(w, J, o);
    l[Z] = function(u, f, t) {
      return g(u, f, t, w, e, d);
    };
  }
  function p(l) {
    var Z = l[wn];
    return Z || Ne(l, l[wn] = {}, Pn, _n, Yn, Hn);
  }
  function W(l, Z, x) {
    for (; Xe(Z) && Z.h != 4; ) {
      var w = Z.i, J = x[w];
      if (!J) {
        var o = x[0];
        o && (o = o[w]) && (J = x[w] = rn(o));
      }
      if ((!J || !J(Z, l, w)) && (J = Z, w = l, o = J.j, Ot(J), !J.W)) {
        var d = J.g.h;
        J = J.g.g, J = o === J ? he || (he = new Uint8Array(0)) : Oe ? d.slice(o, J) : new Uint8Array(d.subarray(o, J)), (o = w.ca) ? o.push(J) : w.ca = [J];
      }
    }
    return l;
  }
  function V(l, Z, x) {
    if (Ae.length) {
      var w = Ae.pop();
      l && (Le(w.g, l), w.i = -1, w.h = -1), l = w;
    } else
      l = new qe(l);
    try {
      return W(new Z(), l, p(x));
    } finally {
      Z = l.g, Z.h = null, Z.j = 0, Z.i = 0, Z.g = 0, Z.v = !1, l.i = -1, l.h = -1, 100 > Ae.length && Ae.push(l);
    }
  }
  function k(l, Z, x) {
    for (var w = x.length, J = w % 2 == 1, o = J ? 1 : 0; o < w; o += 2)
      (0, x[o + 1])(Z, l, x[o]);
    fn(l, Z, J ? x[0] : void 0);
  }
  function O(l, Z) {
    var x = new Pe();
    k(l, x, an(Z)), Ie(x, x.g.end()), l = new Uint8Array(x.h), Z = x.i;
    for (var w = Z.length, J = 0, o = 0; o < w; o++) {
      var d = Z[o];
      l.set(d, J), J += d.length;
    }
    return x.i = [l], l;
  }
  function ot(l, Z) {
    return { O: l, P: Z };
  }
  var z = ot(function(l, Z, x) {
    if (l.h !== 5)
      return !1;
    l = l.g;
    var w = l.h[l.g], J = l.h[l.g + 1], o = l.h[l.g + 2], d = l.h[l.g + 3];
    return l.g += 4, At(l), J = (w << 0 | J << 8 | o << 16 | d << 24) >>> 0, l = 2 * (J >> 31) + 1, w = J >>> 23 & 255, J &= 8388607, Lt(Z, x, w == 255 ? J ? NaN : 1 / 0 * l : w == 0 ? l * Math.pow(2, -149) * J : l * Math.pow(2, w - 150) * (J + Math.pow(2, 23))), !0;
  }, function(l, Z, x) {
    if (Z = fe(Z, x), Z != null) {
      Ye(l.g, 8 * x + 5), l = l.g;
      var w = Z;
      w = (x = 0 > w ? 1 : 0) ? -w : w, w === 0 ? 0 < 1 / w ? re = Ve = 0 : (Ve = 0, re = 2147483648) : isNaN(w) ? (Ve = 0, re = 2147483647) : 34028234663852886e22 < w ? (Ve = 0, re = (x << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > w ? (w = Math.round(w / Math.pow(2, -149)), Ve = 0, re = (x << 31 | w) >>> 0) : (Z = Math.floor(Math.log(w) / Math.LN2), w *= Math.pow(2, -Z), w = Math.round(8388608 * w), 16777216 <= w && ++Z, Ve = 0, re = (x << 31 | Z + 127 << 23 | w & 8388607) >>> 0), x = re, l.g.push(x >>> 0 & 255), l.g.push(x >>> 8 & 255), l.g.push(x >>> 16 & 255), l.g.push(x >>> 24 & 255);
    }
  }), rt = ot(function(l, Z, x) {
    if (l.h !== 0)
      return !1;
    for (var w = l.g, J = 128, o = 0, d = l = 0; 4 > d && 128 <= J; d++)
      J = w.h[w.g++], At(w), o |= (J & 127) << 7 * d;
    if (128 <= J && (J = w.h[w.g++], At(w), o |= (J & 127) << 28, l |= (J & 127) >> 4), 128 <= J)
      for (d = 0; 5 > d && 128 <= J; d++)
        J = w.h[w.g++], At(w), l |= (J & 127) << 7 * d + 3;
    if (128 > J)
      w = o >>> 0, J = l >>> 0, (l = J & 2147483648) && (w = ~w + 1 >>> 0, J = ~J >>> 0, w == 0 && (J = J + 1 >>> 0)), w = 4294967296 * J + (w >>> 0);
    else
      throw Qt();
    return Lt(Z, x, l ? -w : w), !0;
  }, function(l, Z, x) {
    if (Z = fe(Z, x), Z != null && Z != null) {
      Ye(l.g, 8 * x), l = l.g;
      var w = Z;
      for (x = 0 > w, w = Math.abs(w), Z = w >>> 0, w = Math.floor((w - Z) / 4294967296), w >>>= 0, x && (w = ~w >>> 0, Z = (~Z >>> 0) + 1, 4294967295 < Z && (Z = 0, w++, 4294967295 < w && (w = 0))), re = Z, Ve = w, x = re, Z = Ve; 0 < Z || 127 < x; )
        l.g.push(x & 127 | 128), x = (x >>> 7 | Z << 25) >>> 0, Z >>>= 7;
      l.g.push(x);
    }
  }), bt = ot(function(l, Z, x) {
    return l.h !== 0 ? !1 : (Lt(Z, x, xe(l.g)), !0);
  }, function(l, Z, x) {
    if (Z = fe(Z, x), Z != null && Z != null)
      if (Ye(l.g, 8 * x), l = l.g, x = Z, 0 <= x)
        Ye(l, x);
      else {
        for (Z = 0; 9 > Z; Z++)
          l.g.push(x & 127 | 128), x >>= 7;
        l.g.push(1);
      }
  }), Rt = ot(function(l, Z, x) {
    if (l.h !== 2)
      return !1;
    var w = xe(l.g) >>> 0;
    l = l.g;
    var J = l.g;
    l.g += w, At(l), l = l.h;
    var o;
    if (Tn)
      (o = vn) || (o = vn = new TextDecoder("utf-8", { fatal: !0 })), o = o.decode(l.subarray(J, J + w));
    else {
      w = J + w;
      for (var d = [], g = null, e, u, f; J < w; )
        e = l[J++], 128 > e ? d.push(e) : 224 > e ? J >= w ? we() : (u = l[J++], 194 > e || (u & 192) !== 128 ? (J--, we()) : d.push((e & 31) << 6 | u & 63)) : 240 > e ? J >= w - 1 ? we() : (u = l[J++], (u & 192) !== 128 || e === 224 && 160 > u || e === 237 && 160 <= u || ((o = l[J++]) & 192) !== 128 ? (J--, we()) : d.push((e & 15) << 12 | (u & 63) << 6 | o & 63)) : 244 >= e ? J >= w - 2 ? we() : (u = l[J++], (u & 192) !== 128 || (e << 28) + (u - 144) >> 30 !== 0 || ((o = l[J++]) & 192) !== 128 || ((f = l[J++]) & 192) !== 128 ? (J--, we()) : (e = (e & 7) << 18 | (u & 63) << 12 | (o & 63) << 6 | f & 63, e -= 65536, d.push((e >> 10 & 1023) + 55296, (e & 1023) + 56320))) : we(), 8192 <= d.length && (g = sn(g, d), d.length = 0);
      o = sn(g, d);
    }
    return Lt(Z, x, o), !0;
  }, function(l, Z, x) {
    if (Z = fe(Z, x), Z != null) {
      var w = !1;
      if (w = w === void 0 ? !1 : w, Nn) {
        if (w && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(Z))
          throw Error("Found an unpaired surrogate");
        Z = (Rn || (Rn = new TextEncoder())).encode(Z);
      } else {
        for (var J = 0, o = new Uint8Array(3 * Z.length), d = 0; d < Z.length; d++) {
          var g = Z.charCodeAt(d);
          if (128 > g)
            o[J++] = g;
          else {
            if (2048 > g)
              o[J++] = g >> 6 | 192;
            else {
              if (55296 <= g && 57343 >= g) {
                if (56319 >= g && d < Z.length) {
                  var e = Z.charCodeAt(++d);
                  if (56320 <= e && 57343 >= e) {
                    g = 1024 * (g - 55296) + e - 56320 + 65536, o[J++] = g >> 18 | 240, o[J++] = g >> 12 & 63 | 128, o[J++] = g >> 6 & 63 | 128, o[J++] = g & 63 | 128;
                    continue;
                  } else
                    d--;
                }
                if (w)
                  throw Error("Found an unpaired surrogate");
                g = 65533;
              }
              o[J++] = g >> 12 | 224, o[J++] = g >> 6 & 63 | 128;
            }
            o[J++] = g & 63 | 128;
          }
        }
        Z = o.subarray(0, J);
      }
      Ye(l.g, 8 * x + 2), Ye(l.g, Z.length), Ie(l, l.g.end()), Ie(l, Z);
    }
  }), Et = ot(function(l, Z, x, w, J) {
    if (l.h !== 2)
      return !1;
    Z = te(Z, x, w), x = l.g.i, w = xe(l.g) >>> 0;
    var o = l.g.g + w, d = o - x;
    if (0 >= d && (l.g.i = o, J(Z, l), d = o - l.g.g), d)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (w + " bytes, instead read " + (w - d) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    return l.g.g = o, l.g.i = x, !0;
  }, function(l, Z, x, w, J) {
    if (Z = Fe(Z, w, x), Z != null)
      for (w = 0; w < Z.length; w++) {
        var o = l;
        Ye(o.g, 8 * x + 2);
        var d = o.g.end();
        Ie(o, d), d.push(o.h), o = d, J(Z[w], l), d = l;
        var g = o.pop();
        for (g = d.h + d.g.length() - g; 127 < g; )
          o.push(g & 127 | 128), g >>>= 7, d.h++;
        o.push(g), d.h++;
      }
  });
  function Nt() {
    tn.apply(this, arguments);
  }
  if (mt(Nt, tn), Pt) {
    var $t = {};
    Object.defineProperties(Nt, ($t[Symbol.hasInstance] = hn(Object[Symbol.hasInstance]), $t));
  }
  function Jt(l) {
    Nt.call(this, l);
  }
  mt(Jt, Nt);
  function wt() {
    return [1, bt, 2, z, 3, Rt, 4, Rt];
  }
  function Ut(l) {
    Nt.call(this, l, -1, ae);
  }
  mt(Ut, Nt), Ut.prototype.addClassification = function(l, Z) {
    return te(this, 1, Jt, l, Z), this;
  };
  function Dt() {
    return [1, Et, Jt, wt];
  }
  var ae = [1];
  function pe(l) {
    Nt.call(this, l);
  }
  mt(pe, Nt);
  function ye() {
    return [1, z, 2, z, 3, z, 4, z, 5, z];
  }
  function Je(l) {
    Nt.call(this, l, -1, y);
  }
  mt(Je, Nt);
  function h() {
    return [1, Et, pe, ye];
  }
  var y = [1];
  function v(l) {
    Nt.call(this, l);
  }
  mt(v, Nt);
  function L() {
    return [1, z, 2, z, 3, z, 4, z, 5, z, 6, rt];
  }
  function M(l, Z, x) {
    if (x = l.createShader(x === 0 ? l.VERTEX_SHADER : l.FRAGMENT_SHADER), l.shaderSource(x, Z), l.compileShader(x), !l.getShaderParameter(x, l.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + l.getShaderInfoLog(x));
    return x;
  }
  function _(l) {
    return Fe(l, Jt, 1).map(function(Z) {
      return { index: se(Z, 1), score: oe(Z, 2), label: fe(Z, 3) != null ? tt(Z, 3) : void 0, displayName: fe(Z, 4) != null ? tt(Z, 4) : void 0 };
    });
  }
  function A(l) {
    return { x: oe(l, 1), y: oe(l, 2), z: oe(l, 3), visibility: fe(l, 4) != null ? oe(l, 4) : void 0 };
  }
  function q(l) {
    return l.map(function(Z) {
      return Fe(V(Z, Je, h), pe, 1).map(A);
    });
  }
  function lt(l, Z) {
    this.h = l, this.g = Z, this.l = 0;
  }
  function s(l, Z, x) {
    return G(l, Z), typeof l.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(l.g.canvas.transferToImageBitmap()) : x ? Promise.resolve(l.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(l.g.canvas) : (l.i === void 0 && (l.i = document.createElement("canvas")), new Promise(function(w) {
      l.i.height = l.g.canvas.height, l.i.width = l.g.canvas.width, l.i.getContext("2d", {}).drawImage(l.g.canvas, 0, 0, l.g.canvas.width, l.g.canvas.height), w(l.i);
    }));
  }
  function G(l, Z) {
    var x = l.g;
    if (l.o === void 0) {
      var w = M(x, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), J = M(x, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), o = x.createProgram();
      if (x.attachShader(o, w), x.attachShader(o, J), x.linkProgram(o), !x.getProgramParameter(o, x.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + x.getProgramInfoLog(o));
      w = l.o = o, x.useProgram(w), J = x.getUniformLocation(w, "sampler0"), l.j = { K: x.getAttribLocation(w, "aVertex"), J: x.getAttribLocation(w, "aTex"), qa: J }, l.u = x.createBuffer(), x.bindBuffer(x.ARRAY_BUFFER, l.u), x.enableVertexAttribArray(l.j.K), x.vertexAttribPointer(l.j.K, 2, x.FLOAT, !1, 0, 0), x.bufferData(x.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), x.STATIC_DRAW), x.bindBuffer(x.ARRAY_BUFFER, null), l.s = x.createBuffer(), x.bindBuffer(x.ARRAY_BUFFER, l.s), x.enableVertexAttribArray(l.j.J), x.vertexAttribPointer(
        l.j.J,
        2,
        x.FLOAT,
        !1,
        0,
        0
      ), x.bufferData(x.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), x.STATIC_DRAW), x.bindBuffer(x.ARRAY_BUFFER, null), x.uniform1i(J, 0);
    }
    w = l.j, x.useProgram(l.o), x.canvas.width = Z.width, x.canvas.height = Z.height, x.viewport(0, 0, Z.width, Z.height), x.activeTexture(x.TEXTURE0), l.h.bindTexture2d(Z.glName), x.enableVertexAttribArray(w.K), x.bindBuffer(x.ARRAY_BUFFER, l.u), x.vertexAttribPointer(w.K, 2, x.FLOAT, !1, 0, 0), x.enableVertexAttribArray(w.J), x.bindBuffer(x.ARRAY_BUFFER, l.s), x.vertexAttribPointer(
      w.J,
      2,
      x.FLOAT,
      !1,
      0,
      0
    ), x.bindFramebuffer(x.DRAW_FRAMEBUFFER ? x.DRAW_FRAMEBUFFER : x.FRAMEBUFFER, null), x.clearColor(0, 0, 0, 0), x.clear(x.COLOR_BUFFER_BIT), x.colorMask(!0, !0, !0, !0), x.drawArrays(x.TRIANGLE_FAN, 0, 4), x.disableVertexAttribArray(w.K), x.disableVertexAttribArray(w.J), x.bindBuffer(x.ARRAY_BUFFER, null), l.h.bindTexture2d(0);
  }
  function R(l) {
    this.g = l;
  }
  var Y = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function N(l, Z) {
    return Z + l;
  }
  function K(l, Z) {
    window[l] = Z;
  }
  function E(l) {
    var Z = document.createElement("script");
    return Z.setAttribute("src", l), Z.setAttribute("crossorigin", "anonymous"), new Promise(function(x) {
      Z.addEventListener("load", function() {
        x();
      }, !1), Z.addEventListener("error", function() {
        x();
      }, !1), document.body.appendChild(Z);
    });
  }
  function et() {
    return gt(function(l) {
      switch (l.g) {
        case 1:
          return l.o = 2, P(l, WebAssembly.instantiate(Y), 4);
        case 4:
          l.g = 3, l.o = 0;
          break;
        case 2:
          return l.o = 0, l.j = null, l.return(!1);
        case 3:
          return l.return(!0);
      }
    });
  }
  function $(l) {
    if (this.g = l, this.listeners = {}, this.j = {}, this.H = {}, this.o = {}, this.u = {}, this.I = this.s = this.$ = !0, this.D = Promise.resolve(), this.Z = "", this.C = {}, this.locateFile = l && l.locateFile || N, typeof window == "object")
      var Z = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      Z = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.aa = Z, l.options) {
      Z = T(Object.keys(l.options));
      for (var x = Z.next(); !x.done; x = Z.next()) {
        x = x.value;
        var w = l.options[x].default;
        w !== void 0 && (this.j[x] = typeof w == "function" ? w() : w);
      }
    }
  }
  i = $.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function yt(l) {
    var Z, x, w, J, o, d, g, e, u, f, t;
    return gt(function(c) {
      switch (c.g) {
        case 1:
          return l.$ ? (Z = l.g.files === void 0 ? [] : typeof l.g.files == "function" ? l.g.files(l.j) : l.g.files, P(c, et(), 2)) : c.return();
        case 2:
          if (x = c.h, typeof window == "object")
            return K("createMediapipeSolutionsWasm", { locateFile: l.locateFile }), K("createMediapipeSolutionsPackedAssets", { locateFile: l.locateFile }), d = Z.filter(function(a) {
              return a.data !== void 0;
            }), g = Z.filter(function(a) {
              return a.data === void 0;
            }), e = Promise.all(d.map(function(a) {
              var b = xt(l, a.url);
              if (a.path !== void 0) {
                var I = a.path;
                b = b.then(function(F) {
                  return l.overrideFile(I, F), Promise.resolve(F);
                });
              }
              return b;
            })), u = Promise.all(g.map(function(a) {
              return a.simd === void 0 || a.simd && x || !a.simd && !x ? E(l.locateFile(a.url, l.aa)) : Promise.resolve();
            })).then(function() {
              var a, b, I;
              return gt(function(F) {
                if (F.g == 1)
                  return a = window.createMediapipeSolutionsWasm, b = window.createMediapipeSolutionsPackedAssets, I = l, P(F, a(b), 2);
                I.h = F.h, F.g = 0;
              });
            }), f = function() {
              return gt(function(a) {
                return l.g.graph && l.g.graph.url ? a = P(
                  a,
                  xt(l, l.g.graph.url),
                  0
                ) : (a.g = 0, a = void 0), a;
              });
            }(), P(c, Promise.all([u, e, f]), 7);
          if (typeof importScripts != "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          return w = Z.filter(function(a) {
            return a.simd === void 0 || a.simd && x || !a.simd && !x;
          }).map(function(a) {
            return l.locateFile(a.url, l.aa);
          }), importScripts.apply(null, B(w)), J = l, P(c, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          J.h = c.h, l.l = new OffscreenCanvas(1, 1), l.h.canvas = l.l, o = l.h.GL.createContext(l.l, {
            antialias: !1,
            alpha: !1,
            na: typeof WebGL2RenderingContext < "u" ? 2 : 1
          }), l.h.GL.makeContextCurrent(o), c.g = 4;
          break;
        case 7:
          if (l.l = document.createElement("canvas"), t = l.l.getContext("webgl2", {}), !t && (t = l.l.getContext("webgl", {}), !t))
            return alert("Failed to create WebGL canvas context when passing video frame."), c.return();
          l.G = t, l.h.canvas = l.l, l.h.createContext(l.l, !0, !0, {});
        case 4:
          l.i = new l.h.SolutionWasm(), l.$ = !1, c.g = 0;
      }
    });
  }
  function Xt(l) {
    var Z, x, w, J, o, d, g, e;
    return gt(function(u) {
      if (u.g == 1) {
        if (l.g.graph && l.g.graph.url && l.Z === l.g.graph.url)
          return u.return();
        if (l.s = !0, !l.g.graph || !l.g.graph.url) {
          u.g = 2;
          return;
        }
        return l.Z = l.g.graph.url, P(u, xt(l, l.g.graph.url), 3);
      }
      for (u.g != 2 && (Z = u.h, l.i.loadGraph(Z)), x = T(Object.keys(l.C)), w = x.next(); !w.done; w = x.next())
        J = w.value, l.i.overrideFile(J, l.C[J]);
      if (l.C = {}, l.g.listeners)
        for (o = T(l.g.listeners), d = o.next(); !d.done; d = o.next())
          g = d.value, It(l, g);
      e = l.j, l.j = {}, l.setOptions(e), u.g = 0;
    });
  }
  i.reset = function() {
    var l = this;
    return gt(function(Z) {
      l.i && (l.i.reset(), l.o = {}, l.u = {}), Z.g = 0;
    });
  }, i.setOptions = function(l, Z) {
    var x = this;
    if (Z = Z || this.g.options) {
      for (var w = [], J = [], o = {}, d = T(Object.keys(l)), g = d.next(); !g.done; o = { R: o.R, S: o.S }, g = d.next()) {
        var e = g.value;
        e in this.j && this.j[e] === l[e] || (this.j[e] = l[e], g = Z[e], g !== void 0 && (g.onChange && (o.R = g.onChange, o.S = l[e], w.push(function(u) {
          return function() {
            var f;
            return gt(function(t) {
              if (t.g == 1)
                return P(t, u.R(u.S), 2);
              f = t.h, f === !0 && (x.s = !0), t.g = 0;
            });
          };
        }(o))), g.graphOptionXref && (e = { valueNumber: g.type === 1 ? l[e] : 0, valueBoolean: g.type === 0 ? l[e] : !1, valueString: g.type === 2 ? l[e] : "" }, g = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), g.graphOptionXref), e), J.push(g))));
      }
      (w.length !== 0 || J.length !== 0) && (this.s = !0, this.B = (this.B === void 0 ? [] : this.B).concat(J), this.A = (this.A === void 0 ? [] : this.A).concat(w));
    }
  };
  function Mt(l) {
    var Z, x, w, J, o, d, g;
    return gt(function(e) {
      switch (e.g) {
        case 1:
          if (!l.s)
            return e.return();
          if (!l.A) {
            e.g = 2;
            break;
          }
          Z = T(l.A), x = Z.next();
        case 3:
          if (x.done) {
            e.g = 5;
            break;
          }
          return w = x.value, P(e, w(), 4);
        case 4:
          x = Z.next(), e.g = 3;
          break;
        case 5:
          l.A = void 0;
        case 2:
          if (l.B) {
            for (J = new l.h.GraphOptionChangeRequestList(), o = T(l.B), d = o.next(); !d.done; d = o.next())
              g = d.value, J.push_back(g);
            l.i.changeOptions(J), J.delete(), l.B = void 0;
          }
          l.s = !1, e.g = 0;
      }
    });
  }
  i.initialize = function() {
    var l = this;
    return gt(function(Z) {
      return Z.g == 1 ? P(Z, yt(l), 2) : Z.g != 3 ? P(Z, Xt(l), 3) : P(Z, Mt(l), 0);
    });
  };
  function xt(l, Z) {
    var x, w;
    return gt(function(J) {
      return Z in l.H ? J.return(l.H[Z]) : (x = l.locateFile(Z, ""), w = fetch(x).then(function(o) {
        return o.arrayBuffer();
      }), l.H[Z] = w, J.return(w));
    });
  }
  i.overrideFile = function(l, Z) {
    this.i ? this.i.overrideFile(l, Z) : this.C[l] = Z;
  }, i.clearOverriddenFiles = function() {
    this.C = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(l, Z) {
    var x = this, w, J, o, d, g, e, u, f, t;
    return gt(function(c) {
      switch (c.g) {
        case 1:
          return x.g.inputs ? (w = 1e3 * (Z == null ? performance.now() : Z), P(c, x.D, 2)) : c.return();
        case 2:
          return P(c, x.initialize(), 3);
        case 3:
          for (J = new x.h.PacketDataList(), o = T(Object.keys(l)), d = o.next(); !d.done; d = o.next())
            if (g = d.value, e = x.g.inputs[g]) {
              t: {
                var a = l[g];
                switch (e.type) {
                  case "video":
                    var b = x.o[e.stream];
                    if (b || (b = new lt(x.h, x.G), x.o[e.stream] = b), b.l === 0 && (b.l = b.h.createTexture()), typeof HTMLVideoElement < "u" && a instanceof HTMLVideoElement)
                      var I = a.videoWidth, F = a.videoHeight;
                    else
                      typeof HTMLImageElement < "u" && a instanceof HTMLImageElement ? (I = a.naturalWidth, F = a.naturalHeight) : (I = a.width, F = a.height);
                    F = { glName: b.l, width: I, height: F }, I = b.g, I.canvas.width = F.width, I.canvas.height = F.height, I.activeTexture(I.TEXTURE0), b.h.bindTexture2d(b.l), I.texImage2D(I.TEXTURE_2D, 0, I.RGBA, I.RGBA, I.UNSIGNED_BYTE, a), b.h.bindTexture2d(0), b = F;
                    break t;
                  case "detections":
                    for (b = x.o[e.stream], b || (b = new R(x.h), x.o[e.stream] = b), b.data || (b.data = new b.g.DetectionListData()), b.data.reset(a.length), F = 0; F < a.length; ++F) {
                      I = a[F];
                      var H = b.data, U = H.setBoundingBox, j = F, Q = I.ea, D = new v();
                      if (Lt(D, 1, Q.ka), Lt(D, 2, Q.la), Lt(D, 3, Q.height), Lt(D, 4, Q.width), Lt(D, 5, Q.rotation), Lt(D, 6, Q.ia), Q = O(D, L), U.call(H, j, Q), I.Y)
                        for (H = 0; H < I.Y.length; ++H) {
                          D = I.Y[H];
                          var st = !!D.visibility;
                          U = b.data, j = U.addNormalizedLandmark, Q = F, D = Object.assign(Object.assign({}, D), { visibility: st ? D.visibility : 0 }), st = new pe(), Lt(st, 1, D.x), Lt(st, 2, D.y), Lt(st, 3, D.z), D.visibility && Lt(
                            st,
                            4,
                            D.visibility
                          ), D = O(st, ye), j.call(U, Q, D);
                        }
                      if (I.V)
                        for (H = 0; H < I.V.length; ++H)
                          U = b.data, j = U.addClassification, Q = F, D = I.V[H], st = new Jt(), Lt(st, 2, D.score), D.index && Lt(st, 1, D.index), D.label && Lt(st, 3, D.label), D.displayName && Lt(st, 4, D.displayName), D = O(st, wt), j.call(U, Q, D);
                    }
                    b = b.data;
                    break t;
                  default:
                    b = {};
                }
              }
              switch (u = b, f = e.stream, e.type) {
                case "video":
                  J.pushTexture2d(Object.assign(Object.assign({}, u), { stream: f, timestamp: w }));
                  break;
                case "detections":
                  t = u, t.stream = f, t.timestamp = w, J.pushDetectionList(t);
                  break;
                default:
                  throw Error("Unknown input config type: '" + e.type + "'");
              }
            }
          return x.i.send(J), P(c, x.D, 4);
        case 4:
          J.delete(), c.g = 0;
      }
    });
  };
  function dt(l, Z, x) {
    var w, J, o, d, g, e, u, f, t, c, a, b, I, F;
    return gt(function(H) {
      switch (H.g) {
        case 1:
          if (!x)
            return H.return(Z);
          for (w = {}, J = 0, o = T(Object.keys(x)), d = o.next(); !d.done; d = o.next())
            g = d.value, e = x[g], typeof e != "string" && e.type === "texture" && Z[e.stream] !== void 0 && ++J;
          1 < J && (l.I = !1), u = T(Object.keys(x)), d = u.next();
        case 2:
          if (d.done) {
            H.g = 4;
            break;
          }
          if (f = d.value, t = x[f], typeof t == "string")
            return I = w, F = f, P(H, Wt(l, f, Z[t]), 14);
          if (c = Z[t.stream], t.type === "detection_list") {
            if (c) {
              for (var U = c.getRectList(), j = c.getLandmarksList(), Q = c.getClassificationsList(), D = [], st = 0; st < U.size(); ++st) {
                var ht = V(U.get(st), v, L);
                ht = { ea: { ka: oe(ht, 1), la: oe(ht, 2), height: oe(ht, 3), width: oe(ht, 4), rotation: oe(ht, 5, 0), ia: se(ht, 6) }, Y: Fe(V(j.get(st), Je, h), pe, 1).map(A), V: _(V(Q.get(st), Ut, Dt)) }, D.push(ht);
              }
              U = D;
            } else
              U = [];
            w[f] = U, H.g = 7;
            break;
          }
          if (t.type === "proto_list") {
            if (c) {
              for (U = Array(c.size()), j = 0; j < c.size(); j++)
                U[j] = c.get(j);
              c.delete();
            } else
              U = [];
            w[f] = U, H.g = 7;
            break;
          }
          if (c === void 0) {
            H.g = 3;
            break;
          }
          if (t.type === "float_list") {
            w[f] = c, H.g = 7;
            break;
          }
          if (t.type === "proto") {
            w[f] = c, H.g = 7;
            break;
          }
          if (t.type !== "texture")
            throw Error("Unknown output config type: '" + t.type + "'");
          return a = l.u[f], a || (a = new lt(l.h, l.G), l.u[f] = a), P(H, s(a, c, l.I), 13);
        case 13:
          b = H.h, w[f] = b;
        case 7:
          t.transform && w[f] && (w[f] = t.transform(w[f])), H.g = 3;
          break;
        case 14:
          I[F] = H.h;
        case 3:
          d = u.next(), H.g = 2;
          break;
        case 4:
          return H.return(w);
      }
    });
  }
  function Wt(l, Z, x) {
    var w;
    return gt(function(J) {
      return typeof x == "number" || x instanceof Uint8Array || x instanceof l.h.Uint8BlobList ? J.return(x) : x instanceof l.h.Texture2dDataOut ? (w = l.u[Z], w || (w = new lt(l.h, l.G), l.u[Z] = w), J.return(s(w, x, l.I))) : J.return(void 0);
    });
  }
  function It(l, Z) {
    for (var x = Z.name || "$", w = [].concat(B(Z.wants)), J = new l.h.StringList(), o = T(Z.wants), d = o.next(); !d.done; d = o.next())
      J.push_back(d.value);
    o = l.h.PacketListener.implement({ onResults: function(g) {
      for (var e = {}, u = 0; u < Z.wants.length; ++u)
        e[w[u]] = g.get(u);
      var f = l.listeners[x];
      f && (l.D = dt(l, e, Z.outs).then(function(t) {
        t = f(t);
        for (var c = 0; c < Z.wants.length; ++c) {
          var a = e[w[c]];
          typeof a == "object" && a.hasOwnProperty && a.hasOwnProperty("delete") && a.delete();
        }
        t && (l.D = t);
      }));
    } }), l.i.attachMultiListener(J, o), J.delete();
  }
  i.onResults = function(l, Z) {
    this.listeners[Z || "$"] = l;
  }, Ct("Solution", $), Ct("OptionType", { BOOL: 0, NUMBER: 1, ma: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Yt(l) {
    return l === void 0 && (l = 0), l === 1 ? "hand_landmark_full.tflite" : "hand_landmark_lite.tflite";
  }
  function Ft(l) {
    var Z = this;
    l = l || {}, this.g = new $({ locateFile: l.locateFile, files: function(x) {
      return [{ url: "hands_solution_packed_assets_loader.js" }, { simd: !1, url: "hands_solution_wasm_bin.js" }, { simd: !0, url: "hands_solution_simd_wasm_bin.js" }, { data: !0, url: Yt(x.modelComplexity) }];
    }, graph: { url: "hands.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["multi_hand_landmarks", "multi_hand_world_landmarks", "image_transformed", "multi_handedness"], outs: {
      image: "image_transformed",
      multiHandLandmarks: { type: "proto_list", stream: "multi_hand_landmarks", transform: q },
      multiHandWorldLandmarks: { type: "proto_list", stream: "multi_hand_world_landmarks", transform: q },
      multiHandedness: { type: "proto_list", stream: "multi_handedness", transform: function(x) {
        return x.map(function(w) {
          return _(V(w, Ut, Dt))[0];
        });
      } }
    } }], options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumHands: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculator", fieldName: "int_value" } }, modelComplexity: {
      type: 1,
      graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" },
      onChange: function(x) {
        var w, J, o;
        return gt(function(d) {
          return d.g == 1 ? (w = Yt(x), J = "third_party/mediapipe/modules/hand_landmark/" + w, P(d, xt(Z.g, w), 2)) : (o = d.h, Z.g.overrideFile(J, o), d.return(!0));
        });
      }
    }, minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "handlandmarktrackinggpu__palmdetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } }, minTrackingConfidence: { type: 1, graphOptionXref: {
      calculatorType: "ThresholdingCalculator",
      calculatorName: "handlandmarktrackinggpu__handlandmarkgpu__ThresholdingCalculator",
      fieldName: "threshold"
    } } } });
  }
  i = Ft.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(l) {
    this.g.onResults(l);
  }, i.initialize = function() {
    var l = this;
    return gt(function(Z) {
      return P(Z, l.g.initialize(), 0);
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(l) {
    var Z = this;
    return gt(function(x) {
      return P(x, Z.g.send(l), 0);
    });
  }, i.setOptions = function(l) {
    this.g.setOptions(l);
  }, Ct("Hands", Ft), Ct("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]), Ct("VERSION", "0.4.1646424915");
}).call(yi);
var gi = {};
(function() {
  var i;
  function r(e) {
    var u = 0;
    return function() {
      return u < e.length ? { done: !1, value: e[u++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, u, f) {
    return e == Array.prototype || e == Object.prototype || (e[u] = f.value), e;
  };
  function m(e) {
    e = [typeof globalThis == "object" && globalThis, e, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var u = 0; u < e.length; ++u) {
      var f = e[u];
      if (f && f.Math == Math)
        return f;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(e, u) {
    if (u)
      t: {
        var f = X;
        e = e.split(".");
        for (var t = 0; t < e.length - 1; t++) {
          var c = e[t];
          if (!(c in f))
            break t;
          f = f[c];
        }
        e = e[e.length - 1], t = f[e], u = u(t), u != t && u != null && n(f, e, { configurable: !0, writable: !0, value: u });
      }
  }
  S("Symbol", function(e) {
    function u(a) {
      if (this instanceof u)
        throw new TypeError("Symbol is not a constructor");
      return new f(t + (a || "") + "_" + c++, a);
    }
    function f(a, b) {
      this.g = a, n(this, "description", { configurable: !0, writable: !0, value: b });
    }
    if (e)
      return e;
    f.prototype.toString = function() {
      return this.g;
    };
    var t = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", c = 0;
    return u;
  }), S("Symbol.iterator", function(e) {
    if (e)
      return e;
    e = Symbol("Symbol.iterator");
    for (var u = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), f = 0; f < u.length; f++) {
      var t = X[u[f]];
      typeof t == "function" && typeof t.prototype[e] != "function" && n(t.prototype, e, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return e;
  });
  function C(e) {
    return e = { next: e }, e[Symbol.iterator] = function() {
      return this;
    }, e;
  }
  function T(e) {
    var u = typeof Symbol < "u" && Symbol.iterator && e[Symbol.iterator];
    return u ? u.call(e) : { next: r(e) };
  }
  function B(e) {
    if (!(e instanceof Array)) {
      e = T(e);
      for (var u, f = []; !(u = e.next()).done; )
        f.push(u.value);
      e = f;
    }
    return e;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(e) {
    function u() {
    }
    return u.prototype = e, new u();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(e, u) {
      if (e.__proto__ = u, e.__proto__ !== u)
        throw new TypeError(e + " is not extensible");
      return e;
    } : null;
  }
  var at = ut;
  function mt(e, u) {
    if (e.prototype = nt(u.prototype), e.prototype.constructor = e, at)
      at(e, u);
    else
      for (var f in u)
        if (f != "prototype")
          if (Object.defineProperties) {
            var t = Object.getOwnPropertyDescriptor(u, f);
            t && Object.defineProperty(e, f, t);
          } else
            e[f] = u[f];
    e.da = u.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
  }
  function kt(e) {
    if (e.l)
      throw new TypeError("Generator is already running");
    e.l = !0;
  }
  Bt.prototype.o = function(e) {
    this.h = e;
  };
  function ee(e, u) {
    e.j = { U: u, V: !0 }, e.g = e.m || e.s;
  }
  Bt.prototype.return = function(e) {
    this.j = { return: e }, this.g = this.s;
  };
  function P(e, u, f) {
    return e.g = f, { value: u };
  }
  function De(e) {
    this.g = new Bt(), this.h = e;
  }
  function je(e, u) {
    kt(e.g);
    var f = e.g.i;
    return f ? We(e, "return" in f ? f.return : function(t) {
      return { value: t, done: !0 };
    }, u, e.g.return) : (e.g.return(u), jt(e));
  }
  function We(e, u, f, t) {
    try {
      var c = u.call(e.g.i, f);
      if (!(c instanceof Object))
        throw new TypeError("Iterator result " + c + " is not an object");
      if (!c.done)
        return e.g.l = !1, c;
      var a = c.value;
    } catch (b) {
      return e.g.i = null, ee(e.g, b), jt(e);
    }
    return e.g.i = null, t.call(e.g, a), jt(e);
  }
  function jt(e) {
    for (; e.g.g; )
      try {
        var u = e.h(e.g);
        if (u)
          return e.g.l = !1, { value: u.value, done: !1 };
      } catch (f) {
        e.g.h = void 0, ee(e.g, f);
      }
    if (e.g.l = !1, e.g.j) {
      if (u = e.g.j, e.g.j = null, u.V)
        throw u.U;
      return { value: u.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(e) {
    this.next = function(u) {
      return kt(e.g), e.g.i ? u = We(e, e.g.i.next, u, e.g.o) : (e.g.o(u), u = jt(e)), u;
    }, this.throw = function(u) {
      return kt(e.g), e.g.i ? u = We(e, e.g.i.throw, u, e.g.o) : (ee(e.g, u), u = jt(e)), u;
    }, this.return = function(u) {
      return je(e, u);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(e) {
    function u(t) {
      return e.next(t);
    }
    function f(t) {
      return e.throw(t);
    }
    return new Promise(function(t, c) {
      function a(b) {
        b.done ? t(b.value) : Promise.resolve(b.value).then(u, f).then(a, c);
      }
      a(e.next());
    });
  }
  function gt(e) {
    return ne(new Cn(new De(e)));
  }
  S("Promise", function(e) {
    function u(b) {
      this.h = 0, this.i = void 0, this.g = [], this.o = !1;
      var I = this.j();
      try {
        b(I.resolve, I.reject);
      } catch (F) {
        I.reject(F);
      }
    }
    function f() {
      this.g = null;
    }
    function t(b) {
      return b instanceof u ? b : new u(function(I) {
        I(b);
      });
    }
    if (e)
      return e;
    f.prototype.h = function(b) {
      if (this.g == null) {
        this.g = [];
        var I = this;
        this.i(function() {
          I.l();
        });
      }
      this.g.push(b);
    };
    var c = X.setTimeout;
    f.prototype.i = function(b) {
      c(b, 0);
    }, f.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var b = this.g;
        this.g = [];
        for (var I = 0; I < b.length; ++I) {
          var F = b[I];
          b[I] = null;
          try {
            F();
          } catch (H) {
            this.j(H);
          }
        }
      }
      this.g = null;
    }, f.prototype.j = function(b) {
      this.i(function() {
        throw b;
      });
    }, u.prototype.j = function() {
      function b(H) {
        return function(U) {
          F || (F = !0, H.call(I, U));
        };
      }
      var I = this, F = !1;
      return { resolve: b(this.C), reject: b(this.l) };
    }, u.prototype.C = function(b) {
      if (b === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (b instanceof u)
        this.F(b);
      else {
        t:
          switch (typeof b) {
            case "object":
              var I = b != null;
              break t;
            case "function":
              I = !0;
              break t;
            default:
              I = !1;
          }
        I ? this.v(b) : this.m(b);
      }
    }, u.prototype.v = function(b) {
      var I = void 0;
      try {
        I = b.then;
      } catch (F) {
        this.l(F);
        return;
      }
      typeof I == "function" ? this.G(I, b) : this.m(b);
    }, u.prototype.l = function(b) {
      this.s(2, b);
    }, u.prototype.m = function(b) {
      this.s(1, b);
    }, u.prototype.s = function(b, I) {
      if (this.h != 0)
        throw Error("Cannot settle(" + b + ", " + I + "): Promise already settled in state" + this.h);
      this.h = b, this.i = I, this.h === 2 && this.D(), this.A();
    }, u.prototype.D = function() {
      var b = this;
      c(function() {
        if (b.B()) {
          var I = X.console;
          typeof I < "u" && I.error(b.i);
        }
      }, 1);
    }, u.prototype.B = function() {
      if (this.o)
        return !1;
      var b = X.CustomEvent, I = X.Event, F = X.dispatchEvent;
      return typeof F > "u" ? !0 : (typeof b == "function" ? b = new b("unhandledrejection", { cancelable: !0 }) : typeof I == "function" ? b = new I("unhandledrejection", { cancelable: !0 }) : (b = X.document.createEvent("CustomEvent"), b.initCustomEvent("unhandledrejection", !1, !0, b)), b.promise = this, b.reason = this.i, F(b));
    }, u.prototype.A = function() {
      if (this.g != null) {
        for (var b = 0; b < this.g.length; ++b)
          a.h(this.g[b]);
        this.g = null;
      }
    };
    var a = new f();
    return u.prototype.F = function(b) {
      var I = this.j();
      b.J(I.resolve, I.reject);
    }, u.prototype.G = function(b, I) {
      var F = this.j();
      try {
        b.call(I, F.resolve, F.reject);
      } catch (H) {
        F.reject(H);
      }
    }, u.prototype.then = function(b, I) {
      function F(Q, D) {
        return typeof Q == "function" ? function(st) {
          try {
            H(Q(st));
          } catch (ht) {
            U(ht);
          }
        } : D;
      }
      var H, U, j = new u(function(Q, D) {
        H = Q, U = D;
      });
      return this.J(F(b, H), F(I, U)), j;
    }, u.prototype.catch = function(b) {
      return this.then(void 0, b);
    }, u.prototype.J = function(b, I) {
      function F() {
        switch (H.h) {
          case 1:
            b(H.i);
            break;
          case 2:
            I(H.i);
            break;
          default:
            throw Error("Unexpected state: " + H.h);
        }
      }
      var H = this;
      this.g == null ? a.h(F) : this.g.push(F), this.o = !0;
    }, u.resolve = t, u.reject = function(b) {
      return new u(function(I, F) {
        F(b);
      });
    }, u.race = function(b) {
      return new u(function(I, F) {
        for (var H = T(b), U = H.next(); !U.done; U = H.next())
          t(U.value).J(I, F);
      });
    }, u.all = function(b) {
      var I = T(b), F = I.next();
      return F.done ? t([]) : new u(function(H, U) {
        function j(st) {
          return function(ht) {
            Q[st] = ht, D--, D == 0 && H(Q);
          };
        }
        var Q = [], D = 0;
        do
          Q.push(void 0), D++, t(F.value).J(j(Q.length - 1), U), F = I.next();
        while (!F.done);
      });
    }, u;
  });
  function $e(e, u) {
    e instanceof String && (e += "");
    var f = 0, t = !1, c = { next: function() {
      if (!t && f < e.length) {
        var a = f++;
        return { value: u(a, e[a]), done: !1 };
      }
      return t = !0, { done: !0, value: void 0 };
    } };
    return c[Symbol.iterator] = function() {
      return c;
    }, c;
  }
  var An = typeof Object.assign == "function" ? Object.assign : function(e, u) {
    for (var f = 1; f < arguments.length; f++) {
      var t = arguments[f];
      if (t)
        for (var c in t)
          Object.prototype.hasOwnProperty.call(t, c) && (e[c] = t[c]);
    }
    return e;
  };
  S("Object.assign", function(e) {
    return e || An;
  }), S("Object.is", function(e) {
    return e || function(u, f) {
      return u === f ? u !== 0 || 1 / u === 1 / f : u !== u && f !== f;
    };
  }), S("Array.prototype.includes", function(e) {
    return e || function(u, f) {
      var t = this;
      t instanceof String && (t = String(t));
      var c = t.length;
      for (f = f || 0, 0 > f && (f = Math.max(f + c, 0)); f < c; f++) {
        var a = t[f];
        if (a === u || Object.is(a, u))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(e) {
    return e || function(u, f) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (u instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(u, f || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(e) {
    return e || function() {
      return $e(this, function(u) {
        return u;
      });
    };
  });
  var Re = this || self;
  function Ct(e, u) {
    e = e.split(".");
    var f = Re;
    e[0] in f || typeof f.execScript > "u" || f.execScript("var " + e[0]);
    for (var t; e.length && (t = e.shift()); )
      e.length || u === void 0 ? f[t] && f[t] !== Object.prototype[t] ? f = f[t] : f = f[t] = {} : f[t] = u;
  }
  function we(e) {
    Re.setTimeout(function() {
      throw e;
    }, 0);
  }
  function sn(e) {
    we(e);
  }
  function vn(e, u) {
    sn(Error("Invalid wire type: " + e + " (at position " + u + ")"));
  }
  function Tn() {
    sn(Error("Failed to read varint, encoding is invalid."));
  }
  function Rn(e, u) {
    return u = String.fromCharCode.apply(null, u), e == null ? u : e + u;
  }
  var Nn, dn = typeof TextDecoder < "u", mn, kn = typeof TextEncoder < "u";
  function Fn(e) {
    if (kn)
      e = (mn || (mn = new TextEncoder())).encode(e);
    else {
      var u = void 0;
      u = u === void 0 ? !1 : u;
      for (var f = 0, t = new Uint8Array(3 * e.length), c = 0; c < e.length; c++) {
        var a = e.charCodeAt(c);
        if (128 > a)
          t[f++] = a;
        else {
          if (2048 > a)
            t[f++] = a >> 6 | 192;
          else {
            if (55296 <= a && 57343 >= a) {
              if (56319 >= a && c < e.length) {
                var b = e.charCodeAt(++c);
                if (56320 <= b && 57343 >= b) {
                  a = 1024 * (a - 55296) + b - 56320 + 65536, t[f++] = a >> 18 | 240, t[f++] = a >> 12 & 63 | 128, t[f++] = a >> 6 & 63 | 128, t[f++] = a & 63 | 128;
                  continue;
                } else
                  c--;
              }
              if (u)
                throw Error("Found an unpaired surrogate");
              a = 65533;
            }
            t[f++] = a >> 12 | 224, t[f++] = a >> 6 & 63 | 128;
          }
          t[f++] = a & 63 | 128;
        }
      }
      e = t.subarray(0, f);
    }
    return e;
  }
  var ze = {}, Me = null;
  function xn(e) {
    var u;
    u === void 0 && (u = 0), Se(), u = ze[u];
    for (var f = Array(Math.floor(e.length / 3)), t = u[64] || "", c = 0, a = 0; c < e.length - 2; c += 3) {
      var b = e[c], I = e[c + 1], F = e[c + 2], H = u[b >> 2];
      b = u[(b & 3) << 4 | I >> 4], I = u[(I & 15) << 2 | F >> 6], F = u[F & 63], f[a++] = H + b + I + F;
    }
    switch (H = 0, F = t, e.length - c) {
      case 2:
        H = e[c + 1], F = u[(H & 15) << 2] || t;
      case 1:
        e = e[c], f[a] = u[e >> 2] + u[(e & 3) << 4 | H >> 4] + F + t;
    }
    return f.join("");
  }
  function Gn(e) {
    var u = e.length, f = 3 * u / 4;
    f % 3 ? f = Math.floor(f) : "=.".indexOf(e[u - 1]) != -1 && (f = "=.".indexOf(e[u - 2]) != -1 ? f - 2 : f - 1);
    var t = new Uint8Array(f), c = 0;
    return he(e, function(a) {
      t[c++] = a;
    }), t.subarray(0, c);
  }
  function he(e, u) {
    function f(F) {
      for (; t < e.length; ) {
        var H = e.charAt(t++), U = Me[H];
        if (U != null)
          return U;
        if (!/^[\s\xa0]*$/.test(H))
          throw Error("Unknown base64 encoding at char: " + H);
      }
      return F;
    }
    Se();
    for (var t = 0; ; ) {
      var c = f(-1), a = f(0), b = f(64), I = f(64);
      if (I === 64 && c === -1)
        break;
      u(c << 2 | a >> 4), b != 64 && (u(a << 4 & 240 | b >> 2), I != 64 && u(b << 6 & 192 | I));
    }
  }
  function Se() {
    if (!Me) {
      Me = {};
      for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), u = ["+/=", "+/", "-_=", "-_.", "-_"], f = 0; 5 > f; f++) {
        var t = e.concat(u[f].split(""));
        ze[f] = t;
        for (var c = 0; c < t.length; c++) {
          var a = t[c];
          Me[a] === void 0 && (Me[a] = c);
        }
      }
    }
  }
  var Oe = typeof Uint8Array == "function", re;
  function Ve(e) {
    if (this.g = e, e !== null && e.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  Ve.prototype.toJSON = function() {
    if (this.g == null)
      var e = "";
    else
      e = this.g, e = this.g = e == null || typeof e == "string" ? e : Oe && e instanceof Uint8Array ? xn(e) : null;
    return e;
  };
  var ln = typeof Uint8Array.prototype.slice == "function";
  function Ee(e, u, f) {
    return u === f ? re || (re = new Uint8Array(0)) : ln ? e.slice(u, f) : new Uint8Array(e.subarray(u, f));
  }
  var Qt = 0, Ze = 0;
  function Le(e) {
    if (e.constructor === Uint8Array)
      return e;
    if (e.constructor === ArrayBuffer)
      return new Uint8Array(e);
    if (e.constructor === Array)
      return new Uint8Array(e);
    if (e.constructor === String)
      return Gn(e);
    if (e.constructor === Ve) {
      if (e.g == null)
        var u = re || (re = new Uint8Array(0));
      else {
        u = Uint8Array;
        var f = e.g;
        f = f == null || Oe && f != null && f instanceof Uint8Array ? f : typeof f == "string" ? Gn(f) : null, e = e.g = f, u = new u(e);
      }
      return u;
    }
    if (e instanceof Uint8Array)
      return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function At(e, u) {
    u = u === void 0 ? {} : u, u = u.u === void 0 ? !1 : u.u, this.h = null, this.g = this.i = this.m = 0, this.l = !1, this.u = u, e && xe(this, e);
  }
  function xe(e, u) {
    e.h = Le(u), e.m = 0, e.i = e.h.length, e.g = e.m;
  }
  At.prototype.reset = function() {
    this.g = this.m;
  };
  function zt(e) {
    for (var u = 128, f = 0, t = 0, c = 0; 4 > c && 128 <= u; c++)
      u = e.h[e.g++], f |= (u & 127) << 7 * c;
    if (128 <= u && (u = e.h[e.g++], f |= (u & 127) << 28, t |= (u & 127) >> 4), 128 <= u)
      for (c = 0; 5 > c && 128 <= u; c++)
        u = e.h[e.g++], t |= (u & 127) << 7 * c + 3;
    if (128 > u)
      return e = f >>> 0, u = t >>> 0, (t = u & 2147483648) && (e = ~e + 1 >>> 0, u = ~u >>> 0, e == 0 && (u = u + 1 >>> 0)), e = 4294967296 * u + (e >>> 0), t ? -e : e;
    e.l = !0, Tn();
  }
  function be(e) {
    e.g > e.i && (e.l = !0, sn(Error("Tried to read past the end of the data " + e.g + " > " + e.i)));
  }
  At.prototype.j = function() {
    var e = this.h, u = e[this.g], f = u & 127;
    return 128 > u ? (this.g += 1, be(this), f) : (u = e[this.g + 1], f |= (u & 127) << 7, 128 > u ? (this.g += 2, be(this), f) : (u = e[this.g + 2], f |= (u & 127) << 14, 128 > u ? (this.g += 3, be(this), f) : (u = e[this.g + 3], f |= (u & 127) << 21, 128 > u ? (this.g += 4, be(this), f) : (u = e[this.g + 4], f |= (u & 15) << 28, 128 > u ? (this.g += 5, be(this), f >>> 0) : (this.g += 5, 128 <= e[this.g++] && 128 <= e[this.g++] && 128 <= e[this.g++] && 128 <= e[this.g++] && 128 <= e[this.g++] ? (this.l = !0, Tn(), f) : (be(this), f))))));
  }, At.prototype.o = function() {
    var e = this.h[this.g], u = this.h[this.g + 1], f = this.h[this.g + 2], t = this.h[this.g + 3];
    return this.g += 4, be(this), f = (e << 0 | u << 8 | f << 16 | t << 24) >>> 0, e = 2 * (f >> 31) + 1, u = f >>> 23 & 255, f &= 8388607, u == 255 ? f ? NaN : 1 / 0 * e : u == 0 ? e * Math.pow(2, -149) * f : e * Math.pow(2, u - 150) * (f + Math.pow(2, 23));
  };
  var Ye = [];
  function qe() {
    this.g = new Uint8Array(64), this.h = 0;
  }
  function Xe(e, u) {
    if (!(e.h + 1 < e.g.length)) {
      var f = e.g;
      e.g = new Uint8Array(Math.ceil(1 + 2 * e.g.length)), e.g.set(f);
    }
    e.g[e.h++] = u;
  }
  qe.prototype.length = function() {
    return this.h;
  }, qe.prototype.end = function() {
    var e = this.g, u = this.h;
    return this.h = 0, Ee(e, 0, u);
  };
  function Ot(e, u) {
    for (; 127 < u; )
      Xe(e, u & 127 | 128), u >>>= 7;
    Xe(e, u);
  }
  function Ae(e) {
    var u = {}, f = u.N === void 0 ? !1 : u.N;
    this.m = { u: u.u === void 0 ? !1 : u.u }, this.N = f, u = this.m, Ye.length ? (f = Ye.pop(), u && (f.u = u.u), e && xe(f, e), e = f) : e = new At(e, u), this.g = e, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
  }
  Ae.prototype.reset = function() {
    this.g.reset(), this.h = this.i = -1;
  };
  function Pe(e) {
    var u = e.g;
    if ((u = u.g == u.i) || (u = e.j) || (u = e.g, u = u.l || 0 > u.g || u.g > u.i), u)
      return !1;
    e.l = e.g.g;
    var f = e.g.j();
    return u = f >>> 3, f &= 7, 0 <= f && 5 >= f ? (e.i = u, e.h = f, !0) : (e.j = !0, vn(f, e.l), !1);
  }
  function Ie(e) {
    switch (e.h) {
      case 0:
        if (e.h != 0)
          Ie(e);
        else
          t: {
            e = e.g;
            for (var u = e.g, f = 0; 10 > f; f++) {
              if ((e.h[u] & 128) === 0) {
                e.g = u + 1, be(e);
                break t;
              }
              u++;
            }
            e.l = !0, Tn();
          }
        break;
      case 1:
        e = e.g, e.g += 8, be(e);
        break;
      case 2:
        e.h != 2 ? Ie(e) : (u = e.g.j(), e = e.g, e.g += u, be(e));
        break;
      case 5:
        e = e.g, e.g += 4, be(e);
        break;
      case 3:
        u = e.i;
        do {
          if (!Pe(e)) {
            e.j = !0, sn(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (e.h == 4) {
            e.i != u && (e.j = !0, sn(Error("Unmatched end-group tag")));
            break;
          }
          Ie(e);
        } while (1);
        break;
      default:
        e.j = !0, vn(e.h, e.l);
    }
  }
  function Xn(e, u, f) {
    e.N || (e = Ee(e.g.h, f, e.g.g), (f = u.o) ? f.push(e) : u.o = [e]);
  }
  function cn(e, u, f) {
    var t = e.g.i, c = e.g.j(), a = e.g.g + c;
    if (e.g.i = a, f(u, e), f = a - e.g.g, f !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (c + " bytes, instead read " + (c - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    return e.g.g = a, e.g.i = t, u;
  }
  function _e(e, u, f) {
    var t = e.g.j();
    for (t = e.g.g + t; e.g.g < t; )
      f.push(u.call(e.g));
  }
  var un = [];
  function ve() {
    this.h = [], this.i = 0, this.g = new qe();
  }
  function Te(e, u) {
    u.length !== 0 && (e.h.push(u), e.i += u.length);
  }
  function Ge(e, u, f) {
    Ot(e.g, 8 * u + 2), Ot(e.g, f.length), Te(e, e.g.end()), Te(e, f);
  }
  var ie = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
  function Qe(e, u) {
    Object.isFrozen(e) || (ie ? e[ie] |= u : e.g !== void 0 ? e.g |= u : Object.defineProperties(e, { g: { value: u, configurable: !0, writable: !0, enumerable: !1 } }));
  }
  function qt(e) {
    if (!e)
      return 0;
    var u;
    return ie ? u = e[ie] : u = e.g, u == null ? 0 : u;
  }
  function Pt(e) {
    return Array.isArray(e) && Qe(e, 1), e;
  }
  function hn(e) {
    if (!Array.isArray(e))
      throw Error("cannot mark non-array as immutable");
    Qe(e, 2);
  }
  function fe(e) {
    return e !== null && typeof e == "object" && e.constructor === Object;
  }
  function Lt(e) {
    switch (typeof e) {
      case "number":
        return isFinite(e) ? e : String(e);
      case "object":
        return Oe && e != null && e instanceof Uint8Array ? xn(e) : e;
      default:
        return e;
    }
  }
  function Vt(e, u) {
    if (e != null)
      return Array.isArray(e) || fe(e) ? oe(e, u) : u(e);
  }
  function oe(e, u) {
    if (Array.isArray(e)) {
      for (var f = Array(e.length), t = 0; t < e.length; t++)
        f[t] = Vt(e[t], u);
      return qt(e) & 1 && Pt(f), f;
    }
    f = {};
    for (t in e)
      f[t] = Vt(e[t], u);
    return f;
  }
  var Fe;
  function te(e, u, f) {
    var t = Fe;
    Fe = null, e || (e = t), t = this.constructor.ba, e || (e = t ? [t] : []), this.j = (t ? 0 : -1) - (this.constructor.$ || 0), this.m = this.g = null, this.h = e;
    t: {
      if (t = this.h.length, e = t - 1, t && (t = this.h[e], fe(t))) {
        this.l = e - this.j, this.i = t;
        break t;
      }
      u !== void 0 && -1 < u ? (this.l = Math.max(u, e + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
    }
    if (f)
      for (u = 0; u < f.length; u++)
        e = f[u], e < this.l ? (e += this.j, (t = this.h[e]) ? Pt(t) : this.h[e] = se) : (tt(this), (t = this.i[e]) ? Pt(t) : this.i[e] = se);
  }
  var se = Object.freeze(Pt([]));
  function tt(e) {
    var u = e.l + e.j;
    e.h[u] || (e.i = e.h[u] = {});
  }
  function it(e, u, f) {
    return u === -1 ? null : (f === void 0 ? 0 : f) || u >= e.l ? e.i ? e.i[u] : void 0 : e.h[u + e.j];
  }
  function ct(e, u, f) {
    f = f === void 0 ? !0 : f;
    var t = t === void 0 ? !1 : t, c = it(e, u, t);
    return c == null && (c = se), c === se ? (c = Pt([]), St(e, u, c, t)) : f && Array.isArray(c) && qt(c) & 2 && (c = c.slice(), St(e, u, c, t)), c;
  }
  function _t(e) {
    var u = ct(e, 3, !1);
    if (e.m || (e.m = {}), !e.m[3]) {
      for (var f = 0; f < u.length; f++)
        u[f] = +u[f];
      e.m[3] = !0;
    }
    return u;
  }
  function de(e, u, f) {
    return e = it(e, u), e == null ? f : e;
  }
  function ue(e, u, f) {
    return e = it(e, u), e = e == null ? e : +e, e == null ? f === void 0 ? 0 : f : e;
  }
  function St(e, u, f, t) {
    (t === void 0 ? 0 : t) || u >= e.l ? (tt(e), e.i[u] = f) : e.h[u + e.j] = f;
  }
  function me(e, u, f) {
    if (f === -1)
      return null;
    e.g || (e.g = {});
    var t = e.g[f];
    if (t)
      return t;
    var c = it(e, f, !1);
    return c == null ? t : (u = new u(c), e.g[f] = u);
  }
  function Ce(e, u, f) {
    e.g || (e.g = {});
    var t = e.g[f];
    if (!t) {
      var c = ct(e, f, !1);
      t = [];
      for (var a = Array.isArray(c) ? !!(qt(c) & 2) : !1, b = 0; b < c.length; b++)
        t[b] = new u(c[b]), a && hn(t[b].h);
      a && (hn(t), Object.freeze(t)), e.g[f] = t;
    }
    return t;
  }
  function tn(e, u, f, t, c) {
    var a = Ce(e, t, u);
    f = f || new t(), e = ct(e, u), c != null ? (a.splice(c, 0, f), e.splice(c, 0, en(f))) : (a.push(f), e.push(en(f)));
  }
  te.prototype.toJSON = function() {
    var e = en(this);
    return oe(e, Lt);
  };
  function en(e) {
    if (e.g)
      for (var u in e.g) {
        var f = e.g[u];
        if (Array.isArray(f))
          for (var t = 0; t < f.length; t++)
            f[t] && en(f[t]);
        else
          f && en(f);
      }
    return e.h;
  }
  te.prototype.toString = function() {
    return en(this).toString();
  };
  function fn(e, u) {
    if (e = e.o) {
      Te(u, u.g.end());
      for (var f = 0; f < e.length; f++)
        Te(u, e[f]);
    }
  }
  function pn(e) {
    var u = e[0];
    switch (e.length) {
      case 2:
        var f = e[1];
        return function(F, H, U) {
          return u(F, H, U, f);
        };
      case 3:
        var t = e[1], c = e[2];
        return function(F, H, U) {
          return u(F, H, U, t, c);
        };
      case 4:
        var a = e[1], b = e[2], I = e[3];
        return function(F, H, U) {
          return u(F, H, U, a, b, I);
        };
      default:
        throw Error("unsupported number of parameters, expected [2-4], got " + e.length);
    }
  }
  function He(e, u, f) {
    for (; Pe(u) && u.h != 4; ) {
      var t = u.i, c = f[t];
      if (c) {
        if (Array.isArray(c) && (c = f[t] = pn(c)), !c(u, e, t)) {
          t = u, c = e;
          var a = t.l;
          Ie(t), Xn(t, c, a);
        }
      } else
        t = u, c = e, a = t.l, Ie(t), Xn(t, c, a);
    }
    return e;
  }
  function nn(e, u) {
    var f = new ve();
    if (u(e, f), e = f.i + f.g.length(), e === 0)
      f = new Uint8Array(0);
    else {
      e = new Uint8Array(e);
      for (var t = f.h, c = t.length, a = u = 0; a < c; a++) {
        var b = t[a];
        b.length !== 0 && (e.set(b, u), u += b.length);
      }
      t = f.g, c = t.h, c !== 0 && (e.set(t.g.subarray(0, c), u), t.h = 0), f.h = [e], f = e;
    }
    return f;
  }
  function Kn(e, u, f) {
    if (un.length) {
      var t = un.pop();
      e && (xe(t.g, e), t.i = -1, t.h = -1), e = t;
    } else
      e = new Ae(e);
    try {
      return f(new u(), e);
    } finally {
      u = e.g, u.h = null, u.m = 0, u.i = 0, u.g = 0, u.l = !1, u.u = !1, e.i = -1, e.h = -1, e.j = !1, 100 > un.length && un.push(e);
    }
  }
  function rn(e, u, f) {
    if (u = it(u, f), u != null) {
      Ot(e.g, 8 * f + 5), e = e.g;
      var t = u;
      t = (f = 0 > t ? 1 : 0) ? -t : t, t === 0 ? 0 < 1 / t ? Qt = Ze = 0 : (Ze = 0, Qt = 2147483648) : isNaN(t) ? (Ze = 0, Qt = 2147483647) : 34028234663852886e22 < t ? (Ze = 0, Qt = (f << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > t ? (t = Math.round(t / Math.pow(2, -149)), Ze = 0, Qt = (f << 31 | t) >>> 0) : (u = Math.floor(Math.log(t) / Math.LN2), t *= Math.pow(2, -u), t = Math.round(8388608 * t), 16777216 <= t && ++u, Ze = 0, Qt = (f << 31 | u + 127 << 23 | t & 8388607) >>> 0), f = Qt, Xe(e, f >>> 0 & 255), Xe(e, f >>> 8 & 255), Xe(e, f >>> 16 & 255), Xe(e, f >>> 24 & 255);
    }
  }
  function Ne(e, u, f) {
    return e.h !== 5 ? !1 : (St(u, f, e.g.o()), !0);
  }
  function yn(e, u, f) {
    return e.h !== 5 && e.h !== 2 ? !1 : (u = ct(u, f), e.h == 2 ? _e(e, At.prototype.o, u) : u.push(e.g.o()), !0);
  }
  function In(e, u, f) {
    return e.h !== 0 ? !1 : (St(u, f, zt(e.g)), !0);
  }
  function Be(e, u, f) {
    return e.h !== 0 ? !1 : (St(u, f, e.g.j()), !0);
  }
  function Un(e, u, f) {
    if (e.h !== 2)
      return !1;
    var t = e.g.j();
    e = e.g;
    var c = e.g;
    e.g += t, be(e), e = e.h;
    var a;
    if (dn)
      (a = Nn) || (a = Nn = new TextDecoder("utf-8", { fatal: !1 })), a = a.decode(e.subarray(c, c + t));
    else {
      t = c + t;
      for (var b = [], I = null, F, H, U; c < t; )
        F = e[c++], 128 > F ? b.push(F) : 224 > F ? c >= t ? b.push(65533) : (H = e[c++], 194 > F || (H & 192) !== 128 ? (c--, b.push(65533)) : b.push((F & 31) << 6 | H & 63)) : 240 > F ? c >= t - 1 ? b.push(65533) : (H = e[c++], (H & 192) !== 128 || F === 224 && 160 > H || F === 237 && 160 <= H || ((a = e[c++]) & 192) !== 128 ? (c--, b.push(65533)) : b.push((F & 15) << 12 | (H & 63) << 6 | a & 63)) : 244 >= F ? c >= t - 2 ? b.push(65533) : (H = e[c++], (H & 192) !== 128 || (F << 28) + (H - 144) >> 30 !== 0 || ((a = e[c++]) & 192) !== 128 || ((U = e[c++]) & 192) !== 128 ? (c--, b.push(65533)) : (F = (F & 7) << 18 | (H & 63) << 12 | (a & 63) << 6 | U & 63, F -= 65536, b.push((F >> 10 & 1023) + 55296, (F & 1023) + 56320))) : b.push(65533), 8192 <= b.length && (I = Rn(I, b), b.length = 0);
      a = Rn(I, b);
    }
    return St(u, f, a), !0;
  }
  function on(e, u, f, t, c) {
    if (e.h !== 2)
      return !1;
    e = cn(e, new t(), c);
    var a = a === void 0 ? !1 : a;
    return u.g || (u.g = {}), t = e && en(e), u.g[f] = e, St(u, f, t, a), !0;
  }
  function gn(e, u, f, t, c) {
    return e.h !== 2 ? !1 : (e = cn(e, new t(), c), tn(u, f, e, t, void 0), !0);
  }
  function Sn(e, u, f) {
    return e.h !== 0 && e.h !== 2 ? !1 : (u = ct(u, f), e.h == 2 ? _e(e, At.prototype.j, u) : u.push(e.g.j()), !0);
  }
  function En(e, u, f) {
    return e.h !== 0 ? !1 : (St(u, f, zt(e.g)), !0);
  }
  function an(e) {
    te.call(this, e, -1, _n);
  }
  var wn;
  mt(an, te), an.prototype.getRows = function() {
    return it(this, 1);
  }, an.prototype.getCols = function() {
    return it(this, 2);
  }, an.prototype.getPackedDataList = function() {
    return _t(this);
  }, an.prototype.getLayout = function() {
    return de(this, 4, 0);
  };
  function Pn(e, u) {
    return He(e, u, wn || (wn = { 1: Be, 2: Be, 3: yn, 4: En }));
  }
  var _n = [3];
  function Yn(e) {
    te.call(this, e);
  }
  var Hn;
  mt(Yn, te);
  function p(e, u) {
    var f = it(e, 1);
    if (f != null && f != null) {
      Ot(u.g, 8);
      var t = u.g;
      if (0 <= f)
        Ot(t, f);
      else {
        for (var c = 0; 9 > c; c++)
          Xe(t, f & 127 | 128), f >>= 7;
        Xe(t, 1);
      }
    }
    rn(u, e, 2), t = it(e, 3), t != null && Ge(u, 3, Fn(t)), t = it(e, 4), t != null && Ge(u, 4, Fn(t)), fn(e, u);
  }
  function W(e, u) {
    return He(e, u, Hn || (Hn = { 1: Be, 2: Ne, 3: Un, 4: Un }));
  }
  function V(e) {
    te.call(this, e, -1, ot);
  }
  var k;
  mt(V, te), V.prototype.addClassification = function(e, u) {
    return tn(this, 1, e, Yn, u), this;
  };
  function O(e, u) {
    return He(e, u, k || (k = { 1: [gn, Yn, W] }));
  }
  var ot = [1];
  function z(e) {
    te.call(this, e);
  }
  var rt;
  mt(z, te);
  function bt(e, u) {
    rn(u, e, 1), rn(u, e, 2), rn(u, e, 3), rn(u, e, 4), rn(u, e, 5), fn(e, u);
  }
  function Rt(e, u) {
    return He(e, u, rt || (rt = { 1: Ne, 2: Ne, 3: Ne, 4: Ne, 5: Ne }));
  }
  function Et(e) {
    te.call(this, e, -1, Jt);
  }
  var Nt;
  mt(Et, te);
  function $t(e, u) {
    return He(e, u, Nt || (Nt = { 1: [gn, z, Rt] }));
  }
  var Jt = [1];
  function wt(e) {
    te.call(this, e);
  }
  var Ut;
  mt(wt, te);
  function Dt(e, u) {
    rn(u, e, 1), rn(u, e, 2), rn(u, e, 3), rn(u, e, 4), rn(u, e, 5);
    var f = it(e, 6);
    if (f != null && f != null) {
      Ot(u.g, 48);
      var t = u.g, c = f;
      f = 0 > c, c = Math.abs(c);
      var a = c >>> 0;
      for (c = Math.floor((c - a) / 4294967296), c >>>= 0, f && (c = ~c >>> 0, a = (~a >>> 0) + 1, 4294967295 < a && (a = 0, c++, 4294967295 < c && (c = 0))), Qt = a, Ze = c, f = Qt, a = Ze; 0 < a || 127 < f; )
        Xe(t, f & 127 | 128), f = (f >>> 7 | a << 25) >>> 0, a >>>= 7;
      Xe(t, f);
    }
    fn(e, u);
  }
  function ae(e, u) {
    return He(e, u, Ut || (Ut = { 1: Ne, 2: Ne, 3: Ne, 4: Ne, 5: Ne, 6: In }));
  }
  function pe(e) {
    te.call(this, e, -1, h);
  }
  var ye;
  mt(pe, te), pe.prototype.getVertexType = function() {
    return de(this, 1, 0);
  }, pe.prototype.getPrimitiveType = function() {
    return de(this, 2, 0);
  }, pe.prototype.getVertexBufferList = function() {
    return _t(this);
  }, pe.prototype.getIndexBufferList = function() {
    return ct(this, 4);
  };
  function Je(e, u) {
    return He(e, u, ye || (ye = { 1: En, 2: En, 3: yn, 4: Sn }));
  }
  var h = [3, 4];
  function y(e) {
    te.call(this, e);
  }
  var v;
  mt(y, te), y.prototype.getMesh = function() {
    return me(this, pe, 1);
  }, y.prototype.getPoseTransformMatrix = function() {
    return me(this, an, 2);
  };
  function L(e, u) {
    return He(e, u, v || (v = { 1: [on, pe, Je], 2: [on, an, Pn] }));
  }
  var M = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], _ = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], A = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], q = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], lt = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], s = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], G = [].concat(B(M), B(_), B(A), B(q), B(lt), B(s));
  function R(e, u, f) {
    if (f = e.createShader(f === 0 ? e.VERTEX_SHADER : e.FRAGMENT_SHADER), e.shaderSource(f, u), e.compileShader(f), !e.getShaderParameter(f, e.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + e.getShaderInfoLog(f));
    return f;
  }
  function Y(e) {
    return Ce(e, Yn, 1).map(function(u) {
      return { index: de(u, 1, 0), score: ue(u, 2), label: it(u, 3) != null ? de(u, 3, "") : void 0, displayName: it(u, 4) != null ? de(u, 4, "") : void 0 };
    });
  }
  function N(e) {
    return { x: ue(e, 1), y: ue(e, 2), z: ue(e, 3), visibility: it(e, 4) != null ? ue(e, 4) : void 0 };
  }
  function K(e) {
    return Ce(Kn(e, Et, $t), z, 1).map(N);
  }
  function E(e, u) {
    this.h = e, this.g = u, this.l = 0;
  }
  function et(e, u, f) {
    return $(e, u), typeof e.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(e.g.canvas.transferToImageBitmap()) : f ? Promise.resolve(e.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(e.g.canvas) : (e.i === void 0 && (e.i = document.createElement("canvas")), new Promise(function(t) {
      e.i.height = e.g.canvas.height, e.i.width = e.g.canvas.width, e.i.getContext("2d", {}).drawImage(e.g.canvas, 0, 0, e.g.canvas.width, e.g.canvas.height), t(e.i);
    }));
  }
  function $(e, u) {
    var f = e.g;
    if (e.m === void 0) {
      var t = R(f, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), c = R(f, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), a = f.createProgram();
      if (f.attachShader(a, t), f.attachShader(a, c), f.linkProgram(a), !f.getProgramParameter(a, f.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + f.getProgramInfoLog(a));
      t = e.m = a, f.useProgram(t), c = f.getUniformLocation(t, "sampler0"), e.j = { I: f.getAttribLocation(t, "aVertex"), H: f.getAttribLocation(t, "aTex"), ca: c }, e.s = f.createBuffer(), f.bindBuffer(f.ARRAY_BUFFER, e.s), f.enableVertexAttribArray(e.j.I), f.vertexAttribPointer(e.j.I, 2, f.FLOAT, !1, 0, 0), f.bufferData(f.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), f.STATIC_DRAW), f.bindBuffer(f.ARRAY_BUFFER, null), e.o = f.createBuffer(), f.bindBuffer(f.ARRAY_BUFFER, e.o), f.enableVertexAttribArray(e.j.H), f.vertexAttribPointer(
        e.j.H,
        2,
        f.FLOAT,
        !1,
        0,
        0
      ), f.bufferData(f.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), f.STATIC_DRAW), f.bindBuffer(f.ARRAY_BUFFER, null), f.uniform1i(c, 0);
    }
    t = e.j, f.useProgram(e.m), f.canvas.width = u.width, f.canvas.height = u.height, f.viewport(0, 0, u.width, u.height), f.activeTexture(f.TEXTURE0), e.h.bindTexture2d(u.glName), f.enableVertexAttribArray(t.I), f.bindBuffer(f.ARRAY_BUFFER, e.s), f.vertexAttribPointer(t.I, 2, f.FLOAT, !1, 0, 0), f.enableVertexAttribArray(t.H), f.bindBuffer(f.ARRAY_BUFFER, e.o), f.vertexAttribPointer(
      t.H,
      2,
      f.FLOAT,
      !1,
      0,
      0
    ), f.bindFramebuffer(f.DRAW_FRAMEBUFFER ? f.DRAW_FRAMEBUFFER : f.FRAMEBUFFER, null), f.clearColor(0, 0, 0, 0), f.clear(f.COLOR_BUFFER_BIT), f.colorMask(!0, !0, !0, !0), f.drawArrays(f.TRIANGLE_FAN, 0, 4), f.disableVertexAttribArray(t.I), f.disableVertexAttribArray(t.H), f.bindBuffer(f.ARRAY_BUFFER, null), e.h.bindTexture2d(0);
  }
  function yt(e) {
    this.g = e;
  }
  var Xt = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Mt(e, u) {
    return u + e;
  }
  function xt(e, u) {
    window[e] = u;
  }
  function dt(e) {
    var u = document.createElement("script");
    return u.setAttribute("src", e), u.setAttribute("crossorigin", "anonymous"), new Promise(function(f) {
      u.addEventListener("load", function() {
        f();
      }, !1), u.addEventListener("error", function() {
        f();
      }, !1), document.body.appendChild(u);
    });
  }
  function Wt() {
    return gt(function(e) {
      switch (e.g) {
        case 1:
          return e.m = 2, P(e, WebAssembly.instantiate(Xt), 4);
        case 4:
          e.g = 3, e.m = 0;
          break;
        case 2:
          return e.m = 0, e.j = null, e.return(!1);
        case 3:
          return e.return(!0);
      }
    });
  }
  function It(e) {
    if (this.g = e, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = Promise.resolve(), this.P = "", this.B = {}, this.locateFile = e && e.locateFile || Mt, typeof window == "object")
      var u = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      u = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.S = u, e.options) {
      u = T(Object.keys(e.options));
      for (var f = u.next(); !f.done; f = u.next()) {
        f = f.value;
        var t = e.options[f].default;
        t !== void 0 && (this.j[f] = typeof t == "function" ? t() : t);
      }
    }
  }
  i = It.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function Yt(e) {
    var u, f, t, c, a, b, I, F, H, U, j;
    return gt(function(Q) {
      switch (Q.g) {
        case 1:
          return e.R ? (u = e.g.files === void 0 ? [] : typeof e.g.files == "function" ? e.g.files(e.j) : e.g.files, P(Q, Wt(), 2)) : Q.return();
        case 2:
          if (f = Q.h, typeof window == "object")
            return xt("createMediapipeSolutionsWasm", { locateFile: e.locateFile }), xt("createMediapipeSolutionsPackedAssets", { locateFile: e.locateFile }), b = u.filter(function(D) {
              return D.data !== void 0;
            }), I = u.filter(function(D) {
              return D.data === void 0;
            }), F = Promise.all(b.map(function(D) {
              var st = Z(e, D.url);
              if (D.path !== void 0) {
                var ht = D.path;
                st = st.then(function(ft) {
                  return e.overrideFile(ht, ft), Promise.resolve(ft);
                });
              }
              return st;
            })), H = Promise.all(I.map(function(D) {
              return D.simd === void 0 || D.simd && f || !D.simd && !f ? dt(e.locateFile(D.url, e.S)) : Promise.resolve();
            })).then(function() {
              var D, st, ht;
              return gt(function(ft) {
                if (ft.g == 1)
                  return D = window.createMediapipeSolutionsWasm, st = window.createMediapipeSolutionsPackedAssets, ht = e, P(ft, D(st), 2);
                ht.h = ft.h, ft.g = 0;
              });
            }), U = function() {
              return gt(function(D) {
                return e.g.graph && e.g.graph.url ? D = P(
                  D,
                  Z(e, e.g.graph.url),
                  0
                ) : (D.g = 0, D = void 0), D;
              });
            }(), P(Q, Promise.all([H, F, U]), 7);
          if (typeof importScripts != "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          return t = u.filter(function(D) {
            return D.simd === void 0 || D.simd && f || !D.simd && !f;
          }).map(function(D) {
            return e.locateFile(D.url, e.S);
          }), importScripts.apply(null, B(t)), c = e, P(Q, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          c.h = Q.h, e.l = new OffscreenCanvas(1, 1), e.h.canvas = e.l, a = e.h.GL.createContext(e.l, {
            antialias: !1,
            alpha: !1,
            aa: typeof WebGL2RenderingContext < "u" ? 2 : 1
          }), e.h.GL.makeContextCurrent(a), Q.g = 4;
          break;
        case 7:
          if (e.l = document.createElement("canvas"), j = e.l.getContext("webgl2", {}), !j && (j = e.l.getContext("webgl", {}), !j))
            return alert("Failed to create WebGL canvas context when passing video frame."), Q.return();
          e.D = j, e.h.canvas = e.l, e.h.createContext(e.l, !0, !0, {});
        case 4:
          e.i = new e.h.SolutionWasm(), e.R = !1, Q.g = 0;
      }
    });
  }
  function Ft(e) {
    var u, f, t, c, a, b, I, F;
    return gt(function(H) {
      if (H.g == 1) {
        if (e.g.graph && e.g.graph.url && e.P === e.g.graph.url)
          return H.return();
        if (e.o = !0, !e.g.graph || !e.g.graph.url) {
          H.g = 2;
          return;
        }
        return e.P = e.g.graph.url, P(H, Z(e, e.g.graph.url), 3);
      }
      for (H.g != 2 && (u = H.h, e.i.loadGraph(u)), f = T(Object.keys(e.B)), t = f.next(); !t.done; t = f.next())
        c = t.value, e.i.overrideFile(c, e.B[c]);
      if (e.B = {}, e.g.listeners)
        for (a = T(e.g.listeners), b = a.next(); !b.done; b = a.next())
          I = b.value, J(e, I);
      F = e.j, e.j = {}, e.setOptions(F), H.g = 0;
    });
  }
  i.reset = function() {
    var e = this;
    return gt(function(u) {
      e.i && (e.i.reset(), e.m = {}, e.s = {}), u.g = 0;
    });
  }, i.setOptions = function(e, u) {
    var f = this;
    if (u = u || this.g.options) {
      for (var t = [], c = [], a = {}, b = T(Object.keys(e)), I = b.next(); !I.done; a = { K: a.K, L: a.L }, I = b.next()) {
        var F = I.value;
        F in this.j && this.j[F] === e[F] || (this.j[F] = e[F], I = u[F], I !== void 0 && (I.onChange && (a.K = I.onChange, a.L = e[F], t.push(function(H) {
          return function() {
            var U;
            return gt(function(j) {
              if (j.g == 1)
                return P(j, H.K(H.L), 2);
              U = j.h, U === !0 && (f.o = !0), j.g = 0;
            });
          };
        }(a))), I.graphOptionXref && (F = { valueNumber: I.type === 1 ? e[F] : 0, valueBoolean: I.type === 0 ? e[F] : !1, valueString: I.type === 2 ? e[F] : "" }, I = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), I.graphOptionXref), F), c.push(I))));
      }
      (t.length !== 0 || c.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(c), this.v = (this.v === void 0 ? [] : this.v).concat(t));
    }
  };
  function l(e) {
    var u, f, t, c, a, b, I;
    return gt(function(F) {
      switch (F.g) {
        case 1:
          if (!e.o)
            return F.return();
          if (!e.v) {
            F.g = 2;
            break;
          }
          u = T(e.v), f = u.next();
        case 3:
          if (f.done) {
            F.g = 5;
            break;
          }
          return t = f.value, P(F, t(), 4);
        case 4:
          f = u.next(), F.g = 3;
          break;
        case 5:
          e.v = void 0;
        case 2:
          if (e.A) {
            for (c = new e.h.GraphOptionChangeRequestList(), a = T(e.A), b = a.next(); !b.done; b = a.next())
              I = b.value, c.push_back(I);
            e.i.changeOptions(c), c.delete(), e.A = void 0;
          }
          e.o = !1, F.g = 0;
      }
    });
  }
  i.initialize = function() {
    var e = this;
    return gt(function(u) {
      return u.g == 1 ? P(u, Yt(e), 2) : u.g != 3 ? P(u, Ft(e), 3) : P(u, l(e), 0);
    });
  };
  function Z(e, u) {
    var f, t;
    return gt(function(c) {
      return u in e.F ? c.return(e.F[u]) : (f = e.locateFile(u, ""), t = fetch(f).then(function(a) {
        return a.arrayBuffer();
      }), e.F[u] = t, c.return(t));
    });
  }
  i.overrideFile = function(e, u) {
    this.i ? this.i.overrideFile(e, u) : this.B[e] = u;
  }, i.clearOverriddenFiles = function() {
    this.B = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(e, u) {
    var f = this, t, c, a, b, I, F, H, U, j;
    return gt(function(Q) {
      switch (Q.g) {
        case 1:
          return f.g.inputs ? (t = 1e3 * (u == null ? performance.now() : u), P(Q, f.C, 2)) : Q.return();
        case 2:
          return P(Q, f.initialize(), 3);
        case 3:
          for (c = new f.h.PacketDataList(), a = T(Object.keys(e)), b = a.next(); !b.done; b = a.next())
            if (I = b.value, F = f.g.inputs[I]) {
              t: {
                var D = e[I];
                switch (F.type) {
                  case "video":
                    var st = f.m[F.stream];
                    if (st || (st = new E(f.h, f.D), f.m[F.stream] = st), st.l === 0 && (st.l = st.h.createTexture()), typeof HTMLVideoElement < "u" && D instanceof HTMLVideoElement)
                      var ht = D.videoWidth, ft = D.videoHeight;
                    else
                      typeof HTMLImageElement < "u" && D instanceof HTMLImageElement ? (ht = D.naturalWidth, ft = D.naturalHeight) : (ht = D.width, ft = D.height);
                    ft = { glName: st.l, width: ht, height: ft }, ht = st.g, ht.canvas.width = ft.width, ht.canvas.height = ft.height, ht.activeTexture(ht.TEXTURE0), st.h.bindTexture2d(st.l), ht.texImage2D(ht.TEXTURE_2D, 0, ht.RGBA, ht.RGBA, ht.UNSIGNED_BYTE, D), st.h.bindTexture2d(0), st = ft;
                    break t;
                  case "detections":
                    for (st = f.m[F.stream], st || (st = new yt(f.h), f.m[F.stream] = st), st.data || (st.data = new st.g.DetectionListData()), st.data.reset(D.length), ft = 0; ft < D.length; ++ft) {
                      ht = D[ft];
                      var Gt = st.data, vt = Gt.setBoundingBox, Kt = ft, le = ht.T, ce = new wt();
                      if (St(ce, 1, le.X), St(ce, 2, le.Y), St(ce, 3, le.height), St(ce, 4, le.width), St(ce, 5, le.rotation), St(ce, 6, le.W), le = nn(ce, Dt), vt.call(Gt, Kt, le), ht.O)
                        for (Gt = 0; Gt < ht.O.length; ++Gt) {
                          ce = ht.O[Gt];
                          var ke = !!ce.visibility;
                          vt = st.data, Kt = vt.addNormalizedLandmark, le = ft, ce = Object.assign(Object.assign({}, ce), { visibility: ke ? ce.visibility : 0 }), ke = new z(), St(ke, 1, ce.x), St(ke, 2, ce.y), St(ke, 3, ce.z), ce.visibility && St(ke, 4, ce.visibility), ce = nn(ke, bt), Kt.call(vt, le, ce);
                        }
                      if (ht.M)
                        for (Gt = 0; Gt < ht.M.length; ++Gt)
                          vt = st.data, Kt = vt.addClassification, le = ft, ce = ht.M[Gt], ke = new Yn(), St(ke, 2, ce.score), ce.index && St(ke, 1, ce.index), ce.label && St(ke, 3, ce.label), ce.displayName && St(ke, 4, ce.displayName), ce = nn(ke, p), Kt.call(vt, le, ce);
                    }
                    st = st.data;
                    break t;
                  default:
                    st = {};
                }
              }
              switch (H = st, U = F.stream, F.type) {
                case "video":
                  c.pushTexture2d(Object.assign(Object.assign({}, H), { stream: U, timestamp: t }));
                  break;
                case "detections":
                  j = H, j.stream = U, j.timestamp = t, c.pushDetectionList(j);
                  break;
                default:
                  throw Error("Unknown input config type: '" + F.type + "'");
              }
            }
          return f.i.send(c), P(Q, f.C, 4);
        case 4:
          c.delete(), Q.g = 0;
      }
    });
  };
  function x(e, u, f) {
    var t, c, a, b, I, F, H, U, j, Q, D, st, ht, ft;
    return gt(function(Gt) {
      switch (Gt.g) {
        case 1:
          if (!f)
            return Gt.return(u);
          for (t = {}, c = 0, a = T(Object.keys(f)), b = a.next(); !b.done; b = a.next())
            I = b.value, F = f[I], typeof F != "string" && F.type === "texture" && u[F.stream] !== void 0 && ++c;
          1 < c && (e.G = !1), H = T(Object.keys(f)), b = H.next();
        case 2:
          if (b.done) {
            Gt.g = 4;
            break;
          }
          if (U = b.value, j = f[U], typeof j == "string")
            return ht = t, ft = U, P(Gt, w(e, U, u[j]), 14);
          if (Q = u[j.stream], j.type === "detection_list") {
            if (Q) {
              for (var vt = Q.getRectList(), Kt = Q.getLandmarksList(), le = Q.getClassificationsList(), ce = [], ke = 0; ke < vt.size(); ++ke) {
                var Wn = Kn(vt.get(ke), wt, ae);
                Wn = { T: { X: ue(Wn, 1), Y: ue(Wn, 2), height: ue(Wn, 3), width: ue(Wn, 4), rotation: ue(Wn, 5, 0), W: de(Wn, 6, 0) }, O: K(Kt.get(ke)), M: Y(Kn(le.get(ke), V, O)) }, ce.push(Wn);
              }
              vt = ce;
            } else
              vt = [];
            t[U] = vt, Gt.g = 7;
            break;
          }
          if (j.type === "proto_list") {
            if (Q) {
              for (vt = Array(Q.size()), Kt = 0; Kt < Q.size(); Kt++)
                vt[Kt] = Q.get(Kt);
              Q.delete();
            } else
              vt = [];
            t[U] = vt, Gt.g = 7;
            break;
          }
          if (Q === void 0) {
            Gt.g = 3;
            break;
          }
          if (j.type === "float_list") {
            t[U] = Q, Gt.g = 7;
            break;
          }
          if (j.type === "proto") {
            t[U] = Q, Gt.g = 7;
            break;
          }
          if (j.type !== "texture")
            throw Error("Unknown output config type: '" + j.type + "'");
          return D = e.s[U], D || (D = new E(e.h, e.D), e.s[U] = D), P(Gt, et(D, Q, e.G), 13);
        case 13:
          st = Gt.h, t[U] = st;
        case 7:
          j.transform && t[U] && (t[U] = j.transform(t[U])), Gt.g = 3;
          break;
        case 14:
          ht[ft] = Gt.h;
        case 3:
          b = H.next(), Gt.g = 2;
          break;
        case 4:
          return Gt.return(t);
      }
    });
  }
  function w(e, u, f) {
    var t;
    return gt(function(c) {
      return typeof f == "number" || f instanceof Uint8Array || f instanceof e.h.Uint8BlobList ? c.return(f) : f instanceof e.h.Texture2dDataOut ? (t = e.s[u], t || (t = new E(e.h, e.D), e.s[u] = t), c.return(et(t, f, e.G))) : c.return(void 0);
    });
  }
  function J(e, u) {
    for (var f = u.name || "$", t = [].concat(B(u.wants)), c = new e.h.StringList(), a = T(u.wants), b = a.next(); !b.done; b = a.next())
      c.push_back(b.value);
    a = e.h.PacketListener.implement({ onResults: function(I) {
      for (var F = {}, H = 0; H < u.wants.length; ++H)
        F[t[H]] = I.get(H);
      var U = e.listeners[f];
      U && (e.C = x(e, F, u.outs).then(function(j) {
        j = U(j);
        for (var Q = 0; Q < u.wants.length; ++Q) {
          var D = F[t[Q]];
          typeof D == "object" && D.hasOwnProperty && D.hasOwnProperty("delete") && D.delete();
        }
        j && (e.C = j);
      }));
    } }), e.i.attachMultiListener(c, a), c.delete();
  }
  i.onResults = function(e, u) {
    this.listeners[u || "$"] = e;
  }, Ct("Solution", It), Ct("OptionType", { BOOL: 0, NUMBER: 1, Z: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function o(e) {
    return e.map(d);
  }
  function d(e) {
    e = Kn(e, y, L);
    var u = e.getMesh();
    if (!u)
      return e;
    var f = new Float32Array(u.getVertexBufferList());
    u.getVertexBufferList = function() {
      return f;
    };
    var t = new Uint32Array(u.getIndexBufferList());
    return u.getIndexBufferList = function() {
      return t;
    }, e;
  }
  function g(e) {
    var u = this;
    e = e || {}, this.g = new It({
      locateFile: e.locateFile,
      files: [{ url: "holistic_solution_packed_assets_loader.js" }, { simd: !1, url: "holistic_solution_wasm_bin.js" }, { simd: !0, url: "holistic_solution_simd_wasm_bin.js" }],
      graph: { url: "holistic.binarypb" },
      inputs: { image: { type: "video", stream: "input_frames_gpu" } },
      listeners: [{ wants: "left_hand_landmarks right_hand_landmarks face_landmarks pose_landmarks world_landmarks segmentation_mask image_transformed multi_face_geometry".split(" "), outs: { image: {
        type: "texture",
        stream: "image_transformed"
      }, leftHandLandmarks: { type: "proto", stream: "left_hand_landmarks", transform: K }, rightHandLandmarks: { type: "proto", stream: "right_hand_landmarks", transform: K }, faceLandmarks: { type: "proto", stream: "face_landmarks", transform: K }, poseLandmarks: { type: "proto", stream: "pose_landmarks", transform: K }, ea: { type: "proto", stream: "world_landmarks", transform: K }, segmentationMask: { type: "texture", stream: "segmentation_mask" }, multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: o } } }],
      options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: { calculatorName: "EnableFaceGeometryConstant", calculatorType: "ConstantSidePacketCalculator", fieldName: "bool_value" } }, selfieMode: { type: 0, graphOptionXref: {
        calculatorType: "GlScalerCalculator",
        calculatorIndex: 1,
        fieldName: "flip_horizontal"
      } }, modelComplexity: { type: 1, default: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(f) {
        var t, c, a, b;
        return gt(function(I) {
          if (I.g == 1) {
            switch (t = "", f) {
              case 1:
                t = "pose_landmark_full.tflite";
                break;
              case 2:
                t = "pose_landmark_heavy.tflite";
                break;
              default:
                t = "pose_landmark_lite.tflite";
            }
            return c = "third_party/mediapipe/modules/pose_landmark/" + t, a = u.g.locateFile(
              t,
              ""
            ), P(I, fetch(a), 3);
          }
          return I.g != 2 ? P(I, I.h.arrayBuffer(), 2) : (b = I.h, u.g.overrideFile(c, b), P(I, u.g.reset(), 0));
        });
      } }, smoothLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" } }, enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } }, smoothSegmentation: {
        type: 0,
        graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" }
      }, refineFaceLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineFaceLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: { type: 1, graphOptionXref: {
        calculatorType: "TensorsToDetectionsCalculator",
        calculatorName: "holisticlandmarkgpu__poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
        fieldName: "min_score_thresh"
      } }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "holisticlandmarkgpu__poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "near" } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: {
        type: 1,
        graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" }
      } }
    });
  }
  i = g.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(e) {
    this.g.onResults(e);
  }, i.initialize = function() {
    var e = this;
    return gt(function(u) {
      return P(u, e.g.initialize(), 0);
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(e) {
    var u = this;
    return gt(function(f) {
      return P(f, u.g.send(e), 0);
    });
  }, i.setOptions = function(e) {
    this.g.setOptions(e);
  }, Ct("Holistic", g), Ct("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } }), Ct("FACEMESH_LIPS", M), Ct("FACEMESH_LEFT_EYE", _), Ct("FACEMESH_LEFT_EYEBROW", A), Ct("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]), Ct("FACEMESH_RIGHT_EYE", q), Ct("FACEMESH_RIGHT_EYEBROW", lt), Ct("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]), Ct("FACEMESH_FACE_OVAL", s), Ct("FACEMESH_CONTOURS", G), Ct("FACEMESH_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [
      212,
      214
    ],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [
      92,
      40
    ],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [
      170,
      140
    ],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [
      100,
      36
    ],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [
      170,
      149
    ],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [138, 172],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [
      143,
      111
    ],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [38, 82],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [201, 83],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [
      228,
      24
    ],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [112, 233],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [
      332,
      297
    ],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [
      367,
      416
    ],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [399, 419],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [
      451,
      349
    ],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [
      462,
      328
    ],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [395, 369],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [
      197,
      419
    ],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [
      439,
      455
    ],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [436, 426],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [369, 262],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [
      428,
      262
    ],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [259, 444],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [
      372,
      383
    ],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [
      232,
      120
    ],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [160, 30],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [
      30,
      247
    ],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [91, 146],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [56, 28],
    [
      28,
      157
    ],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [122, 168],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [
      218,
      115
    ],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [
      222,
      52
    ],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [205, 36],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [
      212,
      186
    ],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [112, 232],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [236, 174],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [
      418,
      431
    ],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [
      421,
      18
    ],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [
      382,
      256
    ],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [346, 352],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [
      352,
      366
    ],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [349, 329],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [175, 396],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [
      195,
      248
    ],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [
      420,
      429
    ],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [410, 287],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [
      256,
      341
    ],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [412, 343],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]), Ct("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]), Ct("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]), Ct("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 }), Ct("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 }), Ct("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 }), Ct("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 }), Ct("matrixDataToMatrix", function(e) {
    for (var u = e.getCols(), f = e.getRows(), t = e.getPackedDataList(), c = [], a = 0; a < f; a++)
      c.push(Array(u));
    for (a = 0; a < f; a++)
      for (var b = 0; b < u; b++) {
        var I = e.getLayout() === 1 ? a * u + b : b * f + a;
        c[a][b] = t[I];
      }
    return c;
  }), Ct("VERSION", "0.5.1635989137");
}).call(gi);
const Zi = {};
(function() {
  var i;
  function r(o) {
    var d = 0;
    return function() {
      return d < o.length ? { done: !1, value: o[d++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(o, d, g) {
    return o == Array.prototype || o == Object.prototype || (o[d] = g.value), o;
  };
  function m(o) {
    o = [typeof globalThis == "object" && globalThis, o, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var d = 0; d < o.length; ++d) {
      var g = o[d];
      if (g && g.Math == Math)
        return g;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(o, d) {
    if (d)
      t: {
        var g = X;
        o = o.split(".");
        for (var e = 0; e < o.length - 1; e++) {
          var u = o[e];
          if (!(u in g))
            break t;
          g = g[u];
        }
        o = o[o.length - 1], e = g[o], d = d(e), d != e && d != null && n(g, o, { configurable: !0, writable: !0, value: d });
      }
  }
  S("Symbol", function(o) {
    function d(f) {
      if (this instanceof d)
        throw new TypeError("Symbol is not a constructor");
      return new g(e + (f || "") + "_" + u++, f);
    }
    function g(f, t) {
      this.g = f, n(this, "description", { configurable: !0, writable: !0, value: t });
    }
    if (o)
      return o;
    g.prototype.toString = function() {
      return this.g;
    };
    var e = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", u = 0;
    return d;
  }), S("Symbol.iterator", function(o) {
    if (o)
      return o;
    o = Symbol("Symbol.iterator");
    for (var d = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), g = 0; g < d.length; g++) {
      var e = X[d[g]];
      typeof e == "function" && typeof e.prototype[o] != "function" && n(e.prototype, o, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return o;
  });
  function C(o) {
    return o = { next: o }, o[Symbol.iterator] = function() {
      return this;
    }, o;
  }
  function T(o) {
    var d = typeof Symbol < "u" && Symbol.iterator && o[Symbol.iterator];
    return d ? d.call(o) : { next: r(o) };
  }
  function B(o) {
    if (!(o instanceof Array)) {
      o = T(o);
      for (var d, g = []; !(d = o.next()).done; )
        g.push(d.value);
      o = g;
    }
    return o;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(o) {
    function d() {
    }
    return d.prototype = o, new d();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(o, d) {
      if (o.__proto__ = d, o.__proto__ !== d)
        throw new TypeError(o + " is not extensible");
      return o;
    } : null;
  }
  var at = ut;
  function mt(o, d) {
    if (o.prototype = nt(d.prototype), o.prototype.constructor = o, at)
      at(o, d);
    else
      for (var g in d)
        if (g != "prototype")
          if (Object.defineProperties) {
            var e = Object.getOwnPropertyDescriptor(d, g);
            e && Object.defineProperty(o, g, e);
          } else
            o[g] = d[g];
    o.na = d.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.u = this.o = 0, this.j = null;
  }
  function kt(o) {
    if (o.l)
      throw new TypeError("Generator is already running");
    o.l = !0;
  }
  Bt.prototype.s = function(o) {
    this.h = o;
  };
  function ee(o, d) {
    o.j = { da: d, ea: !0 }, o.g = o.o || o.u;
  }
  Bt.prototype.return = function(o) {
    this.j = { return: o }, this.g = this.u;
  };
  function P(o, d, g) {
    return o.g = g, { value: d };
  }
  function De(o) {
    this.g = new Bt(), this.h = o;
  }
  function je(o, d) {
    kt(o.g);
    var g = o.g.i;
    return g ? We(o, "return" in g ? g.return : function(e) {
      return { value: e, done: !0 };
    }, d, o.g.return) : (o.g.return(d), jt(o));
  }
  function We(o, d, g, e) {
    try {
      var u = d.call(o.g.i, g);
      if (!(u instanceof Object))
        throw new TypeError("Iterator result " + u + " is not an object");
      if (!u.done)
        return o.g.l = !1, u;
      var f = u.value;
    } catch (t) {
      return o.g.i = null, ee(o.g, t), jt(o);
    }
    return o.g.i = null, e.call(o.g, f), jt(o);
  }
  function jt(o) {
    for (; o.g.g; )
      try {
        var d = o.h(o.g);
        if (d)
          return o.g.l = !1, { value: d.value, done: !1 };
      } catch (g) {
        o.g.h = void 0, ee(o.g, g);
      }
    if (o.g.l = !1, o.g.j) {
      if (d = o.g.j, o.g.j = null, d.ea)
        throw d.da;
      return { value: d.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(o) {
    this.next = function(d) {
      return kt(o.g), o.g.i ? d = We(o, o.g.i.next, d, o.g.s) : (o.g.s(d), d = jt(o)), d;
    }, this.throw = function(d) {
      return kt(o.g), o.g.i ? d = We(o, o.g.i.throw, d, o.g.s) : (ee(o.g, d), d = jt(o)), d;
    }, this.return = function(d) {
      return je(o, d);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(o) {
    function d(e) {
      return o.next(e);
    }
    function g(e) {
      return o.throw(e);
    }
    return new Promise(function(e, u) {
      function f(t) {
        t.done ? e(t.value) : Promise.resolve(t.value).then(d, g).then(f, u);
      }
      f(o.next());
    });
  }
  function gt(o) {
    return ne(new Cn(new De(o)));
  }
  S("Promise", function(o) {
    function d(t) {
      this.h = 0, this.i = void 0, this.g = [], this.s = !1;
      var c = this.j();
      try {
        t(c.resolve, c.reject);
      } catch (a) {
        c.reject(a);
      }
    }
    function g() {
      this.g = null;
    }
    function e(t) {
      return t instanceof d ? t : new d(function(c) {
        c(t);
      });
    }
    if (o)
      return o;
    g.prototype.h = function(t) {
      if (this.g == null) {
        this.g = [];
        var c = this;
        this.i(function() {
          c.l();
        });
      }
      this.g.push(t);
    };
    var u = X.setTimeout;
    g.prototype.i = function(t) {
      u(t, 0);
    }, g.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var t = this.g;
        this.g = [];
        for (var c = 0; c < t.length; ++c) {
          var a = t[c];
          t[c] = null;
          try {
            a();
          } catch (b) {
            this.j(b);
          }
        }
      }
      this.g = null;
    }, g.prototype.j = function(t) {
      this.i(function() {
        throw t;
      });
    }, d.prototype.j = function() {
      function t(b) {
        return function(I) {
          a || (a = !0, b.call(c, I));
        };
      }
      var c = this, a = !1;
      return { resolve: t(this.D), reject: t(this.l) };
    }, d.prototype.D = function(t) {
      if (t === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (t instanceof d)
        this.H(t);
      else {
        t:
          switch (typeof t) {
            case "object":
              var c = t != null;
              break t;
            case "function":
              c = !0;
              break t;
            default:
              c = !1;
          }
        c ? this.A(t) : this.o(t);
      }
    }, d.prototype.A = function(t) {
      var c = void 0;
      try {
        c = t.then;
      } catch (a) {
        this.l(a);
        return;
      }
      typeof c == "function" ? this.I(c, t) : this.o(t);
    }, d.prototype.l = function(t) {
      this.u(2, t);
    }, d.prototype.o = function(t) {
      this.u(1, t);
    }, d.prototype.u = function(t, c) {
      if (this.h != 0)
        throw Error("Cannot settle(" + t + ", " + c + "): Promise already settled in state" + this.h);
      this.h = t, this.i = c, this.h === 2 && this.G(), this.B();
    }, d.prototype.G = function() {
      var t = this;
      u(function() {
        if (t.C()) {
          var c = X.console;
          typeof c < "u" && c.error(t.i);
        }
      }, 1);
    }, d.prototype.C = function() {
      if (this.s)
        return !1;
      var t = X.CustomEvent, c = X.Event, a = X.dispatchEvent;
      return typeof a > "u" ? !0 : (typeof t == "function" ? t = new t("unhandledrejection", { cancelable: !0 }) : typeof c == "function" ? t = new c("unhandledrejection", { cancelable: !0 }) : (t = X.document.createEvent("CustomEvent"), t.initCustomEvent("unhandledrejection", !1, !0, t)), t.promise = this, t.reason = this.i, a(t));
    }, d.prototype.B = function() {
      if (this.g != null) {
        for (var t = 0; t < this.g.length; ++t)
          f.h(this.g[t]);
        this.g = null;
      }
    };
    var f = new g();
    return d.prototype.H = function(t) {
      var c = this.j();
      t.M(c.resolve, c.reject);
    }, d.prototype.I = function(t, c) {
      var a = this.j();
      try {
        t.call(c, a.resolve, a.reject);
      } catch (b) {
        a.reject(b);
      }
    }, d.prototype.then = function(t, c) {
      function a(H, U) {
        return typeof H == "function" ? function(j) {
          try {
            b(H(j));
          } catch (Q) {
            I(Q);
          }
        } : U;
      }
      var b, I, F = new d(function(H, U) {
        b = H, I = U;
      });
      return this.M(a(t, b), a(c, I)), F;
    }, d.prototype.catch = function(t) {
      return this.then(void 0, t);
    }, d.prototype.M = function(t, c) {
      function a() {
        switch (b.h) {
          case 1:
            t(b.i);
            break;
          case 2:
            c(b.i);
            break;
          default:
            throw Error("Unexpected state: " + b.h);
        }
      }
      var b = this;
      this.g == null ? f.h(a) : this.g.push(a), this.s = !0;
    }, d.resolve = e, d.reject = function(t) {
      return new d(function(c, a) {
        a(t);
      });
    }, d.race = function(t) {
      return new d(function(c, a) {
        for (var b = T(t), I = b.next(); !I.done; I = b.next())
          e(I.value).M(c, a);
      });
    }, d.all = function(t) {
      var c = T(t), a = c.next();
      return a.done ? e([]) : new d(function(b, I) {
        function F(j) {
          return function(Q) {
            H[j] = Q, U--, U == 0 && b(H);
          };
        }
        var H = [], U = 0;
        do
          H.push(void 0), U++, e(a.value).M(F(H.length - 1), I), a = c.next();
        while (!a.done);
      });
    }, d;
  });
  function $e(o, d) {
    o instanceof String && (o += "");
    var g = 0, e = !1, u = { next: function() {
      if (!e && g < o.length) {
        var f = g++;
        return { value: d(f, o[f]), done: !1 };
      }
      return e = !0, { done: !0, value: void 0 };
    } };
    return u[Symbol.iterator] = function() {
      return u;
    }, u;
  }
  var An = typeof Object.assign == "function" ? Object.assign : function(o, d) {
    for (var g = 1; g < arguments.length; g++) {
      var e = arguments[g];
      if (e)
        for (var u in e)
          Object.prototype.hasOwnProperty.call(e, u) && (o[u] = e[u]);
    }
    return o;
  };
  S("Object.assign", function(o) {
    return o || An;
  }), S("Object.is", function(o) {
    return o || function(d, g) {
      return d === g ? d !== 0 || 1 / d === 1 / g : d !== d && g !== g;
    };
  }), S("Array.prototype.includes", function(o) {
    return o || function(d, g) {
      var e = this;
      e instanceof String && (e = String(e));
      var u = e.length;
      for (g = g || 0, 0 > g && (g = Math.max(g + u, 0)); g < u; g++) {
        var f = e[g];
        if (f === d || Object.is(f, d))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(o) {
    return o || function(d, g) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (d instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(d, g || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(o) {
    return o || function() {
      return $e(this, function(d) {
        return d;
      });
    };
  });
  var Re = this || self;
  function Ct(o, d) {
    o = o.split(".");
    var g = Re;
    o[0] in g || typeof g.execScript > "u" || g.execScript("var " + o[0]);
    for (var e; o.length && (e = o.shift()); )
      o.length || d === void 0 ? g[e] && g[e] !== Object.prototype[e] ? g = g[e] : g = g[e] = {} : g[e] = d;
  }
  function we() {
    throw Error("Invalid UTF8");
  }
  function sn(o, d) {
    return d = String.fromCharCode.apply(null, d), o == null ? d : o + d;
  }
  var vn, Tn = typeof TextDecoder < "u", Rn, Nn = typeof TextEncoder < "u", dn = {}, mn = null;
  function kn(o) {
    var d;
    d === void 0 && (d = 0), Me(), d = dn[d];
    for (var g = Array(Math.floor(o.length / 3)), e = d[64] || "", u = 0, f = 0; u < o.length - 2; u += 3) {
      var t = o[u], c = o[u + 1], a = o[u + 2], b = d[t >> 2];
      t = d[(t & 3) << 4 | c >> 4], c = d[(c & 15) << 2 | a >> 6], a = d[a & 63], g[f++] = b + t + c + a;
    }
    switch (b = 0, a = e, o.length - u) {
      case 2:
        b = o[u + 1], a = d[(b & 15) << 2] || e;
      case 1:
        o = o[u], g[f] = d[o >> 2] + d[(o & 3) << 4 | b >> 4] + a + e;
    }
    return g.join("");
  }
  function Fn(o) {
    var d = o.length, g = 3 * d / 4;
    g % 3 ? g = Math.floor(g) : "=.".indexOf(o[d - 1]) != -1 && (g = "=.".indexOf(o[d - 2]) != -1 ? g - 2 : g - 1);
    var e = new Uint8Array(g), u = 0;
    return ze(o, function(f) {
      e[u++] = f;
    }), u !== g ? e.subarray(0, u) : e;
  }
  function ze(o, d) {
    function g(a) {
      for (; e < o.length; ) {
        var b = o.charAt(e++), I = mn[b];
        if (I != null)
          return I;
        if (!/^[\s\xa0]*$/.test(b))
          throw Error("Unknown base64 encoding at char: " + b);
      }
      return a;
    }
    Me();
    for (var e = 0; ; ) {
      var u = g(-1), f = g(0), t = g(64), c = g(64);
      if (c === 64 && u === -1)
        break;
      d(u << 2 | f >> 4), t != 64 && (d(f << 4 & 240 | t >> 2), c != 64 && d(t << 6 & 192 | c));
    }
  }
  function Me() {
    if (!mn) {
      mn = {};
      for (var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), d = ["+/=", "+/", "-_=", "-_.", "-_"], g = 0; 5 > g; g++) {
        var e = o.concat(d[g].split(""));
        dn[g] = e;
        for (var u = 0; u < e.length; u++) {
          var f = e[u];
          mn[f] === void 0 && (mn[f] = u);
        }
      }
    }
  }
  var xn = typeof Uint8Array == "function";
  function Gn(o) {
    return xn && o != null && o instanceof Uint8Array;
  }
  var he;
  function Se(o) {
    if (this.L = o, o !== null && o.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var Oe = typeof Uint8Array.prototype.slice == "function", re = 0, Ve = 0;
  function ln(o, d) {
    if (o.constructor === Uint8Array)
      return o;
    if (o.constructor === ArrayBuffer)
      return new Uint8Array(o);
    if (o.constructor === Array)
      return new Uint8Array(o);
    if (o.constructor === String)
      return Fn(o);
    if (o.constructor === Se)
      return !d && (d = o.L) && d.constructor === Uint8Array ? d : (d = o.L, d = d == null || Gn(d) ? d : typeof d == "string" ? Fn(d) : null, (o = o.L = d) ? new Uint8Array(o) : he || (he = new Uint8Array(0)));
    if (o instanceof Uint8Array)
      return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ee(o, d) {
    return Error("Invalid wire type: " + o + " (at position " + d + ")");
  }
  function Qt() {
    return Error("Failed to read varint, encoding is invalid.");
  }
  function Ze(o, d) {
    d = d === void 0 ? {} : d, d = d.v === void 0 ? !1 : d.v, this.h = null, this.g = this.i = this.j = 0, this.v = d, o && Le(this, o);
  }
  function Le(o, d) {
    o.h = ln(d, o.v), o.j = 0, o.i = o.h.length, o.g = o.j;
  }
  Ze.prototype.reset = function() {
    this.g = this.j;
  };
  function At(o) {
    if (o.g > o.i)
      throw Error("Tried to read past the end of the data " + o.g + " > " + o.i);
  }
  function xe(o) {
    var d = o.h, g = d[o.g], e = g & 127;
    if (128 > g)
      return o.g += 1, At(o), e;
    if (g = d[o.g + 1], e |= (g & 127) << 7, 128 > g)
      return o.g += 2, At(o), e;
    if (g = d[o.g + 2], e |= (g & 127) << 14, 128 > g)
      return o.g += 3, At(o), e;
    if (g = d[o.g + 3], e |= (g & 127) << 21, 128 > g)
      return o.g += 4, At(o), e;
    if (g = d[o.g + 4], o.g += 5, e |= (g & 15) << 28, 128 > g)
      return At(o), e;
    if (128 <= d[o.g++] && 128 <= d[o.g++] && 128 <= d[o.g++] && 128 <= d[o.g++] && 128 <= d[o.g++])
      throw Qt();
    return At(o), e;
  }
  var zt = [];
  function be() {
    this.g = [];
  }
  be.prototype.length = function() {
    return this.g.length;
  }, be.prototype.end = function() {
    var o = this.g;
    return this.g = [], o;
  };
  function Ye(o, d) {
    for (; 127 < d; )
      o.g.push(d & 127 | 128), d >>>= 7;
    o.g.push(d);
  }
  function qe(o) {
    var d = {}, g = d.W === void 0 ? !1 : d.W;
    this.l = { v: d.v === void 0 ? !1 : d.v }, this.W = g, d = this.l, zt.length ? (g = zt.pop(), d && (g.v = d.v), o && Le(g, o), o = g) : o = new Ze(o, d), this.g = o, this.j = this.g.g, this.h = this.i = -1;
  }
  qe.prototype.reset = function() {
    this.g.reset(), this.j = this.g.g, this.h = this.i = -1;
  };
  function Xe(o) {
    var d = o.g;
    if (d.g == d.i)
      return !1;
    o.j = o.g.g;
    var g = xe(o.g) >>> 0;
    if (d = g >>> 3, g &= 7, !(0 <= g && 5 >= g))
      throw Ee(g, o.j);
    if (1 > d)
      throw Error("Invalid field number: " + d + " (at position " + o.j + ")");
    return o.i = d, o.h = g, !0;
  }
  function Ot(o) {
    switch (o.h) {
      case 0:
        if (o.h != 0)
          Ot(o);
        else
          t: {
            o = o.g;
            for (var d = o.g, g = d + 10; d < g; )
              if ((o.h[d++] & 128) === 0) {
                o.g = d, At(o);
                break t;
              }
            throw Qt();
          }
        break;
      case 1:
        o = o.g, o.g += 8, At(o);
        break;
      case 2:
        o.h != 2 ? Ot(o) : (d = xe(o.g) >>> 0, o = o.g, o.g += d, At(o));
        break;
      case 5:
        o = o.g, o.g += 4, At(o);
        break;
      case 3:
        d = o.i;
        do {
          if (!Xe(o))
            throw Error("Unmatched start-group tag: stream EOF");
          if (o.h == 4) {
            if (o.i != d)
              throw Error("Unmatched end-group tag");
            break;
          }
          Ot(o);
        } while (1);
        break;
      default:
        throw Ee(o.h, o.j);
    }
  }
  var Ae = [];
  function Pe() {
    this.i = [], this.h = 0, this.g = new be();
  }
  function Ie(o, d) {
    d.length !== 0 && (o.i.push(d), o.h += d.length);
  }
  function Xn(o, d) {
    if (d = d.ba) {
      Ie(o, o.g.end());
      for (var g = 0; g < d.length; g++)
        Ie(o, d[g]);
    }
  }
  var cn = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
  function _e(o, d) {
    Object.isFrozen(o) || (cn ? o[cn] |= d : o.N !== void 0 ? o.N |= d : Object.defineProperties(o, { N: { value: d, configurable: !0, writable: !0, enumerable: !1 } }));
  }
  function un(o) {
    var d;
    return cn ? d = o[cn] : d = o.N, d == null ? 0 : d;
  }
  function ve(o) {
    return _e(o, 1), o;
  }
  function Te(o) {
    return Array.isArray(o) ? !!(un(o) & 2) : !1;
  }
  function Ge(o) {
    if (!Array.isArray(o))
      throw Error("cannot mark non-array as immutable");
    _e(o, 2);
  }
  function ie(o) {
    return o !== null && typeof o == "object" && !Array.isArray(o) && o.constructor === Object;
  }
  var Qe = Object.freeze(ve([]));
  function qt(o) {
    if (Te(o.m))
      throw Error("Cannot mutate an immutable Message");
  }
  var Pt = typeof Symbol < "u" && typeof Symbol.hasInstance < "u";
  function hn(o) {
    return { value: o, configurable: !1, writable: !1, enumerable: !1 };
  }
  function fe(o, d, g) {
    return d === -1 ? null : d >= o.i ? o.g ? o.g[d] : void 0 : (g === void 0 ? 0 : g) && o.g && (g = o.g[d], g != null) ? g : o.m[d + o.h];
  }
  function Lt(o, d, g, e) {
    e = e === void 0 ? !1 : e, qt(o), d < o.i && !e ? o.m[d + o.h] = g : (o.g || (o.g = o.m[o.i + o.h] = {}))[d] = g;
  }
  function Vt(o, d, g, e) {
    g = g === void 0 ? !0 : g, e = e === void 0 ? !1 : e;
    var u = fe(o, d, e);
    return u == null && (u = Qe), Te(o.m) ? g && (Ge(u), Object.freeze(u)) : (u === Qe || Te(u)) && (u = ve(u.slice()), Lt(o, d, u, e)), u;
  }
  function oe(o, d, g) {
    return o = fe(o, d), o = o == null ? o : +o, o == null ? g === void 0 ? 0 : g : o;
  }
  function Fe(o, d, g, e) {
    o.j || (o.j = {});
    var u = Te(o.m), f = o.j[g];
    if (!f) {
      e = Vt(o, g, !0, e === void 0 ? !1 : e), f = [], u = u || Te(e);
      for (var t = 0; t < e.length; t++)
        f[t] = new d(e[t]), u && Ge(f[t].m);
      u && (Ge(f), Object.freeze(f)), o.j[g] = f;
    }
    return f;
  }
  function te(o, d, g, e, u) {
    var f = f === void 0 ? !1 : f;
    return qt(o), f = Fe(o, g, d, f), g = e || new g(), o = Vt(o, d), u != null ? (f.splice(u, 0, g), o.splice(u, 0, g.m)) : (f.push(g), o.push(g.m)), g;
  }
  function se(o, d) {
    return o = fe(o, d), o == null ? 0 : o;
  }
  function tt(o, d) {
    return o = fe(o, d), o == null ? "" : o;
  }
  function it(o) {
    switch (typeof o) {
      case "number":
        return isFinite(o) ? o : String(o);
      case "object":
        if (o && !Array.isArray(o)) {
          if (Gn(o))
            return kn(o);
          if (o instanceof Se) {
            var d = o.L;
            return d = d == null || typeof d == "string" ? d : xn && d instanceof Uint8Array ? kn(d) : null, (o.L = d) || "";
          }
        }
    }
    return o;
  }
  function ct(o) {
    var d = ue;
    return d = d === void 0 ? St : d, de(o, d);
  }
  function _t(o, d) {
    if (o != null) {
      if (Array.isArray(o))
        o = de(o, d);
      else if (ie(o)) {
        var g = {}, e;
        for (e in o)
          g[e] = _t(o[e], d);
        o = g;
      } else
        o = d(o);
      return o;
    }
  }
  function de(o, d) {
    for (var g = o.slice(), e = 0; e < g.length; e++)
      g[e] = _t(g[e], d);
    return Array.isArray(o) && un(o) & 1 && ve(g), g;
  }
  function ue(o) {
    return o && typeof o == "object" && o.toJSON ? o.toJSON() : (o = it(o), Array.isArray(o) ? ct(o) : o);
  }
  function St(o) {
    return Gn(o) ? new Uint8Array(o) : o;
  }
  function me(o, d, g) {
    o || (o = Ce), Ce = null;
    var e = this.constructor.h;
    o || (o = e ? [e] : []), this.h = (e ? 0 : -1) - (this.constructor.g || 0), this.j = void 0, this.m = o;
    t: {
      if (e = this.m.length, o = e - 1, e && (e = this.m[o], ie(e))) {
        this.i = o - this.h, this.g = e;
        break t;
      }
      d !== void 0 && -1 < d ? (this.i = Math.max(d, o + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
    }
    if (g)
      for (d = 0; d < g.length; d++)
        if (o = g[d], o < this.i)
          o += this.h, (e = this.m[o]) ? Array.isArray(e) && ve(e) : this.m[o] = Qe;
        else {
          e = this.g || (this.g = this.m[this.i + this.h] = {});
          var u = e[o];
          u ? Array.isArray(u) && ve(u) : e[o] = Qe;
        }
  }
  me.prototype.toJSON = function() {
    return ct(this.m);
  }, me.prototype.toString = function() {
    return this.m.toString();
  };
  var Ce;
  function tn() {
    me.apply(this, arguments);
  }
  if (mt(tn, me), Pt) {
    var en = {};
    Object.defineProperties(tn, (en[Symbol.hasInstance] = hn(function() {
      throw Error("Cannot perform instanceof checks for MutableMessage");
    }), en));
  }
  function fn(o, d, g) {
    if (g) {
      var e = {}, u;
      for (u in g) {
        var f = g[u], t = f.ha;
        t || (e.F = f.la || f.fa.P, f.aa ? (e.U = In(f.aa), t = function(c) {
          return function(a, b, I) {
            return c.F(a, b, I, c.U);
          };
        }(e)) : f.ca ? (e.T = Be(f.X.g, f.ca), t = function(c) {
          return function(a, b, I) {
            return c.F(a, b, I, c.T);
          };
        }(e)) : t = e.F, f.ha = t), t(d, o, f.X), e = { F: e.F, U: e.U, T: e.T };
      }
    }
    Xn(d, o);
  }
  var pn = Symbol();
  function He(o, d, g) {
    return o[pn] || (o[pn] = function(e, u) {
      return d(e, u, g);
    });
  }
  function nn(o) {
    var d = o[pn];
    if (!d) {
      var g = p(o);
      d = function(e, u) {
        return W(e, u, g);
      }, o[pn] = d;
    }
    return d;
  }
  function Kn(o) {
    var d = o.aa;
    if (d)
      return nn(d);
    if (d = o.ka)
      return He(o.X.g, d, o.ca);
  }
  function rn(o) {
    var d = Kn(o), g = o.X, e = o.fa.O;
    return d ? function(u, f) {
      return e(u, f, g, d);
    } : function(u, f) {
      return e(u, f, g);
    };
  }
  function Ne(o, d, g, e, u, f) {
    o = o();
    var t = 0;
    for (o.length && typeof o[0] != "number" && (g(d, o[0]), t++); t < o.length; ) {
      g = o[t++];
      for (var c = t + 1; c < o.length && typeof o[c] != "number"; )
        c++;
      var a = o[t++];
      switch (c -= t, c) {
        case 0:
          e(d, g, a);
          break;
        case 1:
          e(d, g, a, o[t++]);
          break;
        case 2:
          u(d, g, a, o[t++], o[t++]);
          break;
        case 3:
          c = o[t++];
          var b = o[t++], I = o[t++];
          Array.isArray(I) ? u(d, g, a, c, b, I) : f(d, g, a, c, b, I);
          break;
        case 4:
          f(d, g, a, o[t++], o[t++], o[t++], o[t++]);
          break;
        default:
          throw Error("unexpected number of binary field arguments: " + c);
      }
    }
    return d;
  }
  var yn = Symbol();
  function In(o) {
    var d = o[yn];
    if (!d) {
      var g = an(o);
      d = function(e, u) {
        return k(e, u, g);
      }, o[yn] = d;
    }
    return d;
  }
  function Be(o, d) {
    var g = o[yn];
    return g || (g = function(e, u) {
      return fn(e, u, d);
    }, o[yn] = g), g;
  }
  var Un = Symbol();
  function on(o, d) {
    o.push(d);
  }
  function gn(o, d, g) {
    o.push(d, g.P);
  }
  function Sn(o, d, g, e, u) {
    var f = In(u), t = g.P;
    o.push(d, function(c, a, b) {
      return t(c, a, b, e, f);
    });
  }
  function En(o, d, g, e, u, f) {
    var t = Be(e, f), c = g.P;
    o.push(d, function(a, b, I) {
      return c(a, b, I, e, t);
    });
  }
  function an(o) {
    var d = o[Un];
    return d || Ne(o, o[Un] = [], on, gn, Sn, En);
  }
  var wn = Symbol();
  function Pn(o, d) {
    o[0] = d;
  }
  function _n(o, d, g, e) {
    var u = g.O;
    o[d] = e ? function(f, t, c) {
      return u(f, t, c, e);
    } : u;
  }
  function Yn(o, d, g, e, u, f) {
    var t = g.O, c = nn(u);
    o[d] = function(a, b, I) {
      return t(a, b, I, e, c, f);
    };
  }
  function Hn(o, d, g, e, u, f, t) {
    var c = g.O, a = He(e, u, f);
    o[d] = function(b, I, F) {
      return c(b, I, F, e, a, t);
    };
  }
  function p(o) {
    var d = o[wn];
    return d || Ne(o, o[wn] = {}, Pn, _n, Yn, Hn);
  }
  function W(o, d, g) {
    for (; Xe(d) && d.h != 4; ) {
      var e = d.i, u = g[e];
      if (!u) {
        var f = g[0];
        f && (f = f[e]) && (u = g[e] = rn(f));
      }
      if ((!u || !u(d, o, e)) && (u = d, e = o, f = u.j, Ot(u), !u.W)) {
        var t = u.g.h;
        u = u.g.g, u = f === u ? he || (he = new Uint8Array(0)) : Oe ? t.slice(f, u) : new Uint8Array(t.subarray(f, u)), (f = e.ba) ? f.push(u) : e.ba = [u];
      }
    }
    return o;
  }
  function V(o, d, g) {
    if (Ae.length) {
      var e = Ae.pop();
      o && (Le(e.g, o), e.i = -1, e.h = -1), o = e;
    } else
      o = new qe(o);
    try {
      return W(new d(), o, p(g));
    } finally {
      d = o.g, d.h = null, d.j = 0, d.i = 0, d.g = 0, d.v = !1, o.i = -1, o.h = -1, 100 > Ae.length && Ae.push(o);
    }
  }
  function k(o, d, g) {
    for (var e = g.length, u = e % 2 == 1, f = u ? 1 : 0; f < e; f += 2)
      (0, g[f + 1])(d, o, g[f]);
    fn(o, d, u ? g[0] : void 0);
  }
  function O(o, d) {
    var g = new Pe();
    k(o, g, an(d)), Ie(g, g.g.end()), o = new Uint8Array(g.h), d = g.i;
    for (var e = d.length, u = 0, f = 0; f < e; f++) {
      var t = d[f];
      o.set(t, u), u += t.length;
    }
    return g.i = [o], o;
  }
  function ot(o, d) {
    return { O: o, P: d };
  }
  var z = ot(function(o, d, g) {
    if (o.h !== 5)
      return !1;
    o = o.g;
    var e = o.h[o.g], u = o.h[o.g + 1], f = o.h[o.g + 2], t = o.h[o.g + 3];
    return o.g += 4, At(o), u = (e << 0 | u << 8 | f << 16 | t << 24) >>> 0, o = 2 * (u >> 31) + 1, e = u >>> 23 & 255, u &= 8388607, Lt(d, g, e == 255 ? u ? NaN : 1 / 0 * o : e == 0 ? o * Math.pow(2, -149) * u : o * Math.pow(2, e - 150) * (u + Math.pow(2, 23))), !0;
  }, function(o, d, g) {
    if (d = fe(d, g), d != null) {
      Ye(o.g, 8 * g + 5), o = o.g;
      var e = d;
      e = (g = 0 > e ? 1 : 0) ? -e : e, e === 0 ? 0 < 1 / e ? re = Ve = 0 : (Ve = 0, re = 2147483648) : isNaN(e) ? (Ve = 0, re = 2147483647) : 34028234663852886e22 < e ? (Ve = 0, re = (g << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > e ? (e = Math.round(e / Math.pow(2, -149)), Ve = 0, re = (g << 31 | e) >>> 0) : (d = Math.floor(Math.log(e) / Math.LN2), e *= Math.pow(2, -d), e = Math.round(8388608 * e), 16777216 <= e && ++d, Ve = 0, re = (g << 31 | d + 127 << 23 | e & 8388607) >>> 0), g = re, o.g.push(g >>> 0 & 255), o.g.push(g >>> 8 & 255), o.g.push(g >>> 16 & 255), o.g.push(g >>> 24 & 255);
    }
  }), rt = ot(function(o, d, g) {
    if (o.h !== 0)
      return !1;
    for (var e = o.g, u = 128, f = 0, t = o = 0; 4 > t && 128 <= u; t++)
      u = e.h[e.g++], At(e), f |= (u & 127) << 7 * t;
    if (128 <= u && (u = e.h[e.g++], At(e), f |= (u & 127) << 28, o |= (u & 127) >> 4), 128 <= u)
      for (t = 0; 5 > t && 128 <= u; t++)
        u = e.h[e.g++], At(e), o |= (u & 127) << 7 * t + 3;
    if (128 > u)
      e = f >>> 0, u = o >>> 0, (o = u & 2147483648) && (e = ~e + 1 >>> 0, u = ~u >>> 0, e == 0 && (u = u + 1 >>> 0)), e = 4294967296 * u + (e >>> 0);
    else
      throw Qt();
    return Lt(d, g, o ? -e : e), !0;
  }, function(o, d, g) {
    if (d = fe(d, g), d != null && d != null) {
      Ye(o.g, 8 * g), o = o.g;
      var e = d;
      for (g = 0 > e, e = Math.abs(e), d = e >>> 0, e = Math.floor((e - d) / 4294967296), e >>>= 0, g && (e = ~e >>> 0, d = (~d >>> 0) + 1, 4294967295 < d && (d = 0, e++, 4294967295 < e && (e = 0))), re = d, Ve = e, g = re, d = Ve; 0 < d || 127 < g; )
        o.g.push(g & 127 | 128), g = (g >>> 7 | d << 25) >>> 0, d >>>= 7;
      o.g.push(g);
    }
  }), bt = ot(function(o, d, g) {
    return o.h !== 0 ? !1 : (Lt(d, g, xe(o.g)), !0);
  }, function(o, d, g) {
    if (d = fe(d, g), d != null && d != null)
      if (Ye(o.g, 8 * g), o = o.g, g = d, 0 <= g)
        Ye(o, g);
      else {
        for (d = 0; 9 > d; d++)
          o.g.push(g & 127 | 128), g >>= 7;
        o.g.push(1);
      }
  }), Rt = ot(function(o, d, g) {
    if (o.h !== 2)
      return !1;
    var e = xe(o.g) >>> 0;
    o = o.g;
    var u = o.g;
    o.g += e, At(o), o = o.h;
    var f;
    if (Tn)
      (f = vn) || (f = vn = new TextDecoder("utf-8", { fatal: !0 })), f = f.decode(o.subarray(u, u + e));
    else {
      e = u + e;
      for (var t = [], c = null, a, b, I; u < e; )
        a = o[u++], 128 > a ? t.push(a) : 224 > a ? u >= e ? we() : (b = o[u++], 194 > a || (b & 192) !== 128 ? (u--, we()) : t.push((a & 31) << 6 | b & 63)) : 240 > a ? u >= e - 1 ? we() : (b = o[u++], (b & 192) !== 128 || a === 224 && 160 > b || a === 237 && 160 <= b || ((f = o[u++]) & 192) !== 128 ? (u--, we()) : t.push((a & 15) << 12 | (b & 63) << 6 | f & 63)) : 244 >= a ? u >= e - 2 ? we() : (b = o[u++], (b & 192) !== 128 || (a << 28) + (b - 144) >> 30 !== 0 || ((f = o[u++]) & 192) !== 128 || ((I = o[u++]) & 192) !== 128 ? (u--, we()) : (a = (a & 7) << 18 | (b & 63) << 12 | (f & 63) << 6 | I & 63, a -= 65536, t.push((a >> 10 & 1023) + 55296, (a & 1023) + 56320))) : we(), 8192 <= t.length && (c = sn(c, t), t.length = 0);
      f = sn(c, t);
    }
    return Lt(d, g, f), !0;
  }, function(o, d, g) {
    if (d = fe(d, g), d != null) {
      var e = !1;
      if (e = e === void 0 ? !1 : e, Nn) {
        if (e && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(d))
          throw Error("Found an unpaired surrogate");
        d = (Rn || (Rn = new TextEncoder())).encode(d);
      } else {
        for (var u = 0, f = new Uint8Array(3 * d.length), t = 0; t < d.length; t++) {
          var c = d.charCodeAt(t);
          if (128 > c)
            f[u++] = c;
          else {
            if (2048 > c)
              f[u++] = c >> 6 | 192;
            else {
              if (55296 <= c && 57343 >= c) {
                if (56319 >= c && t < d.length) {
                  var a = d.charCodeAt(++t);
                  if (56320 <= a && 57343 >= a) {
                    c = 1024 * (c - 55296) + a - 56320 + 65536, f[u++] = c >> 18 | 240, f[u++] = c >> 12 & 63 | 128, f[u++] = c >> 6 & 63 | 128, f[u++] = c & 63 | 128;
                    continue;
                  } else
                    t--;
                }
                if (e)
                  throw Error("Found an unpaired surrogate");
                c = 65533;
              }
              f[u++] = c >> 12 | 224, f[u++] = c >> 6 & 63 | 128;
            }
            f[u++] = c & 63 | 128;
          }
        }
        d = f.subarray(0, u);
      }
      Ye(o.g, 8 * g + 2), Ye(o.g, d.length), Ie(o, o.g.end()), Ie(o, d);
    }
  }), Et = ot(function(o, d, g, e, u) {
    if (o.h !== 2)
      return !1;
    d = te(d, g, e), g = o.g.i, e = xe(o.g) >>> 0;
    var f = o.g.g + e, t = f - g;
    if (0 >= t && (o.g.i = f, u(d, o), t = f - o.g.g), t)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (e + " bytes, instead read " + (e - t) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    return o.g.g = f, o.g.i = g, !0;
  }, function(o, d, g, e, u) {
    if (d = Fe(d, e, g), d != null)
      for (e = 0; e < d.length; e++) {
        var f = o;
        Ye(f.g, 8 * g + 2);
        var t = f.g.end();
        Ie(f, t), t.push(f.h), f = t, u(d[e], o), t = o;
        var c = f.pop();
        for (c = t.h + t.g.length() - c; 127 < c; )
          f.push(c & 127 | 128), c >>>= 7, t.h++;
        f.push(c), t.h++;
      }
  });
  function Nt() {
    tn.apply(this, arguments);
  }
  if (mt(Nt, tn), Pt) {
    var $t = {};
    Object.defineProperties(Nt, ($t[Symbol.hasInstance] = hn(Object[Symbol.hasInstance]), $t));
  }
  function Jt(o) {
    Nt.call(this, o);
  }
  mt(Jt, Nt);
  function wt() {
    return [1, bt, 2, z, 3, Rt, 4, Rt];
  }
  function Ut(o) {
    Nt.call(this, o, -1, ae);
  }
  mt(Ut, Nt), Ut.prototype.addClassification = function(o, d) {
    return te(this, 1, Jt, o, d), this;
  };
  function Dt() {
    return [1, Et, Jt, wt];
  }
  var ae = [1];
  function pe(o) {
    Nt.call(this, o);
  }
  mt(pe, Nt);
  function ye() {
    return [1, z, 2, z, 3, z, 4, z, 5, z];
  }
  function Je(o) {
    Nt.call(this, o, -1, y);
  }
  mt(Je, Nt);
  function h() {
    return [1, Et, pe, ye];
  }
  var y = [1];
  function v(o) {
    Nt.call(this, o);
  }
  mt(v, Nt);
  function L() {
    return [1, z, 2, z, 3, z, 4, z, 5, z, 6, rt];
  }
  var M = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], _ = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], A = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], q = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], lt = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], s = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], G = [].concat(B(M), B(_), B(A), B(q), B(lt), B(s));
  function R(o, d, g) {
    if (g = o.createShader(g === 0 ? o.VERTEX_SHADER : o.FRAGMENT_SHADER), o.shaderSource(g, d), o.compileShader(g), !o.getShaderParameter(g, o.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + o.getShaderInfoLog(g));
    return g;
  }
  function Y(o) {
    return Fe(o, Jt, 1).map(function(d) {
      return { index: se(d, 1), ga: oe(d, 2), label: fe(d, 3) != null ? tt(d, 3) : void 0, displayName: fe(d, 4) != null ? tt(d, 4) : void 0 };
    });
  }
  function N(o) {
    return { x: oe(o, 1), y: oe(o, 2), z: oe(o, 3), visibility: fe(o, 4) != null ? oe(o, 4) : void 0 };
  }
  function K(o, d) {
    this.h = o, this.g = d, this.l = 0;
  }
  function E(o, d, g) {
    return et(o, d), typeof o.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(o.g.canvas.transferToImageBitmap()) : g ? Promise.resolve(o.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(o.g.canvas) : (o.i === void 0 && (o.i = document.createElement("canvas")), new Promise(function(e) {
      o.i.height = o.g.canvas.height, o.i.width = o.g.canvas.width, o.i.getContext("2d", {}).drawImage(o.g.canvas, 0, 0, o.g.canvas.width, o.g.canvas.height), e(o.i);
    }));
  }
  function et(o, d) {
    var g = o.g;
    if (o.o === void 0) {
      var e = R(g, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), u = R(g, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), f = g.createProgram();
      if (g.attachShader(f, e), g.attachShader(f, u), g.linkProgram(f), !g.getProgramParameter(f, g.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + g.getProgramInfoLog(f));
      e = o.o = f, g.useProgram(e), u = g.getUniformLocation(e, "sampler0"), o.j = { K: g.getAttribLocation(e, "aVertex"), J: g.getAttribLocation(e, "aTex"), ma: u }, o.u = g.createBuffer(), g.bindBuffer(g.ARRAY_BUFFER, o.u), g.enableVertexAttribArray(o.j.K), g.vertexAttribPointer(o.j.K, 2, g.FLOAT, !1, 0, 0), g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), g.STATIC_DRAW), g.bindBuffer(g.ARRAY_BUFFER, null), o.s = g.createBuffer(), g.bindBuffer(g.ARRAY_BUFFER, o.s), g.enableVertexAttribArray(o.j.J), g.vertexAttribPointer(
        o.j.J,
        2,
        g.FLOAT,
        !1,
        0,
        0
      ), g.bufferData(g.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), g.STATIC_DRAW), g.bindBuffer(g.ARRAY_BUFFER, null), g.uniform1i(u, 0);
    }
    e = o.j, g.useProgram(o.o), g.canvas.width = d.width, g.canvas.height = d.height, g.viewport(0, 0, d.width, d.height), g.activeTexture(g.TEXTURE0), o.h.bindTexture2d(d.glName), g.enableVertexAttribArray(e.K), g.bindBuffer(g.ARRAY_BUFFER, o.u), g.vertexAttribPointer(e.K, 2, g.FLOAT, !1, 0, 0), g.enableVertexAttribArray(e.J), g.bindBuffer(g.ARRAY_BUFFER, o.s), g.vertexAttribPointer(
      e.J,
      2,
      g.FLOAT,
      !1,
      0,
      0
    ), g.bindFramebuffer(g.DRAW_FRAMEBUFFER ? g.DRAW_FRAMEBUFFER : g.FRAMEBUFFER, null), g.clearColor(0, 0, 0, 0), g.clear(g.COLOR_BUFFER_BIT), g.colorMask(!0, !0, !0, !0), g.drawArrays(g.TRIANGLE_FAN, 0, 4), g.disableVertexAttribArray(e.K), g.disableVertexAttribArray(e.J), g.bindBuffer(g.ARRAY_BUFFER, null), o.h.bindTexture2d(0);
  }
  function $(o) {
    this.g = o;
  }
  var yt = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Xt(o, d) {
    return d + o;
  }
  function Mt(o, d) {
    window[o] = d;
  }
  function xt(o) {
    var d = document.createElement("script");
    return d.setAttribute("src", o), d.setAttribute("crossorigin", "anonymous"), new Promise(function(g) {
      d.addEventListener("load", function() {
        g();
      }, !1), d.addEventListener("error", function() {
        g();
      }, !1), document.body.appendChild(d);
    });
  }
  function dt() {
    return gt(function(o) {
      switch (o.g) {
        case 1:
          return o.o = 2, P(o, WebAssembly.instantiate(yt), 4);
        case 4:
          o.g = 3, o.o = 0;
          break;
        case 2:
          return o.o = 0, o.j = null, o.return(!1);
        case 3:
          return o.return(!0);
      }
    });
  }
  function Wt(o) {
    if (this.g = o, this.listeners = {}, this.j = {}, this.H = {}, this.o = {}, this.u = {}, this.I = this.s = this.Z = !0, this.D = Promise.resolve(), this.Y = "", this.C = {}, this.locateFile = o && o.locateFile || Xt, typeof window == "object")
      var d = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      d = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.$ = d, o.options) {
      d = T(Object.keys(o.options));
      for (var g = d.next(); !g.done; g = d.next()) {
        g = g.value;
        var e = o.options[g].default;
        e !== void 0 && (this.j[g] = typeof e == "function" ? e() : e);
      }
    }
  }
  i = Wt.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function It(o) {
    var d, g, e, u, f, t, c, a, b, I, F;
    return gt(function(H) {
      switch (H.g) {
        case 1:
          return o.Z ? (d = o.g.files === void 0 ? [] : typeof o.g.files == "function" ? o.g.files(o.j) : o.g.files, P(H, dt(), 2)) : H.return();
        case 2:
          if (g = H.h, typeof window == "object")
            return Mt("createMediapipeSolutionsWasm", { locateFile: o.locateFile }), Mt("createMediapipeSolutionsPackedAssets", { locateFile: o.locateFile }), t = d.filter(function(U) {
              return U.data !== void 0;
            }), c = d.filter(function(U) {
              return U.data === void 0;
            }), a = Promise.all(t.map(function(U) {
              var j = l(o, U.url);
              if (U.path !== void 0) {
                var Q = U.path;
                j = j.then(function(D) {
                  return o.overrideFile(Q, D), Promise.resolve(D);
                });
              }
              return j;
            })), b = Promise.all(c.map(function(U) {
              return U.simd === void 0 || U.simd && g || !U.simd && !g ? xt(o.locateFile(U.url, o.$)) : Promise.resolve();
            })).then(function() {
              var U, j, Q;
              return gt(function(D) {
                if (D.g == 1)
                  return U = window.createMediapipeSolutionsWasm, j = window.createMediapipeSolutionsPackedAssets, Q = o, P(D, U(j), 2);
                Q.h = D.h, D.g = 0;
              });
            }), I = function() {
              return gt(function(U) {
                return o.g.graph && o.g.graph.url ? U = P(
                  U,
                  l(o, o.g.graph.url),
                  0
                ) : (U.g = 0, U = void 0), U;
              });
            }(), P(H, Promise.all([b, a, I]), 7);
          if (typeof importScripts != "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          return e = d.filter(function(U) {
            return U.simd === void 0 || U.simd && g || !U.simd && !g;
          }).map(function(U) {
            return o.locateFile(U.url, o.$);
          }), importScripts.apply(null, B(e)), u = o, P(H, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          u.h = H.h, o.l = new OffscreenCanvas(1, 1), o.h.canvas = o.l, f = o.h.GL.createContext(o.l, {
            antialias: !1,
            alpha: !1,
            ja: typeof WebGL2RenderingContext < "u" ? 2 : 1
          }), o.h.GL.makeContextCurrent(f), H.g = 4;
          break;
        case 7:
          if (o.l = document.createElement("canvas"), F = o.l.getContext("webgl2", {}), !F && (F = o.l.getContext("webgl", {}), !F))
            return alert("Failed to create WebGL canvas context when passing video frame."), H.return();
          o.G = F, o.h.canvas = o.l, o.h.createContext(o.l, !0, !0, {});
        case 4:
          o.i = new o.h.SolutionWasm(), o.Z = !1, H.g = 0;
      }
    });
  }
  function Yt(o) {
    var d, g, e, u, f, t, c, a;
    return gt(function(b) {
      if (b.g == 1) {
        if (o.g.graph && o.g.graph.url && o.Y === o.g.graph.url)
          return b.return();
        if (o.s = !0, !o.g.graph || !o.g.graph.url) {
          b.g = 2;
          return;
        }
        return o.Y = o.g.graph.url, P(b, l(o, o.g.graph.url), 3);
      }
      for (b.g != 2 && (d = b.h, o.i.loadGraph(d)), g = T(Object.keys(o.C)), e = g.next(); !e.done; e = g.next())
        u = e.value, o.i.overrideFile(u, o.C[u]);
      if (o.C = {}, o.g.listeners)
        for (f = T(o.g.listeners), t = f.next(); !t.done; t = f.next())
          c = t.value, w(o, c);
      a = o.j, o.j = {}, o.setOptions(a), b.g = 0;
    });
  }
  i.reset = function() {
    var o = this;
    return gt(function(d) {
      o.i && (o.i.reset(), o.o = {}, o.u = {}), d.g = 0;
    });
  }, i.setOptions = function(o, d) {
    var g = this;
    if (d = d || this.g.options) {
      for (var e = [], u = [], f = {}, t = T(Object.keys(o)), c = t.next(); !c.done; f = { R: f.R, S: f.S }, c = t.next()) {
        var a = c.value;
        a in this.j && this.j[a] === o[a] || (this.j[a] = o[a], c = d[a], c !== void 0 && (c.onChange && (f.R = c.onChange, f.S = o[a], e.push(function(b) {
          return function() {
            var I;
            return gt(function(F) {
              if (F.g == 1)
                return P(F, b.R(b.S), 2);
              I = F.h, I === !0 && (g.s = !0), F.g = 0;
            });
          };
        }(f))), c.graphOptionXref && (a = { valueNumber: c.type === 1 ? o[a] : 0, valueBoolean: c.type === 0 ? o[a] : !1, valueString: c.type === 2 ? o[a] : "" }, c = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), c.graphOptionXref), a), u.push(c))));
      }
      (e.length !== 0 || u.length !== 0) && (this.s = !0, this.B = (this.B === void 0 ? [] : this.B).concat(u), this.A = (this.A === void 0 ? [] : this.A).concat(e));
    }
  };
  function Ft(o) {
    var d, g, e, u, f, t, c;
    return gt(function(a) {
      switch (a.g) {
        case 1:
          if (!o.s)
            return a.return();
          if (!o.A) {
            a.g = 2;
            break;
          }
          d = T(o.A), g = d.next();
        case 3:
          if (g.done) {
            a.g = 5;
            break;
          }
          return e = g.value, P(a, e(), 4);
        case 4:
          g = d.next(), a.g = 3;
          break;
        case 5:
          o.A = void 0;
        case 2:
          if (o.B) {
            for (u = new o.h.GraphOptionChangeRequestList(), f = T(o.B), t = f.next(); !t.done; t = f.next())
              c = t.value, u.push_back(c);
            o.i.changeOptions(u), u.delete(), o.B = void 0;
          }
          o.s = !1, a.g = 0;
      }
    });
  }
  i.initialize = function() {
    var o = this;
    return gt(function(d) {
      return d.g == 1 ? P(d, It(o), 2) : d.g != 3 ? P(d, Yt(o), 3) : P(d, Ft(o), 0);
    });
  };
  function l(o, d) {
    var g, e;
    return gt(function(u) {
      return d in o.H ? u.return(o.H[d]) : (g = o.locateFile(d, ""), e = fetch(g).then(function(f) {
        return f.arrayBuffer();
      }), o.H[d] = e, u.return(e));
    });
  }
  i.overrideFile = function(o, d) {
    this.i ? this.i.overrideFile(o, d) : this.C[o] = d;
  }, i.clearOverriddenFiles = function() {
    this.C = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(o, d) {
    var g = this, e, u, f, t, c, a, b, I, F;
    return gt(function(H) {
      switch (H.g) {
        case 1:
          return g.g.inputs ? (e = 1e3 * (d == null ? performance.now() : d), P(H, g.D, 2)) : H.return();
        case 2:
          return P(H, g.initialize(), 3);
        case 3:
          for (u = new g.h.PacketDataList(), f = T(Object.keys(o)), t = f.next(); !t.done; t = f.next())
            if (c = t.value, a = g.g.inputs[c]) {
              t: {
                var U = o[c];
                switch (a.type) {
                  case "video":
                    var j = g.o[a.stream];
                    if (j || (j = new K(g.h, g.G), g.o[a.stream] = j), j.l === 0 && (j.l = j.h.createTexture()), typeof HTMLVideoElement < "u" && U instanceof HTMLVideoElement)
                      var Q = U.videoWidth, D = U.videoHeight;
                    else
                      typeof HTMLImageElement < "u" && U instanceof HTMLImageElement ? (Q = U.naturalWidth, D = U.naturalHeight) : (Q = U.width, D = U.height);
                    D = { glName: j.l, width: Q, height: D }, Q = j.g, Q.canvas.width = D.width, Q.canvas.height = D.height, Q.activeTexture(Q.TEXTURE0), j.h.bindTexture2d(j.l), Q.texImage2D(Q.TEXTURE_2D, 0, Q.RGBA, Q.RGBA, Q.UNSIGNED_BYTE, U), j.h.bindTexture2d(0), j = D;
                    break t;
                  case "detections":
                    for (j = g.o[a.stream], j || (j = new $(g.h), g.o[a.stream] = j), j.data || (j.data = new j.g.DetectionListData()), j.data.reset(U.length), D = 0; D < U.length; ++D) {
                      Q = U[D];
                      var st = j.data, ht = st.setBoundingBox, ft = D, Gt = Q.boundingBox, vt = new v();
                      if (Lt(vt, 1, Gt.xCenter), Lt(vt, 2, Gt.yCenter), Lt(vt, 3, Gt.height), Lt(vt, 4, Gt.width), Lt(vt, 5, Gt.rotation), Lt(vt, 6, Gt.rectId), Gt = O(vt, L), ht.call(st, ft, Gt), Q.landmarks)
                        for (st = 0; st < Q.landmarks.length; ++st) {
                          vt = Q.landmarks[st];
                          var Kt = !!vt.visibility;
                          ht = j.data, ft = ht.addNormalizedLandmark, Gt = D, vt = Object.assign(Object.assign({}, vt), { visibility: Kt ? vt.visibility : 0 }), Kt = new pe(), Lt(
                            Kt,
                            1,
                            vt.x
                          ), Lt(Kt, 2, vt.y), Lt(Kt, 3, vt.z), vt.visibility && Lt(Kt, 4, vt.visibility), vt = O(Kt, ye), ft.call(ht, Gt, vt);
                        }
                      if (Q.V)
                        for (st = 0; st < Q.V.length; ++st)
                          ht = j.data, ft = ht.addClassification, Gt = D, vt = Q.V[st], Kt = new Jt(), Lt(Kt, 2, vt.ga), vt.index && Lt(Kt, 1, vt.index), vt.label && Lt(Kt, 3, vt.label), vt.displayName && Lt(Kt, 4, vt.displayName), vt = O(Kt, wt), ft.call(ht, Gt, vt);
                    }
                    j = j.data;
                    break t;
                  default:
                    j = {};
                }
              }
              switch (b = j, I = a.stream, a.type) {
                case "video":
                  u.pushTexture2d(Object.assign(Object.assign({}, b), { stream: I, timestamp: e }));
                  break;
                case "detections":
                  F = b, F.stream = I, F.timestamp = e, u.pushDetectionList(F);
                  break;
                default:
                  throw Error("Unknown input config type: '" + a.type + "'");
              }
            }
          return g.i.send(u), P(H, g.D, 4);
        case 4:
          u.delete(), H.g = 0;
      }
    });
  };
  function Z(o, d, g) {
    var e, u, f, t, c, a, b, I, F, H, U, j, Q, D;
    return gt(function(st) {
      switch (st.g) {
        case 1:
          if (!g)
            return st.return(d);
          for (e = {}, u = 0, f = T(Object.keys(g)), t = f.next(); !t.done; t = f.next())
            c = t.value, a = g[c], typeof a != "string" && a.type === "texture" && d[a.stream] !== void 0 && ++u;
          1 < u && (o.I = !1), b = T(Object.keys(g)), t = b.next();
        case 2:
          if (t.done) {
            st.g = 4;
            break;
          }
          if (I = t.value, F = g[I], typeof F == "string")
            return Q = e, D = I, P(st, x(o, I, d[F]), 14);
          if (H = d[F.stream], F.type === "detection_list") {
            if (H) {
              for (var ht = H.getRectList(), ft = H.getLandmarksList(), Gt = H.getClassificationsList(), vt = [], Kt = 0; Kt < ht.size(); ++Kt) {
                var le = V(ht.get(Kt), v, L);
                le = { boundingBox: { xCenter: oe(le, 1), yCenter: oe(le, 2), height: oe(le, 3), width: oe(le, 4), rotation: oe(le, 5, 0), rectId: se(le, 6) }, landmarks: Fe(V(ft.get(Kt), Je, h), pe, 1).map(N), V: Y(V(Gt.get(Kt), Ut, Dt)) }, vt.push(le);
              }
              ht = vt;
            } else
              ht = [];
            e[I] = ht, st.g = 7;
            break;
          }
          if (F.type === "proto_list") {
            if (H) {
              for (ht = Array(H.size()), ft = 0; ft < H.size(); ft++)
                ht[ft] = H.get(ft);
              H.delete();
            } else
              ht = [];
            e[I] = ht, st.g = 7;
            break;
          }
          if (H === void 0) {
            st.g = 3;
            break;
          }
          if (F.type === "float_list") {
            e[I] = H, st.g = 7;
            break;
          }
          if (F.type === "proto") {
            e[I] = H, st.g = 7;
            break;
          }
          if (F.type !== "texture")
            throw Error("Unknown output config type: '" + F.type + "'");
          return U = o.u[I], U || (U = new K(o.h, o.G), o.u[I] = U), P(st, E(U, H, o.I), 13);
        case 13:
          j = st.h, e[I] = j;
        case 7:
          F.transform && e[I] && (e[I] = F.transform(e[I])), st.g = 3;
          break;
        case 14:
          Q[D] = st.h;
        case 3:
          t = b.next(), st.g = 2;
          break;
        case 4:
          return st.return(e);
      }
    });
  }
  function x(o, d, g) {
    var e;
    return gt(function(u) {
      return typeof g == "number" || g instanceof Uint8Array || g instanceof o.h.Uint8BlobList ? u.return(g) : g instanceof o.h.Texture2dDataOut ? (e = o.u[d], e || (e = new K(o.h, o.G), o.u[d] = e), u.return(E(e, g, o.I))) : u.return(void 0);
    });
  }
  function w(o, d) {
    for (var g = d.name || "$", e = [].concat(B(d.wants)), u = new o.h.StringList(), f = T(d.wants), t = f.next(); !t.done; t = f.next())
      u.push_back(t.value);
    f = o.h.PacketListener.implement({ onResults: function(c) {
      for (var a = {}, b = 0; b < d.wants.length; ++b)
        a[e[b]] = c.get(b);
      var I = o.listeners[g];
      I && (o.D = Z(o, a, d.outs).then(function(F) {
        F = I(F);
        for (var H = 0; H < d.wants.length; ++H) {
          var U = a[e[H]];
          typeof U == "object" && U.hasOwnProperty && U.hasOwnProperty("delete") && U.delete();
        }
        F && (o.D = F);
      }));
    } }), o.i.attachMultiListener(u, f), u.delete();
  }
  i.onResults = function(o, d) {
    this.listeners[d || "$"] = o;
  }, Ct("Solution", Wt), Ct("OptionType", { BOOL: 0, NUMBER: 1, ia: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function J(o) {
    var d = this;
    o = o || {};
    var g = { url: "face_detection_short.binarypb" }, e = { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } };
    this.g = new Wt({
      locateFile: o.locateFile,
      files: [{ data: !0, url: "face_detection_short.binarypb" }, { data: !0, url: "face_detection_short_range.tflite" }, { simd: !0, url: "face_detection_solution_simd_wasm_bin.js" }, { simd: !1, url: "face_detection_solution_wasm_bin.js" }],
      graph: g,
      listeners: [{ wants: ["detections", "image_transformed"], outs: { image: "image_transformed", detections: { type: "detection_list", stream: "detections" } } }],
      inputs: { image: { type: "video", stream: "input_frames_gpu" } },
      options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, model: { type: 0, onChange: function(u) {
        var f, t, c, a, b, I;
        return gt(function(F) {
          switch (F.g) {
            case 1:
              f = u === "short" ? ["face_detection_short_range.tflite"] : ["face_detection_full_range_sparse.tflite"], t = T(f), c = t.next();
            case 2:
              if (c.done) {
                F.g = 4;
                break;
              }
              return a = c.value, b = "third_party/mediapipe/modules/face_detection/" + a, P(F, l(d.g, a), 5);
            case 5:
              I = F.h, d.g.overrideFile(b, I), c = t.next(), F.g = 2;
              break;
            case 4:
              return g.url = u === "short" ? "face_detection_short.binarypb" : "face_detection_full.binarypb", e.graphOptionXref.calculatorName = u === "short" ? "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator" : "facedetectionfullrangegpu__facedetectionfullrangecommon__TensorsToDetectionsCalculator", F.return(!0);
          }
        });
      } }, minDetectionConfidence: e }
    });
  }
  i = J.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(o) {
    this.g.onResults(o);
  }, i.initialize = function() {
    var o = this;
    return gt(function(d) {
      return P(d, o.g.initialize(), 0);
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(o) {
    var d = this;
    return gt(function(g) {
      return P(g, d.g.send(o), 0);
    });
  }, i.setOptions = function(o) {
    this.g.setOptions(o);
  }, Ct("FaceDetection", J), Ct("FACEDETECTION_LIPS", M), Ct("FACEDETECTION_LEFT_EYE", _), Ct("FACEDETECTION_LEFT_EYEBROW", A), Ct("FACEDETECTION_RIGHT_EYE", q), Ct("FACEDETECTION_RIGHT_EYEBROW", lt), Ct("FACEDETECTION_FACE_OVAL", s), Ct("FACEDETECTION_CONTOURS", G), Ct("FACEDETECTION_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [212, 214],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [92, 40],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [170, 140],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [100, 36],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [170, 149],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [
      138,
      172
    ],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [143, 111],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [
      38,
      82
    ],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [
      201,
      83
    ],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [228, 24],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [
      112,
      233
    ],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [332, 297],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [367, 416],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [
      399,
      419
    ],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [451, 349],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [462, 328],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [
      395,
      369
    ],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [197, 419],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [439, 455],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [
      436,
      426
    ],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [
      369,
      262
    ],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [428, 262],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [
      259,
      444
    ],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [372, 383],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [232, 120],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [
      160,
      30
    ],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [30, 247],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [
      91,
      146
    ],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [
      56,
      28
    ],
    [28, 157],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [
      122,
      168
    ],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [218, 115],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [222, 52],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [
      205,
      36
    ],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [212, 186],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [
      112,
      232
    ],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [
      236,
      174
    ],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [418, 431],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [421, 18],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [382, 256],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [
      346,
      352
    ],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [352, 366],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [
      349,
      329
    ],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [
      175,
      396
    ],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [195, 248],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [420, 429],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [
      410,
      287
    ],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [256, 341],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [
      412,
      343
    ],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]), Ct("VERSION", "0.4.1646425229");
}).call(Zi);
const vi = {};
(function() {
  var i;
  function r(h) {
    var y = 0;
    return function() {
      return y < h.length ? { done: !1, value: h[y++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(h, y, v) {
    return h == Array.prototype || h == Object.prototype || (h[y] = v.value), h;
  };
  function m(h) {
    h = [typeof globalThis == "object" && globalThis, h, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var y = 0; y < h.length; ++y) {
      var v = h[y];
      if (v && v.Math == Math)
        return v;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(h, y) {
    if (y)
      t: {
        var v = X;
        h = h.split(".");
        for (var L = 0; L < h.length - 1; L++) {
          var M = h[L];
          if (!(M in v))
            break t;
          v = v[M];
        }
        h = h[h.length - 1], L = v[h], y = y(L), y != L && y != null && n(v, h, { configurable: !0, writable: !0, value: y });
      }
  }
  S("Symbol", function(h) {
    function y(_) {
      if (this instanceof y)
        throw new TypeError("Symbol is not a constructor");
      return new v(L + (_ || "") + "_" + M++, _);
    }
    function v(_, A) {
      this.g = _, n(this, "description", { configurable: !0, writable: !0, value: A });
    }
    if (h)
      return h;
    v.prototype.toString = function() {
      return this.g;
    };
    var L = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", M = 0;
    return y;
  }), S("Symbol.iterator", function(h) {
    if (h)
      return h;
    h = Symbol("Symbol.iterator");
    for (var y = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), v = 0; v < y.length; v++) {
      var L = X[y[v]];
      typeof L == "function" && typeof L.prototype[h] != "function" && n(L.prototype, h, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return h;
  });
  function C(h) {
    return h = { next: h }, h[Symbol.iterator] = function() {
      return this;
    }, h;
  }
  function T(h) {
    var y = typeof Symbol < "u" && Symbol.iterator && h[Symbol.iterator];
    return y ? y.call(h) : { next: r(h) };
  }
  function B(h) {
    if (!(h instanceof Array)) {
      h = T(h);
      for (var y, v = []; !(y = h.next()).done; )
        v.push(y.value);
      h = v;
    }
    return h;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(h) {
    function y() {
    }
    return y.prototype = h, new y();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(h, y) {
      if (h.__proto__ = y, h.__proto__ !== y)
        throw new TypeError(h + " is not extensible");
      return h;
    } : null;
  }
  var at = ut;
  function mt(h, y) {
    if (h.prototype = nt(y.prototype), h.prototype.constructor = h, at)
      at(h, y);
    else
      for (var v in y)
        if (v != "prototype")
          if (Object.defineProperties) {
            var L = Object.getOwnPropertyDescriptor(y, v);
            L && Object.defineProperty(h, v, L);
          } else
            h[v] = y[v];
    h.ea = y.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
  }
  function kt(h) {
    if (h.l)
      throw new TypeError("Generator is already running");
    h.l = !0;
  }
  Bt.prototype.o = function(h) {
    this.h = h;
  };
  function ee(h, y) {
    h.j = { U: y, V: !0 }, h.g = h.m || h.s;
  }
  Bt.prototype.return = function(h) {
    this.j = { return: h }, this.g = this.s;
  };
  function P(h, y, v) {
    return h.g = v, { value: y };
  }
  function De(h) {
    this.g = new Bt(), this.h = h;
  }
  function je(h, y) {
    kt(h.g);
    var v = h.g.i;
    return v ? We(h, "return" in v ? v.return : function(L) {
      return { value: L, done: !0 };
    }, y, h.g.return) : (h.g.return(y), jt(h));
  }
  function We(h, y, v, L) {
    try {
      var M = y.call(h.g.i, v);
      if (!(M instanceof Object))
        throw new TypeError("Iterator result " + M + " is not an object");
      if (!M.done)
        return h.g.l = !1, M;
      var _ = M.value;
    } catch (A) {
      return h.g.i = null, ee(h.g, A), jt(h);
    }
    return h.g.i = null, L.call(h.g, _), jt(h);
  }
  function jt(h) {
    for (; h.g.g; )
      try {
        var y = h.h(h.g);
        if (y)
          return h.g.l = !1, { value: y.value, done: !1 };
      } catch (v) {
        h.g.h = void 0, ee(h.g, v);
      }
    if (h.g.l = !1, h.g.j) {
      if (y = h.g.j, h.g.j = null, y.V)
        throw y.U;
      return { value: y.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(h) {
    this.next = function(y) {
      return kt(h.g), h.g.i ? y = We(h, h.g.i.next, y, h.g.o) : (h.g.o(y), y = jt(h)), y;
    }, this.throw = function(y) {
      return kt(h.g), h.g.i ? y = We(h, h.g.i.throw, y, h.g.o) : (ee(h.g, y), y = jt(h)), y;
    }, this.return = function(y) {
      return je(h, y);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(h, y) {
    return y = new Cn(new De(y)), at && h.prototype && at(y, h.prototype), y;
  }
  function gt(h, y) {
    h instanceof String && (h += "");
    var v = 0, L = !1, M = { next: function() {
      if (!L && v < h.length) {
        var _ = v++;
        return { value: y(_, h[_]), done: !1 };
      }
      return L = !0, { done: !0, value: void 0 };
    } };
    return M[Symbol.iterator] = function() {
      return M;
    }, M;
  }
  var $e = typeof Object.assign == "function" ? Object.assign : function(h, y) {
    for (var v = 1; v < arguments.length; v++) {
      var L = arguments[v];
      if (L)
        for (var M in L)
          Object.prototype.hasOwnProperty.call(L, M) && (h[M] = L[M]);
    }
    return h;
  };
  S("Object.assign", function(h) {
    return h || $e;
  }), S("Promise", function(h) {
    function y(A) {
      this.h = 0, this.i = void 0, this.g = [], this.o = !1;
      var q = this.j();
      try {
        A(q.resolve, q.reject);
      } catch (lt) {
        q.reject(lt);
      }
    }
    function v() {
      this.g = null;
    }
    function L(A) {
      return A instanceof y ? A : new y(function(q) {
        q(A);
      });
    }
    if (h)
      return h;
    v.prototype.h = function(A) {
      if (this.g == null) {
        this.g = [];
        var q = this;
        this.i(function() {
          q.l();
        });
      }
      this.g.push(A);
    };
    var M = X.setTimeout;
    v.prototype.i = function(A) {
      M(A, 0);
    }, v.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var A = this.g;
        this.g = [];
        for (var q = 0; q < A.length; ++q) {
          var lt = A[q];
          A[q] = null;
          try {
            lt();
          } catch (s) {
            this.j(s);
          }
        }
      }
      this.g = null;
    }, v.prototype.j = function(A) {
      this.i(function() {
        throw A;
      });
    }, y.prototype.j = function() {
      function A(s) {
        return function(G) {
          lt || (lt = !0, s.call(q, G));
        };
      }
      var q = this, lt = !1;
      return { resolve: A(this.C), reject: A(this.l) };
    }, y.prototype.C = function(A) {
      if (A === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (A instanceof y)
        this.F(A);
      else {
        t:
          switch (typeof A) {
            case "object":
              var q = A != null;
              break t;
            case "function":
              q = !0;
              break t;
            default:
              q = !1;
          }
        q ? this.u(A) : this.m(A);
      }
    }, y.prototype.u = function(A) {
      var q = void 0;
      try {
        q = A.then;
      } catch (lt) {
        this.l(lt);
        return;
      }
      typeof q == "function" ? this.G(q, A) : this.m(A);
    }, y.prototype.l = function(A) {
      this.s(2, A);
    }, y.prototype.m = function(A) {
      this.s(1, A);
    }, y.prototype.s = function(A, q) {
      if (this.h != 0)
        throw Error("Cannot settle(" + A + ", " + q + "): Promise already settled in state" + this.h);
      this.h = A, this.i = q, this.h === 2 && this.D(), this.A();
    }, y.prototype.D = function() {
      var A = this;
      M(function() {
        if (A.B()) {
          var q = X.console;
          typeof q < "u" && q.error(A.i);
        }
      }, 1);
    }, y.prototype.B = function() {
      if (this.o)
        return !1;
      var A = X.CustomEvent, q = X.Event, lt = X.dispatchEvent;
      return typeof lt > "u" ? !0 : (typeof A == "function" ? A = new A("unhandledrejection", { cancelable: !0 }) : typeof q == "function" ? A = new q("unhandledrejection", { cancelable: !0 }) : (A = X.document.createEvent("CustomEvent"), A.initCustomEvent("unhandledrejection", !1, !0, A)), A.promise = this, A.reason = this.i, lt(A));
    }, y.prototype.A = function() {
      if (this.g != null) {
        for (var A = 0; A < this.g.length; ++A)
          _.h(this.g[A]);
        this.g = null;
      }
    };
    var _ = new v();
    return y.prototype.F = function(A) {
      var q = this.j();
      A.J(q.resolve, q.reject);
    }, y.prototype.G = function(A, q) {
      var lt = this.j();
      try {
        A.call(q, lt.resolve, lt.reject);
      } catch (s) {
        lt.reject(s);
      }
    }, y.prototype.then = function(A, q) {
      function lt(Y, N) {
        return typeof Y == "function" ? function(K) {
          try {
            s(Y(K));
          } catch (E) {
            G(E);
          }
        } : N;
      }
      var s, G, R = new y(function(Y, N) {
        s = Y, G = N;
      });
      return this.J(lt(A, s), lt(q, G)), R;
    }, y.prototype.catch = function(A) {
      return this.then(void 0, A);
    }, y.prototype.J = function(A, q) {
      function lt() {
        switch (s.h) {
          case 1:
            A(s.i);
            break;
          case 2:
            q(s.i);
            break;
          default:
            throw Error("Unexpected state: " + s.h);
        }
      }
      var s = this;
      this.g == null ? _.h(lt) : this.g.push(lt), this.o = !0;
    }, y.resolve = L, y.reject = function(A) {
      return new y(function(q, lt) {
        lt(A);
      });
    }, y.race = function(A) {
      return new y(function(q, lt) {
        for (var s = T(A), G = s.next(); !G.done; G = s.next())
          L(G.value).J(q, lt);
      });
    }, y.all = function(A) {
      var q = T(A), lt = q.next();
      return lt.done ? L([]) : new y(function(s, G) {
        function R(K) {
          return function(E) {
            Y[K] = E, N--, N == 0 && s(Y);
          };
        }
        var Y = [], N = 0;
        do
          Y.push(void 0), N++, L(lt.value).J(R(Y.length - 1), G), lt = q.next();
        while (!lt.done);
      });
    }, y;
  }), S("Object.is", function(h) {
    return h || function(y, v) {
      return y === v ? y !== 0 || 1 / y === 1 / v : y !== y && v !== v;
    };
  }), S("Array.prototype.includes", function(h) {
    return h || function(y, v) {
      var L = this;
      L instanceof String && (L = String(L));
      var M = L.length;
      for (v = v || 0, 0 > v && (v = Math.max(v + M, 0)); v < M; v++) {
        var _ = L[v];
        if (_ === y || Object.is(_, y))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(h) {
    return h || function(y, v) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (y instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(y, v || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(h) {
    return h || function() {
      return gt(this, function(y) {
        return y;
      });
    };
  });
  var An = this || self;
  function Re(h, y) {
    h = h.split(".");
    var v = An;
    h[0] in v || typeof v.execScript > "u" || v.execScript("var " + h[0]);
    for (var L; h.length && (L = h.shift()); )
      h.length || y === void 0 ? v[L] && v[L] !== Object.prototype[L] ? v = v[L] : v = v[L] = {} : v[L] = y;
  }
  function Ct(h, y) {
    return y = String.fromCharCode.apply(null, y), h == null ? y : h + y;
  }
  var we, sn = typeof TextDecoder < "u", vn, Tn = typeof TextEncoder < "u";
  function Rn(h) {
    if (Tn)
      h = (vn || (vn = new TextEncoder())).encode(h);
    else {
      var y = void 0;
      y = y === void 0 ? !1 : y;
      for (var v = 0, L = new Uint8Array(3 * h.length), M = 0; M < h.length; M++) {
        var _ = h.charCodeAt(M);
        if (128 > _)
          L[v++] = _;
        else {
          if (2048 > _)
            L[v++] = _ >> 6 | 192;
          else {
            if (55296 <= _ && 57343 >= _) {
              if (56319 >= _ && M < h.length) {
                var A = h.charCodeAt(++M);
                if (56320 <= A && 57343 >= A) {
                  _ = 1024 * (_ - 55296) + A - 56320 + 65536, L[v++] = _ >> 18 | 240, L[v++] = _ >> 12 & 63 | 128, L[v++] = _ >> 6 & 63 | 128, L[v++] = _ & 63 | 128;
                  continue;
                } else
                  M--;
              }
              if (y)
                throw Error("Found an unpaired surrogate");
              _ = 65533;
            }
            L[v++] = _ >> 12 | 224, L[v++] = _ >> 6 & 63 | 128;
          }
          L[v++] = _ & 63 | 128;
        }
      }
      h = L.subarray(0, v);
    }
    return h;
  }
  var Nn = {}, dn = null;
  function mn(h, y) {
    y === void 0 && (y = 0), ze(), y = Nn[y];
    for (var v = Array(Math.floor(h.length / 3)), L = y[64] || "", M = 0, _ = 0; M < h.length - 2; M += 3) {
      var A = h[M], q = h[M + 1], lt = h[M + 2], s = y[A >> 2];
      A = y[(A & 3) << 4 | q >> 4], q = y[(q & 15) << 2 | lt >> 6], lt = y[lt & 63], v[_++] = s + A + q + lt;
    }
    switch (s = 0, lt = L, h.length - M) {
      case 2:
        s = h[M + 1], lt = y[(s & 15) << 2] || L;
      case 1:
        h = h[M], v[_] = y[h >> 2] + y[(h & 3) << 4 | s >> 4] + lt + L;
    }
    return v.join("");
  }
  function kn(h) {
    var y = h.length, v = 3 * y / 4;
    v % 3 ? v = Math.floor(v) : "=.".indexOf(h[y - 1]) != -1 && (v = "=.".indexOf(h[y - 2]) != -1 ? v - 2 : v - 1);
    var L = new Uint8Array(v), M = 0;
    return Fn(h, function(_) {
      L[M++] = _;
    }), L.subarray(0, M);
  }
  function Fn(h, y) {
    function v(lt) {
      for (; L < h.length; ) {
        var s = h.charAt(L++), G = dn[s];
        if (G != null)
          return G;
        if (!/^[\s\xa0]*$/.test(s))
          throw Error("Unknown base64 encoding at char: " + s);
      }
      return lt;
    }
    ze();
    for (var L = 0; ; ) {
      var M = v(-1), _ = v(0), A = v(64), q = v(64);
      if (q === 64 && M === -1)
        break;
      y(M << 2 | _ >> 4), A != 64 && (y(_ << 4 & 240 | A >> 2), q != 64 && y(A << 6 & 192 | q));
    }
  }
  function ze() {
    if (!dn) {
      dn = {};
      for (var h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), y = ["+/=", "+/", "-_=", "-_.", "-_"], v = 0; 5 > v; v++) {
        var L = h.concat(y[v].split(""));
        Nn[v] = L;
        for (var M = 0; M < L.length; M++) {
          var _ = L[M];
          dn[_] === void 0 && (dn[_] = M);
        }
      }
    }
  }
  var Me = typeof Uint8Array.prototype.slice == "function", xn;
  function Gn(h, y, v) {
    return y === v ? xn || (xn = new Uint8Array(0)) : Me ? h.slice(y, v) : new Uint8Array(h.subarray(y, v));
  }
  var he = 0, Se = 0;
  function Oe(h, y) {
    y = y === void 0 ? {} : y, y = y.v === void 0 ? !1 : y.v, this.h = null, this.g = this.j = this.l = 0, this.m = !1, this.v = y, h && re(this, h);
  }
  function re(h, y) {
    y = y.constructor === Uint8Array ? y : y.constructor === ArrayBuffer ? new Uint8Array(y) : y.constructor === Array ? new Uint8Array(y) : y.constructor === String ? kn(y) : y instanceof Uint8Array ? new Uint8Array(y.buffer, y.byteOffset, y.byteLength) : new Uint8Array(0), h.h = y, h.l = 0, h.j = h.h.length, h.g = h.l;
  }
  Oe.prototype.reset = function() {
    this.g = this.l;
  };
  function Ve(h) {
    for (var y = 128, v = 0, L = 0, M = 0; 4 > M && 128 <= y; M++)
      y = h.h[h.g++], v |= (y & 127) << 7 * M;
    if (128 <= y && (y = h.h[h.g++], v |= (y & 127) << 28, L |= (y & 127) >> 4), 128 <= y)
      for (M = 0; 5 > M && 128 <= y; M++)
        y = h.h[h.g++], L |= (y & 127) << 7 * M + 3;
    if (128 > y)
      return h = v >>> 0, y = L >>> 0, (L = y & 2147483648) && (h = ~h + 1 >>> 0, y = ~y >>> 0, h == 0 && (y = y + 1 >>> 0)), h = 4294967296 * y + (h >>> 0), L ? -h : h;
    h.m = !0;
  }
  Oe.prototype.i = function() {
    var h = this.h, y = h[this.g], v = y & 127;
    return 128 > y ? (this.g += 1, v) : (y = h[this.g + 1], v |= (y & 127) << 7, 128 > y ? (this.g += 2, v) : (y = h[this.g + 2], v |= (y & 127) << 14, 128 > y ? (this.g += 3, v) : (y = h[this.g + 3], v |= (y & 127) << 21, 128 > y ? (this.g += 4, v) : (y = h[this.g + 4], v |= (y & 15) << 28, 128 > y ? (this.g += 5, v >>> 0) : (this.g += 5, 128 <= h[this.g++] && 128 <= h[this.g++] && 128 <= h[this.g++] && 128 <= h[this.g++] && this.g++, v)))));
  }, Oe.prototype.o = function() {
    var h = this.h[this.g], y = this.h[this.g + 1], v = this.h[this.g + 2], L = this.h[this.g + 3];
    return this.g += 4, v = (h << 0 | y << 8 | v << 16 | L << 24) >>> 0, h = 2 * (v >> 31) + 1, y = v >>> 23 & 255, v &= 8388607, y == 255 ? v ? NaN : 1 / 0 * h : y == 0 ? h * Math.pow(2, -149) * v : h * Math.pow(2, y - 150) * (v + Math.pow(2, 23));
  };
  var ln = [];
  function Ee() {
    this.g = new Uint8Array(64), this.h = 0;
  }
  Ee.prototype.push = function(h) {
    if (!(this.h + 1 < this.g.length)) {
      var y = this.g;
      this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length)), this.g.set(y);
    }
    this.g[this.h++] = h;
  }, Ee.prototype.length = function() {
    return this.h;
  }, Ee.prototype.end = function() {
    var h = this.g, y = this.h;
    return this.h = 0, Gn(h, 0, y);
  };
  function Qt(h, y) {
    for (; 127 < y; )
      h.push(y & 127 | 128), y >>>= 7;
    h.push(y);
  }
  function Ze(h) {
    var y = {}, v = y.N === void 0 ? !1 : y.N;
    this.o = { v: y.v === void 0 ? !1 : y.v }, this.N = v, y = this.o, ln.length ? (v = ln.pop(), y && (v.v = y.v), h && re(v, h), h = v) : h = new Oe(h, y), this.g = h, this.m = this.g.g, this.h = this.i = this.l = -1, this.j = !1;
  }
  Ze.prototype.reset = function() {
    this.g.reset(), this.h = this.l = -1;
  };
  function Le(h) {
    var y = h.g;
    if ((y = y.g == y.j) || (y = h.j) || (y = h.g, y = y.m || 0 > y.g || y.g > y.j), y)
      return !1;
    h.m = h.g.g, y = h.g.i();
    var v = y & 7;
    return v != 0 && v != 5 && v != 1 && v != 2 && v != 3 && v != 4 ? (h.j = !0, !1) : (h.i = y, h.l = y >>> 3, h.h = v, !0);
  }
  function At(h) {
    switch (h.h) {
      case 0:
        if (h.h != 0)
          At(h);
        else {
          for (h = h.g; h.h[h.g] & 128; )
            h.g++;
          h.g++;
        }
        break;
      case 1:
        h.h != 1 ? At(h) : (h = h.g, h.g += 8);
        break;
      case 2:
        if (h.h != 2)
          At(h);
        else {
          var y = h.g.i();
          h = h.g, h.g += y;
        }
        break;
      case 5:
        h.h != 5 ? At(h) : (h = h.g, h.g += 4);
        break;
      case 3:
        y = h.l;
        do {
          if (!Le(h)) {
            h.j = !0;
            break;
          }
          if (h.h == 4) {
            h.l != y && (h.j = !0);
            break;
          }
          At(h);
        } while (1);
        break;
      default:
        h.j = !0;
    }
  }
  function xe(h, y, v) {
    var L = h.g.j, M = h.g.i(), _ = h.g.g + M;
    if (h.g.j = _, v(y, h), v = _ - h.g.g, v !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + M + " bytes, instead read " + (M - v) + " bytes, either the data ended unexpectedly or the message misreported its own length");
    return h.g.g = _, h.g.j = L, y;
  }
  function zt(h) {
    return h.g.o();
  }
  function be(h) {
    var y = h.g.i();
    h = h.g;
    var v = h.g;
    h.g += y, h = h.h;
    var L;
    if (sn)
      (L = we) || (L = we = new TextDecoder("utf-8", { fatal: !1 })), L = L.decode(h.subarray(v, v + y));
    else {
      y = v + y;
      for (var M = [], _ = null, A, q, lt; v < y; )
        A = h[v++], 128 > A ? M.push(A) : 224 > A ? v >= y ? M.push(65533) : (q = h[v++], 194 > A || (q & 192) !== 128 ? (v--, M.push(65533)) : M.push((A & 31) << 6 | q & 63)) : 240 > A ? v >= y - 1 ? M.push(65533) : (q = h[v++], (q & 192) !== 128 || A === 224 && 160 > q || A === 237 && 160 <= q || ((L = h[v++]) & 192) !== 128 ? (v--, M.push(65533)) : M.push((A & 15) << 12 | (q & 63) << 6 | L & 63)) : 244 >= A ? v >= y - 2 ? M.push(65533) : (q = h[v++], (q & 192) !== 128 || (A << 28) + (q - 144) >> 30 !== 0 || ((L = h[v++]) & 192) !== 128 || ((lt = h[v++]) & 192) !== 128 ? (v--, M.push(65533)) : (A = (A & 7) << 18 | (q & 63) << 12 | (L & 63) << 6 | lt & 63, A -= 65536, M.push((A >> 10 & 1023) + 55296, (A & 1023) + 56320))) : M.push(65533), 8192 <= M.length && (_ = Ct(_, M), M.length = 0);
      L = Ct(_, M);
    }
    return L;
  }
  function Ye(h, y, v) {
    var L = h.g.i();
    for (L = h.g.g + L; h.g.g < L; )
      v.push(y.call(h.g));
  }
  function qe(h, y) {
    h.h == 2 ? Ye(h, Oe.prototype.o, y) : y.push(zt(h));
  }
  function Xe() {
    this.h = [], this.i = 0, this.g = new Ee();
  }
  function Ot(h, y) {
    y.length !== 0 && (h.h.push(y), h.i += y.length);
  }
  function Ae(h) {
    var y = h.i + h.g.length();
    if (y === 0)
      return new Uint8Array(0);
    y = new Uint8Array(y);
    for (var v = h.h, L = v.length, M = 0, _ = 0; _ < L; _++) {
      var A = v[_];
      A.length !== 0 && (y.set(A, M), M += A.length);
    }
    return v = h.g, L = v.h, L !== 0 && (y.set(v.g.subarray(0, L), M), v.h = 0), h.h = [y], y;
  }
  function Pe(h, y, v) {
    if (v != null) {
      Qt(h.g, 8 * y + 5), h = h.g;
      var L = v;
      L = (v = 0 > L ? 1 : 0) ? -L : L, L === 0 ? 0 < 1 / L ? he = Se = 0 : (Se = 0, he = 2147483648) : isNaN(L) ? (Se = 0, he = 2147483647) : 34028234663852886e22 < L ? (Se = 0, he = (v << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > L ? (L = Math.round(L / Math.pow(2, -149)), Se = 0, he = (v << 31 | L) >>> 0) : (y = Math.floor(Math.log(L) / Math.LN2), L *= Math.pow(2, -y), L = Math.round(8388608 * L), 16777216 <= L && ++y, Se = 0, he = (v << 31 | y + 127 << 23 | L & 8388607) >>> 0), v = he, h.push(v >>> 0 & 255), h.push(v >>> 8 & 255), h.push(v >>> 16 & 255), h.push(v >>> 24 & 255);
    }
  }
  var Ie = typeof Uint8Array == "function";
  function Xn(h, y, v) {
    if (h != null)
      return typeof h == "object" ? Ie && h instanceof Uint8Array ? v(h) : cn(h, y, v) : y(h);
  }
  function cn(h, y, v) {
    if (Array.isArray(h)) {
      for (var L = Array(h.length), M = 0; M < h.length; M++)
        L[M] = Xn(h[M], y, v);
      return Array.isArray(h) && h.W && ve(L), L;
    }
    L = {};
    for (M in h)
      L[M] = Xn(h[M], y, v);
    return L;
  }
  function _e(h) {
    return typeof h == "number" ? isFinite(h) ? h : String(h) : h;
  }
  var un = { W: { value: !0, configurable: !0 } };
  function ve(h) {
    return Array.isArray(h) && !Object.isFrozen(h) && Object.defineProperties(h, un), h;
  }
  var Te;
  function Ge(h, y, v) {
    var L = Te;
    Te = null, h || (h = L), L = this.constructor.ca, h || (h = L ? [L] : []), this.j = L ? 0 : -1, this.m = this.g = null, this.h = h;
    t: {
      if (L = this.h.length, h = L - 1, L && (L = this.h[h], !(L === null || typeof L != "object" || Array.isArray(L) || Ie && L instanceof Uint8Array))) {
        this.l = h - this.j, this.i = L;
        break t;
      }
      y !== void 0 && -1 < y ? (this.l = Math.max(y, h + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
    }
    if (v)
      for (y = 0; y < v.length; y++)
        h = v[y], h < this.l ? (h += this.j, (L = this.h[h]) ? ve(L) : this.h[h] = ie) : (Qe(this), (L = this.i[h]) ? ve(L) : this.i[h] = ie);
  }
  var ie = Object.freeze(ve([]));
  function Qe(h) {
    var y = h.l + h.j;
    h.h[y] || (h.i = h.h[y] = {});
  }
  function qt(h, y, v) {
    return y === -1 ? null : (v === void 0 ? 0 : v) || y >= h.l ? h.i ? h.i[y] : void 0 : h.h[y + h.j];
  }
  function Pt(h, y) {
    var v = v === void 0 ? !1 : v, L = qt(h, y, v);
    return L == null && (L = ie), L === ie && (L = ve([]), Vt(h, y, L, v)), L;
  }
  function hn(h) {
    var y = Pt(h, 3);
    if (h.m || (h.m = {}), !h.m[3]) {
      for (var v = 0; v < y.length; v++)
        y[v] = +y[v];
      h.m[3] = !0;
    }
    return y;
  }
  function fe(h, y, v) {
    return h = qt(h, y), h == null ? v : h;
  }
  function Lt(h, y, v) {
    return h = qt(h, y), h = h == null ? h : +h, h == null ? v === void 0 ? 0 : v : h;
  }
  function Vt(h, y, v, L) {
    (L === void 0 ? 0 : L) || y >= h.l ? (Qe(h), h.i[y] = v) : h.h[y + h.j] = v;
  }
  function oe(h, y, v) {
    if (v === -1)
      return null;
    if (h.g || (h.g = {}), !h.g[v]) {
      var L = qt(h, v, !1);
      L && (h.g[v] = new y(L));
    }
    return h.g[v];
  }
  function Fe(h, y) {
    h.g || (h.g = {});
    var v = h.g[1];
    if (!v) {
      var L = Pt(h, 1);
      v = [];
      for (var M = 0; M < L.length; M++)
        v[M] = new y(L[M]);
      h.g[1] = v;
    }
    return v;
  }
  function te(h, y, v) {
    var L = L === void 0 ? !1 : L;
    h.g || (h.g = {});
    var M = v && tt(v);
    h.g[y] = v, Vt(h, y, M, L);
  }
  function se(h, y, v, L) {
    var M = Fe(h, v);
    y = y || new v(), h = Pt(h, 1), L != null ? (M.splice(L, 0, y), h.splice(L, 0, tt(y))) : (M.push(y), h.push(tt(y)));
  }
  Ge.prototype.toJSON = function() {
    var h = tt(this);
    return cn(h, _e, mn);
  };
  function tt(h, y) {
    if (h.g)
      for (var v in h.g) {
        var L = h.g[v];
        if (Array.isArray(L))
          for (var M = 0; M < L.length; M++)
            L[M] && tt(L[M]);
        else
          L && tt(L);
      }
    return h.h;
  }
  Ge.prototype.toString = function() {
    return tt(this).toString();
  };
  function it(h, y) {
    if (h = h.o) {
      Ot(y, y.g.end());
      for (var v = 0; v < h.length; v++)
        Ot(y, h[v]);
    }
  }
  function ct(h, y) {
    if (y.h == 4)
      return !1;
    var v = y.m;
    return At(y), y.N || (y = Gn(y.g.h, v, y.g.g), (v = h.o) ? v.push(y) : h.o = [y]), !0;
  }
  function _t(h) {
    Ge.call(this, h, -1, ue);
  }
  mt(_t, Ge), _t.prototype.getRows = function() {
    return qt(this, 1);
  }, _t.prototype.getCols = function() {
    return qt(this, 2);
  }, _t.prototype.getPackedDataList = function() {
    return hn(this);
  }, _t.prototype.getLayout = function() {
    return fe(this, 4, 0);
  };
  function de(h, y) {
    for (; Le(y); )
      switch (y.i) {
        case 8:
          var v = y.g.i();
          Vt(h, 1, v);
          break;
        case 16:
          v = y.g.i(), Vt(h, 2, v);
          break;
        case 29:
        case 26:
          qe(y, h.getPackedDataList());
          break;
        case 32:
          v = Ve(y.g), Vt(h, 4, v);
          break;
        default:
          if (!ct(h, y))
            return h;
      }
    return h;
  }
  var ue = [3];
  function St(h, y) {
    var v = void 0;
    return new (v || (v = Promise))(function(L, M) {
      function _(lt) {
        try {
          q(y.next(lt));
        } catch (s) {
          M(s);
        }
      }
      function A(lt) {
        try {
          q(y.throw(lt));
        } catch (s) {
          M(s);
        }
      }
      function q(lt) {
        lt.done ? L(lt.value) : new v(function(s) {
          s(lt.value);
        }).then(_, A);
      }
      q((y = y.apply(h, void 0)).next());
    });
  }
  function me(h) {
    Ge.call(this, h);
  }
  mt(me, Ge);
  function Ce(h, y) {
    for (; Le(y); )
      switch (y.i) {
        case 8:
          var v = y.g.i();
          Vt(h, 1, v);
          break;
        case 21:
          v = zt(y), Vt(h, 2, v);
          break;
        case 26:
          v = be(y), Vt(h, 3, v);
          break;
        case 34:
          v = be(y), Vt(h, 4, v);
          break;
        default:
          if (!ct(h, y))
            return h;
      }
    return h;
  }
  function tn(h) {
    Ge.call(this, h, -1, en);
  }
  mt(tn, Ge), tn.prototype.addClassification = function(h, y) {
    return se(this, h, me, y), this;
  };
  var en = [1];
  function fn(h) {
    Ge.call(this, h);
  }
  mt(fn, Ge);
  function pn(h, y) {
    for (; Le(y); )
      switch (y.i) {
        case 13:
          var v = zt(y);
          Vt(h, 1, v);
          break;
        case 21:
          v = zt(y), Vt(h, 2, v);
          break;
        case 29:
          v = zt(y), Vt(h, 3, v);
          break;
        case 37:
          v = zt(y), Vt(h, 4, v);
          break;
        case 45:
          v = zt(y), Vt(h, 5, v);
          break;
        default:
          if (!ct(h, y))
            return h;
      }
    return h;
  }
  function He(h) {
    Ge.call(this, h, -1, Kn);
  }
  mt(He, Ge);
  function nn(h) {
    t: {
      var y = new He();
      for (h = new Ze(h); Le(h); )
        switch (h.i) {
          case 10:
            var v = xe(h, new fn(), pn);
            se(y, v, fn, void 0);
            break;
          default:
            if (!ct(y, h))
              break t;
        }
    }
    return y;
  }
  var Kn = [1];
  function rn(h) {
    Ge.call(this, h);
  }
  mt(rn, Ge);
  function Ne(h) {
    Ge.call(this, h, -1, In);
  }
  mt(Ne, Ge), Ne.prototype.getVertexType = function() {
    return fe(this, 1, 0);
  }, Ne.prototype.getPrimitiveType = function() {
    return fe(this, 2, 0);
  }, Ne.prototype.getVertexBufferList = function() {
    return hn(this);
  }, Ne.prototype.getIndexBufferList = function() {
    return Pt(this, 4);
  };
  function yn(h, y) {
    for (; Le(y); )
      switch (y.i) {
        case 8:
          var v = Ve(y.g);
          Vt(h, 1, v);
          break;
        case 16:
          v = Ve(y.g), Vt(h, 2, v);
          break;
        case 29:
        case 26:
          qe(y, h.getVertexBufferList());
          break;
        case 32:
        case 34:
          v = y;
          var L = h.getIndexBufferList();
          v.h == 2 ? Ye(v, Oe.prototype.i, L) : L.push(v.g.i());
          break;
        default:
          if (!ct(h, y))
            return h;
      }
    return h;
  }
  var In = [3, 4];
  function Be(h) {
    Ge.call(this, h);
  }
  mt(Be, Ge), Be.prototype.getMesh = function() {
    return oe(this, Ne, 1);
  }, Be.prototype.getPoseTransformMatrix = function() {
    return oe(this, _t, 2);
  };
  function Un(h) {
    t: {
      var y = new Be();
      for (h = new Ze(h); Le(h); )
        switch (h.i) {
          case 10:
            var v = xe(h, new Ne(), yn);
            te(y, 1, v);
            break;
          case 18:
            v = xe(h, new _t(), de), te(y, 2, v);
            break;
          default:
            if (!ct(y, h))
              break t;
        }
    }
    return y;
  }
  function on(h, y, v) {
    if (v = h.createShader(v === 0 ? h.VERTEX_SHADER : h.FRAGMENT_SHADER), h.shaderSource(v, y), h.compileShader(v), !h.getShaderParameter(v, h.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + h.getShaderInfoLog(v));
    return v;
  }
  function gn(h) {
    return Fe(h, me).map(function(y) {
      return { index: fe(y, 1, 0), Y: Lt(y, 2), label: qt(y, 3) != null ? fe(y, 3, "") : void 0, displayName: qt(y, 4) != null ? fe(y, 4, "") : void 0 };
    });
  }
  function Sn(h) {
    return { x: Lt(h, 1), y: Lt(h, 2), z: Lt(h, 3), visibility: qt(h, 4) != null ? Lt(h, 4) : void 0 };
  }
  function En(h, y) {
    this.h = h, this.g = y, this.l = 0;
  }
  function an(h, y, v) {
    return wn(h, y), typeof h.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(h.g.canvas.transferToImageBitmap()) : v ? Promise.resolve(h.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(h.g.canvas) : (h.i === void 0 && (h.i = document.createElement("canvas")), new Promise(function(L) {
      h.i.height = h.g.canvas.height, h.i.width = h.g.canvas.width, h.i.getContext("2d", {}).drawImage(h.g.canvas, 0, 0, h.g.canvas.width, h.g.canvas.height), L(h.i);
    }));
  }
  function wn(h, y) {
    var v = h.g;
    if (h.m === void 0) {
      var L = on(v, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), M = on(v, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), _ = v.createProgram();
      if (v.attachShader(_, L), v.attachShader(_, M), v.linkProgram(_), !v.getProgramParameter(_, v.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + v.getProgramInfoLog(_));
      L = h.m = _, v.useProgram(L), M = v.getUniformLocation(L, "sampler0"), h.j = { I: v.getAttribLocation(L, "aVertex"), H: v.getAttribLocation(L, "aTex"), da: M }, h.s = v.createBuffer(), v.bindBuffer(v.ARRAY_BUFFER, h.s), v.enableVertexAttribArray(h.j.I), v.vertexAttribPointer(h.j.I, 2, v.FLOAT, !1, 0, 0), v.bufferData(v.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), v.STATIC_DRAW), v.bindBuffer(v.ARRAY_BUFFER, null), h.o = v.createBuffer(), v.bindBuffer(v.ARRAY_BUFFER, h.o), v.enableVertexAttribArray(h.j.H), v.vertexAttribPointer(
        h.j.H,
        2,
        v.FLOAT,
        !1,
        0,
        0
      ), v.bufferData(v.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), v.STATIC_DRAW), v.bindBuffer(v.ARRAY_BUFFER, null), v.uniform1i(M, 0);
    }
    L = h.j, v.useProgram(h.m), v.canvas.width = y.width, v.canvas.height = y.height, v.viewport(0, 0, y.width, y.height), v.activeTexture(v.TEXTURE0), h.h.bindTexture2d(y.glName), v.enableVertexAttribArray(L.I), v.bindBuffer(v.ARRAY_BUFFER, h.s), v.vertexAttribPointer(L.I, 2, v.FLOAT, !1, 0, 0), v.enableVertexAttribArray(L.H), v.bindBuffer(v.ARRAY_BUFFER, h.o), v.vertexAttribPointer(
      L.H,
      2,
      v.FLOAT,
      !1,
      0,
      0
    ), v.bindFramebuffer(v.DRAW_FRAMEBUFFER ? v.DRAW_FRAMEBUFFER : v.FRAMEBUFFER, null), v.clearColor(0, 0, 0, 0), v.clear(v.COLOR_BUFFER_BIT), v.colorMask(!0, !0, !0, !0), v.drawArrays(v.TRIANGLE_FAN, 0, 4), v.disableVertexAttribArray(L.I), v.disableVertexAttribArray(L.H), v.bindBuffer(v.ARRAY_BUFFER, null), h.h.bindTexture2d(0);
  }
  function Pn(h) {
    this.g = h;
  }
  var _n = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Yn(h, y) {
    return y + h;
  }
  function Hn(h, y) {
    window[h] = y;
  }
  function p(h) {
    var y = document.createElement("script");
    return y.setAttribute("src", h), y.setAttribute("crossorigin", "anonymous"), new Promise(function(v) {
      y.addEventListener("load", function() {
        v();
      }, !1), y.addEventListener("error", function() {
        v();
      }, !1), document.body.appendChild(y);
    });
  }
  function W() {
    return St(this, function h() {
      return ne(h, function(y) {
        switch (y.g) {
          case 1:
            return y.m = 2, P(y, WebAssembly.instantiate(_n), 4);
          case 4:
            y.g = 3, y.m = 0;
            break;
          case 2:
            return y.m = 0, y.j = null, y.return(!1);
          case 3:
            return y.return(!0);
        }
      });
    });
  }
  function V(h) {
    if (this.g = h, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = Promise.resolve(), this.P = "", this.B = {}, this.locateFile = h && h.locateFile || Yn, typeof window == "object")
      var y = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      y = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.S = y, h.options) {
      y = T(Object.keys(h.options));
      for (var v = y.next(); !v.done; v = y.next()) {
        v = v.value;
        var L = h.options[v].default;
        L !== void 0 && (this.j[v] = typeof L == "function" ? L() : L);
      }
    }
  }
  i = V.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function k(h, y) {
    return h.g.files === void 0 ? [] : typeof h.g.files == "function" ? h.g.files(y) : h.g.files;
  }
  function O(h) {
    return St(h, function y() {
      var v = this, L, M, _, A, q, lt, s, G, R, Y, N;
      return ne(y, function(K) {
        switch (K.g) {
          case 1:
            return L = v, v.R ? (M = k(v, v.j), P(K, W(), 2)) : K.return();
          case 2:
            if (_ = K.h, typeof window == "object")
              return Hn("createMediapipeSolutionsWasm", { locateFile: v.locateFile }), Hn("createMediapipeSolutionsPackedAssets", { locateFile: v.locateFile }), lt = M.filter(function(E) {
                return E.data !== void 0;
              }), s = M.filter(function(E) {
                return E.data === void 0;
              }), G = Promise.all(lt.map(function(E) {
                var et = rt(L, E.url);
                if (E.path !== void 0) {
                  var $ = E.path;
                  et = et.then(function(yt) {
                    return L.overrideFile($, yt), Promise.resolve(yt);
                  });
                }
                return et;
              })), R = Promise.all(s.map(function(E) {
                return E.simd === void 0 || E.simd && _ || !E.simd && !_ ? p(L.locateFile(E.url, L.S)) : Promise.resolve();
              })).then(function() {
                return St(L, function E() {
                  var et, $, yt = this;
                  return ne(E, function(Xt) {
                    if (Xt.g == 1)
                      return et = window.createMediapipeSolutionsWasm, $ = window.createMediapipeSolutionsPackedAssets, P(Xt, et($), 2);
                    yt.h = Xt.h, Xt.g = 0;
                  });
                });
              }), Y = function() {
                return St(L, function E() {
                  var et = this;
                  return ne(E, function($) {
                    return et.g.graph && et.g.graph.url ? $ = P($, rt(et, et.g.graph.url), 0) : ($.g = 0, $ = void 0), $;
                  });
                });
              }(), P(K, Promise.all([R, G, Y]), 7);
            if (typeof importScripts != "function")
              throw Error("solutions can only be loaded on a web page or in a web worker");
            return A = M.filter(function(E) {
              return E.simd === void 0 || E.simd && _ || !E.simd && !_;
            }).map(function(E) {
              return L.locateFile(E.url, L.S);
            }), importScripts.apply(null, B(A)), P(K, createMediapipeSolutionsWasm(Module), 6);
          case 6:
            v.h = K.h, v.l = new OffscreenCanvas(1, 1), v.h.canvas = v.l, q = v.h.GL.createContext(
              v.l,
              { antialias: !1, alpha: !1, ba: typeof WebGL2RenderingContext < "u" ? 2 : 1 }
            ), v.h.GL.makeContextCurrent(q), K.g = 4;
            break;
          case 7:
            if (v.l = document.createElement("canvas"), N = v.l.getContext("webgl2", {}), !N && (N = v.l.getContext("webgl", {}), !N))
              return alert("Failed to create WebGL canvas context when passing video frame."), K.return();
            v.D = N, v.h.canvas = v.l, v.h.createContext(v.l, !0, !0, {});
          case 4:
            v.i = new v.h.SolutionWasm(), v.R = !1, K.g = 0;
        }
      });
    });
  }
  function ot(h) {
    return St(h, function y() {
      var v = this, L, M, _, A, q, lt, s, G;
      return ne(y, function(R) {
        if (R.g == 1) {
          if (v.g.graph && v.g.graph.url && v.P === v.g.graph.url)
            return R.return();
          if (v.o = !0, !v.g.graph || !v.g.graph.url) {
            R.g = 2;
            return;
          }
          return v.P = v.g.graph.url, P(R, rt(v, v.g.graph.url), 3);
        }
        for (R.g != 2 && (L = R.h, v.i.loadGraph(L)), M = T(Object.keys(v.B)), _ = M.next(); !_.done; _ = M.next())
          A = _.value, v.i.overrideFile(A, v.B[A]);
        if (v.B = {}, v.g.listeners)
          for (q = T(v.g.listeners), lt = q.next(); !lt.done; lt = q.next())
            s = lt.value, Et(v, s);
        G = v.j, v.j = {}, v.setOptions(G), R.g = 0;
      });
    });
  }
  i.reset = function() {
    return St(this, function h() {
      var y = this;
      return ne(h, function(v) {
        y.i && (y.i.reset(), y.m = {}, y.s = {}), v.g = 0;
      });
    });
  }, i.setOptions = function(h, y) {
    var v = this;
    if (y = y || this.g.options) {
      for (var L = [], M = [], _ = {}, A = T(Object.keys(h)), q = A.next(); !q.done; _ = { K: _.K, L: _.L }, q = A.next()) {
        var lt = q.value;
        lt in this.j && this.j[lt] === h[lt] || (this.j[lt] = h[lt], q = y[lt], q !== void 0 && (q.onChange && (_.K = q.onChange, _.L = h[lt], L.push(function(s) {
          return function() {
            return St(v, function G() {
              var R, Y = this;
              return ne(G, function(N) {
                if (N.g == 1)
                  return P(N, s.K(s.L), 2);
                R = N.h, R === !0 && (Y.o = !0), N.g = 0;
              });
            });
          };
        }(_))), q.graphOptionXref && (lt = { valueNumber: q.type === 1 ? h[lt] : 0, valueBoolean: q.type === 0 ? h[lt] : !1, valueString: q.type === 2 ? h[lt] : "" }, q = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), q.graphOptionXref), lt), M.push(q))));
      }
      (L.length !== 0 || M.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(M), this.u = (this.u === void 0 ? [] : this.u).concat(L));
    }
  };
  function z(h) {
    return St(h, function y() {
      var v = this, L, M, _, A, q, lt, s;
      return ne(y, function(G) {
        switch (G.g) {
          case 1:
            if (!v.o)
              return G.return();
            if (!v.u) {
              G.g = 2;
              break;
            }
            L = T(v.u), M = L.next();
          case 3:
            if (M.done) {
              G.g = 5;
              break;
            }
            return _ = M.value, P(G, _(), 4);
          case 4:
            M = L.next(), G.g = 3;
            break;
          case 5:
            v.u = void 0;
          case 2:
            if (v.A) {
              for (A = new v.h.GraphOptionChangeRequestList(), q = T(v.A), lt = q.next(); !lt.done; lt = q.next())
                s = lt.value, A.push_back(s);
              v.i.changeOptions(A), A.delete(), v.A = void 0;
            }
            v.o = !1, G.g = 0;
        }
      });
    });
  }
  i.initialize = function() {
    return St(this, function h() {
      var y = this;
      return ne(h, function(v) {
        return v.g == 1 ? P(v, O(y), 2) : v.g != 3 ? P(v, ot(y), 3) : P(v, z(y), 0);
      });
    });
  };
  function rt(h, y) {
    return St(h, function v() {
      var L = this, M, _;
      return ne(v, function(A) {
        return y in L.F ? A.return(L.F[y]) : (M = L.locateFile(y, ""), _ = fetch(M).then(function(q) {
          return q.arrayBuffer();
        }), L.F[y] = _, A.return(_));
      });
    });
  }
  i.overrideFile = function(h, y) {
    this.i ? this.i.overrideFile(h, y) : this.B[h] = y;
  }, i.clearOverriddenFiles = function() {
    this.B = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(h, y) {
    return St(this, function v() {
      var L = this, M, _, A, q, lt, s, G, R, Y;
      return ne(v, function(N) {
        switch (N.g) {
          case 1:
            return L.g.inputs ? (M = 1e3 * (y == null ? performance.now() : y), P(N, L.C, 2)) : N.return();
          case 2:
            return P(N, L.initialize(), 3);
          case 3:
            for (_ = new L.h.PacketDataList(), A = T(Object.keys(h)), q = A.next(); !q.done; q = A.next())
              if (lt = q.value, s = L.g.inputs[lt]) {
                t: {
                  var K = L, E = h[lt];
                  switch (s.type) {
                    case "video":
                      var et = K.m[s.stream];
                      if (et || (et = new En(K.h, K.D), K.m[s.stream] = et), K = et, K.l === 0 && (K.l = K.h.createTexture()), typeof HTMLVideoElement < "u" && E instanceof HTMLVideoElement) {
                        var $ = E.videoWidth;
                        et = E.videoHeight;
                      } else
                        typeof HTMLImageElement < "u" && E instanceof HTMLImageElement ? ($ = E.naturalWidth, et = E.naturalHeight) : ($ = E.width, et = E.height);
                      et = { glName: K.l, width: $, height: et }, $ = K.g, $.canvas.width = et.width, $.canvas.height = et.height, $.activeTexture($.TEXTURE0), K.h.bindTexture2d(K.l), $.texImage2D($.TEXTURE_2D, 0, $.RGBA, $.RGBA, $.UNSIGNED_BYTE, E), K.h.bindTexture2d(0), K = et;
                      break t;
                    case "detections":
                      for (et = K.m[s.stream], et || (et = new Pn(K.h), K.m[s.stream] = et), K = et, K.data || (K.data = new K.g.DetectionListData()), K.data.reset(E.length), et = 0; et < E.length; ++et) {
                        $ = E[et];
                        var yt = K.data, Xt = yt.setBoundingBox, Mt = et, xt = $.T, dt = new rn();
                        Vt(dt, 1, xt.Z), Vt(dt, 2, xt.$), Vt(dt, 3, xt.height), Vt(dt, 4, xt.width), Vt(dt, 5, xt.rotation), Vt(dt, 6, xt.X);
                        var Wt = xt = new Xe();
                        Pe(Wt, 1, qt(dt, 1)), Pe(Wt, 2, qt(dt, 2)), Pe(Wt, 3, qt(dt, 3)), Pe(Wt, 4, qt(dt, 4)), Pe(Wt, 5, qt(dt, 5));
                        var It = qt(dt, 6);
                        if (It != null && It != null) {
                          Qt(Wt.g, 48);
                          var Yt = Wt.g, Ft = It;
                          It = 0 > Ft, Ft = Math.abs(Ft);
                          var l = Ft >>> 0;
                          for (Ft = Math.floor((Ft - l) / 4294967296), Ft >>>= 0, It && (Ft = ~Ft >>> 0, l = (~l >>> 0) + 1, 4294967295 < l && (l = 0, Ft++, 4294967295 < Ft && (Ft = 0))), he = l, Se = Ft, It = he, l = Se; 0 < l || 127 < It; )
                            Yt.push(It & 127 | 128), It = (It >>> 7 | l << 25) >>> 0, l >>>= 7;
                          Yt.push(It);
                        }
                        if (it(dt, Wt), xt = Ae(xt), Xt.call(yt, Mt, xt), $.O)
                          for (yt = 0; yt < $.O.length; ++yt)
                            dt = $.O[yt], Wt = !!dt.visibility, Xt = K.data, Mt = Xt.addNormalizedLandmark, xt = et, dt = Object.assign(Object.assign({}, dt), { visibility: Wt ? dt.visibility : 0 }), Wt = new fn(), Vt(Wt, 1, dt.x), Vt(Wt, 2, dt.y), Vt(Wt, 3, dt.z), dt.visibility && Vt(Wt, 4, dt.visibility), Yt = dt = new Xe(), Pe(Yt, 1, qt(Wt, 1)), Pe(Yt, 2, qt(Wt, 2)), Pe(Yt, 3, qt(Wt, 3)), Pe(Yt, 4, qt(Wt, 4)), Pe(Yt, 5, qt(Wt, 5)), it(Wt, Yt), dt = Ae(dt), Mt.call(Xt, xt, dt);
                        if ($.M)
                          for (yt = 0; yt < $.M.length; ++yt) {
                            if (Xt = K.data, Mt = Xt.addClassification, xt = et, dt = $.M[yt], Wt = new me(), Vt(Wt, 2, dt.Y), dt.index && Vt(Wt, 1, dt.index), dt.label && Vt(Wt, 3, dt.label), dt.displayName && Vt(Wt, 4, dt.displayName), Yt = dt = new Xe(), l = qt(Wt, 1), l != null && l != null)
                              if (Qt(Yt.g, 8), It = Yt.g, 0 <= l)
                                Qt(It, l);
                              else {
                                for (Ft = 0; 9 > Ft; Ft++)
                                  It.push(l & 127 | 128), l >>= 7;
                                It.push(1);
                              }
                            Pe(Yt, 2, qt(Wt, 2)), It = qt(Wt, 3), It != null && (It = Rn(It), Qt(Yt.g, 26), Qt(Yt.g, It.length), Ot(Yt, Yt.g.end()), Ot(Yt, It)), It = qt(Wt, 4), It != null && (It = Rn(It), Qt(Yt.g, 34), Qt(Yt.g, It.length), Ot(Yt, Yt.g.end()), Ot(Yt, It)), it(Wt, Yt), dt = Ae(dt), Mt.call(Xt, xt, dt);
                          }
                      }
                      K = K.data;
                      break t;
                    default:
                      K = {};
                  }
                }
                switch (G = K, R = s.stream, s.type) {
                  case "video":
                    _.pushTexture2d(Object.assign(Object.assign({}, G), { stream: R, timestamp: M }));
                    break;
                  case "detections":
                    Y = G, Y.stream = R, Y.timestamp = M, _.pushDetectionList(Y);
                    break;
                  default:
                    throw Error("Unknown input config type: '" + s.type + "'");
                }
              }
            return L.i.send(_), P(N, L.C, 4);
          case 4:
            _.delete(), N.g = 0;
        }
      });
    });
  };
  function bt(h, y, v) {
    return St(h, function L() {
      var M, _, A, q, lt, s, G = this, R, Y, N, K, E, et, $, yt;
      return ne(L, function(Xt) {
        switch (Xt.g) {
          case 1:
            if (!v)
              return Xt.return(y);
            for (M = {}, _ = 0, A = T(Object.keys(v)), q = A.next(); !q.done; q = A.next())
              lt = q.value, s = v[lt], typeof s != "string" && s.type === "texture" && y[s.stream] !== void 0 && ++_;
            1 < _ && (G.G = !1), R = T(Object.keys(v)), q = R.next();
          case 2:
            if (q.done) {
              Xt.g = 4;
              break;
            }
            if (Y = q.value, N = v[Y], typeof N == "string")
              return $ = M, yt = Y, P(Xt, Rt(G, Y, y[N]), 14);
            if (K = y[N.stream], N.type === "detection_list") {
              if (K) {
                for (var Mt = K.getRectList(), xt = K.getLandmarksList(), dt = K.getClassificationsList(), Wt = [], It = 0; It < Mt.size(); ++It) {
                  var Yt = Mt.get(It);
                  t: {
                    var Ft = new rn();
                    for (Yt = new Ze(Yt); Le(Yt); )
                      switch (Yt.i) {
                        case 13:
                          var l = zt(Yt);
                          Vt(Ft, 1, l);
                          break;
                        case 21:
                          l = zt(Yt), Vt(Ft, 2, l);
                          break;
                        case 29:
                          l = zt(Yt), Vt(Ft, 3, l);
                          break;
                        case 37:
                          l = zt(Yt), Vt(Ft, 4, l);
                          break;
                        case 45:
                          l = zt(Yt), Vt(Ft, 5, l);
                          break;
                        case 48:
                          l = Ve(Yt.g), Vt(Ft, 6, l);
                          break;
                        default:
                          if (!ct(Ft, Yt))
                            break t;
                      }
                  }
                  Ft = { Z: Lt(Ft, 1), $: Lt(Ft, 2), height: Lt(Ft, 3), width: Lt(Ft, 4), rotation: Lt(Ft, 5, 0), X: fe(Ft, 6, 0) }, Yt = Fe(nn(xt.get(It)), fn).map(Sn);
                  var Z = dt.get(It);
                  t:
                    for (l = new tn(), Z = new Ze(Z); Le(Z); )
                      switch (Z.i) {
                        case 10:
                          l.addClassification(xe(Z, new me(), Ce));
                          break;
                        default:
                          if (!ct(l, Z))
                            break t;
                      }
                  Ft = { T: Ft, O: Yt, M: gn(l) }, Wt.push(Ft);
                }
                Mt = Wt;
              } else
                Mt = [];
              M[Y] = Mt, Xt.g = 7;
              break;
            }
            if (N.type === "proto_list") {
              if (K) {
                for (Mt = Array(K.size()), xt = 0; xt < K.size(); xt++)
                  Mt[xt] = K.get(xt);
                K.delete();
              } else
                Mt = [];
              M[Y] = Mt, Xt.g = 7;
              break;
            }
            if (K === void 0) {
              Xt.g = 3;
              break;
            }
            if (N.type === "float_list") {
              M[Y] = K, Xt.g = 7;
              break;
            }
            if (N.type === "proto") {
              M[Y] = K, Xt.g = 7;
              break;
            }
            if (N.type !== "texture")
              throw Error("Unknown output config type: '" + N.type + "'");
            return E = G.s[Y], E || (E = new En(G.h, G.D), G.s[Y] = E), P(Xt, an(E, K, G.G), 13);
          case 13:
            et = Xt.h, M[Y] = et;
          case 7:
            N.transform && M[Y] && (M[Y] = N.transform(M[Y])), Xt.g = 3;
            break;
          case 14:
            $[yt] = Xt.h;
          case 3:
            q = R.next(), Xt.g = 2;
            break;
          case 4:
            return Xt.return(M);
        }
      });
    });
  }
  function Rt(h, y, v) {
    return St(h, function L() {
      var M = this, _;
      return ne(L, function(A) {
        return typeof v == "number" || v instanceof Uint8Array || v instanceof M.h.Uint8BlobList ? A.return(v) : v instanceof M.h.Texture2dDataOut ? (_ = M.s[y], _ || (_ = new En(M.h, M.D), M.s[y] = _), A.return(an(_, v, M.G))) : A.return(void 0);
      });
    });
  }
  function Et(h, y) {
    for (var v = y.name || "$", L = [].concat(B(y.wants)), M = new h.h.StringList(), _ = T(y.wants), A = _.next(); !A.done; A = _.next())
      M.push_back(A.value);
    _ = h.h.PacketListener.implement({ onResults: function(q) {
      for (var lt = {}, s = 0; s < y.wants.length; ++s)
        lt[L[s]] = q.get(s);
      var G = h.listeners[v];
      G && (h.C = bt(h, lt, y.outs).then(function(R) {
        R = G(R);
        for (var Y = 0; Y < y.wants.length; ++Y) {
          var N = lt[L[Y]];
          typeof N == "object" && N.hasOwnProperty && N.hasOwnProperty("delete") && N.delete();
        }
        R && (h.C = R);
      }));
    } }), h.i.attachMultiListener(M, _), M.delete();
  }
  i.onResults = function(h, y) {
    this.listeners[y || "$"] = h;
  }, Re("Solution", V), Re("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Nt(h) {
    h = Un(h);
    var y = h.getMesh();
    if (!y)
      return h;
    var v = new Float32Array(y.getVertexBufferList());
    y.getVertexBufferList = function() {
      return v;
    };
    var L = new Uint32Array(y.getIndexBufferList());
    return y.getIndexBufferList = function() {
      return L;
    }, h;
  }
  var $t = { files: [{ url: "face_mesh_solution_packed_assets_loader.js" }, { simd: !0, url: "face_mesh_solution_simd_wasm_bin.js" }, { simd: !1, url: "face_mesh_solution_wasm_bin.js" }], graph: { url: "face_mesh.binarypb" }, listeners: [{ wants: ["multi_face_geometry", "image_transformed", "multi_face_landmarks"], outs: { image: "image_transformed", multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: function(h) {
    return h.map(Nt);
  } }, multiFaceLandmarks: { type: "proto_list", stream: "multi_face_landmarks", transform: function(h) {
    return h.map(function(y) {
      return Fe(
        nn(y),
        fn
      ).map(Sn);
    });
  } } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: {
    calculatorName: "EnableFaceGeometryConstant",
    calculatorType: "ConstantSidePacketCalculator",
    fieldName: "bool_value"
  } }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumFaces: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorNumFaces", fieldName: "int_value" } }, refineLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: {
    type: 1,
    graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facelandmarkfrontgpu__facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" }
  }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: {
    calculatorType: "FaceGeometryEnvGeneratorCalculator",
    fieldName: "near"
  } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" } } } }, Jt = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], wt = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], Ut = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], Dt = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], ae = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], pe = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], ye = [].concat(B(Jt), B(wt), B(Ut), B(Dt), B(ae), B(pe));
  function Je(h) {
    h = h || {}, h = Object.assign(Object.assign({}, $t), h), this.g = new V(h);
  }
  i = Je.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(h) {
    this.g.onResults(h);
  }, i.initialize = function() {
    return St(this, function h() {
      var y = this;
      return ne(h, function(v) {
        return P(v, y.g.initialize(), 0);
      });
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(h) {
    return St(this, function y() {
      var v = this;
      return ne(y, function(L) {
        return P(L, v.g.send(h), 0);
      });
    });
  }, i.setOptions = function(h) {
    this.g.setOptions(h);
  }, Re("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } }), Re("FaceMesh", Je), Re("FACEMESH_LIPS", Jt), Re("FACEMESH_LEFT_EYE", wt), Re("FACEMESH_LEFT_EYEBROW", Ut), Re("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]), Re("FACEMESH_RIGHT_EYE", Dt), Re("FACEMESH_RIGHT_EYEBROW", ae), Re("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]), Re("FACEMESH_FACE_OVAL", pe), Re("FACEMESH_CONTOURS", ye), Re("FACEMESH_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [
      212,
      214
    ],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [
      92,
      40
    ],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [
      170,
      140
    ],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [
      100,
      36
    ],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [
      170,
      149
    ],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [138, 172],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [
      143,
      111
    ],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [38, 82],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [201, 83],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [
      228,
      24
    ],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [112, 233],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [
      332,
      297
    ],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [
      367,
      416
    ],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [399, 419],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [
      451,
      349
    ],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [
      462,
      328
    ],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [395, 369],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [
      197,
      419
    ],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [
      439,
      455
    ],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [436, 426],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [369, 262],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [
      428,
      262
    ],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [259, 444],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [
      372,
      383
    ],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [
      232,
      120
    ],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [160, 30],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [
      30,
      247
    ],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [91, 146],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [56, 28],
    [
      28,
      157
    ],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [122, 168],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [
      218,
      115
    ],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [
      222,
      52
    ],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [205, 36],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [
      212,
      186
    ],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [112, 232],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [236, 174],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [
      418,
      431
    ],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [
      421,
      18
    ],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [
      382,
      256
    ],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [346, 352],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [
      352,
      366
    ],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [349, 329],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [175, 396],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [
      195,
      248
    ],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [
      420,
      429
    ],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [410, 287],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [
      256,
      341
    ],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [412, 343],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]), Re("matrixDataToMatrix", function(h) {
    for (var y = h.getCols(), v = h.getRows(), L = h.getPackedDataList(), M = [], _ = 0; _ < v; _++)
      M.push(Array(y));
    for (_ = 0; _ < v; _++)
      for (var A = 0; A < y; A++) {
        var q = h.getLayout() === 1 ? _ * y + A : A * v + _;
        M[_][A] = L[q];
      }
    return M;
  }), Re("VERSION", "0.4.1633559619");
}).call(vi);
const Gi = {};
(function() {
  var i;
  function r(t) {
    var c = 0;
    return function() {
      return c < t.length ? { done: !1, value: t[c++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(t, c, a) {
    return t == Array.prototype || t == Object.prototype || (t[c] = a.value), t;
  };
  function m(t) {
    t = [typeof globalThis == "object" && globalThis, t, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var c = 0; c < t.length; ++c) {
      var a = t[c];
      if (a && a.Math == Math)
        return a;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(t, c) {
    if (c)
      t: {
        var a = X;
        t = t.split(".");
        for (var b = 0; b < t.length - 1; b++) {
          var I = t[b];
          if (!(I in a))
            break t;
          a = a[I];
        }
        t = t[t.length - 1], b = a[t], c = c(b), c != b && c != null && n(a, t, { configurable: !0, writable: !0, value: c });
      }
  }
  S("Symbol", function(t) {
    function c(F) {
      if (this instanceof c)
        throw new TypeError("Symbol is not a constructor");
      return new a(b + (F || "") + "_" + I++, F);
    }
    function a(F, H) {
      this.g = F, n(this, "description", { configurable: !0, writable: !0, value: H });
    }
    if (t)
      return t;
    a.prototype.toString = function() {
      return this.g;
    };
    var b = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", I = 0;
    return c;
  }), S("Symbol.iterator", function(t) {
    if (t)
      return t;
    t = Symbol("Symbol.iterator");
    for (var c = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), a = 0; a < c.length; a++) {
      var b = X[c[a]];
      typeof b == "function" && typeof b.prototype[t] != "function" && n(b.prototype, t, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return t;
  });
  function C(t) {
    return t = { next: t }, t[Symbol.iterator] = function() {
      return this;
    }, t;
  }
  function T(t) {
    var c = typeof Symbol < "u" && Symbol.iterator && t[Symbol.iterator];
    return c ? c.call(t) : { next: r(t) };
  }
  function B(t) {
    if (!(t instanceof Array)) {
      t = T(t);
      for (var c, a = []; !(c = t.next()).done; )
        a.push(c.value);
      t = a;
    }
    return t;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(t) {
    function c() {
    }
    return c.prototype = t, new c();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(t, c) {
      if (t.__proto__ = c, t.__proto__ !== c)
        throw new TypeError(t + " is not extensible");
      return t;
    } : null;
  }
  var at = ut;
  function mt(t, c) {
    if (t.prototype = nt(c.prototype), t.prototype.constructor = t, at)
      at(t, c);
    else
      for (var a in c)
        if (a != "prototype")
          if (Object.defineProperties) {
            var b = Object.getOwnPropertyDescriptor(c, a);
            b && Object.defineProperty(t, a, b);
          } else
            t[a] = c[a];
    t.ka = c.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
  }
  function kt(t) {
    if (t.l)
      throw new TypeError("Generator is already running");
    t.l = !0;
  }
  Bt.prototype.o = function(t) {
    this.h = t;
  };
  function ee(t, c) {
    t.j = { V: c, X: !0 }, t.g = t.m || t.s;
  }
  Bt.prototype.return = function(t) {
    this.j = { return: t }, this.g = this.s;
  };
  function P(t, c, a) {
    return t.g = a, { value: c };
  }
  function De(t) {
    this.g = new Bt(), this.h = t;
  }
  function je(t, c) {
    kt(t.g);
    var a = t.g.i;
    return a ? We(t, "return" in a ? a.return : function(b) {
      return { value: b, done: !0 };
    }, c, t.g.return) : (t.g.return(c), jt(t));
  }
  function We(t, c, a, b) {
    try {
      var I = c.call(t.g.i, a);
      if (!(I instanceof Object))
        throw new TypeError("Iterator result " + I + " is not an object");
      if (!I.done)
        return t.g.l = !1, I;
      var F = I.value;
    } catch (H) {
      return t.g.i = null, ee(t.g, H), jt(t);
    }
    return t.g.i = null, b.call(t.g, F), jt(t);
  }
  function jt(t) {
    for (; t.g.g; )
      try {
        var c = t.h(t.g);
        if (c)
          return t.g.l = !1, { value: c.value, done: !1 };
      } catch (a) {
        t.g.h = void 0, ee(t.g, a);
      }
    if (t.g.l = !1, t.g.j) {
      if (c = t.g.j, t.g.j = null, c.X)
        throw c.V;
      return { value: c.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(t) {
    this.next = function(c) {
      return kt(t.g), t.g.i ? c = We(t, t.g.i.next, c, t.g.o) : (t.g.o(c), c = jt(t)), c;
    }, this.throw = function(c) {
      return kt(t.g), t.g.i ? c = We(t, t.g.i.throw, c, t.g.o) : (ee(t.g, c), c = jt(t)), c;
    }, this.return = function(c) {
      return je(t, c);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(t) {
    function c(b) {
      return t.next(b);
    }
    function a(b) {
      return t.throw(b);
    }
    return new Promise(function(b, I) {
      function F(H) {
        H.done ? b(H.value) : Promise.resolve(H.value).then(c, a).then(F, I);
      }
      F(t.next());
    });
  }
  function gt(t) {
    return ne(new Cn(new De(t)));
  }
  S("Promise", function(t) {
    function c(H) {
      this.h = 0, this.i = void 0, this.g = [], this.o = !1;
      var U = this.j();
      try {
        H(U.resolve, U.reject);
      } catch (j) {
        U.reject(j);
      }
    }
    function a() {
      this.g = null;
    }
    function b(H) {
      return H instanceof c ? H : new c(function(U) {
        U(H);
      });
    }
    if (t)
      return t;
    a.prototype.h = function(H) {
      if (this.g == null) {
        this.g = [];
        var U = this;
        this.i(function() {
          U.l();
        });
      }
      this.g.push(H);
    };
    var I = X.setTimeout;
    a.prototype.i = function(H) {
      I(H, 0);
    }, a.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var H = this.g;
        this.g = [];
        for (var U = 0; U < H.length; ++U) {
          var j = H[U];
          H[U] = null;
          try {
            j();
          } catch (Q) {
            this.j(Q);
          }
        }
      }
      this.g = null;
    }, a.prototype.j = function(H) {
      this.i(function() {
        throw H;
      });
    }, c.prototype.j = function() {
      function H(Q) {
        return function(D) {
          j || (j = !0, Q.call(U, D));
        };
      }
      var U = this, j = !1;
      return { resolve: H(this.D), reject: H(this.l) };
    }, c.prototype.D = function(H) {
      if (H === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (H instanceof c)
        this.G(H);
      else {
        t:
          switch (typeof H) {
            case "object":
              var U = H != null;
              break t;
            case "function":
              U = !0;
              break t;
            default:
              U = !1;
          }
        U ? this.A(H) : this.m(H);
      }
    }, c.prototype.A = function(H) {
      var U = void 0;
      try {
        U = H.then;
      } catch (j) {
        this.l(j);
        return;
      }
      typeof U == "function" ? this.H(U, H) : this.m(H);
    }, c.prototype.l = function(H) {
      this.s(2, H);
    }, c.prototype.m = function(H) {
      this.s(1, H);
    }, c.prototype.s = function(H, U) {
      if (this.h != 0)
        throw Error("Cannot settle(" + H + ", " + U + "): Promise already settled in state" + this.h);
      this.h = H, this.i = U, this.h === 2 && this.F(), this.B();
    }, c.prototype.F = function() {
      var H = this;
      I(function() {
        if (H.C()) {
          var U = X.console;
          typeof U < "u" && U.error(H.i);
        }
      }, 1);
    }, c.prototype.C = function() {
      if (this.o)
        return !1;
      var H = X.CustomEvent, U = X.Event, j = X.dispatchEvent;
      return typeof j > "u" ? !0 : (typeof H == "function" ? H = new H("unhandledrejection", { cancelable: !0 }) : typeof U == "function" ? H = new U("unhandledrejection", { cancelable: !0 }) : (H = X.document.createEvent("CustomEvent"), H.initCustomEvent("unhandledrejection", !1, !0, H)), H.promise = this, H.reason = this.i, j(H));
    }, c.prototype.B = function() {
      if (this.g != null) {
        for (var H = 0; H < this.g.length; ++H)
          F.h(this.g[H]);
        this.g = null;
      }
    };
    var F = new a();
    return c.prototype.G = function(H) {
      var U = this.j();
      H.K(U.resolve, U.reject);
    }, c.prototype.H = function(H, U) {
      var j = this.j();
      try {
        H.call(U, j.resolve, j.reject);
      } catch (Q) {
        j.reject(Q);
      }
    }, c.prototype.then = function(H, U) {
      function j(ht, ft) {
        return typeof ht == "function" ? function(Gt) {
          try {
            Q(ht(Gt));
          } catch (vt) {
            D(vt);
          }
        } : ft;
      }
      var Q, D, st = new c(function(ht, ft) {
        Q = ht, D = ft;
      });
      return this.K(j(H, Q), j(U, D)), st;
    }, c.prototype.catch = function(H) {
      return this.then(void 0, H);
    }, c.prototype.K = function(H, U) {
      function j() {
        switch (Q.h) {
          case 1:
            H(Q.i);
            break;
          case 2:
            U(Q.i);
            break;
          default:
            throw Error("Unexpected state: " + Q.h);
        }
      }
      var Q = this;
      this.g == null ? F.h(j) : this.g.push(j), this.o = !0;
    }, c.resolve = b, c.reject = function(H) {
      return new c(function(U, j) {
        j(H);
      });
    }, c.race = function(H) {
      return new c(function(U, j) {
        for (var Q = T(H), D = Q.next(); !D.done; D = Q.next())
          b(D.value).K(U, j);
      });
    }, c.all = function(H) {
      var U = T(H), j = U.next();
      return j.done ? b([]) : new c(function(Q, D) {
        function st(Gt) {
          return function(vt) {
            ht[Gt] = vt, ft--, ft == 0 && Q(ht);
          };
        }
        var ht = [], ft = 0;
        do
          ht.push(void 0), ft++, b(j.value).K(st(ht.length - 1), D), j = U.next();
        while (!j.done);
      });
    }, c;
  });
  function $e(t, c) {
    t instanceof String && (t += "");
    var a = 0, b = !1, I = { next: function() {
      if (!b && a < t.length) {
        var F = a++;
        return { value: c(F, t[F]), done: !1 };
      }
      return b = !0, { done: !0, value: void 0 };
    } };
    return I[Symbol.iterator] = function() {
      return I;
    }, I;
  }
  var An = typeof Object.assign == "function" ? Object.assign : function(t, c) {
    for (var a = 1; a < arguments.length; a++) {
      var b = arguments[a];
      if (b)
        for (var I in b)
          Object.prototype.hasOwnProperty.call(b, I) && (t[I] = b[I]);
    }
    return t;
  };
  S("Object.assign", function(t) {
    return t || An;
  }), S("Object.is", function(t) {
    return t || function(c, a) {
      return c === a ? c !== 0 || 1 / c === 1 / a : c !== c && a !== a;
    };
  }), S("Array.prototype.includes", function(t) {
    return t || function(c, a) {
      var b = this;
      b instanceof String && (b = String(b));
      var I = b.length;
      for (a = a || 0, 0 > a && (a = Math.max(a + I, 0)); a < I; a++) {
        var F = b[a];
        if (F === c || Object.is(F, c))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(t) {
    return t || function(c, a) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (c instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(c, a || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(t) {
    return t || function() {
      return $e(this, function(c) {
        return c;
      });
    };
  });
  var Re = this || self;
  function Ct(t, c) {
    t = t.split(".");
    var a = Re;
    t[0] in a || typeof a.execScript > "u" || a.execScript("var " + t[0]);
    for (var b; t.length && (b = t.shift()); )
      t.length || c === void 0 ? a[b] && a[b] !== Object.prototype[b] ? a = a[b] : a = a[b] = {} : a[b] = c;
  }
  function we(t) {
    throw t;
  }
  function sn(t, c) {
    we(Error("Invalid wire type: " + t + " (at position " + c + ")"));
  }
  function vn() {
    we(Error("Failed to read varint, encoding is invalid."));
  }
  function Tn(t, c) {
    return c = String.fromCharCode.apply(null, c), t == null ? c : t + c;
  }
  var Rn, Nn = typeof TextDecoder < "u", dn, mn = typeof TextEncoder < "u";
  function kn(t) {
    if (mn)
      t = (dn || (dn = new TextEncoder())).encode(t);
    else {
      var c = void 0;
      c = c === void 0 ? !1 : c;
      for (var a = 0, b = new Uint8Array(3 * t.length), I = 0; I < t.length; I++) {
        var F = t.charCodeAt(I);
        if (128 > F)
          b[a++] = F;
        else {
          if (2048 > F)
            b[a++] = F >> 6 | 192;
          else {
            if (55296 <= F && 57343 >= F) {
              if (56319 >= F && I < t.length) {
                var H = t.charCodeAt(++I);
                if (56320 <= H && 57343 >= H) {
                  F = 1024 * (F - 55296) + H - 56320 + 65536, b[a++] = F >> 18 | 240, b[a++] = F >> 12 & 63 | 128, b[a++] = F >> 6 & 63 | 128, b[a++] = F & 63 | 128;
                  continue;
                } else
                  I--;
              }
              if (c)
                throw Error("Found an unpaired surrogate");
              F = 65533;
            }
            b[a++] = F >> 12 | 224, b[a++] = F >> 6 & 63 | 128;
          }
          b[a++] = F & 63 | 128;
        }
      }
      t = b.subarray(0, a);
    }
    return t;
  }
  var Fn = {}, ze = null;
  function Me(t) {
    var c;
    c === void 0 && (c = 0), he(), c = Fn[c];
    for (var a = Array(Math.floor(t.length / 3)), b = c[64] || "", I = 0, F = 0; I < t.length - 2; I += 3) {
      var H = t[I], U = t[I + 1], j = t[I + 2], Q = c[H >> 2];
      H = c[(H & 3) << 4 | U >> 4], U = c[(U & 15) << 2 | j >> 6], j = c[j & 63], a[F++] = Q + H + U + j;
    }
    switch (Q = 0, j = b, t.length - I) {
      case 2:
        Q = t[I + 1], j = c[(Q & 15) << 2] || b;
      case 1:
        t = t[I], a[F] = c[t >> 2] + c[(t & 3) << 4 | Q >> 4] + j + b;
    }
    return a.join("");
  }
  function xn(t) {
    var c = t.length, a = 3 * c / 4;
    a % 3 ? a = Math.floor(a) : "=.".indexOf(t[c - 1]) != -1 && (a = "=.".indexOf(t[c - 2]) != -1 ? a - 2 : a - 1);
    var b = new Uint8Array(a), I = 0;
    return Gn(t, function(F) {
      b[I++] = F;
    }), b.subarray(0, I);
  }
  function Gn(t, c) {
    function a(j) {
      for (; b < t.length; ) {
        var Q = t.charAt(b++), D = ze[Q];
        if (D != null)
          return D;
        if (!/^[\s\xa0]*$/.test(Q))
          throw Error("Unknown base64 encoding at char: " + Q);
      }
      return j;
    }
    he();
    for (var b = 0; ; ) {
      var I = a(-1), F = a(0), H = a(64), U = a(64);
      if (U === 64 && I === -1)
        break;
      c(I << 2 | F >> 4), H != 64 && (c(F << 4 & 240 | H >> 2), U != 64 && c(H << 6 & 192 | U));
    }
  }
  function he() {
    if (!ze) {
      ze = {};
      for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), c = ["+/=", "+/", "-_=", "-_.", "-_"], a = 0; 5 > a; a++) {
        var b = t.concat(c[a].split(""));
        Fn[a] = b;
        for (var I = 0; I < b.length; I++) {
          var F = b[I];
          ze[F] === void 0 && (ze[F] = I);
        }
      }
    }
  }
  var Se = typeof Uint8Array == "function", Oe;
  function re(t) {
    if (this.g = t, t !== null && t.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var Ve = typeof Uint8Array.prototype.slice == "function";
  function ln(t, c, a) {
    return c === a ? Oe || (Oe = new Uint8Array(0)) : Ve ? t.slice(c, a) : new Uint8Array(t.subarray(c, a));
  }
  var Ee = 0, Qt = 0;
  function Ze(t) {
    if (t.constructor === Uint8Array)
      return t;
    if (t.constructor === ArrayBuffer)
      return new Uint8Array(t);
    if (t.constructor === Array)
      return new Uint8Array(t);
    if (t.constructor === String)
      return xn(t);
    if (t.constructor === re) {
      if (t.g == null)
        var c = Oe || (Oe = new Uint8Array(0));
      else {
        c = Uint8Array;
        var a = t.g;
        a = a == null || Se && a != null && a instanceof Uint8Array ? a : typeof a == "string" ? xn(a) : null, t = t.g = a, c = new c(t);
      }
      return c;
    }
    if (t instanceof Uint8Array)
      return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Le(t, c) {
    c = c === void 0 ? {} : c, c = c.v === void 0 ? !1 : c.v, this.h = null, this.g = this.i = this.l = 0, this.j = !1, this.v = c, t && At(this, t);
  }
  function At(t, c) {
    t.h = Ze(c), t.l = 0, t.i = t.h.length, t.g = t.l;
  }
  Le.prototype.reset = function() {
    this.g = this.l;
  };
  function xe(t) {
    for (var c = 128, a = 0, b = 0, I = 0; 4 > I && 128 <= c; I++)
      c = t.h[t.g++], a |= (c & 127) << 7 * I;
    if (128 <= c && (c = t.h[t.g++], a |= (c & 127) << 28, b |= (c & 127) >> 4), 128 <= c)
      for (I = 0; 5 > I && 128 <= c; I++)
        c = t.h[t.g++], b |= (c & 127) << 7 * I + 3;
    if (128 > c)
      return t = a >>> 0, c = b >>> 0, (b = c & 2147483648) && (t = ~t + 1 >>> 0, c = ~c >>> 0, t == 0 && (c = c + 1 >>> 0)), t = 4294967296 * c + (t >>> 0), b ? -t : t;
    t.j = !0, vn();
  }
  function zt(t) {
    t.g > t.i && (t.j = !0, we(Error("Tried to read past the end of the data " + t.g + " > " + t.i)));
  }
  function be(t) {
    var c = t.h, a = c[t.g], b = a & 127;
    return 128 > a ? (t.g += 1, zt(t), b) : (a = c[t.g + 1], b |= (a & 127) << 7, 128 > a ? (t.g += 2, zt(t), b) : (a = c[t.g + 2], b |= (a & 127) << 14, 128 > a ? (t.g += 3, zt(t), b) : (a = c[t.g + 3], b |= (a & 127) << 21, 128 > a ? (t.g += 4, zt(t), b) : (a = c[t.g + 4], b |= (a & 15) << 28, 128 > a ? (t.g += 5, zt(t), b >>> 0) : (t.g += 5, 128 <= c[t.g++] && 128 <= c[t.g++] && 128 <= c[t.g++] && 128 <= c[t.g++] && 128 <= c[t.g++] ? (t.j = !0, vn(), b) : (zt(t), b))))));
  }
  function Ye(t) {
    var c = t.h[t.g], a = t.h[t.g + 1], b = t.h[t.g + 2], I = t.h[t.g + 3];
    return t.g += 4, zt(t), (c << 0 | a << 8 | b << 16 | I << 24) >>> 0;
  }
  Le.prototype.m = function() {
    var t = Ye(this), c = 2 * (t >> 31) + 1, a = t >>> 23 & 255;
    return t &= 8388607, a == 255 ? t ? NaN : 1 / 0 * c : a == 0 ? c * Math.pow(2, -149) * t : c * Math.pow(2, a - 150) * (t + Math.pow(2, 23));
  };
  var qe = [];
  function Xe() {
    this.g = new Uint8Array(64), this.h = 0;
  }
  function Ot(t, c) {
    if (!(t.h + 1 < t.g.length)) {
      var a = t.g;
      t.g = new Uint8Array(Math.ceil(1 + 2 * t.g.length)), t.g.set(a);
    }
    t.g[t.h++] = c;
  }
  Xe.prototype.length = function() {
    return this.h;
  }, Xe.prototype.end = function() {
    var t = this.g, c = this.h;
    return this.h = 0, ln(t, 0, c);
  };
  function Ae(t, c) {
    for (; 127 < c; )
      Ot(t, c & 127 | 128), c >>>= 7;
    Ot(t, c);
  }
  function Pe(t) {
    var c = {}, a = c.O === void 0 ? !1 : c.O;
    this.m = { v: c.v === void 0 ? !1 : c.v }, this.O = a, c = this.m, qe.length ? (a = qe.pop(), c && (a.v = c.v), t && At(a, t), t = a) : t = new Le(t, c), this.g = t, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
  }
  Pe.prototype.reset = function() {
    this.g.reset(), this.h = this.i = -1;
  };
  function Ie(t) {
    var c = t.g;
    if ((c = c.g == c.i) || (c = t.j) || (c = t.g, c = c.j || 0 > c.g || c.g > c.i), c)
      return !1;
    t.l = t.g.g;
    var a = be(t.g);
    return c = a >>> 3, a &= 7, 0 <= a && 5 >= a ? (t.i = c, t.h = a, !0) : (t.j = !0, sn(a, t.l), !1);
  }
  function Xn(t) {
    switch (t.h) {
      case 0:
        if (t.h != 0)
          Xn(t);
        else
          t: {
            t = t.g;
            for (var c = t.g, a = 0; 10 > a; a++) {
              if ((t.h[c] & 128) === 0) {
                t.g = c + 1, zt(t);
                break t;
              }
              c++;
            }
            t.j = !0, vn();
          }
        break;
      case 1:
        t = t.g, t.g += 8, zt(t);
        break;
      case 2:
        t.h != 2 ? Xn(t) : (c = be(t.g), t = t.g, t.g += c, zt(t));
        break;
      case 5:
        t = t.g, t.g += 4, zt(t);
        break;
      case 3:
        c = t.i;
        do {
          if (!Ie(t)) {
            t.j = !0, we(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (t.h == 4) {
            t.i != c && (t.j = !0, we(Error("Unmatched end-group tag")));
            break;
          }
          Xn(t);
        } while (1);
        break;
      default:
        t.j = !0, sn(t.h, t.l);
    }
  }
  function cn(t, c, a) {
    var b = t.g.i, I = be(t.g), F = t.g.g + I;
    if (t.g.i = F, a(c, t), a = F - t.g.g, a !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (I + " bytes, instead read " + (I - a) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    return t.g.g = F, t.g.i = b, c;
  }
  var _e = [];
  function un() {
    this.h = [], this.i = 0, this.g = new Xe();
  }
  function ve(t, c) {
    c.length !== 0 && (t.h.push(c), t.i += c.length);
  }
  function Te(t, c, a) {
    Ae(t.g, 8 * c + 2), Ae(t.g, a.length), ve(t, t.g.end()), ve(t, a);
  }
  var Ge = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
  function ie(t) {
    return Object.isFrozen(t) || (Ge ? t[Ge] |= 1 : t.g !== void 0 ? t.g |= 1 : Object.defineProperties(t, { g: { value: 1, configurable: !0, writable: !0, enumerable: !1 } })), t;
  }
  function Qe(t) {
    return t !== null && typeof t == "object" && t.constructor === Object;
  }
  function qt(t) {
    switch (typeof t) {
      case "number":
        return isFinite(t) ? t : String(t);
      case "object":
        if (Se && t != null && t instanceof Uint8Array)
          return Me(t);
        if (t instanceof re) {
          if (t.g == null)
            t = "";
          else {
            var c = t.g;
            c = c == null || typeof c == "string" ? c : Se && c instanceof Uint8Array ? Me(c) : null, t = t.g = c;
          }
          return t;
        }
    }
    return t;
  }
  function Pt(t, c) {
    if (t != null)
      return Array.isArray(t) || Qe(t) ? hn(t, c) : c(t);
  }
  function hn(t, c) {
    if (Array.isArray(t)) {
      for (var a = Array(t.length), b = 0; b < t.length; b++)
        a[b] = Pt(t[b], c);
      if (c = Array.isArray(t)) {
        var I;
        Ge ? I = t[Ge] : I = t.g, c = (I == null ? 0 : I) & 1;
      }
      return c && ie(a), a;
    }
    I = {};
    for (a in t)
      I[a] = Pt(t[a], c);
    return I;
  }
  function fe(t) {
    return t = qt(t), Array.isArray(t) ? hn(t, fe) : t;
  }
  var Lt;
  function Vt(t, c, a) {
    var b = Lt;
    Lt = null, t || (t = b), b = this.constructor.ha, t || (t = b ? [b] : []), this.i = (b ? 0 : -1) - (this.constructor.fa || 0), this.l = this.g = null, this.u = t;
    t: {
      if (b = this.u.length, t = b - 1, b && (b = this.u[t], Qe(b))) {
        this.j = t - this.i, this.h = b;
        break t;
      }
      c !== void 0 && -1 < c ? (this.j = Math.max(c, t + 1 - this.i), this.h = null) : this.j = Number.MAX_VALUE;
    }
    if (a)
      for (c = 0; c < a.length; c++)
        t = a[c], t < this.j ? (t += this.i, (b = this.u[t]) ? Array.isArray(b) && ie(b) : this.u[t] = oe) : (Fe(this), (b = this.h[t]) ? Array.isArray(b) && ie(b) : this.h[t] = oe);
  }
  var oe = Object.freeze(ie([]));
  function Fe(t) {
    var c = t.j + t.i;
    t.u[c] || (t.h = t.u[c] = {});
  }
  function te(t, c, a) {
    return c === -1 ? null : (a === void 0 ? 0 : a) || c >= t.j ? t.h ? t.h[c] : void 0 : t.u[c + t.i];
  }
  function se(t, c, a) {
    a = a === void 0 ? !1 : a;
    var b = te(t, c, a);
    return b == null && (b = oe), b === oe && (b = ie(b.slice()), ct(t, c, b, a)), b;
  }
  function tt(t, c) {
    var a = se(t, c);
    if (t.l || (t.l = {}), !t.l[c]) {
      for (var b = 0; b < a.length; b++)
        a[b] = +a[b];
      t.l[c] = !0;
    }
    return a;
  }
  function it(t, c, a) {
    return t = te(t, c), t = t == null ? t : +t, t == null ? a === void 0 ? 0 : a : t;
  }
  function ct(t, c, a, b) {
    (b === void 0 ? 0 : b) || c >= t.j ? (Fe(t), t.h[c] = a) : t.u[c + t.i] = a;
  }
  function _t(t, c, a, b) {
    a !== b ? ct(t, c, a) : ct(t, c, void 0, !1);
  }
  function de(t, c, a) {
    if (a === -1)
      return null;
    t.g || (t.g = {});
    var b = t.g[a];
    if (b)
      return b;
    var I = te(t, a, !1);
    return I == null ? b : (c = new c(I), t.g[a] = c);
  }
  function ue(t, c, a) {
    t.g || (t.g = {});
    var b = t.g[a];
    if (!b) {
      var I = se(t, a, !1);
      b = [];
      for (var F = 0; F < I.length; F++)
        b[F] = new c(I[F]);
      t.g[a] = b;
    }
    return b;
  }
  function St(t, c, a, b, I) {
    var F = ue(t, b, c);
    a = a || new b(), t = se(t, c), I != null ? (F.splice(I, 0, a), t.splice(I, 0, a.u)) : (F.push(a), t.push(a.u));
  }
  Vt.prototype.toJSON = function() {
    return hn(this.u, fe);
  }, Vt.prototype.toString = function() {
    return this.u.toString();
  };
  function me(t, c) {
    return t = te(t, c), t == null ? 0 : t;
  }
  function Ce(t, c) {
    return t = te(t, c), t == null ? "" : t;
  }
  function tn(t, c) {
    if (t = t.m) {
      ve(c, c.g.end());
      for (var a = 0; a < t.length; a++)
        ve(c, t[a]);
    }
  }
  var en = Symbol();
  function fn(t, c, a) {
    return t[en] || (t[en] = function(b, I) {
      return c(b, I, a);
    });
  }
  function pn(t) {
    var c = t[en];
    if (!c) {
      var a = t[rn] || (t[rn] = t());
      c = function(b, I) {
        return Ne(b, I, a);
      }, t[en] = c;
    }
    return c;
  }
  function He(t) {
    var c = t.da;
    if (c)
      return pn(c);
    if (c = t.ia) {
      var a = t.Y;
      return delete t.Y, fn(t.W.g, c, a);
    }
  }
  function nn(t) {
    var c = He(t), a = t.W, b = t.ea;
    return c ? function(I, F) {
      return b(I, F, a, c);
    } : function(I, F) {
      return b(I, F, a);
    };
  }
  function Kn(t) {
    var c = t[0];
    switch (t.length) {
      case 2:
        var a = t[1];
        return function(ft, Gt, vt) {
          return c(ft, Gt, vt, a);
        };
      case 3:
        var b = t[1], I = pn(t[2]);
        return function(ft, Gt, vt) {
          return c(ft, Gt, vt, b, I);
        };
      case 4:
        var F = t[1], H = t[3], U = pn(t[2]);
        return function(ft, Gt, vt) {
          return c(ft, Gt, vt, F, U, H);
        };
      case 5:
        var j = t[1], Q = fn(j, t[3], t[4]);
        return function(ft, Gt, vt) {
          return c(ft, Gt, vt, j, Q);
        };
      case 6:
        var D = t[1], st = t[5], ht = fn(D, t[3], t[4]);
        return function(ft, Gt, vt) {
          return c(ft, Gt, vt, D, ht, st);
        };
      default:
        throw Error("Unsupported number of parameters, expected [2-6], got " + t.length);
    }
  }
  var rn = Symbol();
  function Ne(t, c, a) {
    for (; Ie(c) && c.h != 4; ) {
      var b = c.i, I = a[b];
      if (I)
        Array.isArray(I) && (I = a[b] = Kn(I));
      else {
        var F = a[0];
        F && (F = F[b]) && (I = a[b] = nn(F));
      }
      I && I(c, t, b) || (I = c, b = t, F = I.l, Xn(I), I.O || (I = ln(I.g.h, F, I.g.g), (F = b.m) ? F.push(I) : b.m = [I]));
    }
    return t;
  }
  function yn(t, c) {
    var a = new un();
    if (c(t, a), t = a.i + a.g.length(), t === 0)
      a = new Uint8Array(0);
    else {
      t = new Uint8Array(t);
      for (var b = a.h, I = b.length, F = c = 0; F < I; F++) {
        var H = b[F];
        H.length !== 0 && (t.set(H, c), c += H.length);
      }
      b = a.g, I = b.h, I !== 0 && (t.set(b.g.subarray(0, I), c), b.h = 0), a.h = [t], a = t;
    }
    return a;
  }
  function In(t, c, a) {
    if (_e.length) {
      var b = _e.pop();
      t && (At(b.g, t), b.i = -1, b.h = -1), t = b;
    } else
      t = new Pe(t);
    try {
      var I = new c();
      return Ne(I, t, a[rn] || (a[rn] = a()));
    } finally {
      c = t.g, c.h = null, c.l = 0, c.i = 0, c.g = 0, c.j = !1, c.v = !1, t.i = -1, t.h = -1, t.j = !1, 100 > _e.length && _e.push(t);
    }
  }
  function Be(t, c, a) {
    if (c = te(c, a), c != null) {
      Ae(t.g, 8 * a + 5), t = t.g;
      var b = c;
      b = (a = 0 > b ? 1 : 0) ? -b : b, b === 0 ? 0 < 1 / b ? Ee = Qt = 0 : (Qt = 0, Ee = 2147483648) : isNaN(b) ? (Qt = 0, Ee = 2147483647) : 34028234663852886e22 < b ? (Qt = 0, Ee = (a << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > b ? (b = Math.round(b / Math.pow(2, -149)), Qt = 0, Ee = (a << 31 | b) >>> 0) : (c = Math.floor(Math.log(b) / Math.LN2), b *= Math.pow(2, -c), b = Math.round(8388608 * b), 16777216 <= b && ++c, Qt = 0, Ee = (a << 31 | c + 127 << 23 | b & 8388607) >>> 0), a = Ee, Ot(t, a >>> 0 & 255), Ot(t, a >>> 8 & 255), Ot(t, a >>> 16 & 255), Ot(t, a >>> 24 & 255);
    }
  }
  function Un(t, c, a) {
    if (t.h !== 1)
      return !1;
    var b = t.g;
    t = Ye(b);
    var I = Ye(b);
    b = 2 * (I >> 31) + 1;
    var F = I >>> 20 & 2047;
    return t = 4294967296 * (I & 1048575) + t, _t(c, a, F == 2047 ? t ? NaN : 1 / 0 * b : F == 0 ? b * Math.pow(2, -1074) * t : b * Math.pow(2, F - 1075) * (t + 4503599627370496), 0), !0;
  }
  function on(t, c, a) {
    return t.h !== 5 ? !1 : (ct(c, a, t.g.m()), !0);
  }
  function gn(t, c, a) {
    if (t.h !== 5 && t.h !== 2)
      return !1;
    if (c = se(c, a), t.h == 2) {
      a = Le.prototype.m;
      var b = be(t.g);
      for (b = t.g.g + b; t.g.g < b; )
        c.push(a.call(t.g));
    } else
      c.push(t.g.m());
    return !0;
  }
  function Sn(t, c, a) {
    return t.h !== 5 ? !1 : (t = t.g.m(), _t(c, a, t, 0), !0);
  }
  function En(t, c, a) {
    return t.h !== 0 ? !1 : (ct(c, a, xe(t.g)), !0);
  }
  function an(t, c, a) {
    return t.h !== 0 ? !1 : (ct(c, a, be(t.g)), !0);
  }
  function wn(t, c, a) {
    return t.h !== 0 ? !1 : (t = be(t.g), _t(c, a, t, 0), !0);
  }
  function Pn(t, c, a) {
    return t.h !== 0 ? !1 : (t = !!be(t.g), _t(c, a, t, !1), !0);
  }
  function _n(t, c, a) {
    if (t.h !== 2)
      return !1;
    var b = be(t.g);
    t = t.g;
    var I = t.g;
    t.g += b, zt(t), t = t.h;
    var F;
    if (Nn)
      (F = Rn) || (F = Rn = new TextDecoder("utf-8", { fatal: !1 })), F = F.decode(t.subarray(I, I + b));
    else {
      b = I + b;
      for (var H = [], U = null, j, Q, D; I < b; )
        j = t[I++], 128 > j ? H.push(j) : 224 > j ? I >= b ? H.push(65533) : (Q = t[I++], 194 > j || (Q & 192) !== 128 ? (I--, H.push(65533)) : H.push((j & 31) << 6 | Q & 63)) : 240 > j ? I >= b - 1 ? H.push(65533) : (Q = t[I++], (Q & 192) !== 128 || j === 224 && 160 > Q || j === 237 && 160 <= Q || ((F = t[I++]) & 192) !== 128 ? (I--, H.push(65533)) : H.push((j & 15) << 12 | (Q & 63) << 6 | F & 63)) : 244 >= j ? I >= b - 2 ? H.push(65533) : (Q = t[I++], (Q & 192) !== 128 || (j << 28) + (Q - 144) >> 30 !== 0 || ((F = t[I++]) & 192) !== 128 || ((D = t[I++]) & 192) !== 128 ? (I--, H.push(65533)) : (j = (j & 7) << 18 | (Q & 63) << 12 | (F & 63) << 6 | D & 63, j -= 65536, H.push((j >> 10 & 1023) + 55296, (j & 1023) + 56320))) : H.push(65533), 8192 <= H.length && (U = Tn(U, H), H.length = 0);
      F = Tn(U, H);
    }
    return ct(c, a, F), !0;
  }
  function Yn(t, c, a, b, I) {
    return t.h !== 2 ? !1 : (t = cn(t, new b(), I), c.g || (c.g = {}), b = t && t.u, c.g[a] = t, ct(c, a, b, !1), !0);
  }
  function Hn(t, c, a, b, I) {
    return t.h !== 2 ? !1 : (t = cn(t, new b(), I), St(c, a, t, b, void 0), !0);
  }
  function p(t, c, a) {
    return t.h !== 0 ? !1 : (ct(c, a, xe(t.g)), !0);
  }
  function W(t) {
    Vt.call(this, t);
  }
  mt(W, Vt);
  function V() {
    return { 1: an, 2: on, 3: _n, 4: _n };
  }
  function k(t, c) {
    var a = te(t, 1);
    if (a != null && a != null) {
      Ae(c.g, 8);
      var b = c.g;
      if (0 <= a)
        Ae(b, a);
      else {
        for (var I = 0; 9 > I; I++)
          Ot(b, a & 127 | 128), a >>= 7;
        Ot(b, 1);
      }
    }
    Be(c, t, 2), b = te(t, 3), b != null && Te(c, 3, kn(b)), b = te(t, 4), b != null && Te(c, 4, kn(b)), tn(t, c);
  }
  function O(t) {
    Vt.call(this, t, -1, z);
  }
  mt(O, Vt), O.prototype.addClassification = function(t, c) {
    return St(this, 1, t, W, c), this;
  };
  function ot() {
    return { 1: [Hn, W, V] };
  }
  var z = [1];
  function rt(t) {
    Vt.call(this, t);
  }
  mt(rt, Vt);
  function bt() {
    return { 1: on, 2: on, 3: on, 4: on, 5: on };
  }
  function Rt(t, c) {
    Be(c, t, 1), Be(c, t, 2), Be(c, t, 3), Be(c, t, 4), Be(c, t, 5), tn(t, c);
  }
  function Et(t) {
    Vt.call(this, t, -1, $t);
  }
  mt(Et, Vt);
  function Nt() {
    return { 1: [Hn, rt, bt] };
  }
  var $t = [1];
  function Jt(t) {
    Vt.call(this, t);
  }
  mt(Jt, Vt);
  function wt() {
    return { 1: on, 2: on, 3: on, 4: on, 5: on, 6: En };
  }
  function Ut(t, c) {
    Be(c, t, 1), Be(c, t, 2), Be(c, t, 3), Be(c, t, 4), Be(c, t, 5);
    var a = te(t, 6);
    if (a != null && a != null) {
      Ae(c.g, 48);
      var b = c.g, I = a;
      a = 0 > I, I = Math.abs(I);
      var F = I >>> 0;
      for (I = Math.floor((I - F) / 4294967296), I >>>= 0, a && (I = ~I >>> 0, F = (~F >>> 0) + 1, 4294967295 < F && (F = 0, I++, 4294967295 < I && (I = 0))), Ee = F, Qt = I, a = Ee, F = Qt; 0 < F || 127 < a; )
        Ot(b, a & 127 | 128), a = (a >>> 7 | F << 25) >>> 0, F >>>= 7;
      Ot(b, a);
    }
    tn(t, c);
  }
  function Dt(t) {
    Vt.call(this, t, -1, Je);
  }
  mt(Dt, Vt);
  function ae() {
    return { 1: p, 2: p, 3: gn, 4: [Yn, pe, ye], 5: an, 6: an, 7: gn, 8: gn, 9: gn };
  }
  function pe(t) {
    Vt.call(this, t);
  }
  mt(pe, Vt);
  function ye() {
    return { 1: on, 2: on, 3: on };
  }
  var Je = [3, 7, 8, 9];
  function h(t) {
    Vt.call(this, t);
  }
  mt(h, Vt);
  function y() {
    return { 1: Sn, 2: Sn, 3: Sn };
  }
  function v(t) {
    Vt.call(this, t);
  }
  mt(v, Vt);
  function L() {
    return { 1: Sn, 2: Sn, 3: Sn };
  }
  function M(t) {
    Vt.call(this, t);
  }
  mt(M, Vt);
  function _() {
    return { 1: wn, 2: [Yn, v, L], 3: [Yn, h, y], 4: Pn };
  }
  function A(t) {
    Vt.call(this, t, -1, lt);
  }
  mt(A, Vt);
  function q() {
    return { 1: wn, 2: [Hn, M, _], 3: Sn, 4: gn, 5: gn, 6: gn };
  }
  var lt = [2, 4, 5, 6];
  function s(t) {
    Vt.call(this, t, -1, R);
  }
  mt(s, Vt);
  function G() {
    return { 1: wn, 2: [Hn, A, q], 3: [Yn, Dt, ae], 4: Un, 5: gn, 6: gn };
  }
  var R = [2, 5, 6];
  function Y(t, c, a) {
    if (a = t.createShader(a === 0 ? t.VERTEX_SHADER : t.FRAGMENT_SHADER), t.shaderSource(a, c), t.compileShader(a), !t.getShaderParameter(a, t.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + t.getShaderInfoLog(a));
    return a;
  }
  function N(t) {
    return ue(t, W, 1).map(function(c) {
      return { index: me(c, 1), $: it(c, 2), label: te(c, 3) != null ? Ce(c, 3) : void 0, displayName: te(c, 4) != null ? Ce(c, 4) : void 0 };
    });
  }
  function K(t) {
    return { x: it(t, 1), y: it(t, 2), z: it(t, 3), visibility: te(t, 4) != null ? it(t, 4) : void 0 };
  }
  function E(t, c) {
    this.h = t, this.g = c, this.l = 0;
  }
  function et(t, c, a) {
    return $(t, c), typeof t.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(t.g.canvas.transferToImageBitmap()) : a ? Promise.resolve(t.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(t.g.canvas) : (t.i === void 0 && (t.i = document.createElement("canvas")), new Promise(function(b) {
      t.i.height = t.g.canvas.height, t.i.width = t.g.canvas.width, t.i.getContext("2d", {}).drawImage(t.g.canvas, 0, 0, t.g.canvas.width, t.g.canvas.height), b(t.i);
    }));
  }
  function $(t, c) {
    var a = t.g;
    if (t.m === void 0) {
      var b = Y(a, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), I = Y(a, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), F = a.createProgram();
      if (a.attachShader(F, b), a.attachShader(F, I), a.linkProgram(F), !a.getProgramParameter(F, a.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + a.getProgramInfoLog(F));
      b = t.m = F, a.useProgram(b), I = a.getUniformLocation(b, "sampler0"), t.j = { J: a.getAttribLocation(b, "aVertex"), I: a.getAttribLocation(b, "aTex"), ja: I }, t.s = a.createBuffer(), a.bindBuffer(a.ARRAY_BUFFER, t.s), a.enableVertexAttribArray(t.j.J), a.vertexAttribPointer(t.j.J, 2, a.FLOAT, !1, 0, 0), a.bufferData(a.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), a.STATIC_DRAW), a.bindBuffer(a.ARRAY_BUFFER, null), t.o = a.createBuffer(), a.bindBuffer(a.ARRAY_BUFFER, t.o), a.enableVertexAttribArray(t.j.I), a.vertexAttribPointer(
        t.j.I,
        2,
        a.FLOAT,
        !1,
        0,
        0
      ), a.bufferData(a.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), a.STATIC_DRAW), a.bindBuffer(a.ARRAY_BUFFER, null), a.uniform1i(I, 0);
    }
    b = t.j, a.useProgram(t.m), a.canvas.width = c.width, a.canvas.height = c.height, a.viewport(0, 0, c.width, c.height), a.activeTexture(a.TEXTURE0), t.h.bindTexture2d(c.glName), a.enableVertexAttribArray(b.J), a.bindBuffer(a.ARRAY_BUFFER, t.s), a.vertexAttribPointer(b.J, 2, a.FLOAT, !1, 0, 0), a.enableVertexAttribArray(b.I), a.bindBuffer(a.ARRAY_BUFFER, t.o), a.vertexAttribPointer(
      b.I,
      2,
      a.FLOAT,
      !1,
      0,
      0
    ), a.bindFramebuffer(a.DRAW_FRAMEBUFFER ? a.DRAW_FRAMEBUFFER : a.FRAMEBUFFER, null), a.clearColor(0, 0, 0, 0), a.clear(a.COLOR_BUFFER_BIT), a.colorMask(!0, !0, !0, !0), a.drawArrays(a.TRIANGLE_FAN, 0, 4), a.disableVertexAttribArray(b.J), a.disableVertexAttribArray(b.I), a.bindBuffer(a.ARRAY_BUFFER, null), t.h.bindTexture2d(0);
  }
  function yt(t) {
    this.g = t;
  }
  var Xt = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Mt(t, c) {
    return c + t;
  }
  function xt(t, c) {
    window[t] = c;
  }
  function dt(t) {
    var c = document.createElement("script");
    return c.setAttribute("src", t), c.setAttribute("crossorigin", "anonymous"), new Promise(function(a) {
      c.addEventListener("load", function() {
        a();
      }, !1), c.addEventListener("error", function() {
        a();
      }, !1), document.body.appendChild(c);
    });
  }
  function Wt() {
    return gt(function(t) {
      switch (t.g) {
        case 1:
          return t.m = 2, P(t, WebAssembly.instantiate(Xt), 4);
        case 4:
          t.g = 3, t.m = 0;
          break;
        case 2:
          return t.m = 0, t.j = null, t.return(!1);
        case 3:
          return t.return(!0);
      }
    });
  }
  function It(t) {
    if (this.g = t, this.listeners = {}, this.j = {}, this.G = {}, this.m = {}, this.s = {}, this.H = this.o = this.S = !0, this.D = Promise.resolve(), this.R = "", this.C = {}, this.locateFile = t && t.locateFile || Mt, typeof window == "object")
      var c = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      c = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.T = c, t.options) {
      c = T(Object.keys(t.options));
      for (var a = c.next(); !a.done; a = c.next()) {
        a = a.value;
        var b = t.options[a].default;
        b !== void 0 && (this.j[a] = typeof b == "function" ? b() : b);
      }
    }
  }
  i = It.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function Yt(t) {
    var c, a, b, I, F, H, U, j, Q, D, st;
    return gt(function(ht) {
      switch (ht.g) {
        case 1:
          return t.S ? (c = t.g.files === void 0 ? [] : typeof t.g.files == "function" ? t.g.files(t.j) : t.g.files, P(ht, Wt(), 2)) : ht.return();
        case 2:
          if (a = ht.h, typeof window == "object")
            return xt("createMediapipeSolutionsWasm", { locateFile: t.locateFile }), xt("createMediapipeSolutionsPackedAssets", { locateFile: t.locateFile }), H = c.filter(function(ft) {
              return ft.data !== void 0;
            }), U = c.filter(function(ft) {
              return ft.data === void 0;
            }), j = Promise.all(H.map(function(ft) {
              var Gt = Z(t, ft.url);
              if (ft.path !== void 0) {
                var vt = ft.path;
                Gt = Gt.then(function(Kt) {
                  return t.overrideFile(vt, Kt), Promise.resolve(Kt);
                });
              }
              return Gt;
            })), Q = Promise.all(U.map(function(ft) {
              return ft.simd === void 0 || ft.simd && a || !ft.simd && !a ? dt(t.locateFile(ft.url, t.T)) : Promise.resolve();
            })).then(function() {
              var ft, Gt, vt;
              return gt(function(Kt) {
                if (Kt.g == 1)
                  return ft = window.createMediapipeSolutionsWasm, Gt = window.createMediapipeSolutionsPackedAssets, vt = t, P(Kt, ft(Gt), 2);
                vt.h = Kt.h, Kt.g = 0;
              });
            }), D = function() {
              return gt(function(ft) {
                return t.g.graph && t.g.graph.url ? ft = P(
                  ft,
                  Z(t, t.g.graph.url),
                  0
                ) : (ft.g = 0, ft = void 0), ft;
              });
            }(), P(ht, Promise.all([Q, j, D]), 7);
          if (typeof importScripts != "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          return b = c.filter(function(ft) {
            return ft.simd === void 0 || ft.simd && a || !ft.simd && !a;
          }).map(function(ft) {
            return t.locateFile(ft.url, t.T);
          }), importScripts.apply(null, B(b)), I = t, P(ht, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          I.h = ht.h, t.l = new OffscreenCanvas(1, 1), t.h.canvas = t.l, F = t.h.GL.createContext(t.l, {
            antialias: !1,
            alpha: !1,
            ga: typeof WebGL2RenderingContext < "u" ? 2 : 1
          }), t.h.GL.makeContextCurrent(F), ht.g = 4;
          break;
        case 7:
          if (t.l = document.createElement("canvas"), st = t.l.getContext("webgl2", {}), !st && (st = t.l.getContext("webgl", {}), !st))
            return alert("Failed to create WebGL canvas context when passing video frame."), ht.return();
          t.F = st, t.h.canvas = t.l, t.h.createContext(t.l, !0, !0, {});
        case 4:
          t.i = new t.h.SolutionWasm(), t.S = !1, ht.g = 0;
      }
    });
  }
  function Ft(t) {
    var c, a, b, I, F, H, U, j;
    return gt(function(Q) {
      if (Q.g == 1) {
        if (t.g.graph && t.g.graph.url && t.R === t.g.graph.url)
          return Q.return();
        if (t.o = !0, !t.g.graph || !t.g.graph.url) {
          Q.g = 2;
          return;
        }
        return t.R = t.g.graph.url, P(Q, Z(t, t.g.graph.url), 3);
      }
      for (Q.g != 2 && (c = Q.h, t.i.loadGraph(c)), a = T(Object.keys(t.C)), b = a.next(); !b.done; b = a.next())
        I = b.value, t.i.overrideFile(I, t.C[I]);
      if (t.C = {}, t.g.listeners)
        for (F = T(t.g.listeners), H = F.next(); !H.done; H = F.next())
          U = H.value, J(t, U);
      j = t.j, t.j = {}, t.setOptions(j), Q.g = 0;
    });
  }
  i.reset = function() {
    var t = this;
    return gt(function(c) {
      t.i && (t.i.reset(), t.m = {}, t.s = {}), c.g = 0;
    });
  }, i.setOptions = function(t, c) {
    var a = this;
    if (c = c || this.g.options) {
      for (var b = [], I = [], F = {}, H = T(Object.keys(t)), U = H.next(); !U.done; F = { L: F.L, M: F.M }, U = H.next()) {
        var j = U.value;
        j in this.j && this.j[j] === t[j] || (this.j[j] = t[j], U = c[j], U !== void 0 && (U.onChange && (F.L = U.onChange, F.M = t[j], b.push(function(Q) {
          return function() {
            var D;
            return gt(function(st) {
              if (st.g == 1)
                return P(st, Q.L(Q.M), 2);
              D = st.h, D === !0 && (a.o = !0), st.g = 0;
            });
          };
        }(F))), U.graphOptionXref && (j = { valueNumber: U.type === 1 ? t[j] : 0, valueBoolean: U.type === 0 ? t[j] : !1, valueString: U.type === 2 ? t[j] : "" }, U = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), U.graphOptionXref), j), I.push(U))));
      }
      (b.length !== 0 || I.length !== 0) && (this.o = !0, this.B = (this.B === void 0 ? [] : this.B).concat(I), this.A = (this.A === void 0 ? [] : this.A).concat(b));
    }
  };
  function l(t) {
    var c, a, b, I, F, H, U;
    return gt(function(j) {
      switch (j.g) {
        case 1:
          if (!t.o)
            return j.return();
          if (!t.A) {
            j.g = 2;
            break;
          }
          c = T(t.A), a = c.next();
        case 3:
          if (a.done) {
            j.g = 5;
            break;
          }
          return b = a.value, P(j, b(), 4);
        case 4:
          a = c.next(), j.g = 3;
          break;
        case 5:
          t.A = void 0;
        case 2:
          if (t.B) {
            for (I = new t.h.GraphOptionChangeRequestList(), F = T(t.B), H = F.next(); !H.done; H = F.next())
              U = H.value, I.push_back(U);
            t.i.changeOptions(I), I.delete(), t.B = void 0;
          }
          t.o = !1, j.g = 0;
      }
    });
  }
  i.initialize = function() {
    var t = this;
    return gt(function(c) {
      return c.g == 1 ? P(c, Yt(t), 2) : c.g != 3 ? P(c, Ft(t), 3) : P(c, l(t), 0);
    });
  };
  function Z(t, c) {
    var a, b;
    return gt(function(I) {
      return c in t.G ? I.return(t.G[c]) : (a = t.locateFile(c, ""), b = fetch(a).then(function(F) {
        return F.arrayBuffer();
      }), t.G[c] = b, I.return(b));
    });
  }
  i.overrideFile = function(t, c) {
    this.i ? this.i.overrideFile(t, c) : this.C[t] = c;
  }, i.clearOverriddenFiles = function() {
    this.C = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(t, c) {
    var a = this, b, I, F, H, U, j, Q, D, st;
    return gt(function(ht) {
      switch (ht.g) {
        case 1:
          return a.g.inputs ? (b = 1e3 * (c == null ? performance.now() : c), P(ht, a.D, 2)) : ht.return();
        case 2:
          return P(ht, a.initialize(), 3);
        case 3:
          for (I = new a.h.PacketDataList(), F = T(Object.keys(t)), H = F.next(); !H.done; H = F.next())
            if (U = H.value, j = a.g.inputs[U]) {
              t: {
                var ft = t[U];
                switch (j.type) {
                  case "video":
                    var Gt = a.m[j.stream];
                    if (Gt || (Gt = new E(a.h, a.F), a.m[j.stream] = Gt), Gt.l === 0 && (Gt.l = Gt.h.createTexture()), typeof HTMLVideoElement < "u" && ft instanceof HTMLVideoElement)
                      var vt = ft.videoWidth, Kt = ft.videoHeight;
                    else
                      typeof HTMLImageElement < "u" && ft instanceof HTMLImageElement ? (vt = ft.naturalWidth, Kt = ft.naturalHeight) : (vt = ft.width, Kt = ft.height);
                    Kt = { glName: Gt.l, width: vt, height: Kt }, vt = Gt.g, vt.canvas.width = Kt.width, vt.canvas.height = Kt.height, vt.activeTexture(vt.TEXTURE0), Gt.h.bindTexture2d(Gt.l), vt.texImage2D(vt.TEXTURE_2D, 0, vt.RGBA, vt.RGBA, vt.UNSIGNED_BYTE, ft), Gt.h.bindTexture2d(0), Gt = Kt;
                    break t;
                  case "detections":
                    for (Gt = a.m[j.stream], Gt || (Gt = new yt(a.h), a.m[j.stream] = Gt), Gt.data || (Gt.data = new Gt.g.DetectionListData()), Gt.data.reset(ft.length), Kt = 0; Kt < ft.length; ++Kt) {
                      vt = ft[Kt];
                      var le = Gt.data, ce = le.setBoundingBox, ke = Kt, Wn = vt.U, Ue = new Jt();
                      if (ct(Ue, 1, Wn.aa), ct(Ue, 2, Wn.ba), ct(Ue, 3, Wn.height), ct(Ue, 4, Wn.width), ct(Ue, 5, Wn.rotation), ct(Ue, 6, Wn.Z), Wn = yn(Ue, Ut), ce.call(le, ke, Wn), vt.P)
                        for (le = 0; le < vt.P.length; ++le) {
                          Ue = vt.P[le];
                          var Jn = !!Ue.visibility;
                          ce = Gt.data, ke = ce.addNormalizedLandmark, Wn = Kt, Ue = Object.assign(Object.assign({}, Ue), { visibility: Jn ? Ue.visibility : 0 }), Jn = new rt(), ct(Jn, 1, Ue.x), ct(Jn, 2, Ue.y), ct(Jn, 3, Ue.z), Ue.visibility && ct(Jn, 4, Ue.visibility), Ue = yn(Jn, Rt), ke.call(ce, Wn, Ue);
                        }
                      if (vt.N)
                        for (le = 0; le < vt.N.length; ++le)
                          ce = Gt.data, ke = ce.addClassification, Wn = Kt, Ue = vt.N[le], Jn = new W(), ct(Jn, 2, Ue.$), Ue.index && ct(Jn, 1, Ue.index), Ue.label && ct(Jn, 3, Ue.label), Ue.displayName && ct(Jn, 4, Ue.displayName), Ue = yn(Jn, k), ke.call(ce, Wn, Ue);
                    }
                    Gt = Gt.data;
                    break t;
                  default:
                    Gt = {};
                }
              }
              switch (Q = Gt, D = j.stream, j.type) {
                case "video":
                  I.pushTexture2d(Object.assign(Object.assign({}, Q), { stream: D, timestamp: b }));
                  break;
                case "detections":
                  st = Q, st.stream = D, st.timestamp = b, I.pushDetectionList(st);
                  break;
                default:
                  throw Error("Unknown input config type: '" + j.type + "'");
              }
            }
          return a.i.send(I), P(ht, a.D, 4);
        case 4:
          I.delete(), ht.g = 0;
      }
    });
  };
  function x(t, c, a) {
    var b, I, F, H, U, j, Q, D, st, ht, ft, Gt, vt, Kt;
    return gt(function(le) {
      switch (le.g) {
        case 1:
          if (!a)
            return le.return(c);
          for (b = {}, I = 0, F = T(Object.keys(a)), H = F.next(); !H.done; H = F.next())
            U = H.value, j = a[U], typeof j != "string" && j.type === "texture" && c[j.stream] !== void 0 && ++I;
          1 < I && (t.H = !1), Q = T(Object.keys(a)), H = Q.next();
        case 2:
          if (H.done) {
            le.g = 4;
            break;
          }
          if (D = H.value, st = a[D], typeof st == "string")
            return vt = b, Kt = D, P(le, w(t, D, c[st]), 14);
          if (ht = c[st.stream], st.type === "detection_list") {
            if (ht) {
              for (var ce = ht.getRectList(), ke = ht.getLandmarksList(), Wn = ht.getClassificationsList(), Ue = [], Jn = 0; Jn < ce.size(); ++Jn) {
                var nr = In(ce.get(Jn), Jt, wt);
                nr = { U: { aa: it(nr, 1), ba: it(nr, 2), height: it(nr, 3), width: it(nr, 4), rotation: it(nr, 5, 0), Z: me(nr, 6) }, P: ue(In(ke.get(Jn), Et, Nt), rt, 1).map(K), N: N(In(Wn.get(Jn), O, ot)) }, Ue.push(nr);
              }
              ce = Ue;
            } else
              ce = [];
            b[D] = ce, le.g = 7;
            break;
          }
          if (st.type === "proto_list") {
            if (ht) {
              for (ce = Array(ht.size()), ke = 0; ke < ht.size(); ke++)
                ce[ke] = ht.get(ke);
              ht.delete();
            } else
              ce = [];
            b[D] = ce, le.g = 7;
            break;
          }
          if (ht === void 0) {
            le.g = 3;
            break;
          }
          if (st.type === "float_list") {
            b[D] = ht, le.g = 7;
            break;
          }
          if (st.type === "proto") {
            b[D] = ht, le.g = 7;
            break;
          }
          if (st.type !== "texture")
            throw Error("Unknown output config type: '" + st.type + "'");
          return ft = t.s[D], ft || (ft = new E(t.h, t.F), t.s[D] = ft), P(le, et(ft, ht, t.H), 13);
        case 13:
          Gt = le.h, b[D] = Gt;
        case 7:
          st.transform && b[D] && (b[D] = st.transform(b[D])), le.g = 3;
          break;
        case 14:
          vt[Kt] = le.h;
        case 3:
          H = Q.next(), le.g = 2;
          break;
        case 4:
          return le.return(b);
      }
    });
  }
  function w(t, c, a) {
    var b;
    return gt(function(I) {
      return typeof a == "number" || a instanceof Uint8Array || a instanceof t.h.Uint8BlobList ? I.return(a) : a instanceof t.h.Texture2dDataOut ? (b = t.s[c], b || (b = new E(t.h, t.F), t.s[c] = b), I.return(et(b, a, t.H))) : I.return(void 0);
    });
  }
  function J(t, c) {
    for (var a = c.name || "$", b = [].concat(B(c.wants)), I = new t.h.StringList(), F = T(c.wants), H = F.next(); !H.done; H = F.next())
      I.push_back(H.value);
    F = t.h.PacketListener.implement({ onResults: function(U) {
      for (var j = {}, Q = 0; Q < c.wants.length; ++Q)
        j[b[Q]] = U.get(Q);
      var D = t.listeners[a];
      D && (t.D = x(t, j, c.outs).then(function(st) {
        st = D(st);
        for (var ht = 0; ht < c.wants.length; ++ht) {
          var ft = j[b[ht]];
          typeof ft == "object" && ft.hasOwnProperty && ft.hasOwnProperty("delete") && ft.delete();
        }
        st && (t.D = st);
      }));
    } }), t.i.attachMultiListener(I, F), I.delete();
  }
  i.onResults = function(t, c) {
    this.listeners[c || "$"] = t;
  }, Ct("Solution", It), Ct("OptionType", { BOOL: 0, NUMBER: 1, ca: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function o(t) {
    var c = me(t, 1), a = de(t, h, 3);
    return a = { x: it(a, 1), y: it(a, 2), depth: it(a, 3) }, t = de(t, v, 2), { id: c, point2d: a, point3d: { x: it(t, 1), y: it(t, 2), z: it(t, 3) } };
  }
  function d(t) {
    var c = In(t, s, G);
    t = [], c = ue(c, A, 2);
    for (var a = 0; a < c.length; a++)
      t.push({ id: me(c[a], 1), keypoints: ue(c[a], M, 2).map(o), visibility: it(c[a], 3), scale: tt(c[a], 6), translation: tt(c[a], 5), rotation: tt(c[a], 4) });
    return t;
  }
  function g(t) {
    switch (t) {
      case "Camera":
        return "object_detection_3d_camera.tflite";
      case "Chair":
        return "object_detection_3d_chair.tflite";
      case "Cup":
        return "object_detection_3d_cup.tflite";
      default:
        return "object_detection_3d_sneakers.tflite";
    }
  }
  function e(t) {
    switch (t) {
      case "Camera":
        return "Camera";
      case "Chair":
        return "Chair";
      case "Cup":
        return "Coffee cup, Mug";
      default:
        return "Footwear";
    }
  }
  var u = {
    focalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_x" } },
    focalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_y" } },
    principalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_x" } },
    principalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_y" } },
    allowedLabels: { type: 2, graphOptionXref: { calculatorName: "ConstantSidePacketCalculatorAllowedLabels", calculatorType: "ConstantSidePacketCalculator", fieldName: "string_value" } }
  };
  function f(t) {
    var c = this;
    t = t || {}, this.g = new It({ locateFile: t.locateFile, files: [{ url: "objectron_solution_packed_assets_loader.js" }, { simd: !1, url: "objectron_solution_wasm_bin.js" }, { simd: !0, url: "objectron_solution_simd_wasm_bin.js" }], graph: { url: "objectron.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["lifted_objects", "image_transformed"], outs: { image: "image_transformed", objectDetections: { type: "proto", stream: "lifted_objects", transform: d } } }], options: {
      useCpuInference: {
        type: 0,
        graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" },
        default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
      },
      selfieMode: { type: 0, default: !1, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
      maxNumObjects: { type: 1, default: 5, graphOptionXref: {
        calculatorType: "ConstantSidePacketCalculator",
        calculatorName: "ConstantSidePacketCalculatorMaxNumObjects",
        fieldName: "int_value"
      } },
      staticImageMode: { type: 0, default: !0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "objectrongpusubgraph__ConstantSidePacketCalculator", fieldName: "bool_value" } },
      minDetectionConfidence: { type: 1, default: 0.5, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "objectrongpusubgraph__objectdetectionoidv4subgraph__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
      minTrackingConfidence: { type: 1, default: 0.99, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "objectrongpusubgraph__boxlandmarksubgraph__ThresholdingCalculator", fieldName: "threshold" } },
      modelName: { default: "Shoe", onChange: function(a) {
        var b, I, F, H;
        return gt(function(U) {
          return U.g == 1 ? (b = a, c.g.setOptions({ allowedLabels: e(b) }, u), I = g(b), F = "object_detection_3d.tflite", P(U, Z(c.g, I), 2)) : (H = U.h, c.g.overrideFile(F, H), U.return(!0));
        });
      } },
      focalLength: { default: [1, 1], onChange: function(a) {
        var b;
        return gt(function(I) {
          return b = a, c.h = b, c.g.setOptions({ focalX: b[0], focalY: b[1] }, u), I.return(!0);
        });
      } },
      principalPoint: { default: [0, 0], onChange: function(a) {
        var b;
        return gt(function(I) {
          return b = a, c.i = b, c.g.setOptions({ principalX: b[0], principalY: b[1] }, u), I.return(!0);
        });
      } },
      imageSize: { onChange: function(a) {
        var b, I, F, H;
        return gt(function(U) {
          if (c.h === void 0 || c.i === void 0)
            return console.error('"focalLength" and "principalPoint" must be set if setting image size'), U.return();
          b = a, I = [b[0] / 2, b[1] / 2], F = [
            c.h[0] / I[0],
            c.h[1] / I[1]
          ], H = [c.i[0] / I[0], c.i[1] / I[1]], c.setOptions({ focalLength: F, principalPoint: H }), U.g = 0;
        });
      } }
    } });
  }
  i = f.prototype, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(t) {
    this.g.onResults(t);
  }, i.initialize = function() {
    var t = this;
    return gt(function(c) {
      return P(c, t.g.initialize(), 0);
    });
  }, i.reset = function() {
    this.g.reset();
  }, i.send = function(t) {
    var c = this;
    return gt(function(a) {
      return P(a, c.g.send(t), 0);
    });
  }, i.setOptions = function(t) {
    this.g.setOptions(t);
  }, Ct("Objectron", f), Ct("BOX_CONNECTIONS", [[1, 2], [2, 4], [4, 3], [3, 1], [5, 6], [6, 8], [8, 7], [7, 5], [1, 5], [2, 6], [3, 7], [4, 8]]), Ct("BOX_KEYPOINTS", { CENTER: 0, BACK_BOTTOM_LEFT: 1, FRONT_BOTTOM_LEFT: 2, BACK_TOP_LEFT: 3, FRONT_TOP_LEFT: 4, BACK_BOTTOM_RIGHT: 5, FRONT_BOTTOM_RIGHT: 6, BACK_TOP_RIGHT: 7, FRONT_TOP_RIGHT: 8 }), Ct("VERSION", "0.4.1636596145");
}).call(Gi);
const Xi = {};
(function() {
  var i;
  function r(s) {
    var G = 0;
    return function() {
      return G < s.length ? { done: !1, value: s[G++] } : { done: !0 };
    };
  }
  var n = typeof Object.defineProperties == "function" ? Object.defineProperty : function(s, G, R) {
    return s == Array.prototype || s == Object.prototype || (s[G] = R.value), s;
  };
  function m(s) {
    s = [typeof globalThis == "object" && globalThis, s, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var G = 0; G < s.length; ++G) {
      var R = s[G];
      if (R && R.Math == Math)
        return R;
    }
    throw Error("Cannot find global object");
  }
  var X = m(this);
  function S(s, G) {
    if (G)
      t: {
        var R = X;
        s = s.split(".");
        for (var Y = 0; Y < s.length - 1; Y++) {
          var N = s[Y];
          if (!(N in R))
            break t;
          R = R[N];
        }
        s = s[s.length - 1], Y = R[s], G = G(Y), G != Y && G != null && n(R, s, { configurable: !0, writable: !0, value: G });
      }
  }
  S("Symbol", function(s) {
    function G(K) {
      if (this instanceof G)
        throw new TypeError("Symbol is not a constructor");
      return new R(Y + (K || "") + "_" + N++, K);
    }
    function R(K, E) {
      this.g = K, n(this, "description", { configurable: !0, writable: !0, value: E });
    }
    if (s)
      return s;
    R.prototype.toString = function() {
      return this.g;
    };
    var Y = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", N = 0;
    return G;
  }), S("Symbol.iterator", function(s) {
    if (s)
      return s;
    s = Symbol("Symbol.iterator");
    for (var G = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), R = 0; R < G.length; R++) {
      var Y = X[G[R]];
      typeof Y == "function" && typeof Y.prototype[s] != "function" && n(Y.prototype, s, { configurable: !0, writable: !0, value: function() {
        return C(r(this));
      } });
    }
    return s;
  });
  function C(s) {
    return s = { next: s }, s[Symbol.iterator] = function() {
      return this;
    }, s;
  }
  function T(s) {
    var G = typeof Symbol < "u" && Symbol.iterator && s[Symbol.iterator];
    return G ? G.call(s) : { next: r(s) };
  }
  function B(s) {
    if (!(s instanceof Array)) {
      s = T(s);
      for (var G, R = []; !(G = s.next()).done; )
        R.push(G.value);
      s = R;
    }
    return s;
  }
  var nt = typeof Object.create == "function" ? Object.create : function(s) {
    function G() {
    }
    return G.prototype = s, new G();
  }, ut;
  if (typeof Object.setPrototypeOf == "function")
    ut = Object.setPrototypeOf;
  else {
    var pt;
    t: {
      var Tt = { a: !0 }, Ht = {};
      try {
        Ht.__proto__ = Tt, pt = Ht.a;
        break t;
      } catch {
      }
      pt = !1;
    }
    ut = pt ? function(s, G) {
      if (s.__proto__ = G, s.__proto__ !== G)
        throw new TypeError(s + " is not extensible");
      return s;
    } : null;
  }
  var at = ut;
  function mt(s, G) {
    if (s.prototype = nt(G.prototype), s.prototype.constructor = s, at)
      at(s, G);
    else
      for (var R in G)
        if (R != "prototype")
          if (Object.defineProperties) {
            var Y = Object.getOwnPropertyDescriptor(G, R);
            Y && Object.defineProperty(s, R, Y);
          } else
            s[R] = G[R];
    s.ea = G.prototype;
  }
  function Bt() {
    this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
  }
  function kt(s) {
    if (s.l)
      throw new TypeError("Generator is already running");
    s.l = !0;
  }
  Bt.prototype.o = function(s) {
    this.h = s;
  };
  function ee(s, G) {
    s.j = { U: G, V: !0 }, s.g = s.m || s.s;
  }
  Bt.prototype.return = function(s) {
    this.j = { return: s }, this.g = this.s;
  };
  function P(s, G, R) {
    return s.g = R, { value: G };
  }
  function De(s) {
    this.g = new Bt(), this.h = s;
  }
  function je(s, G) {
    kt(s.g);
    var R = s.g.i;
    return R ? We(s, "return" in R ? R.return : function(Y) {
      return { value: Y, done: !0 };
    }, G, s.g.return) : (s.g.return(G), jt(s));
  }
  function We(s, G, R, Y) {
    try {
      var N = G.call(s.g.i, R);
      if (!(N instanceof Object))
        throw new TypeError("Iterator result " + N + " is not an object");
      if (!N.done)
        return s.g.l = !1, N;
      var K = N.value;
    } catch (E) {
      return s.g.i = null, ee(s.g, E), jt(s);
    }
    return s.g.i = null, Y.call(s.g, K), jt(s);
  }
  function jt(s) {
    for (; s.g.g; )
      try {
        var G = s.h(s.g);
        if (G)
          return s.g.l = !1, { value: G.value, done: !1 };
      } catch (R) {
        s.g.h = void 0, ee(s.g, R);
      }
    if (s.g.l = !1, s.g.j) {
      if (G = s.g.j, s.g.j = null, G.V)
        throw G.U;
      return { value: G.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function Cn(s) {
    this.next = function(G) {
      return kt(s.g), s.g.i ? G = We(s, s.g.i.next, G, s.g.o) : (s.g.o(G), G = jt(s)), G;
    }, this.throw = function(G) {
      return kt(s.g), s.g.i ? G = We(s, s.g.i.throw, G, s.g.o) : (ee(s.g, G), G = jt(s)), G;
    }, this.return = function(G) {
      return je(s, G);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ne(s) {
    function G(Y) {
      return s.next(Y);
    }
    function R(Y) {
      return s.throw(Y);
    }
    return new Promise(function(Y, N) {
      function K(E) {
        E.done ? Y(E.value) : Promise.resolve(E.value).then(G, R).then(K, N);
      }
      K(s.next());
    });
  }
  function gt(s) {
    return ne(new Cn(new De(s)));
  }
  S("Promise", function(s) {
    function G(E) {
      this.h = 0, this.i = void 0, this.g = [], this.o = !1;
      var et = this.j();
      try {
        E(et.resolve, et.reject);
      } catch ($) {
        et.reject($);
      }
    }
    function R() {
      this.g = null;
    }
    function Y(E) {
      return E instanceof G ? E : new G(function(et) {
        et(E);
      });
    }
    if (s)
      return s;
    R.prototype.h = function(E) {
      if (this.g == null) {
        this.g = [];
        var et = this;
        this.i(function() {
          et.l();
        });
      }
      this.g.push(E);
    };
    var N = X.setTimeout;
    R.prototype.i = function(E) {
      N(E, 0);
    }, R.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var E = this.g;
        this.g = [];
        for (var et = 0; et < E.length; ++et) {
          var $ = E[et];
          E[et] = null;
          try {
            $();
          } catch (yt) {
            this.j(yt);
          }
        }
      }
      this.g = null;
    }, R.prototype.j = function(E) {
      this.i(function() {
        throw E;
      });
    }, G.prototype.j = function() {
      function E(yt) {
        return function(Xt) {
          $ || ($ = !0, yt.call(et, Xt));
        };
      }
      var et = this, $ = !1;
      return { resolve: E(this.C), reject: E(this.l) };
    }, G.prototype.C = function(E) {
      if (E === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (E instanceof G)
        this.F(E);
      else {
        t:
          switch (typeof E) {
            case "object":
              var et = E != null;
              break t;
            case "function":
              et = !0;
              break t;
            default:
              et = !1;
          }
        et ? this.v(E) : this.m(E);
      }
    }, G.prototype.v = function(E) {
      var et = void 0;
      try {
        et = E.then;
      } catch ($) {
        this.l($);
        return;
      }
      typeof et == "function" ? this.G(et, E) : this.m(E);
    }, G.prototype.l = function(E) {
      this.s(2, E);
    }, G.prototype.m = function(E) {
      this.s(1, E);
    }, G.prototype.s = function(E, et) {
      if (this.h != 0)
        throw Error("Cannot settle(" + E + ", " + et + "): Promise already settled in state" + this.h);
      this.h = E, this.i = et, this.h === 2 && this.D(), this.A();
    }, G.prototype.D = function() {
      var E = this;
      N(function() {
        if (E.B()) {
          var et = X.console;
          typeof et < "u" && et.error(E.i);
        }
      }, 1);
    }, G.prototype.B = function() {
      if (this.o)
        return !1;
      var E = X.CustomEvent, et = X.Event, $ = X.dispatchEvent;
      return typeof $ > "u" ? !0 : (typeof E == "function" ? E = new E("unhandledrejection", { cancelable: !0 }) : typeof et == "function" ? E = new et("unhandledrejection", { cancelable: !0 }) : (E = X.document.createEvent("CustomEvent"), E.initCustomEvent("unhandledrejection", !1, !0, E)), E.promise = this, E.reason = this.i, $(E));
    }, G.prototype.A = function() {
      if (this.g != null) {
        for (var E = 0; E < this.g.length; ++E)
          K.h(this.g[E]);
        this.g = null;
      }
    };
    var K = new R();
    return G.prototype.F = function(E) {
      var et = this.j();
      E.J(et.resolve, et.reject);
    }, G.prototype.G = function(E, et) {
      var $ = this.j();
      try {
        E.call(et, $.resolve, $.reject);
      } catch (yt) {
        $.reject(yt);
      }
    }, G.prototype.then = function(E, et) {
      function $(xt, dt) {
        return typeof xt == "function" ? function(Wt) {
          try {
            yt(xt(Wt));
          } catch (It) {
            Xt(It);
          }
        } : dt;
      }
      var yt, Xt, Mt = new G(function(xt, dt) {
        yt = xt, Xt = dt;
      });
      return this.J($(E, yt), $(et, Xt)), Mt;
    }, G.prototype.catch = function(E) {
      return this.then(void 0, E);
    }, G.prototype.J = function(E, et) {
      function $() {
        switch (yt.h) {
          case 1:
            E(yt.i);
            break;
          case 2:
            et(yt.i);
            break;
          default:
            throw Error("Unexpected state: " + yt.h);
        }
      }
      var yt = this;
      this.g == null ? K.h($) : this.g.push($), this.o = !0;
    }, G.resolve = Y, G.reject = function(E) {
      return new G(function(et, $) {
        $(E);
      });
    }, G.race = function(E) {
      return new G(function(et, $) {
        for (var yt = T(E), Xt = yt.next(); !Xt.done; Xt = yt.next())
          Y(Xt.value).J(et, $);
      });
    }, G.all = function(E) {
      var et = T(E), $ = et.next();
      return $.done ? Y([]) : new G(function(yt, Xt) {
        function Mt(Wt) {
          return function(It) {
            xt[Wt] = It, dt--, dt == 0 && yt(xt);
          };
        }
        var xt = [], dt = 0;
        do
          xt.push(void 0), dt++, Y($.value).J(Mt(xt.length - 1), Xt), $ = et.next();
        while (!$.done);
      });
    }, G;
  });
  function $e(s, G) {
    s instanceof String && (s += "");
    var R = 0, Y = !1, N = { next: function() {
      if (!Y && R < s.length) {
        var K = R++;
        return { value: G(K, s[K]), done: !1 };
      }
      return Y = !0, { done: !0, value: void 0 };
    } };
    return N[Symbol.iterator] = function() {
      return N;
    }, N;
  }
  var An = typeof Object.assign == "function" ? Object.assign : function(s, G) {
    for (var R = 1; R < arguments.length; R++) {
      var Y = arguments[R];
      if (Y)
        for (var N in Y)
          Object.prototype.hasOwnProperty.call(Y, N) && (s[N] = Y[N]);
    }
    return s;
  };
  S("Object.assign", function(s) {
    return s || An;
  }), S("Object.is", function(s) {
    return s || function(G, R) {
      return G === R ? G !== 0 || 1 / G === 1 / R : G !== G && R !== R;
    };
  }), S("Array.prototype.includes", function(s) {
    return s || function(G, R) {
      var Y = this;
      Y instanceof String && (Y = String(Y));
      var N = Y.length;
      for (R = R || 0, 0 > R && (R = Math.max(R + N, 0)); R < N; R++) {
        var K = Y[R];
        if (K === G || Object.is(K, G))
          return !0;
      }
      return !1;
    };
  }), S("String.prototype.includes", function(s) {
    return s || function(G, R) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (G instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(G, R || 0) !== -1;
    };
  }), S("Array.prototype.keys", function(s) {
    return s || function() {
      return $e(this, function(G) {
        return G;
      });
    };
  });
  var Re = this || self;
  function Ct(s, G) {
    s = s.split(".");
    var R = Re;
    s[0] in R || typeof R.execScript > "u" || R.execScript("var " + s[0]);
    for (var Y; s.length && (Y = s.shift()); )
      s.length || G === void 0 ? R[Y] && R[Y] !== Object.prototype[Y] ? R = R[Y] : R = R[Y] = {} : R[Y] = G;
  }
  function we(s) {
    Re.setTimeout(function() {
      throw s;
    }, 0);
  }
  function sn(s) {
    we(s);
  }
  function vn(s, G) {
    sn(Error("Invalid wire type: " + s + " (at position " + G + ")"));
  }
  function Tn() {
    sn(Error("Failed to read varint, encoding is invalid."));
  }
  function Rn(s, G) {
    return G = String.fromCharCode.apply(null, G), s == null ? G : s + G;
  }
  var Nn, dn = typeof TextDecoder < "u", mn, kn = typeof TextEncoder < "u";
  function Fn(s) {
    if (kn)
      s = (mn || (mn = new TextEncoder())).encode(s);
    else {
      var G = void 0;
      G = G === void 0 ? !1 : G;
      for (var R = 0, Y = new Uint8Array(3 * s.length), N = 0; N < s.length; N++) {
        var K = s.charCodeAt(N);
        if (128 > K)
          Y[R++] = K;
        else {
          if (2048 > K)
            Y[R++] = K >> 6 | 192;
          else {
            if (55296 <= K && 57343 >= K) {
              if (56319 >= K && N < s.length) {
                var E = s.charCodeAt(++N);
                if (56320 <= E && 57343 >= E) {
                  K = 1024 * (K - 55296) + E - 56320 + 65536, Y[R++] = K >> 18 | 240, Y[R++] = K >> 12 & 63 | 128, Y[R++] = K >> 6 & 63 | 128, Y[R++] = K & 63 | 128;
                  continue;
                } else
                  N--;
              }
              if (G)
                throw Error("Found an unpaired surrogate");
              K = 65533;
            }
            Y[R++] = K >> 12 | 224, Y[R++] = K >> 6 & 63 | 128;
          }
          Y[R++] = K & 63 | 128;
        }
      }
      s = Y.subarray(0, R);
    }
    return s;
  }
  var ze = {}, Me = null;
  function xn(s) {
    var G;
    G === void 0 && (G = 0), Se(), G = ze[G];
    for (var R = Array(Math.floor(s.length / 3)), Y = G[64] || "", N = 0, K = 0; N < s.length - 2; N += 3) {
      var E = s[N], et = s[N + 1], $ = s[N + 2], yt = G[E >> 2];
      E = G[(E & 3) << 4 | et >> 4], et = G[(et & 15) << 2 | $ >> 6], $ = G[$ & 63], R[K++] = yt + E + et + $;
    }
    switch (yt = 0, $ = Y, s.length - N) {
      case 2:
        yt = s[N + 1], $ = G[(yt & 15) << 2] || Y;
      case 1:
        s = s[N], R[K] = G[s >> 2] + G[(s & 3) << 4 | yt >> 4] + $ + Y;
    }
    return R.join("");
  }
  function Gn(s) {
    var G = s.length, R = 3 * G / 4;
    R % 3 ? R = Math.floor(R) : "=.".indexOf(s[G - 1]) != -1 && (R = "=.".indexOf(s[G - 2]) != -1 ? R - 2 : R - 1);
    var Y = new Uint8Array(R), N = 0;
    return he(s, function(K) {
      Y[N++] = K;
    }), Y.subarray(0, N);
  }
  function he(s, G) {
    function R($) {
      for (; Y < s.length; ) {
        var yt = s.charAt(Y++), Xt = Me[yt];
        if (Xt != null)
          return Xt;
        if (!/^[\s\xa0]*$/.test(yt))
          throw Error("Unknown base64 encoding at char: " + yt);
      }
      return $;
    }
    Se();
    for (var Y = 0; ; ) {
      var N = R(-1), K = R(0), E = R(64), et = R(64);
      if (et === 64 && N === -1)
        break;
      G(N << 2 | K >> 4), E != 64 && (G(K << 4 & 240 | E >> 2), et != 64 && G(E << 6 & 192 | et));
    }
  }
  function Se() {
    if (!Me) {
      Me = {};
      for (var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), G = ["+/=", "+/", "-_=", "-_.", "-_"], R = 0; 5 > R; R++) {
        var Y = s.concat(G[R].split(""));
        ze[R] = Y;
        for (var N = 0; N < Y.length; N++) {
          var K = Y[N];
          Me[K] === void 0 && (Me[K] = N);
        }
      }
    }
  }
  var Oe = typeof Uint8Array == "function", re;
  function Ve(s) {
    if (this.g = s, s !== null && s.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  Ve.prototype.toJSON = function() {
    if (this.g == null)
      var s = "";
    else
      s = this.g, s = this.g = s == null || typeof s == "string" ? s : Oe && s instanceof Uint8Array ? xn(s) : null;
    return s;
  };
  var ln = typeof Uint8Array.prototype.slice == "function";
  function Ee(s, G, R) {
    return G === R ? re || (re = new Uint8Array(0)) : ln ? s.slice(G, R) : new Uint8Array(s.subarray(G, R));
  }
  var Qt = 0, Ze = 0;
  function Le(s) {
    if (s.constructor === Uint8Array)
      return s;
    if (s.constructor === ArrayBuffer)
      return new Uint8Array(s);
    if (s.constructor === Array)
      return new Uint8Array(s);
    if (s.constructor === String)
      return Gn(s);
    if (s.constructor === Ve) {
      if (s.g == null)
        var G = re || (re = new Uint8Array(0));
      else {
        G = Uint8Array;
        var R = s.g;
        R = R == null || Oe && R != null && R instanceof Uint8Array ? R : typeof R == "string" ? Gn(R) : null, s = s.g = R, G = new G(s);
      }
      return G;
    }
    if (s instanceof Uint8Array)
      return new Uint8Array(s.buffer, s.byteOffset, s.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function At(s, G) {
    G = G === void 0 ? {} : G, G = G.u === void 0 ? !1 : G.u, this.h = null, this.g = this.i = this.l = 0, this.j = !1, this.u = G, s && xe(this, s);
  }
  function xe(s, G) {
    s.h = Le(G), s.l = 0, s.i = s.h.length, s.g = s.l;
  }
  At.prototype.reset = function() {
    this.g = this.l;
  };
  function zt(s) {
    s.g > s.i && (s.j = !0, sn(Error("Tried to read past the end of the data " + s.g + " > " + s.i)));
  }
  function be(s) {
    var G = s.h, R = G[s.g], Y = R & 127;
    return 128 > R ? (s.g += 1, zt(s), Y) : (R = G[s.g + 1], Y |= (R & 127) << 7, 128 > R ? (s.g += 2, zt(s), Y) : (R = G[s.g + 2], Y |= (R & 127) << 14, 128 > R ? (s.g += 3, zt(s), Y) : (R = G[s.g + 3], Y |= (R & 127) << 21, 128 > R ? (s.g += 4, zt(s), Y) : (R = G[s.g + 4], Y |= (R & 15) << 28, 128 > R ? (s.g += 5, zt(s), Y >>> 0) : (s.g += 5, 128 <= G[s.g++] && 128 <= G[s.g++] && 128 <= G[s.g++] && 128 <= G[s.g++] && 128 <= G[s.g++] ? (s.j = !0, Tn(), Y) : (zt(s), Y))))));
  }
  var Ye = [];
  function qe() {
    this.g = new Uint8Array(64), this.h = 0;
  }
  function Xe(s, G) {
    if (!(s.h + 1 < s.g.length)) {
      var R = s.g;
      s.g = new Uint8Array(Math.ceil(1 + 2 * s.g.length)), s.g.set(R);
    }
    s.g[s.h++] = G;
  }
  qe.prototype.length = function() {
    return this.h;
  }, qe.prototype.end = function() {
    var s = this.g, G = this.h;
    return this.h = 0, Ee(s, 0, G);
  };
  function Ot(s, G) {
    for (; 127 < G; )
      Xe(s, G & 127 | 128), G >>>= 7;
    Xe(s, G);
  }
  function Ae(s) {
    var G = {}, R = G.N === void 0 ? !1 : G.N;
    this.m = { u: G.u === void 0 ? !1 : G.u }, this.N = R, G = this.m, Ye.length ? (R = Ye.pop(), G && (R.u = G.u), s && xe(R, s), s = R) : s = new At(s, G), this.g = s, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
  }
  Ae.prototype.reset = function() {
    this.g.reset(), this.h = this.i = -1;
  };
  function Pe(s) {
    var G = s.g;
    if ((G = G.g == G.i) || (G = s.j) || (G = s.g, G = G.j || 0 > G.g || G.g > G.i), G)
      return !1;
    s.l = s.g.g;
    var R = be(s.g);
    return G = R >>> 3, R &= 7, 0 <= R && 5 >= R ? (s.i = G, s.h = R, !0) : (s.j = !0, vn(R, s.l), !1);
  }
  function Ie(s) {
    switch (s.h) {
      case 0:
        if (s.h != 0)
          Ie(s);
        else
          t: {
            s = s.g;
            for (var G = s.g, R = 0; 10 > R; R++) {
              if ((s.h[G] & 128) === 0) {
                s.g = G + 1, zt(s);
                break t;
              }
              G++;
            }
            s.j = !0, Tn();
          }
        break;
      case 1:
        s = s.g, s.g += 8, zt(s);
        break;
      case 2:
        s.h != 2 ? Ie(s) : (G = be(s.g), s = s.g, s.g += G, zt(s));
        break;
      case 5:
        s = s.g, s.g += 4, zt(s);
        break;
      case 3:
        G = s.i;
        do {
          if (!Pe(s)) {
            s.j = !0, sn(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (s.h == 4) {
            s.i != G && (s.j = !0, sn(Error("Unmatched end-group tag")));
            break;
          }
          Ie(s);
        } while (1);
        break;
      default:
        s.j = !0, vn(s.h, s.l);
    }
  }
  function Xn(s, G, R) {
    s.N || (s = Ee(s.g.h, R, s.g.g), (R = G.m) ? R.push(s) : G.m = [s]);
  }
  var cn = [];
  function _e() {
    this.h = [], this.i = 0, this.g = new qe();
  }
  function un(s, G) {
    G.length !== 0 && (s.h.push(G), s.i += G.length);
  }
  function ve(s, G, R) {
    Ot(s.g, 8 * G + 2), Ot(s.g, R.length), un(s, s.g.end()), un(s, R);
  }
  var Te = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
  function Ge(s, G) {
    Object.isFrozen(s) || (Te ? s[Te] |= G : s.g !== void 0 ? s.g |= G : Object.defineProperties(s, { g: { value: G, configurable: !0, writable: !0, enumerable: !1 } }));
  }
  function ie(s) {
    if (!s)
      return 0;
    var G;
    return Te ? G = s[Te] : G = s.g, G == null ? 0 : G;
  }
  function Qe(s) {
    return Array.isArray(s) && Ge(s, 1), s;
  }
  function qt(s) {
    if (!Array.isArray(s))
      throw Error("cannot mark non-array as immutable");
    Ge(s, 2);
  }
  function Pt(s) {
    return s !== null && typeof s == "object" && s.constructor === Object;
  }
  function hn(s) {
    switch (typeof s) {
      case "number":
        return isFinite(s) ? s : String(s);
      case "object":
        return Oe && s != null && s instanceof Uint8Array ? xn(s) : s;
      default:
        return s;
    }
  }
  function fe(s, G) {
    if (s != null)
      return Array.isArray(s) || Pt(s) ? Lt(s, G) : G(s);
  }
  function Lt(s, G) {
    if (Array.isArray(s)) {
      for (var R = Array(s.length), Y = 0; Y < s.length; Y++)
        R[Y] = fe(s[Y], G);
      return ie(s) & 1 && Qe(R), R;
    }
    R = {};
    for (Y in s)
      R[Y] = fe(s[Y], G);
    return R;
  }
  var Vt;
  function oe(s, G, R) {
    var Y = Vt;
    Vt = null, s || (s = Y), Y = this.constructor.ca, s || (s = Y ? [Y] : []), this.j = (Y ? 0 : -1) - (this.constructor.aa || 0), this.i = null, this.g = s;
    t: {
      if (Y = this.g.length, s = Y - 1, Y && (Y = this.g[s], Pt(Y))) {
        this.l = s - this.j, this.h = Y;
        break t;
      }
      G !== void 0 && -1 < G ? (this.l = Math.max(G, s + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
    }
    if (R)
      for (G = 0; G < R.length; G++)
        s = R[G], s < this.l ? (s += this.j, (Y = this.g[s]) ? Qe(Y) : this.g[s] = Fe) : (te(this), (Y = this.h[s]) ? Qe(Y) : this.h[s] = Fe);
  }
  var Fe = Object.freeze(Qe([]));
  function te(s) {
    var G = s.l + s.j;
    s.g[G] || (s.h = s.g[G] = {});
  }
  function se(s, G, R) {
    return G === -1 ? null : (R === void 0 ? 0 : R) || G >= s.l ? s.h ? s.h[G] : void 0 : s.g[G + s.j];
  }
  function tt(s, G, R) {
    R = R === void 0 ? !0 : R;
    var Y = Y === void 0 ? !1 : Y, N = se(s, G, Y);
    return N == null && (N = Fe), N === Fe ? (N = Qe([]), ct(s, G, N, Y)) : R && Array.isArray(N) && ie(N) & 2 && (N = N.slice(), ct(s, G, N, Y)), N;
  }
  function it(s, G, R) {
    return s = se(s, G), s = s == null ? s : +s, s == null ? R === void 0 ? 0 : R : s;
  }
  function ct(s, G, R, Y) {
    (Y === void 0 ? 0 : Y) || G >= s.l ? (te(s), s.h[G] = R) : s.g[G + s.j] = R;
  }
  function _t(s, G, R) {
    s.i || (s.i = {});
    var Y = s.i[R];
    if (!Y) {
      var N = tt(s, R, !1);
      Y = [];
      for (var K = Array.isArray(N) ? !!(ie(N) & 2) : !1, E = 0; E < N.length; E++)
        Y[E] = new G(N[E]), K && qt(Y[E].g);
      K && (qt(Y), Object.freeze(Y)), s.i[R] = Y;
    }
    return Y;
  }
  function de(s, G, R, Y, N) {
    var K = _t(s, Y, G);
    R = R || new Y(), s = tt(s, G), N != null ? (K.splice(N, 0, R), s.splice(N, 0, ue(R))) : (K.push(R), s.push(ue(R)));
  }
  oe.prototype.toJSON = function() {
    var s = ue(this);
    return Lt(s, hn);
  };
  function ue(s) {
    if (s.i)
      for (var G in s.i) {
        var R = s.i[G];
        if (Array.isArray(R))
          for (var Y = 0; Y < R.length; Y++)
            R[Y] && ue(R[Y]);
        else
          R && ue(R);
      }
    return s.g;
  }
  oe.prototype.toString = function() {
    return ue(this).toString();
  };
  function St(s, G) {
    return s = se(s, G), s == null ? 0 : s;
  }
  function me(s, G) {
    return s = se(s, G), s == null ? "" : s;
  }
  function Ce(s, G) {
    if (s = s.m) {
      un(G, G.g.end());
      for (var R = 0; R < s.length; R++)
        un(G, s[R]);
    }
  }
  function tn(s) {
    var G = s[0];
    switch (s.length) {
      case 2:
        var R = s[1];
        return function($, yt, Xt) {
          return G($, yt, Xt, R);
        };
      case 3:
        var Y = s[1], N = s[2];
        return function($, yt, Xt) {
          return G($, yt, Xt, Y, N);
        };
      case 4:
        var K = s[1], E = s[2], et = s[3];
        return function($, yt, Xt) {
          return G($, yt, Xt, K, E, et);
        };
      default:
        throw Error("unsupported number of parameters, expected [2-4], got " + s.length);
    }
  }
  function en(s, G, R) {
    for (; Pe(G) && G.h != 4; ) {
      var Y = G.i, N = R[Y];
      if (N) {
        if (Array.isArray(N) && (N = R[Y] = tn(N)), !N(G, s, Y)) {
          Y = G, N = s;
          var K = Y.l;
          Ie(Y), Xn(Y, N, K);
        }
      } else
        Y = G, N = s, K = Y.l, Ie(Y), Xn(Y, N, K);
    }
    return s;
  }
  function fn(s, G) {
    var R = new _e();
    if (G(s, R), s = R.i + R.g.length(), s === 0)
      R = new Uint8Array(0);
    else {
      s = new Uint8Array(s);
      for (var Y = R.h, N = Y.length, K = G = 0; K < N; K++) {
        var E = Y[K];
        E.length !== 0 && (s.set(E, G), G += E.length);
      }
      Y = R.g, N = Y.h, N !== 0 && (s.set(Y.g.subarray(0, N), G), Y.h = 0), R.h = [s], R = s;
    }
    return R;
  }
  function pn(s, G, R) {
    if (cn.length) {
      var Y = cn.pop();
      s && (xe(Y.g, s), Y.i = -1, Y.h = -1), s = Y;
    } else
      s = new Ae(s);
    try {
      return R(new G(), s);
    } finally {
      G = s.g, G.h = null, G.l = 0, G.i = 0, G.g = 0, G.j = !1, G.u = !1, s.i = -1, s.h = -1, s.j = !1, 100 > cn.length && cn.push(s);
    }
  }
  function He(s, G, R) {
    if (G = se(G, R), G != null) {
      Ot(s.g, 8 * R + 5), s = s.g;
      var Y = G;
      Y = (R = 0 > Y ? 1 : 0) ? -Y : Y, Y === 0 ? 0 < 1 / Y ? Qt = Ze = 0 : (Ze = 0, Qt = 2147483648) : isNaN(Y) ? (Ze = 0, Qt = 2147483647) : 34028234663852886e22 < Y ? (Ze = 0, Qt = (R << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > Y ? (Y = Math.round(Y / Math.pow(2, -149)), Ze = 0, Qt = (R << 31 | Y) >>> 0) : (G = Math.floor(Math.log(Y) / Math.LN2), Y *= Math.pow(2, -G), Y = Math.round(8388608 * Y), 16777216 <= Y && ++G, Ze = 0, Qt = (R << 31 | G + 127 << 23 | Y & 8388607) >>> 0), R = Qt, Xe(s, R >>> 0 & 255), Xe(s, R >>> 8 & 255), Xe(s, R >>> 16 & 255), Xe(s, R >>> 24 & 255);
    }
  }
  function nn(s, G, R) {
    if (s.h !== 5)
      return !1;
    s = s.g;
    var Y = s.h[s.g], N = s.h[s.g + 1], K = s.h[s.g + 2], E = s.h[s.g + 3];
    return s.g += 4, zt(s), N = (Y << 0 | N << 8 | K << 16 | E << 24) >>> 0, s = 2 * (N >> 31) + 1, Y = N >>> 23 & 255, N &= 8388607, ct(G, R, Y == 255 ? N ? NaN : 1 / 0 * s : Y == 0 ? s * Math.pow(2, -149) * N : s * Math.pow(2, Y - 150) * (N + Math.pow(2, 23))), !0;
  }
  function Kn(s, G, R) {
    if (s.h !== 0)
      return !1;
    for (var Y = s.g, N = 128, K = 0, E = s = 0; 4 > E && 128 <= N; E++)
      N = Y.h[Y.g++], K |= (N & 127) << 7 * E;
    if (128 <= N && (N = Y.h[Y.g++], K |= (N & 127) << 28, s |= (N & 127) >> 4), 128 <= N)
      for (E = 0; 5 > E && 128 <= N; E++)
        N = Y.h[Y.g++], s |= (N & 127) << 7 * E + 3;
    return 128 > N ? (Y = K >>> 0, N = s >>> 0, (s = N & 2147483648) && (Y = ~Y + 1 >>> 0, N = ~N >>> 0, Y == 0 && (N = N + 1 >>> 0)), Y = 4294967296 * N + (Y >>> 0), s = s ? -Y : Y) : (Y.j = !0, Tn(), s = void 0), ct(G, R, s), !0;
  }
  function rn(s, G, R) {
    return s.h !== 0 ? !1 : (ct(G, R, be(s.g)), !0);
  }
  function Ne(s, G, R) {
    if (s.h !== 2)
      return !1;
    var Y = be(s.g);
    s = s.g;
    var N = s.g;
    s.g += Y, zt(s), s = s.h;
    var K;
    if (dn)
      (K = Nn) || (K = Nn = new TextDecoder("utf-8", { fatal: !1 })), K = K.decode(s.subarray(N, N + Y));
    else {
      Y = N + Y;
      for (var E = [], et = null, $, yt, Xt; N < Y; )
        $ = s[N++], 128 > $ ? E.push($) : 224 > $ ? N >= Y ? E.push(65533) : (yt = s[N++], 194 > $ || (yt & 192) !== 128 ? (N--, E.push(65533)) : E.push(($ & 31) << 6 | yt & 63)) : 240 > $ ? N >= Y - 1 ? E.push(65533) : (yt = s[N++], (yt & 192) !== 128 || $ === 224 && 160 > yt || $ === 237 && 160 <= yt || ((K = s[N++]) & 192) !== 128 ? (N--, E.push(65533)) : E.push(($ & 15) << 12 | (yt & 63) << 6 | K & 63)) : 244 >= $ ? N >= Y - 2 ? E.push(65533) : (yt = s[N++], (yt & 192) !== 128 || ($ << 28) + (yt - 144) >> 30 !== 0 || ((K = s[N++]) & 192) !== 128 || ((Xt = s[N++]) & 192) !== 128 ? (N--, E.push(65533)) : ($ = ($ & 7) << 18 | (yt & 63) << 12 | (K & 63) << 6 | Xt & 63, $ -= 65536, E.push(($ >> 10 & 1023) + 55296, ($ & 1023) + 56320))) : E.push(65533), 8192 <= E.length && (et = Rn(et, E), E.length = 0);
      K = Rn(et, E);
    }
    return ct(G, R, K), !0;
  }
  function yn(s, G, R, Y, N) {
    if (s.h !== 2)
      return !1;
    var K = new Y(), E = s.g.i, et = be(s.g), $ = s.g.g + et;
    if (s.g.i = $, N(K, s), N = $ - s.g.g, N !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (et + " bytes, instead read " + (et - N) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    return s.g.g = $, s.g.i = E, de(G, R, K, Y, void 0), !0;
  }
  function In(s) {
    oe.call(this, s);
  }
  var Be;
  mt(In, oe);
  function Un(s, G) {
    var R = se(s, 1);
    if (R != null && R != null) {
      Ot(G.g, 8);
      var Y = G.g;
      if (0 <= R)
        Ot(Y, R);
      else {
        for (var N = 0; 9 > N; N++)
          Xe(Y, R & 127 | 128), R >>= 7;
        Xe(Y, 1);
      }
    }
    He(G, s, 2), Y = se(s, 3), Y != null && ve(G, 3, Fn(Y)), Y = se(s, 4), Y != null && ve(G, 4, Fn(Y)), Ce(s, G);
  }
  function on(s, G) {
    return en(s, G, Be || (Be = { 1: rn, 2: nn, 3: Ne, 4: Ne }));
  }
  function gn(s) {
    oe.call(this, s, -1, an);
  }
  var Sn;
  mt(gn, oe), gn.prototype.addClassification = function(s, G) {
    return de(this, 1, s, In, G), this;
  };
  function En(s, G) {
    return en(s, G, Sn || (Sn = { 1: [yn, In, on] }));
  }
  var an = [1];
  function wn(s) {
    oe.call(this, s);
  }
  var Pn;
  mt(wn, oe);
  function _n(s, G) {
    He(G, s, 1), He(G, s, 2), He(G, s, 3), He(G, s, 4), He(G, s, 5), Ce(s, G);
  }
  function Yn(s, G) {
    return en(s, G, Pn || (Pn = { 1: nn, 2: nn, 3: nn, 4: nn, 5: nn }));
  }
  function Hn(s) {
    oe.call(this, s, -1, V);
  }
  var p;
  mt(Hn, oe);
  function W(s, G) {
    return en(s, G, p || (p = { 1: [yn, wn, Yn] }));
  }
  var V = [1];
  function k(s) {
    oe.call(this, s);
  }
  var O;
  mt(k, oe);
  function ot(s, G) {
    He(G, s, 1), He(G, s, 2), He(G, s, 3), He(G, s, 4), He(G, s, 5);
    var R = se(s, 6);
    if (R != null && R != null) {
      Ot(G.g, 48);
      var Y = G.g, N = R;
      R = 0 > N, N = Math.abs(N);
      var K = N >>> 0;
      for (N = Math.floor((N - K) / 4294967296), N >>>= 0, R && (N = ~N >>> 0, K = (~K >>> 0) + 1, 4294967295 < K && (K = 0, N++, 4294967295 < N && (N = 0))), Qt = K, Ze = N, R = Qt, K = Ze; 0 < K || 127 < R; )
        Xe(Y, R & 127 | 128), R = (R >>> 7 | K << 25) >>> 0, K >>>= 7;
      Xe(Y, R);
    }
    Ce(s, G);
  }
  function z(s, G) {
    return en(s, G, O || (O = { 1: nn, 2: nn, 3: nn, 4: nn, 5: nn, 6: Kn }));
  }
  function rt(s, G, R) {
    if (R = s.createShader(R === 0 ? s.VERTEX_SHADER : s.FRAGMENT_SHADER), s.shaderSource(R, G), s.compileShader(R), !s.getShaderParameter(R, s.COMPILE_STATUS))
      throw Error(`Could not compile WebGL shader.

` + s.getShaderInfoLog(R));
    return R;
  }
  function bt(s) {
    return _t(s, In, 1).map(function(G) {
      return { index: St(G, 1), X: it(G, 2), label: se(G, 3) != null ? me(G, 3) : void 0, displayName: se(G, 4) != null ? me(G, 4) : void 0 };
    });
  }
  function Rt(s) {
    return { x: it(s, 1), y: it(s, 2), z: it(s, 3), visibility: se(s, 4) != null ? it(s, 4) : void 0 };
  }
  function Et(s) {
    return _t(pn(s, Hn, W), wn, 1).map(Rt);
  }
  function Nt(s, G) {
    this.h = s, this.g = G, this.l = 0;
  }
  function $t(s, G, R) {
    return Jt(s, G), typeof s.g.canvas.transferToImageBitmap == "function" ? Promise.resolve(s.g.canvas.transferToImageBitmap()) : R ? Promise.resolve(s.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(s.g.canvas) : (s.i === void 0 && (s.i = document.createElement("canvas")), new Promise(function(Y) {
      s.i.height = s.g.canvas.height, s.i.width = s.g.canvas.width, s.i.getContext("2d", {}).drawImage(s.g.canvas, 0, 0, s.g.canvas.width, s.g.canvas.height), Y(s.i);
    }));
  }
  function Jt(s, G) {
    var R = s.g;
    if (s.m === void 0) {
      var Y = rt(R, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), N = rt(R, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), K = R.createProgram();
      if (R.attachShader(K, Y), R.attachShader(K, N), R.linkProgram(K), !R.getProgramParameter(K, R.LINK_STATUS))
        throw Error(`Could not compile WebGL program.

` + R.getProgramInfoLog(K));
      Y = s.m = K, R.useProgram(Y), N = R.getUniformLocation(Y, "sampler0"), s.j = { I: R.getAttribLocation(Y, "aVertex"), H: R.getAttribLocation(Y, "aTex"), da: N }, s.s = R.createBuffer(), R.bindBuffer(R.ARRAY_BUFFER, s.s), R.enableVertexAttribArray(s.j.I), R.vertexAttribPointer(s.j.I, 2, R.FLOAT, !1, 0, 0), R.bufferData(R.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), R.STATIC_DRAW), R.bindBuffer(R.ARRAY_BUFFER, null), s.o = R.createBuffer(), R.bindBuffer(R.ARRAY_BUFFER, s.o), R.enableVertexAttribArray(s.j.H), R.vertexAttribPointer(
        s.j.H,
        2,
        R.FLOAT,
        !1,
        0,
        0
      ), R.bufferData(R.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), R.STATIC_DRAW), R.bindBuffer(R.ARRAY_BUFFER, null), R.uniform1i(N, 0);
    }
    Y = s.j, R.useProgram(s.m), R.canvas.width = G.width, R.canvas.height = G.height, R.viewport(0, 0, G.width, G.height), R.activeTexture(R.TEXTURE0), s.h.bindTexture2d(G.glName), R.enableVertexAttribArray(Y.I), R.bindBuffer(R.ARRAY_BUFFER, s.s), R.vertexAttribPointer(Y.I, 2, R.FLOAT, !1, 0, 0), R.enableVertexAttribArray(Y.H), R.bindBuffer(R.ARRAY_BUFFER, s.o), R.vertexAttribPointer(
      Y.H,
      2,
      R.FLOAT,
      !1,
      0,
      0
    ), R.bindFramebuffer(R.DRAW_FRAMEBUFFER ? R.DRAW_FRAMEBUFFER : R.FRAMEBUFFER, null), R.clearColor(0, 0, 0, 0), R.clear(R.COLOR_BUFFER_BIT), R.colorMask(!0, !0, !0, !0), R.drawArrays(R.TRIANGLE_FAN, 0, 4), R.disableVertexAttribArray(Y.I), R.disableVertexAttribArray(Y.H), R.bindBuffer(R.ARRAY_BUFFER, null), s.h.bindTexture2d(0);
  }
  function wt(s) {
    this.g = s;
  }
  var Ut = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Dt(s, G) {
    return G + s;
  }
  function ae(s, G) {
    window[s] = G;
  }
  function pe(s) {
    var G = document.createElement("script");
    return G.setAttribute("src", s), G.setAttribute("crossorigin", "anonymous"), new Promise(function(R) {
      G.addEventListener("load", function() {
        R();
      }, !1), G.addEventListener("error", function() {
        R();
      }, !1), document.body.appendChild(G);
    });
  }
  function ye() {
    return gt(function(s) {
      switch (s.g) {
        case 1:
          return s.m = 2, P(s, WebAssembly.instantiate(Ut), 4);
        case 4:
          s.g = 3, s.m = 0;
          break;
        case 2:
          return s.m = 0, s.j = null, s.return(!1);
        case 3:
          return s.return(!0);
      }
    });
  }
  function Je(s) {
    if (this.g = s, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = Promise.resolve(), this.P = "", this.B = {}, this.locateFile = s && s.locateFile || Dt, typeof window == "object")
      var G = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location < "u")
      G = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    if (this.S = G, s.options) {
      G = T(Object.keys(s.options));
      for (var R = G.next(); !R.done; R = G.next()) {
        R = R.value;
        var Y = s.options[R].default;
        Y !== void 0 && (this.j[R] = typeof Y == "function" ? Y() : Y);
      }
    }
  }
  i = Je.prototype, i.close = function() {
    return this.i && this.i.delete(), Promise.resolve();
  };
  function h(s) {
    var G, R, Y, N, K, E, et, $, yt, Xt, Mt;
    return gt(function(xt) {
      switch (xt.g) {
        case 1:
          return s.R ? (G = s.g.files === void 0 ? [] : typeof s.g.files == "function" ? s.g.files(s.j) : s.g.files, P(xt, ye(), 2)) : xt.return();
        case 2:
          if (R = xt.h, typeof window == "object")
            return ae("createMediapipeSolutionsWasm", { locateFile: s.locateFile }), ae("createMediapipeSolutionsPackedAssets", { locateFile: s.locateFile }), E = G.filter(function(dt) {
              return dt.data !== void 0;
            }), et = G.filter(function(dt) {
              return dt.data === void 0;
            }), $ = Promise.all(E.map(function(dt) {
              var Wt = L(s, dt.url);
              if (dt.path !== void 0) {
                var It = dt.path;
                Wt = Wt.then(function(Yt) {
                  return s.overrideFile(It, Yt), Promise.resolve(Yt);
                });
              }
              return Wt;
            })), yt = Promise.all(et.map(function(dt) {
              return dt.simd === void 0 || dt.simd && R || !dt.simd && !R ? pe(s.locateFile(dt.url, s.S)) : Promise.resolve();
            })).then(function() {
              var dt, Wt, It;
              return gt(function(Yt) {
                if (Yt.g == 1)
                  return dt = window.createMediapipeSolutionsWasm, Wt = window.createMediapipeSolutionsPackedAssets, It = s, P(Yt, dt(Wt), 2);
                It.h = Yt.h, Yt.g = 0;
              });
            }), Xt = function() {
              return gt(function(dt) {
                return s.g.graph && s.g.graph.url ? dt = P(
                  dt,
                  L(s, s.g.graph.url),
                  0
                ) : (dt.g = 0, dt = void 0), dt;
              });
            }(), P(xt, Promise.all([yt, $, Xt]), 7);
          if (typeof importScripts != "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          return Y = G.filter(function(dt) {
            return dt.simd === void 0 || dt.simd && R || !dt.simd && !R;
          }).map(function(dt) {
            return s.locateFile(dt.url, s.S);
          }), importScripts.apply(null, B(Y)), N = s, P(xt, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          N.h = xt.h, s.l = new OffscreenCanvas(1, 1), s.h.canvas = s.l, K = s.h.GL.createContext(s.l, {
            antialias: !1,
            alpha: !1,
            ba: typeof WebGL2RenderingContext < "u" ? 2 : 1
          }), s.h.GL.makeContextCurrent(K), xt.g = 4;
          break;
        case 7:
          if (s.l = document.createElement("canvas"), Mt = s.l.getContext("webgl2", {}), !Mt && (Mt = s.l.getContext("webgl", {}), !Mt))
            return alert("Failed to create WebGL canvas context when passing video frame."), xt.return();
          s.D = Mt, s.h.canvas = s.l, s.h.createContext(s.l, !0, !0, {});
        case 4:
          s.i = new s.h.SolutionWasm(), s.R = !1, xt.g = 0;
      }
    });
  }
  function y(s) {
    var G, R, Y, N, K, E, et, $;
    return gt(function(yt) {
      if (yt.g == 1) {
        if (s.g.graph && s.g.graph.url && s.P === s.g.graph.url)
          return yt.return();
        if (s.o = !0, !s.g.graph || !s.g.graph.url) {
          yt.g = 2;
          return;
        }
        return s.P = s.g.graph.url, P(yt, L(s, s.g.graph.url), 3);
      }
      for (yt.g != 2 && (G = yt.h, s.i.loadGraph(G)), R = T(Object.keys(s.B)), Y = R.next(); !Y.done; Y = R.next())
        N = Y.value, s.i.overrideFile(N, s.B[N]);
      if (s.B = {}, s.g.listeners)
        for (K = T(s.g.listeners), E = K.next(); !E.done; E = K.next())
          et = E.value, A(s, et);
      $ = s.j, s.j = {}, s.setOptions($), yt.g = 0;
    });
  }
  i.reset = function() {
    var s = this;
    return gt(function(G) {
      s.i && (s.i.reset(), s.m = {}, s.s = {}), G.g = 0;
    });
  }, i.setOptions = function(s, G) {
    var R = this;
    if (G = G || this.g.options) {
      for (var Y = [], N = [], K = {}, E = T(Object.keys(s)), et = E.next(); !et.done; K = { K: K.K, L: K.L }, et = E.next()) {
        var $ = et.value;
        $ in this.j && this.j[$] === s[$] || (this.j[$] = s[$], et = G[$], et !== void 0 && (et.onChange && (K.K = et.onChange, K.L = s[$], Y.push(function(yt) {
          return function() {
            var Xt;
            return gt(function(Mt) {
              if (Mt.g == 1)
                return P(Mt, yt.K(yt.L), 2);
              Xt = Mt.h, Xt === !0 && (R.o = !0), Mt.g = 0;
            });
          };
        }(K))), et.graphOptionXref && ($ = { valueNumber: et.type === 1 ? s[$] : 0, valueBoolean: et.type === 0 ? s[$] : !1, valueString: et.type === 2 ? s[$] : "" }, et = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), et.graphOptionXref), $), N.push(et))));
      }
      (Y.length !== 0 || N.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(N), this.v = (this.v === void 0 ? [] : this.v).concat(Y));
    }
  };
  function v(s) {
    var G, R, Y, N, K, E, et;
    return gt(function($) {
      switch ($.g) {
        case 1:
          if (!s.o)
            return $.return();
          if (!s.v) {
            $.g = 2;
            break;
          }
          G = T(s.v), R = G.next();
        case 3:
          if (R.done) {
            $.g = 5;
            break;
          }
          return Y = R.value, P($, Y(), 4);
        case 4:
          R = G.next(), $.g = 3;
          break;
        case 5:
          s.v = void 0;
        case 2:
          if (s.A) {
            for (N = new s.h.GraphOptionChangeRequestList(), K = T(s.A), E = K.next(); !E.done; E = K.next())
              et = E.value, N.push_back(et);
            s.i.changeOptions(N), N.delete(), s.A = void 0;
          }
          s.o = !1, $.g = 0;
      }
    });
  }
  i.initialize = function() {
    var s = this;
    return gt(function(G) {
      return G.g == 1 ? P(G, h(s), 2) : G.g != 3 ? P(G, y(s), 3) : P(G, v(s), 0);
    });
  };
  function L(s, G) {
    var R, Y;
    return gt(function(N) {
      return G in s.F ? N.return(s.F[G]) : (R = s.locateFile(G, ""), Y = fetch(R).then(function(K) {
        return K.arrayBuffer();
      }), s.F[G] = Y, N.return(Y));
    });
  }
  i.overrideFile = function(s, G) {
    this.i ? this.i.overrideFile(s, G) : this.B[s] = G;
  }, i.clearOverriddenFiles = function() {
    this.B = {}, this.i && this.i.clearOverriddenFiles();
  }, i.send = function(s, G) {
    var R = this, Y, N, K, E, et, $, yt, Xt, Mt;
    return gt(function(xt) {
      switch (xt.g) {
        case 1:
          return R.g.inputs ? (Y = 1e3 * (G == null ? performance.now() : G), P(xt, R.C, 2)) : xt.return();
        case 2:
          return P(xt, R.initialize(), 3);
        case 3:
          for (N = new R.h.PacketDataList(), K = T(Object.keys(s)), E = K.next(); !E.done; E = K.next())
            if (et = E.value, $ = R.g.inputs[et]) {
              t: {
                var dt = s[et];
                switch ($.type) {
                  case "video":
                    var Wt = R.m[$.stream];
                    if (Wt || (Wt = new Nt(R.h, R.D), R.m[$.stream] = Wt), Wt.l === 0 && (Wt.l = Wt.h.createTexture()), typeof HTMLVideoElement < "u" && dt instanceof HTMLVideoElement)
                      var It = dt.videoWidth, Yt = dt.videoHeight;
                    else
                      typeof HTMLImageElement < "u" && dt instanceof HTMLImageElement ? (It = dt.naturalWidth, Yt = dt.naturalHeight) : (It = dt.width, Yt = dt.height);
                    Yt = { glName: Wt.l, width: It, height: Yt }, It = Wt.g, It.canvas.width = Yt.width, It.canvas.height = Yt.height, It.activeTexture(It.TEXTURE0), Wt.h.bindTexture2d(Wt.l), It.texImage2D(It.TEXTURE_2D, 0, It.RGBA, It.RGBA, It.UNSIGNED_BYTE, dt), Wt.h.bindTexture2d(0), Wt = Yt;
                    break t;
                  case "detections":
                    for (Wt = R.m[$.stream], Wt || (Wt = new wt(R.h), R.m[$.stream] = Wt), Wt.data || (Wt.data = new Wt.g.DetectionListData()), Wt.data.reset(dt.length), Yt = 0; Yt < dt.length; ++Yt) {
                      It = dt[Yt];
                      var Ft = Wt.data, l = Ft.setBoundingBox, Z = Yt, x = It.T, w = new k();
                      if (ct(w, 1, x.Y), ct(w, 2, x.Z), ct(w, 3, x.height), ct(w, 4, x.width), ct(w, 5, x.rotation), ct(w, 6, x.W), x = fn(w, ot), l.call(Ft, Z, x), It.O)
                        for (Ft = 0; Ft < It.O.length; ++Ft) {
                          w = It.O[Ft];
                          var J = !!w.visibility;
                          l = Wt.data, Z = l.addNormalizedLandmark, x = Yt, w = Object.assign(Object.assign({}, w), { visibility: J ? w.visibility : 0 }), J = new wn(), ct(J, 1, w.x), ct(J, 2, w.y), ct(J, 3, w.z), w.visibility && ct(J, 4, w.visibility), w = fn(J, _n), Z.call(l, x, w);
                        }
                      if (It.M)
                        for (Ft = 0; Ft < It.M.length; ++Ft)
                          l = Wt.data, Z = l.addClassification, x = Yt, w = It.M[Ft], J = new In(), ct(J, 2, w.X), w.index && ct(J, 1, w.index), w.label && ct(J, 3, w.label), w.displayName && ct(J, 4, w.displayName), w = fn(J, Un), Z.call(l, x, w);
                    }
                    Wt = Wt.data;
                    break t;
                  default:
                    Wt = {};
                }
              }
              switch (yt = Wt, Xt = $.stream, $.type) {
                case "video":
                  N.pushTexture2d(Object.assign(Object.assign({}, yt), { stream: Xt, timestamp: Y }));
                  break;
                case "detections":
                  Mt = yt, Mt.stream = Xt, Mt.timestamp = Y, N.pushDetectionList(Mt);
                  break;
                default:
                  throw Error("Unknown input config type: '" + $.type + "'");
              }
            }
          return R.i.send(N), P(xt, R.C, 4);
        case 4:
          N.delete(), xt.g = 0;
      }
    });
  };
  function M(s, G, R) {
    var Y, N, K, E, et, $, yt, Xt, Mt, xt, dt, Wt, It, Yt;
    return gt(function(Ft) {
      switch (Ft.g) {
        case 1:
          if (!R)
            return Ft.return(G);
          for (Y = {}, N = 0, K = T(Object.keys(R)), E = K.next(); !E.done; E = K.next())
            et = E.value, $ = R[et], typeof $ != "string" && $.type === "texture" && G[$.stream] !== void 0 && ++N;
          1 < N && (s.G = !1), yt = T(Object.keys(R)), E = yt.next();
        case 2:
          if (E.done) {
            Ft.g = 4;
            break;
          }
          if (Xt = E.value, Mt = R[Xt], typeof Mt == "string")
            return It = Y, Yt = Xt, P(Ft, _(s, Xt, G[Mt]), 14);
          if (xt = G[Mt.stream], Mt.type === "detection_list") {
            if (xt) {
              for (var l = xt.getRectList(), Z = xt.getLandmarksList(), x = xt.getClassificationsList(), w = [], J = 0; J < l.size(); ++J) {
                var o = pn(l.get(J), k, z);
                o = { T: { Y: it(o, 1), Z: it(o, 2), height: it(o, 3), width: it(o, 4), rotation: it(o, 5, 0), W: St(o, 6) }, O: Et(Z.get(J)), M: bt(pn(x.get(J), gn, En)) }, w.push(o);
              }
              l = w;
            } else
              l = [];
            Y[Xt] = l, Ft.g = 7;
            break;
          }
          if (Mt.type === "proto_list") {
            if (xt) {
              for (l = Array(xt.size()), Z = 0; Z < xt.size(); Z++)
                l[Z] = xt.get(Z);
              xt.delete();
            } else
              l = [];
            Y[Xt] = l, Ft.g = 7;
            break;
          }
          if (xt === void 0) {
            Ft.g = 3;
            break;
          }
          if (Mt.type === "float_list") {
            Y[Xt] = xt, Ft.g = 7;
            break;
          }
          if (Mt.type === "proto") {
            Y[Xt] = xt, Ft.g = 7;
            break;
          }
          if (Mt.type !== "texture")
            throw Error("Unknown output config type: '" + Mt.type + "'");
          return dt = s.s[Xt], dt || (dt = new Nt(s.h, s.D), s.s[Xt] = dt), P(Ft, $t(dt, xt, s.G), 13);
        case 13:
          Wt = Ft.h, Y[Xt] = Wt;
        case 7:
          Mt.transform && Y[Xt] && (Y[Xt] = Mt.transform(Y[Xt])), Ft.g = 3;
          break;
        case 14:
          It[Yt] = Ft.h;
        case 3:
          E = yt.next(), Ft.g = 2;
          break;
        case 4:
          return Ft.return(Y);
      }
    });
  }
  function _(s, G, R) {
    var Y;
    return gt(function(N) {
      return typeof R == "number" || R instanceof Uint8Array || R instanceof s.h.Uint8BlobList ? N.return(R) : R instanceof s.h.Texture2dDataOut ? (Y = s.s[G], Y || (Y = new Nt(s.h, s.D), s.s[G] = Y), N.return($t(Y, R, s.G))) : N.return(void 0);
    });
  }
  function A(s, G) {
    for (var R = G.name || "$", Y = [].concat(B(G.wants)), N = new s.h.StringList(), K = T(G.wants), E = K.next(); !E.done; E = K.next())
      N.push_back(E.value);
    K = s.h.PacketListener.implement({ onResults: function(et) {
      for (var $ = {}, yt = 0; yt < G.wants.length; ++yt)
        $[Y[yt]] = et.get(yt);
      var Xt = s.listeners[R];
      Xt && (s.C = M(s, $, G.outs).then(function(Mt) {
        Mt = Xt(Mt);
        for (var xt = 0; xt < G.wants.length; ++xt) {
          var dt = $[Y[xt]];
          typeof dt == "object" && dt.hasOwnProperty && dt.hasOwnProperty("delete") && dt.delete();
        }
        Mt && (s.C = Mt);
      }));
    } }), s.i.attachMultiListener(N, K), N.delete();
  }
  i.onResults = function(s, G) {
    this.listeners[G || "$"] = s;
  }, Ct("Solution", Je), Ct("OptionType", { BOOL: 0, NUMBER: 1, $: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function q(s) {
    switch (s === void 0 && (s = 0), s) {
      case 1:
        return "pose_landmark_full.tflite";
      case 2:
        return "pose_landmark_heavy.tflite";
      default:
        return "pose_landmark_lite.tflite";
    }
  }
  function lt(s) {
    var G = this;
    s = s || {}, this.g = new Je({ locateFile: s.locateFile, files: function(R) {
      return [{ url: "pose_solution_packed_assets_loader.js" }, { simd: !1, url: "pose_solution_wasm_bin.js" }, { simd: !0, url: "pose_solution_simd_wasm_bin.js" }, { data: !0, url: q(R.modelComplexity) }];
    }, graph: { url: "pose_web.binarypb" }, listeners: [{ wants: ["pose_landmarks", "world_landmarks", "segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, poseLandmarks: {
      type: "proto",
      stream: "pose_landmarks",
      transform: Et
    }, poseWorldLandmarks: { type: "proto", stream: "world_landmarks", transform: Et }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: {
      useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document },
      selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
      modelComplexity: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(R) {
        var Y, N, K;
        return gt(function(E) {
          return E.g == 1 ? (Y = q(R), N = "third_party/mediapipe/modules/pose_landmark/" + Y, P(E, L(G.g, Y), 2)) : (K = E.h, G.g.overrideFile(N, K), E.return(!0));
        });
      } },
      smoothLandmarks: {
        type: 0,
        graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" }
      },
      enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } },
      smoothSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" } },
      minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
      minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }
    } });
  }
  i = lt.prototype, i.reset = function() {
    this.g.reset();
  }, i.close = function() {
    return this.g.close(), Promise.resolve();
  }, i.onResults = function(s) {
    this.g.onResults(s);
  }, i.initialize = function() {
    var s = this;
    return gt(function(G) {
      return P(G, s.g.initialize(), 0);
    });
  }, i.send = function(s, G) {
    var R = this;
    return gt(function(Y) {
      return P(Y, R.g.send(s, G), 0);
    });
  }, i.setOptions = function(s) {
    this.g.setOptions(s);
  }, Ct("Pose", lt), Ct("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]), Ct("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 }), Ct("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 }), Ct("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 }), Ct("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 }), Ct("VERSION", "0.5.1635988162");
}).call(Xi);
const tr = class {
  constructor() {
    Zt(this, "mediapipeMap_", /* @__PURE__ */ new Map());
  }
  getVersion(r) {
    switch (r) {
      case "face_detection":
        return Zi.VERSION;
      case "face_mesh":
        return vi.VERSION;
      case "hands":
        return yi.VERSION;
      case "holistic":
        return gi.VERSION;
      case "objectron":
        return Gi.VERSION;
      case "selfie_segmentation":
        return bi.VERSION;
      case "pose":
        return Xi.VERSION;
      default:
        return "";
    }
  }
  initialize(r) {
    return new Promise(async (n, m) => {
      if (r.mediaPipeModelConfigArray.length == 0) {
        m("no model was selected");
        return;
      }
      for (let X = 0; X < r.mediaPipeModelConfigArray.length; X++) {
        const S = r.mediaPipeModelConfigArray[X];
        if (this.mediapipeMap_.has(S.modelType)) {
          m("setting same type is not supported");
          return;
        }
        if (typeof S.listener != "function") {
          m(
            `[${S.modelType}] ResultsListener must be provided`
          );
          return;
        }
        let C;
        switch (S.modelType) {
          case "face_mesh":
            C = new vi.FaceMesh({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "face_mesh/" + this.getVersion("face_mesh")) + "/" + T
            });
            break;
          case "face_detection":
            C = new Zi.FaceDetection({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "face_detection/" + this.getVersion("face_detection")) + "/" + T
            });
            break;
          case "hands":
            C = new yi.Hands({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "hands/" + this.getVersion("hands")) + "/" + T
            });
            break;
          case "holistic":
            C = new gi.Holistic({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "holistic/" + this.getVersion("holistic")) + "/" + T
            });
            break;
          case "objectron":
            C = new Gi.Objectron({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "objectron/" + this.getVersion("objectron")) + "/" + T
            });
            break;
          case "selfie_segmentation":
            C = new bi.SelfieSegmentation({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "selfie_segmentation/" + this.getVersion(
                "selfie_segmentation"
              )) + "/" + T
            });
            break;
          case "pose":
            C = new Xi.Pose({
              locateFile: (T, B) => (S.assetsUri || tr.defaultAssetsBaseUrl + "pose/" + this.getVersion("pose")) + "/" + T
            });
            break;
          default:
            m("unknown model type");
            return;
        }
        C.onResults(S.listener), S.options && C.setOptions(S.options);
        try {
          await C.initialize(), this.mediapipeMap_.set(
            S.modelType,
            C
          );
        } catch (T) {
          m(T);
          return;
        }
      }
      n();
    });
  }
  close(r) {
    return new Promise((n, m) => {
      let X = [];
      if (r) {
        let S = this.mediapipeMap_.get(r);
        if (S)
          this.mediapipeMap_.delete(r), X.push(S.close());
        else {
          m("model not exit");
          return;
        }
      } else {
        for (const [
          S,
          C
        ] of this.mediapipeMap_.entries())
          X.push(C.close());
        this.mediapipeMap_.clear();
      }
      Promise.all(X).then(() => {
        n();
      }).catch((S) => {
        m(S);
      });
    });
  }
  send(r, n) {
    return new Promise((m, X) => {
      let S = [];
      if (n) {
        let C = this.mediapipeMap_.get(n);
        if (C)
          S.push(C.send({ image: r }));
        else {
          X("model not exit");
          return;
        }
      } else
        for (const [
          C,
          T
        ] of this.mediapipeMap_.entries())
          S.push(T.send({ image: r }));
      Promise.all(S).then(() => {
        m();
      }).catch((C) => {
        X(C);
      });
    });
  }
  reset(r) {
    if (r) {
      let n = this.mediapipeMap_.get(r);
      n && typeof n.reset == "function" && n.reset();
    } else
      for (const [n, m] of this.mediapipeMap_.entries())
        m && typeof m.reset == "function" && m.reset();
  }
};
let Pi = tr;
Zt(Pi, "defaultAssetsBaseUrl", "https://d3opqjmqzxf057.cloudfront.net/ml/mediapipe/");
const ir = /* @__PURE__ */ new WeakMap(), ai = /* @__PURE__ */ new WeakMap(), kr = /* @__PURE__ */ new WeakMap(), io = Symbol("anyProducer"), ns = Promise.resolve(), Wi = Symbol("listenerAdded"), Vi = Symbol("listenerRemoved");
let _i = !1;
function Rr(i) {
  if (typeof i != "string" && typeof i != "symbol")
    throw new TypeError("eventName must be a string or a symbol");
}
function $r(i) {
  if (typeof i != "function")
    throw new TypeError("listener must be a function");
}
function xr(i, r) {
  const n = ai.get(i);
  return n.has(r) || n.set(r, /* @__PURE__ */ new Set()), n.get(r);
}
function Ur(i, r) {
  const n = typeof r == "string" || typeof r == "symbol" ? r : io, m = kr.get(i);
  return m.has(n) || m.set(n, /* @__PURE__ */ new Set()), m.get(n);
}
function E2(i, r, n) {
  const m = kr.get(i);
  if (m.has(r))
    for (const X of m.get(r))
      X.enqueue(n);
  if (m.has(io)) {
    const X = Promise.all([r, n]);
    for (const S of m.get(io))
      S.enqueue(X);
  }
}
function rs(i, r) {
  r = Array.isArray(r) ? r : [r];
  let n = !1, m = () => {
  }, X = [];
  const S = {
    enqueue(C) {
      X.push(C), m();
    },
    finish() {
      n = !0, m();
    }
  };
  for (const C of r)
    Ur(i, C).add(S);
  return {
    async next() {
      return X ? X.length === 0 ? n ? (X = void 0, this.next()) : (await new Promise((C) => {
        m = C;
      }), this.next()) : {
        done: !1,
        value: await X.shift()
      } : { done: !0 };
    },
    async return(C) {
      X = void 0;
      for (const T of r)
        Ur(i, T).delete(S);
      return m(), arguments.length > 0 ? { done: !0, value: await C } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function is(i) {
  if (i === void 0)
    return os;
  if (!Array.isArray(i))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const r of i)
    if (!os.includes(r))
      throw typeof r != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${r} is not Emittery method`);
  return i;
}
const Qi = (i) => i === Wi || i === Vi;
class Zr {
  static mixin(r, n) {
    return n = is(n), (m) => {
      if (typeof m != "function")
        throw new TypeError("`target` must be function");
      for (const C of n)
        if (m.prototype[C] !== void 0)
          throw new Error(`The property \`${C}\` already exists on \`target\``);
      function X() {
        return Object.defineProperty(this, r, {
          enumerable: !1,
          value: new Zr()
        }), this[r];
      }
      Object.defineProperty(m.prototype, r, {
        enumerable: !1,
        get: X
      });
      const S = (C) => function(...T) {
        return this[r][C](...T);
      };
      for (const C of n)
        Object.defineProperty(m.prototype, C, {
          enumerable: !1,
          value: S(C)
        });
      return m;
    };
  }
  static get isDebugEnabled() {
    if (typeof process != "object")
      return _i;
    const { env: r } = process || { env: {} };
    return r.DEBUG === "emittery" || r.DEBUG === "*" || _i;
  }
  static set isDebugEnabled(r) {
    _i = r;
  }
  constructor(r = {}) {
    ir.set(this, /* @__PURE__ */ new Set()), ai.set(this, /* @__PURE__ */ new Map()), kr.set(this, /* @__PURE__ */ new Map()), this.debug = r.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (n, m, X, S) => {
      try {
        S = JSON.stringify(S);
      } catch {
        S = `Object with the following keys failed to stringify: ${Object.keys(S).join(",")}`;
      }
      typeof X == "symbol" && (X = X.toString());
      const C = new Date(), T = `${C.getHours()}:${C.getMinutes()}:${C.getSeconds()}.${C.getMilliseconds()}`;
      console.log(`[${T}][emittery:${n}][${m}] Event Name: ${X}
	data: ${S}`);
    });
  }
  logIfDebugEnabled(r, n, m) {
    (Zr.isDebugEnabled || this.debug.enabled) && this.debug.logger(r, this.debug.name, n, m);
  }
  on(r, n) {
    $r(n), r = Array.isArray(r) ? r : [r];
    for (const m of r)
      Rr(m), xr(this, m).add(n), this.logIfDebugEnabled("subscribe", m, void 0), Qi(m) || this.emit(Wi, { eventName: m, listener: n });
    return this.off.bind(this, r, n);
  }
  off(r, n) {
    $r(n), r = Array.isArray(r) ? r : [r];
    for (const m of r)
      Rr(m), xr(this, m).delete(n), this.logIfDebugEnabled("unsubscribe", m, void 0), Qi(m) || this.emit(Vi, { eventName: m, listener: n });
  }
  once(r) {
    return new Promise((n) => {
      const m = this.on(r, (X) => {
        m(), n(X);
      });
    });
  }
  events(r) {
    r = Array.isArray(r) ? r : [r];
    for (const n of r)
      Rr(n);
    return rs(this, r);
  }
  async emit(r, n) {
    Rr(r), this.logIfDebugEnabled("emit", r, n), E2(this, r, n);
    const m = xr(this, r), X = ir.get(this), S = [...m], C = Qi(r) ? [] : [...X];
    await ns, await Promise.all([
      ...S.map(async (T) => {
        if (m.has(T))
          return T(n);
      }),
      ...C.map(async (T) => {
        if (X.has(T))
          return T(r, n);
      })
    ]);
  }
  async emitSerial(r, n) {
    Rr(r), this.logIfDebugEnabled("emitSerial", r, n);
    const m = xr(this, r), X = ir.get(this), S = [...m], C = [...X];
    await ns;
    for (const T of S)
      m.has(T) && await T(n);
    for (const T of C)
      X.has(T) && await T(r, n);
  }
  onAny(r) {
    return $r(r), this.logIfDebugEnabled("subscribeAny", void 0, void 0), ir.get(this).add(r), this.emit(Wi, { listener: r }), this.offAny.bind(this, r);
  }
  anyEvent() {
    return rs(this);
  }
  offAny(r) {
    $r(r), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(Vi, { listener: r }), ir.get(this).delete(r);
  }
  clearListeners(r) {
    r = Array.isArray(r) ? r : [r];
    for (const n of r)
      if (this.logIfDebugEnabled("clear", n, void 0), typeof n == "string" || typeof n == "symbol") {
        xr(this, n).clear();
        const m = Ur(this, n);
        for (const X of m)
          X.finish();
        m.clear();
      } else {
        ir.get(this).clear();
        for (const m of ai.get(this).values())
          m.clear();
        for (const m of kr.get(this).values()) {
          for (const X of m)
            X.finish();
          m.clear();
        }
      }
  }
  listenerCount(r) {
    r = Array.isArray(r) ? r : [r];
    let n = 0;
    for (const m of r) {
      if (typeof m == "string") {
        n += ir.get(this).size + xr(this, m).size + Ur(this, m).size + Ur(this).size;
        continue;
      }
      typeof m < "u" && Rr(m), n += ir.get(this).size;
      for (const X of ai.get(this).values())
        n += X.size;
      for (const X of kr.get(this).values())
        n += X.size;
    }
    return n;
  }
  bindMethods(r, n) {
    if (typeof r != "object" || r === null)
      throw new TypeError("`target` must be an object");
    n = is(n);
    for (const m of n) {
      if (r[m] !== void 0)
        throw new Error(`The property \`${m}\` already exists on \`target\``);
      Object.defineProperty(r, m, {
        enumerable: !1,
        value: this[m].bind(this)
      });
    }
  }
}
const os = Object.getOwnPropertyNames(Zr.prototype).filter((i) => i !== "constructor");
Object.defineProperty(Zr, "listenerAdded", {
  value: Wi,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(Zr, "listenerRemoved", {
  value: Vi,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var ws = Zr;
function go(i, r) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let n = globalThis.vonage.workerizer;
  return n[i] || (n[i] = r), n[i];
}
const Fr = go(
  "globals",
  {}
);
var Dn = /* @__PURE__ */ ((i) => (i.INIT = "INIT", i.FORWARD = "FORWARD", i.TERMINATE = "TERMINATE", i.GLOBALS_SYNC = "GLOBALS_SYNC", i))(Dn || {});
function Ys(i) {
  return [ImageBitmap, ReadableStream, WritableStream].some((r) => i instanceof r);
}
let B2 = 0;
function Ri(i, r, n, m, X) {
  const S = B2++;
  return i.postMessage(
    {
      id: S,
      type: r,
      functionName: n,
      args: m
    },
    m.filter((C) => Ys(C))
  ), new Promise((C) => {
    X == null || X.set(S, C);
  });
}
function jr(i, r) {
  const { id: n, type: m } = i, X = Array.isArray(r) ? r : [r];
  postMessage(
    {
      id: n,
      type: m,
      result: r
    },
    X.filter((S) => Ys(S))
  );
}
const xi = go("workerized", {});
function Zo() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function M2() {
  if (Zo())
    jr({ type: Dn.GLOBALS_SYNC }, Fr);
  else {
    const i = [];
    for (const r in xi) {
      const { worker: n, resolvers: m } = xi[r].workerContext;
      n && i.push(
        Ri(
          n,
          Dn.GLOBALS_SYNC,
          "",
          [Fr],
          m
        )
      );
    }
    await Promise.all(i);
  }
}
function Er(i, r) {
  if (Array.isArray(r))
    r.splice(0, r.length);
  else if (typeof r == "object")
    for (const n in r)
      delete r[n];
  for (const n in i)
    Array.isArray(i[n]) ? (r[n] = [], Er(i[n], r[n])) : typeof i[n] == "object" ? (r[n] = {}, Er(i[n], r[n])) : r[n] = i[n];
}
async function A2(i, r, n) {
  const m = new r();
  if (m.addEventListener(
    "message",
    async ({ data: X }) => {
      var S, C, T, B, nt, ut, pt;
      switch (X.type) {
        case Dn.GLOBALS_SYNC:
          X.id ? ((C = n.get((S = X.id) != null ? S : -1)) == null || C(X.result), n.delete((T = X.id) != null ? T : -1)) : (Er((B = X.result) != null ? B : {}, Fr), await M2());
          break;
        default:
          (ut = n.get((nt = X.id) != null ? nt : -1)) == null || ut(X.result), n.delete((pt = X.id) != null ? pt : -1);
      }
    }
  ), !await Ri(
    m,
    Dn.INIT,
    "",
    [i.workerId, Fr],
    n
  ))
    throw "Failed to instantiate workerized class";
  return m;
}
let K2 = 0;
async function j2(i, r, n) {
  const m = {}, X = K2++;
  return Object.getOwnPropertyNames(i.prototype).forEach(
    (S) => {
      m[S] = (...C) => Ri(r, Dn.FORWARD, S, C, n);
    }
  ), m.terminate = async (...S) => {
    const C = await Ri(
      r,
      Dn.TERMINATE,
      "",
      S,
      n
    );
    return delete xi[X], r.terminate(), m.workerContext.worker = void 0, C;
  }, m.workerContext = {
    id: X,
    worker: r,
    resolvers: n
  }, xi[X] = m, m;
}
async function z2(i, r) {
  const n = /* @__PURE__ */ new Map(), m = await A2(i, r, n);
  return j2(i, m, n);
}
async function O2(i, r) {
  const { functionName: n, args: m } = i;
  if (!r.instance)
    throw "instance not initialized";
  if (!n)
    throw "missing function name to call";
  if (!r.instance[n])
    throw `undefined function [${n}] in class ${r.instance.constructor.workerId}`;
  jr(i, await r.instance[n](...m != null ? m : []));
}
const Ts = go("registeredWorkers", {});
function P2(i, r) {
  r.workerId = i, Zo() && (Ts[r.workerId] = r);
}
function _2(i, r) {
  if (!i.args)
    throw "Missing className while initializing worker";
  const [n, m] = i.args, X = Ts[n];
  if (X)
    r.instance = new X(i.args.slice(1));
  else
    throw `unknown worker class ${n}`;
  Er(m, Fr), jr(i, typeof r.instance !== void 0);
}
async function Q2(i, r) {
  const { args: n } = i;
  if (!r.instance)
    throw "instance not initialized";
  let m;
  r.instance.terminate && (m = await r.instance.terminate(...n != null ? n : [])), jr(i, m);
}
function D2(i) {
  if (!i.args)
    throw "Missing globals while syncing";
  Er(i.args[0], Fr), jr(i, {});
}
function $2() {
  const i = {};
  onmessage = async (r) => {
    const n = r.data;
    switch (n.type) {
      case Dn.INIT:
        _2(n, i);
        break;
      case Dn.FORWARD:
        O2(n, i);
        break;
      case Dn.TERMINATE:
        Q2(n, i);
        break;
      case Dn.GLOBALS_SYNC:
        D2(n);
        break;
    }
  };
}
Zo() && $2();
class ss {
  static async createVideoReadable(r) {
    return new Promise((n, m) => {
      const X = document.createElement("video");
      let S = new AbortController(), C = new AbortController();
      X.addEventListener(
        "canplay",
        () => {
          S.abort(), X.muted = !0, X.loop = !0, X.play().then(() => {
            try {
              const T = X.captureStream(), B = new MediaStreamTrackProcessor(
                T.getVideoTracks()[0]
              );
              n(B.readable);
            } catch (T) {
              m(T);
            }
          });
        },
        { once: !0, signal: C.signal }
      ), X.addEventListener(
        "error",
        (T) => {
          C.abort(), m("loading error:" + T);
        },
        { once: !0, signal: S.signal }
      ), X.crossOrigin = "anonymous", X.src = r;
    });
  }
  static async createImageCanvas(r) {
    const m = await (await fetch(r)).blob();
    return await createImageBitmap(m);
  }
}
var q2 = Object.defineProperty, tc = (i, r, n) => r in i ? q2(i, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : i[r] = n, ec = (i, r, n) => (tc(i, typeof r != "symbol" ? r + "" : r, n), n);
const nc = "hlg.tokbox.com/prod/logging/vcp_webrtc", rc = "https://", ic = 1e4;
let qr;
const oc = new Uint8Array(16);
function sc() {
  if (!qr && (qr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !qr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return qr(oc);
}
const Mn = [];
for (let i = 0; i < 256; ++i)
  Mn.push((i + 256).toString(16).slice(1));
function lc(i, r = 0) {
  return (Mn[i[r + 0]] + Mn[i[r + 1]] + Mn[i[r + 2]] + Mn[i[r + 3]] + "-" + Mn[i[r + 4]] + Mn[i[r + 5]] + "-" + Mn[i[r + 6]] + Mn[i[r + 7]] + "-" + Mn[i[r + 8]] + Mn[i[r + 9]] + "-" + Mn[i[r + 10]] + Mn[i[r + 11]] + Mn[i[r + 12]] + Mn[i[r + 13]] + Mn[i[r + 14]] + Mn[i[r + 15]]).toLowerCase();
}
const cc = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ls = {
  randomUUID: cc
};
function uc(i, r, n) {
  if (ls.randomUUID && !r && !i)
    return ls.randomUUID();
  i = i || {};
  const m = i.random || (i.rng || sc)();
  if (m[6] = m[6] & 15 | 64, m[8] = m[8] & 63 | 128, r) {
    n = n || 0;
    for (let X = 0; X < 16; ++X)
      r[n + X] = m[X];
    return r;
  }
  return lc(m);
}
function vo(i, r) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let n = globalThis.vonage.workerizer;
  return n[i] || (n[i] = r), n[i];
}
const lr = vo(
  "globals",
  {}
);
var br = /* @__PURE__ */ ((i) => (i.INIT = "INIT", i.FORWARD = "FORWARD", i.TERMINATE = "TERMINATE", i.GLOBALS_SYNC = "GLOBALS_SYNC", i))(br || {});
function Fs(i) {
  return [ImageBitmap, ReadableStream, WritableStream].some((r) => i instanceof r);
}
let ac = 0;
function dc(i, r, n, m, X) {
  const S = ac++;
  return i.postMessage(
    {
      id: S,
      type: r,
      functionName: n,
      args: m
    },
    m.filter((C) => Fs(C))
  ), new Promise((C) => {
    X == null || X.set(S, C);
  });
}
function zr(i, r) {
  const { id: n, type: m } = i, X = Array.isArray(r) ? r : [r];
  postMessage(
    {
      id: n,
      type: m,
      result: r
    },
    X.filter((S) => Fs(S))
  );
}
const cs = vo("workerized", {});
function Hs() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function hc() {
  if (Hs())
    zr({ type: br.GLOBALS_SYNC }, lr);
  else {
    const i = [];
    for (const r in cs) {
      const { worker: n, resolvers: m } = cs[r].workerContext;
      n && i.push(
        dc(
          n,
          br.GLOBALS_SYNC,
          "",
          [lr],
          m
        )
      );
    }
    await Promise.all(i);
  }
}
function Ii(i, r) {
  if (Array.isArray(r))
    r.splice(0, r.length);
  else if (typeof r == "object")
    for (const n in r)
      delete r[n];
  for (const n in i)
    Array.isArray(i[n]) ? (r[n] = [], Ii(i[n], r[n])) : typeof i[n] == "object" ? (r[n] = {}, Ii(i[n], r[n])) : r[n] = i[n];
}
async function fc(i, r) {
  const { functionName: n, args: m } = i;
  if (!r.instance)
    throw "instance not initialized";
  if (!n)
    throw "missing function name to call";
  if (!r.instance[n])
    throw `undefined function [${n}] in class ${r.instance.constructor.workerId}`;
  zr(i, await r.instance[n](...m != null ? m : []));
}
const mc = vo("registeredWorkers", {});
function pc(i, r) {
  if (!i.args)
    throw "Missing className while initializing worker";
  const [n, m] = i.args, X = mc[n];
  if (X)
    r.instance = new X(i.args.slice(1));
  else
    throw `unknown worker class ${n}`;
  Ii(m, lr), zr(i, typeof r.instance !== void 0);
}
async function bc(i, r) {
  const { args: n } = i;
  if (!r.instance)
    throw "instance not initialized";
  let m;
  r.instance.terminate && (m = await r.instance.terminate(...n != null ? n : [])), zr(i, m);
}
function yc(i) {
  if (!i.args)
    throw "Missing globals while syncing";
  Ii(i.args[0], lr), zr(i, {});
}
function gc() {
  const i = {};
  onmessage = async (r) => {
    const n = r.data;
    switch (n.type) {
      case br.INIT:
        pc(n, i);
        break;
      case br.FORWARD:
        fc(n, i);
        break;
      case br.TERMINATE:
        bc(n, i);
        break;
      case br.GLOBALS_SYNC:
        yc(n);
        break;
    }
  };
}
Hs() && gc();
function Zc(i, r) {
  return lr[i] || (lr[i] = r), [
    () => lr[i],
    async (n) => {
      lr[i] = n, await hc();
    }
  ];
}
function vc(i, r) {
  return Zc(i, r);
}
const [Gc, Z3] = vc("metadata");
function Di() {
  return Gc();
}
class Xc {
  constructor(r) {
    ec(this, "uuid", uc()), this.config = r;
  }
  async send(r) {
    var n, m, X;
    const { appId: S, sourceType: C } = (n = Di()) != null ? n : {};
    if (!S || !C)
      return "metadata missing";
    const T = new AbortController(), B = setTimeout(() => T.abort(), ic);
    return await ((X = (m = this.config) == null ? void 0 : m.fetch) != null ? X : fetch)(this.getUrl(), {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(this.buildReport(r)),
      signal: T.signal
    }), clearTimeout(B), "success";
  }
  getUrl() {
    var r;
    let n = (r = Di().proxyUrl) != null ? r : rc;
    return n += (n.at(-1) === "/" ? "" : "/") + nc, n;
  }
  getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  }
  buildReport(r) {
    const n = Di();
    return {
      guid: this.uuid,
      ...r,
      applicationId: n.appId,
      timestamp: Date.now(),
      proxyUrl: n.proxyUrl,
      source: n.sourceType
    };
  }
}
const Wc = "5.0.1";
class Go {
  constructor() {
    Zt(this, "canvas");
    Zt(this, "context");
    const r = new OffscreenCanvas(0, 0), n = r.getContext("2d");
    if (!n)
      throw "Fail to retrieve webgl2 context";
    this.canvas = r, this.context = n;
  }
  setFlickeringOptions(r) {
  }
  enablePostProcessing() {
  }
  disablePostProcessing() {
  }
  async profileWebgl(r) {
    return [];
  }
  async render(r, n) {
    return this.canvas;
  }
  resizeCanvas(r) {
    const { width: n, height: m } = r;
    this.canvas.width = n, this.canvas.height = m;
  }
  renderSilhouette(r, n, m = "none") {
    const { width: X, height: S } = r;
    this.context.save(), this.context.drawImage(
      n,
      0,
      0,
      n.width,
      n.height,
      0,
      0,
      X,
      S
    ), this.context.globalCompositeOperation = "source-in", this.context.filter = m, this.context.drawImage(
      r,
      0,
      0,
      X,
      S,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    ), this.context.restore();
  }
}
class Vc extends Go {
  constructor(r) {
    super(), this.radius = r;
  }
  async render(r, n) {
    return super.resizeCanvas(r), this.renderSilhouette(r, n), this.context.save(), this.context.filter = `blur(${this.radius}px)`, this.context.globalCompositeOperation = "destination-over", this.context.drawImage(r, 0, 0, r.width, r.height), this.context.restore(), super.render(r, n);
  }
}
class Rc extends Go {
  constructor(r) {
    super(), this.radius = r;
  }
  async render(r, n) {
    return super.resizeCanvas(r), this.renderSilhouette(r, n, `blur(${this.radius}px)`), this.context.save(), this.context.filter = "none", this.context.globalCompositeOperation = "destination-over", this.context.drawImage(r, 0, 0, r.width, r.height), this.context.restore(), super.render(r, n);
  }
}
class xc extends Go {
  constructor() {
    super(...arguments);
    Zt(this, "backgroundImage");
  }
  setBackgroundImage(n) {
    this.backgroundImage = n;
  }
  async render(n, m) {
    return super.resizeCanvas(n), this.renderSilhouette(n, m), this.backgroundImage && (this.context.save(), this.context.filter = "none", this.context.globalCompositeOperation = "destination-over", this.context.drawImage(
      this.backgroundImage,
      0,
      0,
      this.backgroundImage.width,
      this.backgroundImage.height,
      0,
      0,
      n.width,
      n.height
    ), this.context.restore()), super.render(n, m);
  }
}
/* @license twgl.js 5.2.0 Copyright (c) 2015, Gregg Tavares All Rights Reserved.
Available via the MIT license.
see: http://github.com/greggman/twgl.js for details */
const Xo = 5120, Br = 5121, Wo = 5122, Vo = 5123, Ro = 5124, xo = 5125, Io = 5126, Ic = 32819, Sc = 32820, wc = 33635, Yc = 5131, Tc = 33640, Fc = 35899, Hc = 35902, Lc = 36269, Cc = 34042, Ls = {};
{
  const i = Ls;
  i[Xo] = Int8Array, i[Br] = Uint8Array, i[Wo] = Int16Array, i[Vo] = Uint16Array, i[Ro] = Int32Array, i[xo] = Uint32Array, i[Io] = Float32Array, i[Ic] = Uint16Array, i[Sc] = Uint16Array, i[wc] = Uint16Array, i[Yc] = Uint16Array, i[Tc] = Uint32Array, i[Fc] = Uint32Array, i[Hc] = Uint32Array, i[Lc] = Uint32Array, i[Cc] = Uint32Array;
}
function So(i) {
  if (i instanceof Int8Array)
    return Xo;
  if (i instanceof Uint8Array || i instanceof Uint8ClampedArray)
    return Br;
  if (i instanceof Int16Array)
    return Wo;
  if (i instanceof Uint16Array)
    return Vo;
  if (i instanceof Int32Array)
    return Ro;
  if (i instanceof Uint32Array)
    return xo;
  if (i instanceof Float32Array)
    return Io;
  throw new Error("unsupported typed array type");
}
function Cs(i) {
  if (i === Int8Array)
    return Xo;
  if (i === Uint8Array || i === Uint8ClampedArray)
    return Br;
  if (i === Int16Array)
    return Wo;
  if (i === Uint16Array)
    return Vo;
  if (i === Int32Array)
    return Ro;
  if (i === Uint32Array)
    return xo;
  if (i === Float32Array)
    return Io;
  throw new Error("unsupported typed array type");
}
function Ns(i) {
  const r = Ls[i];
  if (!r)
    throw new Error("unknown gl type");
  return r;
}
const Si = typeof SharedArrayBuffer < "u" ? function(r) {
  return r && r.buffer && (r.buffer instanceof ArrayBuffer || r.buffer instanceof SharedArrayBuffer);
} : function(r) {
  return r && r.buffer && r.buffer instanceof ArrayBuffer;
};
function Js(...i) {
  console.error(...i);
}
const us = /* @__PURE__ */ new Map();
function Li(i, r) {
  if (!i || typeof i != "object")
    return !1;
  let n = us.get(r);
  n || (n = /* @__PURE__ */ new WeakMap(), us.set(r, n));
  let m = n.get(i);
  if (m === void 0) {
    const X = Object.prototype.toString.call(i);
    m = X.substring(8, X.length - 1) === r, n.set(i, m);
  }
  return m;
}
function Nc(i, r) {
  return typeof WebGLBuffer < "u" && Li(r, "WebGLBuffer");
}
function Jc(i, r) {
  return typeof WebGLRenderbuffer < "u" && Li(r, "WebGLRenderbuffer");
}
function wo(i, r) {
  return typeof WebGLTexture < "u" && Li(r, "WebGLTexture");
}
function kc(i, r) {
  return typeof WebGLSampler < "u" && Li(r, "WebGLSampler");
}
const ks = 35044, yr = 34962, Uc = 34963, Ec = 34660, Bc = 5120, Mc = 5121, Ac = 5122, Kc = 5123, jc = 5124, zc = 5125, Us = 5126, Es = {
  attribPrefix: ""
};
function Oc(i, r, n, m, X) {
  i.bindBuffer(r, n), i.bufferData(r, m, X || ks);
}
function Bs(i, r, n, m) {
  if (Nc(i, r))
    return r;
  n = n || yr;
  const X = i.createBuffer();
  return Oc(i, n, X, r, m), X;
}
function Ms(i) {
  return i === "indices";
}
function Pc(i) {
  return i === Int8Array || i === Uint8Array;
}
function _c(i) {
  return i.length ? i : i.data;
}
const Qc = /coord|texture/i, Dc = /color|colour/i;
function $c(i, r) {
  let n;
  if (Qc.test(i) ? n = 2 : Dc.test(i) ? n = 4 : n = 3, r % n > 0)
    throw new Error(`Can not guess numComponents for attribute '${i}'. Tried ${n} but ${r} values is not evenly divisible by ${n}. You should specify it.`);
  return n;
}
function qc(i, r, n) {
  return i.numComponents || i.size || $c(r, n || _c(i).length);
}
function As(i, r) {
  if (Si(i))
    return i;
  if (Si(i.data))
    return i.data;
  Array.isArray(i) && (i = {
    data: i
  });
  let n = i.type ? Yo(i.type) : void 0;
  return n || (Ms(r) ? n = Uint16Array : n = Float32Array), new n(i.data);
}
function tu(i) {
  return typeof i == "number" ? i : i ? Cs(i) : Us;
}
function Yo(i) {
  return typeof i == "number" ? Ns(i) : i || Float32Array;
}
function eu(i, r) {
  return {
    buffer: r.buffer,
    numValues: 2 * 3 * 4,
    type: tu(r.type),
    arrayType: Yo(r.type)
  };
}
function nu(i, r) {
  const n = r.data || r, m = Yo(r.type), X = n * m.BYTES_PER_ELEMENT, S = i.createBuffer();
  return i.bindBuffer(yr, S), i.bufferData(yr, X, r.drawType || ks), {
    buffer: S,
    numValues: n,
    type: Cs(m),
    arrayType: m
  };
}
function ru(i, r, n) {
  const m = As(r, n);
  return {
    arrayType: m.constructor,
    buffer: Bs(i, m, void 0, r.drawType),
    type: So(m),
    numValues: 0
  };
}
function iu(i, r) {
  const n = {};
  return Object.keys(r).forEach(function(m) {
    if (!Ms(m)) {
      const X = r[m], S = X.attrib || X.name || X.attribName || Es.attribPrefix + m;
      if (X.value) {
        if (!Array.isArray(X.value) && !Si(X.value))
          throw new Error("array.value is not array or typedarray");
        n[S] = {
          value: X.value
        };
      } else {
        let C;
        X.buffer && X.buffer instanceof WebGLBuffer ? C = eu : typeof X == "number" || typeof X.data == "number" ? C = nu : C = ru;
        const { buffer: T, type: B, numValues: nt, arrayType: ut } = C(i, X, m), pt = X.normalize !== void 0 ? X.normalize : Pc(ut), Tt = qc(X, m, nt);
        n[S] = {
          buffer: T,
          numComponents: Tt,
          type: B,
          normalize: pt,
          stride: X.stride || 0,
          offset: X.offset || 0,
          divisor: X.divisor === void 0 ? void 0 : X.divisor,
          drawType: X.drawType
        };
      }
    }
  }), i.bindBuffer(yr, null), n;
}
function ou(i, r) {
  return r === Bc || r === Mc ? 1 : r === Ac || r === Kc ? 2 : r === jc || r === zc || r === Us ? 4 : 0;
}
const $i = ["position", "positions", "a_position"];
function su(i, r) {
  let n, m;
  for (m = 0; m < $i.length && (n = $i[m], !(n in r || (n = Es.attribPrefix + n, n in r))); ++m)
    ;
  m === $i.length && (n = Object.keys(r)[0]);
  const X = r[n];
  if (!X.buffer)
    return 1;
  i.bindBuffer(yr, X.buffer);
  const S = i.getBufferParameter(yr, Ec);
  i.bindBuffer(yr, null);
  const C = ou(i, X.type), T = S / C, B = X.numComponents || X.size, nt = T / B;
  if (nt % 1 !== 0)
    throw new Error(`numComponents ${B} not correct for length ${length}`);
  return nt;
}
function lu(i, r, n) {
  const m = iu(i, r), X = Object.assign({}, n || {});
  X.attribs = Object.assign({}, n ? n.attribs : {}, m);
  const S = r.indices;
  if (S) {
    const C = As(S, "indices");
    X.indices = Bs(i, C, Uc), X.numElements = C.length, X.elementType = So(C);
  } else
    X.numElements || (X.numElements = su(i, X.attribs));
  return X;
}
function Or(i) {
  return !!i.texStorage2D;
}
const Ks = function() {
  const i = {}, r = {};
  function n(m) {
    const X = m.constructor.name;
    if (!i[X]) {
      for (const S in m)
        if (typeof m[S] == "number") {
          const C = r[m[S]];
          r[m[S]] = C ? `${C} | ${S}` : S;
        }
      i[X] = !0;
    }
  }
  return function(X, S) {
    return n(X), r[S] || (typeof S == "number" ? `0x${S.toString(16)}` : S);
  };
}(), ur = {
  textureColor: new Uint8Array([128, 192, 255, 255]),
  textureOptions: {},
  crossOrigin: void 0
}, Mr = Si, js = function() {
  let i;
  return function() {
    return i = i || (typeof document < "u" && document.createElement ? document.createElement("canvas").getContext("2d") : null), i;
  };
}(), as = 6406, qn = 6407, Vn = 6408, ds = 6409, hs = 6410, Lr = 6402, fs = 34041, wi = 33071, cu = 9728, uu = 9729, ar = 3553, cr = 34067, vr = 32879, Gr = 35866, To = 34069, au = 34070, du = 34071, hu = 34072, fu = 34073, mu = 34074, oo = 10241, so = 10240, Yi = 10242, Ti = 10243, ms = 32882, pu = 33082, bu = 33083, yu = 33084, gu = 33085, Fo = 3317, zs = 3314, Os = 32878, Ps = 3316, _s = 3315, Qs = 32877, Zu = 37443, vu = 37441, Gu = 37440, Xu = 33321, Wu = 36756, Vu = 33325, Ru = 33326, xu = 33330, Iu = 33329, Su = 33338, wu = 33337, Yu = 33340, Tu = 33339, Fu = 33323, Hu = 36757, Lu = 33327, Cu = 33328, Nu = 33336, Ju = 33335, ku = 33332, Uu = 33331, Eu = 33334, Bu = 33333, Mu = 32849, Au = 35905, Ku = 36194, ju = 36758, zu = 35898, Ou = 35901, Pu = 34843, _u = 34837, Qu = 36221, Du = 36239, $u = 36215, qu = 36233, t1 = 36209, e1 = 36227, n1 = 32856, r1 = 35907, i1 = 36759, o1 = 32855, s1 = 32854, l1 = 32857, c1 = 34842, u1 = 34836, a1 = 36220, d1 = 36238, h1 = 36975, f1 = 36214, m1 = 36232, p1 = 36226, b1 = 36208, y1 = 33189, g1 = 33190, Z1 = 36012, v1 = 36013, G1 = 35056, or = 5120, Zn = 5121, ti = 5122, Ir = 5123, ei = 5124, fr = 5125, jn = 5126, ps = 32819, bs = 32820, ys = 33635, Qn = 5131, Cr = 36193, qi = 33640, X1 = 35899, W1 = 35902, V1 = 36269, R1 = 34042, ni = 33319, Sr = 33320, ri = 6403, wr = 36244, Yr = 36248, mr = 36249;
let to;
function Ci(i) {
  if (!to) {
    const r = {};
    r[as] = { textureFormat: as, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1, 2, 2, 4], type: [Zn, Qn, Cr, jn] }, r[ds] = { textureFormat: ds, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1, 2, 2, 4], type: [Zn, Qn, Cr, jn] }, r[hs] = { textureFormat: hs, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [2, 4, 4, 8], type: [Zn, Qn, Cr, jn] }, r[qn] = { textureFormat: qn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3, 6, 6, 12, 2], type: [Zn, Qn, Cr, jn, ys] }, r[Vn] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 8, 8, 16, 2, 2], type: [Zn, Qn, Cr, jn, ps, bs] }, r[Lr] = { textureFormat: Lr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2, 4], type: [fr, Ir] }, r[Xu] = { textureFormat: ri, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1], type: [Zn] }, r[Wu] = { textureFormat: ri, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [1], type: [or] }, r[Vu] = { textureFormat: ri, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [4, 2], type: [jn, Qn] }, r[Ru] = { textureFormat: ri, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [4], type: [jn] }, r[xu] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [1], type: [Zn] }, r[Iu] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [1], type: [or] }, r[ku] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Ir] }, r[Uu] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [ti] }, r[Eu] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [fr] }, r[Bu] = { textureFormat: wr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [ei] }, r[Fu] = { textureFormat: ni, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [2], type: [Zn] }, r[Hu] = { textureFormat: ni, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [2], type: [or] }, r[Lu] = { textureFormat: ni, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [8, 4], type: [jn, Qn] }, r[Cu] = { textureFormat: ni, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [8], type: [jn] }, r[Nu] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Zn] }, r[Ju] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [or] }, r[Su] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Ir] }, r[wu] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [ti] }, r[Yu] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [fr] }, r[Tu] = { textureFormat: Sr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [ei] }, r[Mu] = { textureFormat: qn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3], type: [Zn] }, r[Au] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [3], type: [Zn] }, r[Ku] = { textureFormat: qn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3, 2], type: [Zn, ys] }, r[ju] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [3], type: [or] }, r[zu] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6, 4], type: [jn, Qn, X1] }, r[Ou] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6, 4], type: [jn, Qn, W1] }, r[Pu] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6], type: [jn, Qn] }, r[_u] = { textureFormat: qn, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [jn] }, r[Qu] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [3], type: [Zn] }, r[Du] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [3], type: [or] }, r[$u] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [6], type: [Ir] }, r[qu] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [6], type: [ti] }, r[t1] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [fr] }, r[e1] = { textureFormat: Yr, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [ei] }, r[n1] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [Zn] }, r[r1] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [Zn] }, r[i1] = { textureFormat: Vn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [4], type: [or] }, r[o1] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 2, 4], type: [Zn, bs, qi] }, r[s1] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 2], type: [Zn, ps] }, r[l1] = { textureFormat: Vn, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [qi] }, r[c1] = { textureFormat: Vn, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [16, 8], type: [jn, Qn] }, r[u1] = { textureFormat: Vn, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [16], type: [jn] }, r[a1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Zn] }, r[d1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [or] }, r[h1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [qi] }, r[f1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [Ir] }, r[m1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [ti] }, r[p1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [16], type: [ei] }, r[b1] = { textureFormat: mr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [16], type: [fr] }, r[y1] = { textureFormat: Lr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2, 4], type: [Ir, fr] }, r[g1] = { textureFormat: Lr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [fr] }, r[Z1] = { textureFormat: Lr, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [jn] }, r[G1] = { textureFormat: fs, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [R1] }, r[v1] = { textureFormat: fs, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [V1] }, Object.keys(r).forEach(function(n) {
      const m = r[n];
      m.bytesPerElementMap = {}, m.bytesPerElement.forEach(function(X, S) {
        const C = m.type[S];
        m.bytesPerElementMap[C] = X;
      });
    }), to = r;
  }
  return to[i];
}
function x1(i, r) {
  const n = Ci(i);
  if (!n)
    throw "unknown internal format";
  const m = n.bytesPerElementMap[r];
  if (m === void 0)
    throw "unknown internal format";
  return m;
}
function Pr(i) {
  const r = Ci(i);
  if (!r)
    throw "unknown internal format";
  return {
    format: r.textureFormat,
    type: r.type[0]
  };
}
function gs(i) {
  return (i & i - 1) === 0;
}
function I1(i, r, n, m) {
  if (!Or(i))
    return gs(r) && gs(n);
  const X = Ci(m);
  if (!X)
    throw "unknown internal format";
  return X.colorRenderable && X.textureFilterable;
}
function S1(i) {
  const r = Ci(i);
  if (!r)
    throw "unknown internal format";
  return r.textureFilterable;
}
function w1(i, r, n) {
  return Mr(r) ? So(r) : n || Zn;
}
function ii(i, r, n, m, X) {
  if (X % 1 !== 0)
    throw "can't guess dimensions";
  if (!n && !m) {
    const S = Math.sqrt(X / (r === cr ? 6 : 1));
    S % 1 === 0 ? (n = S, m = S) : (n = X, m = 1);
  } else if (m) {
    if (!n && (n = X / m, n % 1))
      throw "can't guess dimensions";
  } else if (m = X / n, m % 1)
    throw "can't guess dimensions";
  return {
    width: n,
    height: m
  };
}
function Hr(i, r) {
  r.colorspaceConversion !== void 0 && i.pixelStorei(Zu, r.colorspaceConversion), r.premultiplyAlpha !== void 0 && i.pixelStorei(vu, r.premultiplyAlpha), r.flipY !== void 0 && i.pixelStorei(Gu, r.flipY);
}
function Ds(i) {
  i.pixelStorei(Fo, 4), Or(i) && (i.pixelStorei(zs, 0), i.pixelStorei(Os, 0), i.pixelStorei(Ps, 0), i.pixelStorei(_s, 0), i.pixelStorei(Qs, 0));
}
function Y1(i, r, n, m) {
  m.minMag && (n.call(i, r, oo, m.minMag), n.call(i, r, so, m.minMag)), m.min && n.call(i, r, oo, m.min), m.mag && n.call(i, r, so, m.mag), m.wrap && (n.call(i, r, Yi, m.wrap), n.call(i, r, Ti, m.wrap), (r === vr || kc(i, r)) && n.call(i, r, ms, m.wrap)), m.wrapR && n.call(i, r, ms, m.wrapR), m.wrapS && n.call(i, r, Yi, m.wrapS), m.wrapT && n.call(i, r, Ti, m.wrapT), m.minLod && n.call(i, r, pu, m.minLod), m.maxLod && n.call(i, r, bu, m.maxLod), m.baseLevel && n.call(i, r, yu, m.baseLevel), m.maxLevel && n.call(i, r, gu, m.maxLevel);
}
function $s(i, r, n) {
  const m = n.target || ar;
  i.bindTexture(m, r), Y1(i, m, i.texParameteri, n);
}
function T1(i) {
  return i = i || ur.textureColor, Mr(i) ? i : new Uint8Array([i[0] * 255, i[1] * 255, i[2] * 255, i[3] * 255]);
}
function lo(i, r, n, m, X, S) {
  n = n || ur.textureOptions, S = S || Vn;
  const C = n.target || ar;
  if (m = m || n.width, X = X || n.height, i.bindTexture(C, r), I1(i, m, X, S))
    i.generateMipmap(C);
  else {
    const T = S1(S) ? uu : cu;
    i.texParameteri(C, oo, T), i.texParameteri(C, so, T), i.texParameteri(C, Yi, wi), i.texParameteri(C, Ti, wi);
  }
}
function Ar(i) {
  return i.auto === !0 || i.auto === void 0 && i.level === void 0;
}
function co(i, r) {
  return r = r || {}, r.cubeFaceOrder || [
    To,
    au,
    du,
    hu,
    fu,
    mu
  ];
}
function uo(i, r) {
  const m = co(i, r).map(function(X, S) {
    return { face: X, ndx: S };
  });
  return m.sort(function(X, S) {
    return X.face - S.face;
  }), m;
}
function qs(i, r, n, m) {
  m = m || ur.textureOptions;
  const X = m.target || ar, S = m.level || 0;
  let C = n.width, T = n.height;
  const B = m.internalFormat || m.format || Vn, nt = Pr(B), ut = m.format || nt.format, pt = m.type || nt.type;
  if (Hr(i, m), i.bindTexture(X, r), X === cr) {
    const Tt = n.width, Ht = n.height;
    let at, mt;
    if (Tt / 6 === Ht)
      at = Ht, mt = [0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5, 0];
    else if (Ht / 6 === Tt)
      at = Tt, mt = [0, 0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5];
    else if (Tt / 3 === Ht / 2)
      at = Tt / 3, mt = [0, 0, 1, 0, 2, 0, 0, 1, 1, 1, 2, 1];
    else if (Tt / 2 === Ht / 3)
      at = Tt / 2, mt = [0, 0, 1, 0, 0, 1, 1, 1, 0, 2, 1, 2];
    else
      throw "can't figure out cube map from element: " + (n.src ? n.src : n.nodeName);
    const Bt = js();
    Bt ? (Bt.canvas.width = at, Bt.canvas.height = at, C = at, T = at, uo(i, m).forEach(function(kt) {
      const ee = mt[kt.ndx * 2 + 0] * at, P = mt[kt.ndx * 2 + 1] * at;
      Bt.drawImage(n, ee, P, at, at, 0, 0, at, at), i.texImage2D(kt.face, S, B, ut, pt, Bt.canvas);
    }), Bt.canvas.width = 1, Bt.canvas.height = 1) : typeof createImageBitmap < "u" && (C = at, T = at, uo(i, m).forEach(function(kt) {
      const ee = mt[kt.ndx * 2 + 0] * at, P = mt[kt.ndx * 2 + 1] * at;
      i.texImage2D(kt.face, S, B, at, at, 0, ut, pt, null), createImageBitmap(n, ee, P, at, at, {
        premultiplyAlpha: "none",
        colorSpaceConversion: "none"
      }).then(function(De) {
        Hr(i, m), i.bindTexture(X, r), i.texImage2D(kt.face, S, B, ut, pt, De), Ar(m) && lo(i, r, m, C, T, B);
      });
    }));
  } else if (X === vr || X === Gr) {
    const Tt = Math.min(n.width, n.height), Ht = Math.max(n.width, n.height), at = Ht / Tt;
    if (at % 1 !== 0)
      throw "can not compute 3D dimensions of element";
    const mt = n.width === Ht ? 1 : 0, Bt = n.height === Ht ? 1 : 0;
    i.pixelStorei(Fo, 1), i.pixelStorei(zs, n.width), i.pixelStorei(Os, 0), i.pixelStorei(Qs, 0), i.texImage3D(X, S, B, Tt, Tt, Tt, 0, ut, pt, null);
    for (let kt = 0; kt < at; ++kt) {
      const ee = kt * Tt * mt, P = kt * Tt * Bt;
      i.pixelStorei(Ps, ee), i.pixelStorei(_s, P), i.texSubImage3D(X, S, 0, 0, kt, Tt, Tt, 1, ut, pt, n);
    }
    Ds(i);
  } else
    i.texImage2D(X, S, B, ut, pt, n);
  Ar(m) && lo(i, r, m, C, T, B), $s(i, r, m);
}
function _r() {
}
function F1(i) {
  if (typeof document < "u") {
    const r = document.createElement("a");
    return r.href = i, r.hostname === location.hostname && r.port === location.port && r.protocol === location.protocol;
  } else {
    const r = new URL(location.href).origin;
    return new URL(i, location.href).origin === r;
  }
}
function H1(i, r) {
  return r === void 0 && !F1(i) ? "anonymous" : r;
}
function L1(i, r, n) {
  n = n || _r;
  let m;
  if (r = r !== void 0 ? r : ur.crossOrigin, r = H1(i, r), typeof Image < "u") {
    m = new Image(), r !== void 0 && (m.crossOrigin = r);
    const X = function() {
      m.removeEventListener("error", S), m.removeEventListener("load", C), m = null;
    }, S = function() {
      const B = "couldn't load image: " + i;
      Js(B), n(B, m), X();
    }, C = function() {
      n(null, m), X();
    };
    return m.addEventListener("error", S), m.addEventListener("load", C), m.src = i, m;
  } else if (typeof ImageBitmap < "u") {
    let X, S;
    const C = function() {
      n(X, S);
    }, T = {};
    r && (T.mode = "cors"), fetch(i, T).then(function(B) {
      if (!B.ok)
        throw B;
      return B.blob();
    }).then(function(B) {
      return createImageBitmap(B, {
        premultiplyAlpha: "none",
        colorSpaceConversion: "none"
      });
    }).then(function(B) {
      S = B, setTimeout(C);
    }).catch(function(B) {
      X = B, setTimeout(C);
    }), m = null;
  }
  return m;
}
function tl(i) {
  return typeof ImageBitmap < "u" && i instanceof ImageBitmap || typeof ImageData < "u" && i instanceof ImageData || typeof HTMLElement < "u" && i instanceof HTMLElement;
}
function Ho(i, r, n) {
  return tl(i) ? (setTimeout(function() {
    n(null, i);
  }), i) : L1(i, r, n);
}
function Lo(i, r, n) {
  n = n || ur.textureOptions;
  const m = n.target || ar;
  if (i.bindTexture(m, r), n.color === !1)
    return;
  const X = T1(n.color);
  if (m === cr)
    for (let S = 0; S < 6; ++S)
      i.texImage2D(To + S, 0, Vn, 1, 1, 0, Vn, Zn, X);
  else
    m === vr || m === Gr ? i.texImage3D(m, 0, Vn, 1, 1, 1, 0, Vn, Zn, X) : i.texImage2D(m, 0, Vn, 1, 1, 0, Vn, Zn, X);
}
function C1(i, r, n, m) {
  return m = m || _r, n = n || ur.textureOptions, Lo(i, r, n), n = Object.assign({}, n), Ho(n.src, n.crossOrigin, function(S, C) {
    S ? m(S, r, C) : (qs(i, r, C, n), m(null, r, C));
  });
}
function N1(i, r, n, m) {
  m = m || _r;
  const X = n.src;
  if (X.length !== 6)
    throw "there must be 6 urls for a cubemap";
  const S = n.level || 0, C = n.internalFormat || n.format || Vn, T = Pr(C), B = n.format || T.format, nt = n.type || Zn, ut = n.target || ar;
  if (ut !== cr)
    throw "target must be TEXTURE_CUBE_MAP";
  Lo(i, r, n), n = Object.assign({}, n);
  let pt = 6;
  const Tt = [], Ht = co(i, n);
  let at;
  function mt(Bt) {
    return function(kt, ee) {
      --pt, kt ? Tt.push(kt) : ee.width !== ee.height ? Tt.push("cubemap face img is not a square: " + ee.src) : (Hr(i, n), i.bindTexture(ut, r), pt === 5 ? co().forEach(function(P) {
        i.texImage2D(P, S, C, B, nt, ee);
      }) : i.texImage2D(Bt, S, C, B, nt, ee), Ar(n) && i.generateMipmap(ut)), pt === 0 && m(Tt.length ? Tt : void 0, r, at);
    };
  }
  at = X.map(function(Bt, kt) {
    return Ho(Bt, n.crossOrigin, mt(Ht[kt]));
  });
}
function J1(i, r, n, m) {
  m = m || _r;
  const X = n.src, S = n.internalFormat || n.format || Vn, C = Pr(S), T = n.format || C.format, B = n.type || Zn, nt = n.target || Gr;
  if (nt !== vr && nt !== Gr)
    throw "target must be TEXTURE_3D or TEXTURE_2D_ARRAY";
  Lo(i, r, n), n = Object.assign({}, n);
  let ut = X.length;
  const pt = [];
  let Tt;
  const Ht = n.level || 0;
  let at = n.width, mt = n.height;
  const Bt = X.length;
  let kt = !0;
  function ee(P) {
    return function(De, je) {
      if (--ut, De)
        pt.push(De);
      else {
        if (Hr(i, n), i.bindTexture(nt, r), kt) {
          kt = !1, at = n.width || je.width, mt = n.height || je.height, i.texImage3D(nt, Ht, S, at, mt, Bt, 0, T, B, null);
          for (let We = 0; We < Bt; ++We)
            i.texSubImage3D(nt, Ht, 0, 0, We, at, mt, 1, T, B, je);
        } else {
          let We = je, jt;
          (je.width !== at || je.height !== mt) && (jt = js(), We = jt.canvas, jt.canvas.width = at, jt.canvas.height = mt, jt.drawImage(je, 0, 0, at, mt)), i.texSubImage3D(nt, Ht, 0, 0, P, at, mt, 1, T, B, We), jt && We === jt.canvas && (jt.canvas.width = 0, jt.canvas.height = 0);
        }
        Ar(n) && i.generateMipmap(nt);
      }
      ut === 0 && m(pt.length ? pt : void 0, r, Tt);
    };
  }
  Tt = X.map(function(P, De) {
    return Ho(P, n.crossOrigin, ee(De));
  });
}
function k1(i, r, n, m) {
  m = m || ur.textureOptions;
  const X = m.target || ar;
  i.bindTexture(X, r);
  let S = m.width, C = m.height, T = m.depth;
  const B = m.level || 0, nt = m.internalFormat || m.format || Vn, ut = Pr(nt), pt = m.format || ut.format, Tt = m.type || w1(i, n, ut.type);
  if (Mr(n))
    n instanceof Uint8ClampedArray && (n = new Uint8Array(n.buffer));
  else {
    const Bt = Ns(Tt);
    n = new Bt(n);
  }
  const Ht = x1(nt, Tt), at = n.byteLength / Ht;
  if (at % 1)
    throw "length wrong size for format: " + Ks(i, pt);
  let mt;
  if (X === vr || X === Gr)
    if (!S && !C && !T) {
      const Bt = Math.cbrt(at);
      if (Bt % 1 !== 0)
        throw "can't guess cube size of array of numElements: " + at;
      S = Bt, C = Bt, T = Bt;
    } else
      S && (!C || !T) ? (mt = ii(i, X, C, T, at / S), C = mt.width, T = mt.height) : C && (!S || !T) ? (mt = ii(i, X, S, T, at / C), S = mt.width, T = mt.height) : (mt = ii(i, X, S, C, at / T), S = mt.width, C = mt.height);
  else
    mt = ii(i, X, S, C, at), S = mt.width, C = mt.height;
  if (Ds(i), i.pixelStorei(Fo, m.unpackAlignment || 1), Hr(i, m), X === cr) {
    const Bt = Ht / n.BYTES_PER_ELEMENT, kt = at / 6 * Bt;
    uo(i, m).forEach((ee) => {
      const P = kt * ee.ndx, De = n.subarray(P, P + kt);
      i.texImage2D(ee.face, B, nt, S, C, 0, pt, Tt, De);
    });
  } else
    X === vr || X === Gr ? i.texImage3D(X, B, nt, S, C, T, 0, pt, Tt, n) : i.texImage2D(X, B, nt, S, C, 0, pt, Tt, n);
  return {
    width: S,
    height: C,
    depth: T,
    type: Tt
  };
}
function U1(i, r, n) {
  const m = n.target || ar;
  i.bindTexture(m, r);
  const X = n.level || 0, S = n.internalFormat || n.format || Vn, C = Pr(S), T = n.format || C.format, B = n.type || C.type;
  if (Hr(i, n), m === cr)
    for (let nt = 0; nt < 6; ++nt)
      i.texImage2D(To + nt, X, S, n.width, n.height, 0, T, B, null);
  else
    m === vr || m === Gr ? i.texImage3D(m, X, S, n.width, n.height, n.depth, 0, T, B, null) : i.texImage2D(m, X, S, n.width, n.height, 0, T, B, null);
}
function el(i, r, n) {
  n = n || _r, r = r || ur.textureOptions;
  const m = i.createTexture(), X = r.target || ar;
  let S = r.width || 1, C = r.height || 1;
  const T = r.internalFormat || Vn;
  i.bindTexture(X, m), X === cr && (i.texParameteri(X, Yi, wi), i.texParameteri(X, Ti, wi));
  let B = r.src;
  if (B)
    if (typeof B == "function" && (B = B(i, r)), typeof B == "string")
      C1(i, m, r, n);
    else if (Mr(B) || Array.isArray(B) && (typeof B[0] == "number" || Array.isArray(B[0]) || Mr(B[0]))) {
      const nt = k1(i, m, B, r);
      S = nt.width, C = nt.height;
    } else
      Array.isArray(B) && (typeof B[0] == "string" || tl(B[0])) ? X === cr ? N1(i, m, r, n) : J1(i, m, r, n) : (qs(i, m, B, r), S = B.width, C = B.height);
  else
    U1(i, m, r);
  return Ar(r) && lo(i, m, r, S, C, T), $s(i, m, r), m;
}
const Co = Js;
function nl(i) {
  return typeof document < "u" && document.getElementById ? document.getElementById(i) : null;
}
const Fi = 33984, Ni = 34962, E1 = 34963, B1 = 35713, M1 = 35714, A1 = 35632, K1 = 35633, j1 = 35981, rl = 35718, z1 = 35721, O1 = 35971, P1 = 35382, _1 = 35396, Q1 = 35398, D1 = 35392, $1 = 35395, Ji = 5126, il = 35664, ol = 35665, sl = 35666, No = 5124, ll = 35667, cl = 35668, ul = 35669, al = 35670, dl = 35671, hl = 35672, fl = 35673, ml = 35674, pl = 35675, bl = 35676, q1 = 35678, ta = 35680, ea = 35679, na = 35682, ra = 35685, ia = 35686, oa = 35687, sa = 35688, la = 35689, ca = 35690, ua = 36289, aa = 36292, da = 36293, Jo = 5125, yl = 36294, gl = 36295, Zl = 36296, ha = 36298, fa = 36299, ma = 36300, pa = 36303, ba = 36306, ya = 36307, ga = 36308, Za = 36311, ki = 3553, Ui = 34067, ko = 32879, Ei = 35866, ge = {};
function vl(i, r) {
  return ge[r].bindPoint;
}
function va(i, r) {
  return function(n) {
    i.uniform1f(r, n);
  };
}
function Ga(i, r) {
  return function(n) {
    i.uniform1fv(r, n);
  };
}
function Xa(i, r) {
  return function(n) {
    i.uniform2fv(r, n);
  };
}
function Wa(i, r) {
  return function(n) {
    i.uniform3fv(r, n);
  };
}
function Va(i, r) {
  return function(n) {
    i.uniform4fv(r, n);
  };
}
function Gl(i, r) {
  return function(n) {
    i.uniform1i(r, n);
  };
}
function Xl(i, r) {
  return function(n) {
    i.uniform1iv(r, n);
  };
}
function Wl(i, r) {
  return function(n) {
    i.uniform2iv(r, n);
  };
}
function Vl(i, r) {
  return function(n) {
    i.uniform3iv(r, n);
  };
}
function Rl(i, r) {
  return function(n) {
    i.uniform4iv(r, n);
  };
}
function Ra(i, r) {
  return function(n) {
    i.uniform1ui(r, n);
  };
}
function xa(i, r) {
  return function(n) {
    i.uniform1uiv(r, n);
  };
}
function Ia(i, r) {
  return function(n) {
    i.uniform2uiv(r, n);
  };
}
function Sa(i, r) {
  return function(n) {
    i.uniform3uiv(r, n);
  };
}
function wa(i, r) {
  return function(n) {
    i.uniform4uiv(r, n);
  };
}
function Ya(i, r) {
  return function(n) {
    i.uniformMatrix2fv(r, !1, n);
  };
}
function Ta(i, r) {
  return function(n) {
    i.uniformMatrix3fv(r, !1, n);
  };
}
function Fa(i, r) {
  return function(n) {
    i.uniformMatrix4fv(r, !1, n);
  };
}
function Ha(i, r) {
  return function(n) {
    i.uniformMatrix2x3fv(r, !1, n);
  };
}
function La(i, r) {
  return function(n) {
    i.uniformMatrix3x2fv(r, !1, n);
  };
}
function Ca(i, r) {
  return function(n) {
    i.uniformMatrix2x4fv(r, !1, n);
  };
}
function Na(i, r) {
  return function(n) {
    i.uniformMatrix4x2fv(r, !1, n);
  };
}
function Ja(i, r) {
  return function(n) {
    i.uniformMatrix3x4fv(r, !1, n);
  };
}
function ka(i, r) {
  return function(n) {
    i.uniformMatrix4x3fv(r, !1, n);
  };
}
function zn(i, r, n, m) {
  const X = vl(i, r);
  return Or(i) ? function(S) {
    let C, T;
    wo(i, S) ? (C = S, T = null) : (C = S.texture, T = S.sampler), i.uniform1i(m, n), i.activeTexture(Fi + n), i.bindTexture(X, C), i.bindSampler(n, T);
  } : function(S) {
    i.uniform1i(m, n), i.activeTexture(Fi + n), i.bindTexture(X, S);
  };
}
function On(i, r, n, m, X) {
  const S = vl(i, r), C = new Int32Array(X);
  for (let T = 0; T < X; ++T)
    C[T] = n + T;
  return Or(i) ? function(T) {
    i.uniform1iv(m, C), T.forEach(function(B, nt) {
      i.activeTexture(Fi + C[nt]);
      let ut, pt;
      wo(i, B) ? (ut = B, pt = null) : (ut = B.texture, pt = B.sampler), i.bindSampler(n, pt), i.bindTexture(S, ut);
    });
  } : function(T) {
    i.uniform1iv(m, C), T.forEach(function(B, nt) {
      i.activeTexture(Fi + C[nt]), i.bindTexture(S, B);
    });
  };
}
ge[Ji] = { Type: Float32Array, size: 4, setter: va, arraySetter: Ga };
ge[il] = { Type: Float32Array, size: 8, setter: Xa, cols: 2 };
ge[ol] = { Type: Float32Array, size: 12, setter: Wa, cols: 3 };
ge[sl] = { Type: Float32Array, size: 16, setter: Va, cols: 4 };
ge[No] = { Type: Int32Array, size: 4, setter: Gl, arraySetter: Xl };
ge[ll] = { Type: Int32Array, size: 8, setter: Wl, cols: 2 };
ge[cl] = { Type: Int32Array, size: 12, setter: Vl, cols: 3 };
ge[ul] = { Type: Int32Array, size: 16, setter: Rl, cols: 4 };
ge[Jo] = { Type: Uint32Array, size: 4, setter: Ra, arraySetter: xa };
ge[yl] = { Type: Uint32Array, size: 8, setter: Ia, cols: 2 };
ge[gl] = { Type: Uint32Array, size: 12, setter: Sa, cols: 3 };
ge[Zl] = { Type: Uint32Array, size: 16, setter: wa, cols: 4 };
ge[al] = { Type: Uint32Array, size: 4, setter: Gl, arraySetter: Xl };
ge[dl] = { Type: Uint32Array, size: 8, setter: Wl, cols: 2 };
ge[hl] = { Type: Uint32Array, size: 12, setter: Vl, cols: 3 };
ge[fl] = { Type: Uint32Array, size: 16, setter: Rl, cols: 4 };
ge[ml] = { Type: Float32Array, size: 32, setter: Ya, rows: 2, cols: 2 };
ge[pl] = { Type: Float32Array, size: 48, setter: Ta, rows: 3, cols: 3 };
ge[bl] = { Type: Float32Array, size: 64, setter: Fa, rows: 4, cols: 4 };
ge[ra] = { Type: Float32Array, size: 32, setter: Ha, rows: 2, cols: 3 };
ge[ia] = { Type: Float32Array, size: 32, setter: Ca, rows: 2, cols: 4 };
ge[oa] = { Type: Float32Array, size: 48, setter: La, rows: 3, cols: 2 };
ge[sa] = { Type: Float32Array, size: 48, setter: Ja, rows: 3, cols: 4 };
ge[la] = { Type: Float32Array, size: 64, setter: Na, rows: 4, cols: 2 };
ge[ca] = { Type: Float32Array, size: 64, setter: ka, rows: 4, cols: 3 };
ge[q1] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ki };
ge[ta] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ui };
ge[ea] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ko };
ge[na] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ki };
ge[ua] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ei };
ge[aa] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ei };
ge[da] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ui };
ge[ha] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ki };
ge[fa] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ko };
ge[ma] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ui };
ge[pa] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ei };
ge[ba] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ki };
ge[ya] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: ko };
ge[ga] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ui };
ge[Za] = { Type: null, size: 0, setter: zn, arraySetter: On, bindPoint: Ei };
function Bi(i, r) {
  return function(n) {
    if (n.value)
      switch (i.disableVertexAttribArray(r), n.value.length) {
        case 4:
          i.vertexAttrib4fv(r, n.value);
          break;
        case 3:
          i.vertexAttrib3fv(r, n.value);
          break;
        case 2:
          i.vertexAttrib2fv(r, n.value);
          break;
        case 1:
          i.vertexAttrib1fv(r, n.value);
          break;
        default:
          throw new Error("the length of a float constant value must be between 1 and 4!");
      }
    else
      i.bindBuffer(Ni, n.buffer), i.enableVertexAttribArray(r), i.vertexAttribPointer(
        r,
        n.numComponents || n.size,
        n.type || Ji,
        n.normalize || !1,
        n.stride || 0,
        n.offset || 0
      ), i.vertexAttribDivisor && i.vertexAttribDivisor(r, n.divisor || 0);
  };
}
function dr(i, r) {
  return function(n) {
    if (n.value)
      if (i.disableVertexAttribArray(r), n.value.length === 4)
        i.vertexAttrib4iv(r, n.value);
      else
        throw new Error("The length of an integer constant value must be 4!");
    else
      i.bindBuffer(Ni, n.buffer), i.enableVertexAttribArray(r), i.vertexAttribIPointer(
        r,
        n.numComponents || n.size,
        n.type || No,
        n.stride || 0,
        n.offset || 0
      ), i.vertexAttribDivisor && i.vertexAttribDivisor(r, n.divisor || 0);
  };
}
function Mi(i, r) {
  return function(n) {
    if (n.value)
      if (i.disableVertexAttribArray(r), n.value.length === 4)
        i.vertexAttrib4uiv(r, n.value);
      else
        throw new Error("The length of an unsigned integer constant value must be 4!");
    else
      i.bindBuffer(Ni, n.buffer), i.enableVertexAttribArray(r), i.vertexAttribIPointer(
        r,
        n.numComponents || n.size,
        n.type || Jo,
        n.stride || 0,
        n.offset || 0
      ), i.vertexAttribDivisor && i.vertexAttribDivisor(r, n.divisor || 0);
  };
}
function Uo(i, r, n) {
  const m = n.size, X = n.count;
  return function(S) {
    i.bindBuffer(Ni, S.buffer);
    const C = S.size || S.numComponents || m, T = C / X, B = S.type || Ji, ut = ge[B].size * C, pt = S.normalize || !1, Tt = S.offset || 0, Ht = ut / X;
    for (let at = 0; at < X; ++at)
      i.enableVertexAttribArray(r + at), i.vertexAttribPointer(
        r + at,
        T,
        B,
        pt,
        ut,
        Tt + Ht * at
      ), i.vertexAttribDivisor && i.vertexAttribDivisor(r + at, S.divisor || 0);
  };
}
const Ln = {};
Ln[Ji] = { size: 4, setter: Bi };
Ln[il] = { size: 8, setter: Bi };
Ln[ol] = { size: 12, setter: Bi };
Ln[sl] = { size: 16, setter: Bi };
Ln[No] = { size: 4, setter: dr };
Ln[ll] = { size: 8, setter: dr };
Ln[cl] = { size: 12, setter: dr };
Ln[ul] = { size: 16, setter: dr };
Ln[Jo] = { size: 4, setter: Mi };
Ln[yl] = { size: 8, setter: Mi };
Ln[gl] = { size: 12, setter: Mi };
Ln[Zl] = { size: 16, setter: Mi };
Ln[al] = { size: 4, setter: dr };
Ln[dl] = { size: 8, setter: dr };
Ln[hl] = { size: 12, setter: dr };
Ln[fl] = { size: 16, setter: dr };
Ln[ml] = { size: 4, setter: Uo, count: 2 };
Ln[pl] = { size: 9, setter: Uo, count: 3 };
Ln[bl] = { size: 16, setter: Uo, count: 4 };
const Ua = /ERROR:\s*\d+:(\d+)/gi;
function Ea(i, r = "", n = 0) {
  const m = [...r.matchAll(Ua)], X = new Map(m.map((S, C) => {
    const T = parseInt(S[1]), B = m[C + 1], nt = B ? B.index : r.length, ut = r.substring(S.index, nt);
    return [T - 1, ut];
  }));
  return i.split(`
`).map((S, C) => {
    const T = X.get(C);
    return `${C + 1 + n}: ${S}${T ? `

^^^ ${T}` : ""}`;
  }).join(`
`);
}
const Zs = /^[ \t]*\n/;
function xl(i) {
  let r = 0;
  return Zs.test(i) && (r = 1, i = i.replace(Zs, "")), { lineOffset: r, shaderSource: i };
}
function Ba(i, r) {
  return i.errorCallback(r), i.callback && setTimeout(() => {
    i.callback(`${r}
${i.errors.join(`
`)}`);
  }), null;
}
function Ma(i, r, n, m) {
  if (m = m || Co, !i.getShaderParameter(n, B1)) {
    const S = i.getShaderInfoLog(n), { lineOffset: C, shaderSource: T } = xl(i.getShaderSource(n)), B = `${Ea(T, S, C)}
Error compiling ${Ks(i, r)}: ${S}`;
    return m(B), B;
  }
  return "";
}
function Eo(i, r, n) {
  let m, X, S;
  if (typeof r == "function" && (n = r, r = void 0), typeof i == "function")
    n = i, i = void 0;
  else if (i && !Array.isArray(i)) {
    const nt = i;
    n = nt.errorCallback, i = nt.attribLocations, m = nt.transformFeedbackVaryings, X = nt.transformFeedbackMode, S = nt.callback;
  }
  const C = n || Co, T = [], B = {
    errorCallback(nt, ...ut) {
      T.push(nt), C(nt, ...ut);
    },
    transformFeedbackVaryings: m,
    transformFeedbackMode: X,
    callback: S,
    errors: T
  };
  {
    let nt = {};
    Array.isArray(i) ? i.forEach(function(ut, pt) {
      nt[ut] = r ? r[pt] : pt;
    }) : nt = i || {}, B.attribLocations = nt;
  }
  return B;
}
const Aa = [
  "VERTEX_SHADER",
  "FRAGMENT_SHADER"
];
function Ka(i, r) {
  if (r.indexOf("frag") >= 0)
    return A1;
  if (r.indexOf("vert") >= 0)
    return K1;
}
function ja(i, r, n) {
  const m = i.getAttachedShaders(r);
  for (const X of m)
    n.has(X) && i.deleteShader(X);
  i.deleteProgram(r);
}
const za = (i = 0) => new Promise((r) => setTimeout(r, i));
function Oa(i, r, n) {
  const m = i.createProgram(), {
    attribLocations: X,
    transformFeedbackVaryings: S,
    transformFeedbackMode: C
  } = Eo(n);
  for (let T = 0; T < r.length; ++T) {
    let B = r[T];
    if (typeof B == "string") {
      const nt = nl(B), ut = nt ? nt.text : B;
      let pt = i[Aa[T]];
      nt && nt.type && (pt = Ka(i, nt.type) || pt), B = i.createShader(pt), i.shaderSource(B, xl(ut).shaderSource), i.compileShader(B), i.attachShader(m, B);
    }
  }
  Object.entries(X).forEach(([T, B]) => i.bindAttribLocation(m, B, T));
  {
    let T = S;
    T && (T.attribs && (T = T.attribs), Array.isArray(T) || (T = Object.keys(T)), i.transformFeedbackVaryings(m, T, C || j1));
  }
  return i.linkProgram(m), m;
}
function Pa(i, r, n, m, X) {
  const S = Eo(n, m, X), C = new Set(r), T = Oa(i, r, S);
  function B(nt, ut) {
    const pt = Qa(nt, ut, S.errorCallback);
    return pt && ja(nt, ut, C), pt;
  }
  if (S.callback) {
    _a(i, T).then(() => {
      const nt = B(i, T);
      S.callback(nt, nt ? void 0 : T);
    });
    return;
  }
  return B(i, T) ? void 0 : T;
}
async function _a(i, r) {
  const n = i.getExtension("KHR_parallel_shader_compile"), m = n ? (S, C) => S.getProgramParameter(C, n.COMPLETION_STATUS_KHR) : () => !0;
  let X = 0;
  do
    await za(X), X = 1e3 / 60;
  while (!m(i, r));
}
function Qa(i, r, n) {
  if (n = n || Co, !i.getProgramParameter(r, M1)) {
    const X = i.getProgramInfoLog(r);
    n(`Error in program linking: ${X}`);
    const C = i.getAttachedShaders(r).map((T) => Ma(i, i.getShaderParameter(T, i.SHADER_TYPE), T, n));
    return `${X}
${C.filter((T) => T).join(`
`)}`;
  }
}
function Da(i, r, n, m, X) {
  return Pa(i, r, n, m, X);
}
function Il(i) {
  const r = i.name;
  return r.startsWith("gl_") || r.startsWith("webgl_");
}
const $a = /(\.|\[|]|\w+)/g, qa = (i) => i >= "0" && i <= "9";
function t0(i, r, n, m) {
  const X = i.split($a).filter((T) => T !== "");
  let S = 0, C = "";
  for (; ; ) {
    const T = X[S++];
    C += T;
    const B = qa(T[0]), nt = B ? parseInt(T) : T;
    if (B && (C += X[S++]), S === X.length) {
      n[nt] = r;
      break;
    } else {
      const pt = X[S++], Tt = pt === "[", Ht = n[nt] || (Tt ? [] : {});
      n[nt] = Ht, n = Ht, m[C] = m[C] || function(at) {
        return function(mt) {
          Sl(at, mt);
        };
      }(Ht), C += pt;
    }
  }
}
function e0(i, r) {
  let n = 0;
  function m(T, B, nt) {
    const ut = B.name.endsWith("[0]"), pt = B.type, Tt = ge[pt];
    if (!Tt)
      throw new Error(`unknown type: 0x${pt.toString(16)}`);
    let Ht;
    if (Tt.bindPoint) {
      const at = n;
      n += B.size, ut ? Ht = Tt.arraySetter(i, pt, at, nt, B.size) : Ht = Tt.setter(i, pt, at, nt, B.size);
    } else
      Tt.arraySetter && ut ? Ht = Tt.arraySetter(i, nt) : Ht = Tt.setter(i, nt);
    return Ht.location = nt, Ht;
  }
  const X = {}, S = {}, C = i.getProgramParameter(r, rl);
  for (let T = 0; T < C; ++T) {
    const B = i.getActiveUniform(r, T);
    if (Il(B))
      continue;
    let nt = B.name;
    nt.endsWith("[0]") && (nt = nt.substr(0, nt.length - 3));
    const ut = i.getUniformLocation(r, B.name);
    if (ut) {
      const pt = m(r, B, ut);
      X[nt] = pt, t0(nt, pt, S, X);
    }
  }
  return X;
}
function n0(i, r) {
  const n = {}, m = i.getProgramParameter(r, O1);
  for (let X = 0; X < m; ++X) {
    const S = i.getTransformFeedbackVarying(r, X);
    n[S.name] = {
      index: X,
      type: S.type,
      size: S.size
    };
  }
  return n;
}
function r0(i, r) {
  const n = i.getProgramParameter(r, rl), m = [], X = [];
  for (let T = 0; T < n; ++T) {
    X.push(T), m.push({});
    const B = i.getActiveUniform(r, T);
    m[T].name = B.name;
  }
  [
    ["UNIFORM_TYPE", "type"],
    ["UNIFORM_SIZE", "size"],
    ["UNIFORM_BLOCK_INDEX", "blockNdx"],
    ["UNIFORM_OFFSET", "offset"]
  ].forEach(function(T) {
    const B = T[0], nt = T[1];
    i.getActiveUniforms(r, X, i[B]).forEach(function(ut, pt) {
      m[pt][nt] = ut;
    });
  });
  const S = {}, C = i.getProgramParameter(r, P1);
  for (let T = 0; T < C; ++T) {
    const B = i.getActiveUniformBlockName(r, T), nt = {
      index: i.getUniformBlockIndex(r, B),
      usedByVertexShader: i.getActiveUniformBlockParameter(r, T, _1),
      usedByFragmentShader: i.getActiveUniformBlockParameter(r, T, Q1),
      size: i.getActiveUniformBlockParameter(r, T, D1),
      uniformIndices: i.getActiveUniformBlockParameter(r, T, $1)
    };
    nt.used = nt.usedByVertexShader || nt.usedByFragmentShader, S[B] = nt;
  }
  return {
    blockSpecs: S,
    uniformData: m
  };
}
function Sl(i, r) {
  for (const n in r) {
    const m = i[n];
    typeof m == "function" ? m(r[n]) : Sl(i[n], r[n]);
  }
}
function wl(i, ...r) {
  const n = i.uniformSetters || i, m = r.length;
  for (let X = 0; X < m; ++X) {
    const S = r[X];
    if (Array.isArray(S)) {
      const C = S.length;
      for (let T = 0; T < C; ++T)
        wl(n, S[T]);
    } else
      for (const C in S) {
        const T = n[C];
        T && T(S[C]);
      }
  }
}
function i0(i, r) {
  const n = {}, m = i.getProgramParameter(r, z1);
  for (let X = 0; X < m; ++X) {
    const S = i.getActiveAttrib(r, X);
    if (Il(S))
      continue;
    const C = i.getAttribLocation(r, S.name), T = Ln[S.type], B = T.setter(i, C, T);
    B.location = C, n[S.name] = B;
  }
  return n;
}
function o0(i, r) {
  for (const n in r) {
    const m = i[n];
    m && m(r[n]);
  }
}
function s0(i, r, n) {
  n.vertexArrayObject ? i.bindVertexArray(n.vertexArrayObject) : (o0(r.attribSetters || r, n.attribs), n.indices && i.bindBuffer(E1, n.indices));
}
function vs(i, r) {
  const n = e0(i, r), m = i0(i, r), X = {
    program: r,
    uniformSetters: n,
    attribSetters: m
  };
  return Or(i) && (X.uniformBlockSpec = r0(i, r), X.transformFeedbackInfo = n0(i, r)), X;
}
const l0 = /\s|{|}|;/;
function c0(i, r, n, m, X) {
  const S = Eo(n, m, X), C = [];
  if (r = r.map(function(nt) {
    if (!l0.test(nt)) {
      const ut = nl(nt);
      if (ut)
        nt = ut.text;
      else {
        const pt = `no element with id: ${nt}`;
        S.errorCallback(pt), C.push(pt);
      }
    }
    return nt;
  }), C.length)
    return Ba(S, "");
  const T = S.callback;
  T && (S.callback = (nt, ut) => {
    T(nt, nt ? void 0 : vs(i, ut));
  });
  const B = Da(i, r, S);
  return B ? vs(i, B) : null;
}
const u0 = 4, Gs = 5123;
function a0(i, r, n, m, X, S) {
  n = n === void 0 ? u0 : n;
  const C = r.indices, T = r.elementType, B = m === void 0 ? r.numElements : m;
  X = X === void 0 ? 0 : X, T || C ? S !== void 0 ? i.drawElementsInstanced(n, B, T === void 0 ? Gs : r.elementType, X, S) : i.drawElements(n, B, T === void 0 ? Gs : r.elementType, X) : S !== void 0 ? i.drawArraysInstanced(n, X, B, S) : i.drawArrays(n, X, B);
}
const Yl = 36160, oi = 36161, d0 = 3553, h0 = 5121, f0 = 6402, m0 = 6408, p0 = 33190, b0 = 36012, y0 = 35056, g0 = 36013, Z0 = 32854, v0 = 32855, G0 = 36194, Tl = 33189, Fl = 6401, Hl = 36168, Bo = 34041, ao = 36064, Ai = 36096, Ll = 36128, Mo = 33306, ho = 33071, fo = 9729, X0 = [
  { format: m0, type: h0, min: fo, wrap: ho },
  { format: Bo }
], $n = {};
$n[Bo] = Mo;
$n[Fl] = Ll;
$n[Hl] = Ll;
$n[f0] = Ai;
$n[Tl] = Ai;
$n[p0] = Ai;
$n[b0] = Ai;
$n[y0] = Mo;
$n[g0] = Mo;
function W0(i, r) {
  return $n[i] || $n[r];
}
const hr = {};
hr[Z0] = !0;
hr[v0] = !0;
hr[G0] = !0;
hr[Bo] = !0;
hr[Tl] = !0;
hr[Fl] = !0;
hr[Hl] = !0;
function V0(i) {
  return hr[i];
}
const R0 = 32;
function x0(i) {
  return i >= ao && i < ao + R0;
}
function Hi(i, r, n, m) {
  const X = Yl, S = i.createFramebuffer();
  i.bindFramebuffer(X, S), n = n || i.drawingBufferWidth, m = m || i.drawingBufferHeight, r = r || X0;
  const C = [], T = {
    framebuffer: S,
    attachments: [],
    width: n,
    height: m
  };
  return r.forEach(function(B, nt) {
    let ut = B.attachment;
    const pt = B.samples, Tt = B.format;
    let Ht = B.attachmentPoint || W0(Tt, B.internalFormat);
    if (Ht || (Ht = ao + nt), x0(Ht) && C.push(Ht), !ut)
      if (pt !== void 0 || V0(Tt))
        ut = i.createRenderbuffer(), i.bindRenderbuffer(oi, ut), pt > 1 ? i.renderbufferStorageMultisample(oi, pt, Tt, n, m) : i.renderbufferStorage(oi, Tt, n, m);
      else {
        const at = Object.assign({}, B);
        at.width = n, at.height = m, at.auto === void 0 && (at.auto = !1, at.min = at.min || at.minMag || fo, at.mag = at.mag || at.minMag || fo, at.wrapS = at.wrapS || at.wrap || ho, at.wrapT = at.wrapT || at.wrap || ho), ut = el(i, at);
      }
    if (Jc(i, ut))
      i.framebufferRenderbuffer(X, Ht, oi, ut);
    else if (wo(i, ut))
      B.layer !== void 0 ? i.framebufferTextureLayer(
        X,
        Ht,
        ut,
        B.level || 0,
        B.layer
      ) : i.framebufferTexture2D(
        X,
        Ht,
        B.target || d0,
        ut,
        B.level || 0
      );
    else
      throw new Error("unknown attachment type");
    T.attachments.push(ut);
  }), i.drawBuffers && i.drawBuffers(C), T;
}
function I0(i, r, n) {
  n = n || Yl, r ? (i.bindFramebuffer(n, r.framebuffer), i.viewport(0, 0, r.width, r.height)) : (i.bindFramebuffer(n, null), i.viewport(0, 0, i.drawingBufferWidth, i.drawingBufferHeight));
}
function bn(i, r) {
  return () => r instanceof WebGLTexture ? r : el(i, {
    src: r,
    wrap: i.CLAMP_TO_EDGE
  });
}
const Tr = 2;
class Xr {
  constructor(r) {
    Zt(this, "id", "_");
    Zt(this, "context");
    Zt(this, "output");
    Zt(this, "fbi");
    Zt(this, "options");
    Zt(this, "programInfo");
    Zt(this, "bufferInfo");
    Zt(this, "profiler");
    Zt(this, "lastRun");
    const { context: n, width: m, height: X } = r;
    this.context = n, this.options = r;
    const S = this.buildDefines();
    this.programInfo = c0(this.context, [
      S + this.getVertexShader(),
      S + this.getFragmentShader()
    ]), this.bufferInfo = lu(
      this.context,
      this.getBuffers()
    ), this.fbi = Hi(
      this.context,
      [
        {
          format: this.context.RGBA,
          type: this.context.UNSIGNED_BYTE,
          min: this.context.LINEAR,
          wrap: this.context.CLAMP_TO_EDGE
        }
      ],
      m,
      X
    ), this.output = this.fbi.attachments[0];
  }
  resizeOutput(r, n) {
    this.fbi = Hi(
      this.context,
      [
        {
          format: this.context.RGBA,
          type: this.context.UNSIGNED_BYTE,
          min: this.context.LINEAR,
          wrap: this.context.CLAMP_TO_EDGE
        }
      ],
      r,
      n
    ), this.options.width = r, this.options.height = n, this.output = this.fbi.attachments[0];
  }
  getDefines() {
    return {};
  }
  getBuffers() {
    return {
      position: {
        numComponents: 2,
        data: [-1, -1, -1, 1, 1, -1, 1, 1, -1, 1, 1, -1]
      },
      texture_coord: {
        numComponents: 2,
        data: [0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0]
      }
    };
  }
  buildDefines() {
    let r = "";
    const n = this.getDefines();
    for (let m in n)
      r += `#define ${m} ${n[m].toFixed(1)}
`;
    return r;
  }
  run(r) {
    var X, S, C, T, B, nt;
    (X = this.profiler) == null || X.pushContext(
      `[${this.id}] PROG : ${this.constructor.name}`
    ), (S = this.profiler) == null || S.pushContext(`[${this.id}] UNIFORMS`);
    for (const ut in r)
      typeof r[ut] == "function" && ((C = this.profiler) == null || C.pushContext(`[${this.id}] UNI : ${ut}`), r[ut] = r[ut](), (T = this.profiler) == null || T.popContext(`[${this.id}] UNI : ${ut}`));
    (B = this.profiler) == null || B.popContext(`[${this.id}] UNIFORMS`);
    const n = Date.now();
    let m = 0;
    this.lastRun && (m = (n - this.lastRun) / 1e3), this.lastRun = n, this.context.viewport(
      0,
      0,
      this.context.canvas.width,
      this.context.canvas.height
    ), this.context.useProgram(this.programInfo.program), s0(
      this.context,
      this.programInfo,
      this.bufferInfo
    ), wl(this.programInfo, {
      delta: m,
      canvas: [this.context.canvas.width, this.context.canvas.height],
      ...r
    }), I0(
      this.context,
      this.options.disableFramebuffer ? null : this.fbi
    ), a0(this.context, this.bufferInfo), (nt = this.profiler) == null || nt.popContext(
      `[${this.id}] PROG : ${this.constructor.name}`
    );
  }
  setProfiler(r) {
    this.profiler = r;
  }
}
const S0 = `precision mediump float;

varying vec2 _texture_coord;

uniform sampler2D background;
uniform sampler2D foreground;
uniform sampler2D threshold;

void main() {
  vec4 backgroundColor = texture2D(background, _texture_coord);
  vec4 foregroundColor = texture2D(foreground, _texture_coord);
  vec4 tresholdColor = texture2D(threshold, _texture_coord);
  gl_FragColor = foregroundColor * tresholdColor.a +
                 backgroundColor * (1. - tresholdColor.a);
}
`, w0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  _texture_coord.y = 1. - texture_coord.y;
}
`;
class Ao extends Xr {
  getFragmentShader() {
    return S0;
  }
  getVertexShader() {
    return w0;
  }
}
class Ko {
  constructor() {
    Zt(this, "steps", []);
    Zt(this, "profiler");
  }
  addStep(r) {
    this.steps.push(r);
  }
  async run() {
    for (const r of this.steps)
      r.program.run(r.getUniforms());
  }
  resizeOutput(r, n) {
    var m, X;
    (m = this.profiler) == null || m.pushContext(`PIP [${this.constructor.name}]`);
    for (const S of this.steps)
      S.preventResize || S.program.resizeOutput(r, n);
    (X = this.profiler) == null || X.popContext(`PIP [${this.constructor.name}]`);
  }
  setProfiler(r) {
    this.profiler = r;
    for (const n of this.steps)
      n.program.setProfiler(r);
  }
  setId(r) {
    for (const n of this.steps)
      n.program.id = r;
  }
}
class jo extends Ko {
  constructor() {
    super(...arguments);
    Zt(this, "preciseMaskEnabled", !1);
  }
}
class Cl extends jo {
  constructor(n) {
    super();
    Zt(this, "inputImage");
    Zt(this, "inputBackgroundImage");
    Zt(this, "inputMask");
    Zt(this, "preciseMaskEnabled", !0);
    this.context = n;
    const m = {
      context: n,
      height: n.canvas.height,
      width: n.canvas.width
    }, X = new Ao({ ...m, disableFramebuffer: !0 });
    this.addStep({
      program: X,
      getUniforms: () => ({
        background: bn(n, this.inputBackgroundImage),
        foreground: bn(n, this.inputImage),
        threshold: bn(n, this.inputMask)
      })
    });
  }
  setData(n, m) {
    this.inputImage = n, this.inputMask = m;
  }
}
const Y0 = `precision mediump float;

varying vec2 _texture_coord;
uniform sampler2D texture;

void main() { gl_FragColor = texture2D(texture, _texture_coord); }
`, T0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;
uniform bool invert_y;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  if (invert_y) {
    _texture_coord.y = 1. - texture_coord.y;
  }
}
`;
class F0 extends Xr {
  getFragmentShader() {
    return Y0;
  }
  getVertexShader() {
    return T0;
  }
}
class H0 extends Ko {
  constructor(n, m, X) {
    super();
    Zt(this, "inputImage");
    this.context = n;
    const S = {
      context: n,
      height: X,
      width: m
    };
    this.addStep({
      program: new F0({
        ...S,
        disableFramebuffer: !0
      }),
      getUniforms: () => ({
        texture: bn(n, this.inputImage),
        invert_y: !0
      })
    });
  }
  setData(n) {
    this.inputImage = n;
  }
}
async function Nl(i) {
  return new Promise((r) => {
    setTimeout(() => {
      r();
    }, i);
  });
}
const L0 = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

vec4 loop();

void main() { gl_FragColor = loop(); }
`, C0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
var zo = /* @__PURE__ */ ((i) => (i[i.LINEAR = 0] = "LINEAR", i[i.GAUSSIAN = 1] = "GAUSSIAN", i))(zo || {});
class Jl extends Xr {
  getDefines() {
    var r;
    return { RADIUS: (r = this.options.radius) != null ? r : 1 };
  }
  getFragmentShader() {
    return L0 + this.createLoopFunction();
  }
  getVertexShader() {
    return C0;
  }
  createLoopFunction() {
    var n;
    let r = (n = this.options.radius) != null ? n : 1;
    return `

        vec4 loop() { 
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${r}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;

            for(int y=-${r}; y<${r + 1}; ++y) {
                for(int x=-${r}; x<${r + 1}; ++x) {
                    float factor = 1.;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;
  }
  getFactor(r, n) {
    switch (this.options.type) {
      case 1:
        return this.getLinearFactor(r, n);
      case 0:
      default:
        return this.getLinearFactor(r, n);
    }
  }
  getLinearFactor(r, n) {
    return 1;
  }
  getGaussianFactor(r, n) {
    var B;
    const m = Math.PI * 2, X = Math.max((B = this.options.radius) != null ? B : 1, 1), S = 1 / (m * X ** 2), C = -(r ** 2 + n ** 2), T = S * C;
    return S * Math.E ** T;
  }
}
class Oo extends Xr {
  constructor(n) {
    super(n);
    Zt(this, "fbi2");
    this.fbi2 = Hi(
      n.context,
      [
        {
          format: n.context.RGBA,
          type: n.context.UNSIGNED_BYTE,
          min: n.context.LINEAR,
          mag: n.context.LINEAR,
          wrap: n.context.CLAMP_TO_EDGE
        }
      ],
      n.width,
      n.height
    );
  }
  run(n) {
    const m = this.fbi;
    this.fbi = this.fbi2, this.fbi2 = m, this.output = this.fbi.attachments[0], super.run({
      ...n,
      previous_rendering: this.fbi2.attachments[0]
    });
  }
  resizeOutput(n, m) {
    super.resizeOutput(n, m), this.fbi2 = Hi(
      this.context,
      [
        {
          format: this.context.RGBA,
          type: this.context.UNSIGNED_BYTE,
          min: this.context.LINEAR,
          wrap: this.context.CLAMP_TO_EDGE
        }
      ],
      n,
      m
    );
  }
}
const N0 = `precision mediump float;

varying vec2 _texture_coord;

// uniform float treshold;
uniform sampler2D image_now;
uniform sampler2D image_before;
uniform sampler2D mask_now;
uniform sampler2D mask_before;
uniform sampler2D previous_rendering;
uniform vec2 canvas;

uniform float delta;

float current_factor = 0.69;
float previous_factor = 0.74;
float threshold_activation = 0.54;

float map(float value, float min1, float max1, float min2, float max2) {
  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

float getThreshold() {
  vec4 color = vec4(0.);
  for (float y = -6.; y < 7.; y += 1.) {
    for (float x = -6.; x < 7.; x += 1.) {
      vec4 image_now_color =
          texture2D(image_now, _texture_coord + vec2(x, y) / canvas);
      vec4 image_before_color =
          texture2D(image_before, _texture_coord + vec2(x, y) / canvas);
      color += abs(image_before_color - image_now_color);
    }
  }
  return (color.x + color.y + color.z) / (3. * 9.);
}

void main() {
  float treshold_input = .4;
  float treshold_previous_rendering = .98;

  vec4 mask_now_color = texture2D(mask_now, _texture_coord);
  vec4 mask_before_color = texture2D(mask_before, _texture_coord);
  vec4 previous_rendering_color = texture2D(previous_rendering, _texture_coord);

  vec3 mask_diff = abs(mask_before_color.xyz - mask_now_color.xyz);
  float flickering = mask_diff.x;
  float threshold = getThreshold();
  if (threshold < threshold_activation) {
    gl_FragColor = vec4(flickering, 0., 0., 1.) * current_factor +
                   previous_rendering_color * previous_factor;
    gl_FragColor *= (1. - threshold);
  }
}
`, J0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
class k0 extends Oo {
  getFragmentShader() {
    return N0;
  }
  getVertexShader() {
    return J0;
  }
}
const U0 = `#version 300 es
// https://github.com/Volcomix/virtual-background/blob/main/src/pipelines/webgl2/jointBilateralFilterStage.ts

precision highp float;
uniform sampler2D input_frame;
uniform sampler2D segmentation_mask;
uniform sampler2D threshold;
uniform vec2 texel_size;
uniform float step;
uniform float radius;
uniform float offset;
uniform float sigma_texel;
uniform float sigma_color;

in vec2 _texture_coord;
out vec4 outColor;

float gaussian(float x, float sigma) {
  float coeff = -0.5 / (sigma * sigma * 4.0 + 1.0e-6);
  return exp((x * x) * coeff);
}

void main() {
  vec2 centerCoord = _texture_coord;
  vec3 centerColor = texture(input_frame, centerCoord).rgb;
  float newVal = 0.0;
  float spaceWeight = 0.0;
  float colorWeight = 0.0;
  float totalWeight = 0.0;
  // Subsample kernel space.
  for (float i = -radius + offset; i <= radius; i += step) {
    for (float j = -radius + offset; j <= radius; j += step) {
      vec2 shift = vec2(j, i) * texel_size;
      vec2 coord = vec2(centerCoord + shift);
      vec3 frameColor = texture(input_frame, coord).rgb;
      float threshold = texture(threshold, coord).a;
      float outVal = texture(segmentation_mask, coord).a;

      spaceWeight = gaussian(distance(centerCoord, coord), sigma_texel);
      colorWeight = gaussian(distance(centerColor, frameColor), sigma_color);
      totalWeight += spaceWeight * colorWeight;
      newVal += spaceWeight * colorWeight * outVal * threshold;
    }
  }
  newVal /= totalWeight;
  outColor = vec4(vec3(0.), newVal);
}`, E0 = `#version 300 es
in vec2 position;
in vec2 texture_coord;
out vec2 _texture_coord;
void main() {
  gl_Position = vec4(position, 0.0, 1.0);
  _texture_coord = texture_coord;
}`;
class B0 extends Xr {
  getFragmentShader() {
    return U0;
  }
  getVertexShader() {
    return E0;
  }
}
const M0 = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

void main() {
  int count = 0;
  for (float y = -1.; y < 2.; y += 1.) {
    for (float x = -1.; x < 2.; x += 1.) {
      vec2 coord = _texture_coord + vec2(y, x) / canvas;
      vec4 color = texture2D(texture, coord);
      if (color.r > .1) {
        count++;
      }
    }
  }
  if (count > 5) {
    gl_FragColor = texture2D(texture, _texture_coord);
  }
}
`, A0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
class K0 extends Xr {
  getFragmentShader() {
    return M0;
  }
  getVertexShader() {
    return A0;
  }
}
const j0 = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

void main() {
  vec4 color = texture2D(texture, _texture_coord);
  for (float y = -2.; y < 3.; y += 1.) {
    for (float x = -2.; x < 3.; x += 1.) {
      vec2 coord = _texture_coord;
      coord += vec2(y, x) / canvas;
      color += texture2D(texture, coord) * (1. / 4.);
    }
  }

  gl_FragColor = color;
}
`, z0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
class O0 extends Oo {
  getFragmentShader() {
    return j0;
  }
  getVertexShader() {
    return z0;
  }
}
const P0 = `precision mediump float;

varying vec2 _texture_coord;

uniform sampler2D threshold;
uniform sampler2D inputs;

void main() {
  vec4 inputs_color = texture2D(inputs, _texture_coord);
  vec4 threshold_color = texture2D(threshold, _texture_coord);
  if (threshold_color.r < .1 && inputs_color.r > .5) {
    gl_FragColor = inputs_color;
  }
}
`, _0 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
class Q0 extends Oo {
  getFragmentShader() {
    return P0;
  }
  getVertexShader() {
    return _0;
  }
}
class D0 extends Ko {
  constructor(n, m, X) {
    super();
    Zt(this, "inputImage");
    Zt(this, "inputMask");
    Zt(this, "previousInputImage");
    Zt(this, "previousInputMask");
    Zt(this, "output");
    Zt(this, "options", {
      currentThresholdMinimum: 0,
      currentThresholdMaximum: 1,
      previousThresholdMinimum: 0,
      previousThresholdMaximum: 1,
      thresholdMinimum: 0,
      thresholdMaximum: 1,
      thresholdFactor: 1
    });
    Zt(this, "jointBilateral");
    this.context = n;
    const S = {
      context: n,
      height: X,
      width: m
    }, C = new k0(S), T = new Jl({
      ...S,
      radius: 1,
      type: zo.GAUSSIAN
    }), B = new Q0(S), nt = new O0(S), ut = new K0(S);
    this.jointBilateral = new B0(S), this.addStep({
      program: C,
      getUniforms: () => ({
        image_now: bn(n, this.inputImage),
        image_before: bn(n, this.previousInputImage),
        mask_now: bn(n, this.inputMask),
        mask_before: bn(n, this.previousInputMask),
        current_threshold_minimum: this.options.currentThresholdMinimum,
        current_threshold_maximum: this.options.currentThresholdMaximum,
        previous_threshold_minimum: this.options.previousThresholdMinimum,
        previous_threshold_maximum: this.options.previousThresholdMaximum,
        threshold_minimum: this.options.thresholdMinimum,
        threshold_maximum: this.options.thresholdMaximum,
        threshold_factor: this.options.thresholdFactor
      })
    }), this.addStep({
      program: B,
      getUniforms: () => ({
        inputs: bn(n, this.inputMask),
        threshold: bn(n, C.output)
      })
    }), this.addStep({
      program: ut,
      getUniforms: () => ({
        texture: bn(n, B.output)
      })
    }), this.addStep({
      program: nt,
      getUniforms: () => ({
        texture: bn(n, ut.output)
      })
    }), this.addStep({
      program: T,
      getUniforms: () => ({
        texture: bn(n, nt.output)
      })
    }), this.addStep({
      program: this.jointBilateral,
      getUniforms: () => {
        var De, je, We, jt, Cn, ne, gt, $e;
        const Tt = (je = (De = this.inputImage) == null ? void 0 : De.width) != null ? je : 1, Ht = (jt = (We = this.inputImage) == null ? void 0 : We.height) != null ? jt : 1, at = (ne = (Cn = this.inputMask) == null ? void 0 : Cn.width) != null ? ne : 1, mt = ($e = (gt = this.inputMask) == null ? void 0 : gt.height) != null ? $e : 1, Bt = Math.max(
          Tt / at,
          Ht / mt
        ), kt = Math.max(
          1,
          Math.sqrt(Bt) * 0.66
        ), ee = 1 / Tt, P = 1 / Ht;
        return {
          input_frame: bn(n, this.inputImage),
          segmentation_mask: bn(n, this.inputMask),
          threshold: bn(n, T.output),
          texel_size: [ee, P],
          step: kt,
          radius: Bt,
          offset: kt > 1 ? kt * 0.5 : 0,
          sigma_texel: Math.max(ee, P) * Bt,
          sigma_color: 0.1
        };
      }
    }), this.output = this.jointBilateral.output;
  }
  setData(n, m) {
    this.previousInputImage = this.inputImage ? this.inputImage : n, this.previousInputMask = this.inputMask ? this.inputMask : m, this.inputImage = n, this.inputMask = m;
  }
  setOptions(n) {
    this.options = n;
  }
  resizeOutput(n, m) {
    super.resizeOutput(n, m), this.output = this.jointBilateral.output;
  }
}
var kl = /* @__PURE__ */ ((i) => (i.PUSH = "PUSH", i.POP = "POP", i))(kl || {});
class $0 {
  constructor(r) {
    Zt(this, "context");
    Zt(this, "extension");
    Zt(this, "queries", []);
    Zt(this, "activeQuery");
    this.context = r, this.extension = r.getExtension(
      "EXT_disjoint_timer_query_webgl2"
    );
  }
  start() {
  }
  stop() {
    this.activeQuery && this.context.endQuery(this.extension.TIME_ELAPSED_EXT);
  }
  pushContext(r) {
    this.createQuery("PUSH", r);
  }
  popContext(r) {
    this.createQuery("POP", r);
  }
  createQuery(r, n) {
    this.activeQuery && this.context.endQuery(this.extension.TIME_ELAPSED_EXT), this.activeQuery = this.context.createQuery(), this.context.beginQuery(
      this.extension.TIME_ELAPSED_EXT,
      this.activeQuery
    ), this.queries.push({
      name: n,
      action: r,
      query: this.activeQuery
    });
  }
  async getResolvedQueries() {
    const r = (await Promise.all(
      [...this.queries].map((n) => this.resolveQuery(n))
    )).filter((n) => n);
    for (let n = 1; n < r.length; ++n)
      r[n].timestamp += r[n - 1].duration + r[n - 1].timestamp;
    return r;
  }
  async resolveQuery(r) {
    if (!await this.awaitQueryAvailable(r)) {
      console.log("Unawaitable query", r);
      return;
    }
    if (this.context.getParameter(
      this.extension.GPU_DISJOINT_EXT
    )) {
      console.log("Disjointed query", r);
      return;
    }
    return {
      ...r,
      duration: this.context.getQueryParameter(
        r.query,
        this.context.QUERY_RESULT
      ),
      timestamp: 0
    };
  }
  async awaitQueryAvailable(r) {
    for (let n = 0; n < 10; ++n) {
      if (this.context.getQueryParameter(
        r.query,
        this.context.QUERY_RESULT_AVAILABLE
      ))
        return r;
      await Nl(200);
    }
  }
}
class Ki {
  constructor() {
    Zt(this, "canvas");
    Zt(this, "context");
    Zt(this, "pipeline");
    Zt(this, "previousImageWidth", 0);
    Zt(this, "previousImageHeight", 0);
    Zt(this, "previousMaskWidth", Tr);
    Zt(this, "previousMaskHeight", Tr);
    Zt(this, "profiler");
    Zt(this, "postProcessingEnabled", !0);
    Zt(this, "improveMask");
    const r = new OffscreenCanvas(0, 0), n = r.getContext("webgl2");
    if (!n)
      throw "Fail to retrieve webgl2 context";
    this.canvas = r, this.context = n, this.improveMask = new D0(
      this.context,
      Tr,
      Tr
    );
  }
  setFlickeringOptions(r) {
    this.improveMask.setOptions(r);
  }
  enablePostProcessing() {
    this.postProcessingEnabled = !0;
  }
  disablePostProcessing() {
    this.postProcessingEnabled = !1;
  }
  async profileWebgl(r) {
    const n = new $0(this.context);
    return this.profiler = n, n.start(), await Nl(r), this.profiler = void 0, n.stop(), n.getResolvedQueries();
  }
  async render(r, n) {
    var S, C;
    if (!this.pipeline)
      throw "missing pipeline";
    (this.previousImageHeight !== r.height || this.previousImageWidth !== r.width) && this.resizeOutput(r.width, r.height), (this.previousMaskHeight !== n.height || this.previousMaskWidth !== n.width) && (this.improveMask.resizeOutput(n.width, n.height), this.previousMaskWidth = n.width, this.previousMaskHeight = n.height);
    const m = "renderer";
    (S = this.profiler) == null || S.pushContext(m), this.improveMask.setProfiler(this.profiler), this.pipeline.setProfiler(this.profiler);
    let X = n;
    return this.postProcessingEnabled && (this.improveMask.setData(r, n), this.improveMask.run(), X = this.improveMask.output), this.pipeline.setData(r, X), await this.pipeline.run(), (C = this.profiler) == null || C.popContext(m), this.canvas;
  }
  resizeOutput(r, n) {
    var m;
    this.canvas.width = r, this.canvas.height = n, (m = this.pipeline) == null || m.resizeOutput(r, n), this.previousImageWidth = r, this.previousImageHeight = n;
  }
}
class Ul extends Ki {
  constructor() {
    super();
    Zt(this, "pipeline");
    Zt(this, "backgroundImage");
    Zt(this, "backgroundImageResizerCanvas");
    Zt(this, "backgroundImageResizerContext");
    Zt(this, "backgroundImageResizer");
    this.pipeline = new Cl(this.context);
    const n = new OffscreenCanvas(0, 0), m = n.getContext("webgl2");
    if (!m)
      throw "Fail to retrieve webgl context";
    this.backgroundImageResizerCanvas = n, this.backgroundImageResizerContext = m, this.backgroundImageResizer = new H0(
      this.backgroundImageResizerContext,
      0,
      0
    );
  }
  setBackgroundImage(n) {
    this.backgroundImage = n, this.updateBackgroundImage();
  }
  updateBackgroundImage() {
    const { width: n, height: m } = this.canvas;
    this.backgroundImageResizer.resizeOutput(n, m), this.backgroundImageResizer.setData(this.backgroundImage), this.backgroundImageResizer.run(), this.pipeline.inputBackgroundImage = this.backgroundImageResizerCanvas;
  }
  resizeOutput(n, m) {
    super.resizeOutput(n, m), this.backgroundImageResizerCanvas.width = n, this.backgroundImageResizerCanvas.height = m, this.backgroundImageResizer.resizeOutput(n, m), this.updateBackgroundImage();
  }
}
class q0 extends Ul {
  constructor() {
    super(...arguments);
    Zt(this, "frameReader");
  }
  setBackgroundVideo(n) {
    this.frameReader = n.getReader(), this.readNextVideoFrame();
  }
  async render(n, m) {
    return await this.readNextVideoFrame(), super.render(n, m);
  }
  async readNextVideoFrame() {
    var m;
    const n = await ((m = this.frameReader) == null ? void 0 : m.read());
    if (n != null && n.value) {
      const X = await createImageBitmap(n.value);
      this.setBackgroundImage(X), n.value.close();
    }
  }
}
class Xs {
  blurBackground(r) {
    return new Vc(r);
  }
  blurSilhouette(r) {
    return new Rc(r);
  }
  imageBackground() {
    return new xc();
  }
  videoBackground() {
    return new q0();
  }
}
const t3 = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;
uniform sampler2D mask;

vec4 loop();

void main() { gl_FragColor = loop(); }
`, e3 = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
class n3 extends Xr {
  getDefines() {
    var r;
    return { RADIUS: (r = this.options.radius) != null ? r : 1 };
  }
  getFragmentShader() {
    return t3 + this.createLoopFunction();
  }
  getVertexShader() {
    return e3;
  }
  createLoopFunction() {
    var n;
    let r = (n = this.options.radius) != null ? n : 1;
    return `

        vec4 loop() { 
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${r}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;
            float maxLength = length(normalizedRadius);

            for(int y=-${r}; y<${r + 1}; ++y) {
                for(int x=-${r}; x<${r + 1}; ++x) {
                    float factor = (1.- texture2D(mask, _texture_coord + diff).a) * (maxLength - length(diff)) / maxLength;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;
  }
}
const r3 = 10, i3 = 2, o3 = 8;
class s3 extends jo {
  constructor(n, m) {
    super();
    Zt(this, "inputImage");
    Zt(this, "inputMask");
    Zt(this, "blur");
    this.context = n, this.radius = m;
    const X = {
      context: n,
      height: n.canvas.height,
      width: n.canvas.width
    };
    this.blur = new n3({
      ...X,
      radius: m,
      ...this.getBlurTextureSize(
        n.canvas.width,
        n.canvas.height
      )
    });
    const S = new Ao({ ...X, disableFramebuffer: !0 });
    this.addStep({
      program: this.blur,
      preventResize: !0,
      getUniforms: () => ({
        texture: bn(n, this.inputImage),
        mask: bn(n, this.inputMask)
      })
    }), this.addStep({
      program: S,
      getUniforms: () => ({
        background: bn(n, this.blur.output),
        foreground: bn(n, this.inputImage),
        threshold: bn(n, this.inputMask)
      })
    });
  }
  getBlurTextureSize(n, m) {
    const X = this.radius > r3 ? o3 : i3;
    return {
      width: Math.max(Tr, n / X),
      height: Math.max(Tr, m / X)
    };
  }
  setData(n, m) {
    this.inputImage = n, this.inputMask = m;
  }
  resizeOutput(n, m) {
    super.resizeOutput(n, m);
    const X = this.getBlurTextureSize(n, m);
    this.blur.resizeOutput(X.width, X.height);
  }
}
class l3 extends Ki {
  constructor(n) {
    super();
    Zt(this, "pipeline");
    this.pipeline = new s3(this.context, n), this.disablePostProcessing();
  }
}
class c3 extends jo {
  constructor(n, m) {
    super();
    Zt(this, "inputImage");
    Zt(this, "inputMask");
    this.context = n;
    const X = {
      context: n,
      height: n.canvas.height,
      width: n.canvas.width
    }, S = new Jl({
      ...X,
      radius: m,
      type: zo.GAUSSIAN
    }), C = new Ao({ ...X, disableFramebuffer: !0 });
    this.addStep({
      program: S,
      getUniforms: () => ({
        texture: bn(n, this.inputImage)
      })
    }), this.addStep({
      program: C,
      getUniforms: () => ({
        background: bn(n, this.inputImage),
        foreground: bn(n, S.output),
        threshold: bn(n, this.inputMask)
      })
    });
  }
  setData(n, m) {
    this.inputImage = n, this.inputMask = m;
  }
}
class u3 extends Ki {
  constructor(n) {
    super();
    Zt(this, "pipeline");
    this.pipeline = new c3(this.context, n), this.disablePostProcessing();
  }
}
class a3 extends Cl {
  constructor() {
    super(...arguments);
    Zt(this, "frameReader");
    Zt(this, "preciseMaskEnabled", !0);
  }
  set inputVideo(n) {
    this.frameReader = n.getReader(), this.readNextVideoFrame();
  }
  async run() {
    this.frameReader && (await super.run(), this.readNextVideoFrame());
  }
  async readNextVideoFrame() {
    var m;
    const n = await ((m = this.frameReader) == null ? void 0 : m.read());
    n != null && n.value && (this.inputBackgroundImage = await createImageBitmap(n.value), n.value.close());
  }
}
class d3 extends Ki {
  constructor() {
    super();
    Zt(this, "pipeline");
    this.pipeline = new a3(this.context);
  }
  setBackgroundVideo(n) {
    this.pipeline.inputVideo = n;
  }
}
class Ws {
  blurBackground(r) {
    return new l3(r);
  }
  blurSilhouette(r) {
    return new u3(r);
  }
  imageBackground() {
    return new Ul();
  }
  videoBackground() {
    return new d3();
  }
}
class h3 {
  constructor(r) {
    Zt(this, "factory");
    switch (r) {
      case pi.CANVAS:
        this.factory = new Xs();
        break;
      case pi.WEBGL:
        this.factory = new Ws();
        break;
      default:
        const n = Ss();
        this.factory = n.supported ? new Ws() : new Xs();
    }
  }
  blurBackground(r) {
    return this.getFactory().blurBackground(r);
  }
  blurSilhouette(r) {
    return this.getFactory().blurSilhouette(r);
  }
  imageBackground() {
    return this.getFactory().imageBackground();
  }
  videoBackground() {
    return this.getFactory().videoBackground();
  }
  getFactory() {
    if (!this.factory)
      throw "Factory is not initialized";
    return this.factory;
  }
}
class f3 {
  constructor() {
    Zt(this, "renderer");
  }
  setBackgroundOptions(r) {
    var m, X;
    const n = new h3((m = r.renderingOptions) == null ? void 0 : m.type);
    switch (r.transformerType) {
      case "BackgroundBlur":
        this.renderer = n.blurBackground(
          this.getBlurSize(r.radius)
        );
        break;
      case "SilhouetteBlur":
        this.renderer = n.blurSilhouette(
          this.getBlurSize(r.radius)
        );
        break;
      case "VideoBackground":
        this.renderer = n.videoBackground();
        break;
      case "VirtualBackground":
        this.renderer = n.imageBackground();
        break;
      default:
        throw `Unknown rendering type [${r.transformerType}]`;
    }
    ((X = r.renderingOptions) == null ? void 0 : X.type) === pi.WEBGL && (r.renderingOptions.selfieSegmentationType === ro.PRECISE ? this.renderer.enablePostProcessing() : r.renderingOptions.selfieSegmentationType === ro.FAST && this.renderer.disablePostProcessing());
  }
  setFlickeringOptions(r) {
    var n;
    (n = this.renderer) == null || n.setFlickeringOptions(r);
  }
  setVideoBGReadable(r) {
    const n = this.renderer;
    n.setBackgroundVideo && n.setBackgroundVideo(r);
  }
  async setVirtualBGImage(r) {
    const n = this.renderer;
    n.setBackgroundImage && n.setBackgroundImage(r);
  }
  async process(r, n) {
    if (this.renderer)
      return this.renderer.render(r, n);
  }
  async resizeForeground(r, n) {
  }
  getBlurSize(r = ui.Low) {
    switch (r) {
      case ui.Low:
        return 5;
      case ui.High:
        return 12;
    }
    return r;
  }
  async profile(r) {
    var n, m;
    return (m = (n = this.renderer) == null ? void 0 : n.profileWebgl(r)) != null ? m : [];
  }
}
class m3 {
  constructor() {
    Zt(this, "selfieSegmentation", new Is());
    Zt(this, "backgroundFilter");
    Zt(this, "reporter", new Xc());
    Zt(this, "backgroundOptions");
  }
  async init(r, n) {
    await this.selfieSegmentation.init(
      n.wasmAssetUriPath,
      n.tfliteAssetUriPath
    ), this.backgroundFilter = new f3(), this.report({
      variation: "Create"
    });
  }
  async transform(r, n) {
    var T, B;
    let m;
    const X = (T = r.timestamp) != null ? T : 0, S = await createImageBitmap(r), C = await this.selfieSegmentation.process(S);
    C && (m = await ((B = this.backgroundFilter) == null ? void 0 : B.process(S, C))), m ? (r.close(), n.enqueue(
      new VideoFrame(m, {
        timestamp: X,
        alpha: "discard"
      })
    )) : n.enqueue(r);
  }
  async setBackgroundOptions(r) {
    var n;
    this.backgroundOptions = r, await ((n = this.backgroundFilter) == null ? void 0 : n.setBackgroundOptions(r)), this.report({
      variation: "Update"
    });
  }
  async setVideoBGReadable(r) {
    var n;
    await ((n = this.backgroundFilter) == null ? void 0 : n.setVideoBGReadable(r));
  }
  async setVirtualBGImage(r) {
    var n;
    await ((n = this.backgroundFilter) == null ? void 0 : n.setVirtualBGImage(r));
  }
  setFlickeringOptions(r) {
    var n;
    (n = this.backgroundFilter) == null || n.setFlickeringOptions(r), this.report({
      variation: "Update"
    });
  }
  async profile(r) {
    var n, m;
    return (m = (n = this.backgroundFilter) == null ? void 0 : n.profile(r)) != null ? m : [];
  }
  getTransformerType() {
    var r, n;
    return (n = (r = this.backgroundOptions) == null ? void 0 : r.transformerType) != null ? n : "Undefined";
  }
  report(r) {
    var n;
    this.reporter.send({
      version: Wc,
      action: "MlTransformers",
      transformerType: (n = this.backgroundOptions) == null ? void 0 : n.transformerType,
      config: JSON.stringify(this.backgroundOptions),
      ...r
    });
  }
}
const Po = class {
  constructor() {
    Zt(this, "backgroundTransformer", new m3());
    Zt(this, "mediaProcessor", new S2());
    Zt(this, "rate", 30);
    Zt(this, "resolveOnMediaProcessor");
    Zt(this, "eventsQueue", []);
  }
  async init(r, n) {
    await this.backgroundTransformer.init(r, n), await this.mediaProcessor.setTransformers([this.backgroundTransformer]), this.mediaProcessor.setTrackExpectedRate(this.rate), this.mediaProcessor.onAny((m, X) => {
      this.resolveOnMediaProcessor ? (this.resolveOnMediaProcessor({ name: m, data: X }), this.resolveOnMediaProcessor = void 0) : this.eventsQueue.push({ name: m, data: X });
    });
  }
  async onMediaProcessorEvent() {
    return await new Promise((r) => {
      this.eventsQueue.length > 0 ? r(this.eventsQueue.shift()) : this.resolveOnMediaProcessor = r;
    });
  }
  async setTrackExpectedRate(r) {
    this.rate = r, this.mediaProcessor.setTrackExpectedRate(r);
  }
  async transform(r, n) {
    this.mediaProcessor.transform(r, n);
  }
  async setBackgroundOptions(r) {
    var n;
    await ((n = this.backgroundTransformer) == null ? void 0 : n.setBackgroundOptions(r));
  }
  setVideoBGReadable(r) {
    this.backgroundTransformer.setVideoBGReadable(r);
  }
  async setVirtualBGImage(r) {
    await this.backgroundTransformer.setVirtualBGImage(r);
  }
  async terminate() {
    await this.mediaProcessor.destroy();
  }
  setFlickeringOptions(r) {
    this.backgroundTransformer.setFlickeringOptions(r);
  }
  setVonageMetadata(r) {
    v2(r);
  }
  async profile(r) {
    return JSON.stringify(
      await this.backgroundTransformer.profile(r)
    );
  }
};
let mo = Po;
(() => {
  P2("ProcessorWorker", Po);
})();
const El = "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", Vs = typeof window < "u" && window.Blob && new Blob([atob(El)], { type: "text/javascript;charset=utf-8" });
function p3() {
  const i = Vs && (window.URL || window.webkitURL).createObjectURL(Vs);
  try {
    return i ? new Worker(i) : new Worker("data:application/javascript;base64," + El);
  } finally {
    i && (window.URL || window.webkitURL).revokeObjectURL(i);
  }
}
const _o = class extends ws {
  constructor() {
    super(...arguments);
    Zt(this, "rate", 30);
    Zt(this, "worker");
  }
  async init(n) {
    this.worker = await z2(mo, p3), await this.worker.init(`worker_${_o.initCount++}`, n), await this.worker.setVonageMetadata(li()), await this.setBackgroundOptions(n), this.listenWorker();
  }
  async setTrackExpectedRate(n) {
    var m;
    await ((m = this.worker) == null ? void 0 : m.setTrackExpectedRate(n));
  }
  async setBackgroundOptions(n) {
    var X, S, C;
    await ((X = this.worker) == null ? void 0 : X.setBackgroundOptions(n));
    const { transformerType: m } = n;
    switch (m) {
      case "VideoBackground":
        await ((S = this.worker) == null ? void 0 : S.setVideoBGReadable(
          await ss.createVideoReadable(
            n.backgroundAssetUri
          )
        ));
        break;
      case "VirtualBackground":
        await ((C = this.worker) == null ? void 0 : C.setVirtualBGImage(
          await ss.createImageCanvas(
            n.backgroundAssetUri
          )
        ));
        break;
    }
  }
  async transform(n, m) {
    var X;
    await ((X = this.worker) == null ? void 0 : X.transform(n, m));
  }
  async destroy() {
    var n;
    await ((n = this.worker) == null ? void 0 : n.terminate());
  }
  async setFlickeringOptions(n) {
    var m;
    await ((m = this.worker) == null ? void 0 : m.setFlickeringOptions(n));
  }
  async profile(n) {
    var X;
    const m = await ((X = this.worker) == null ? void 0 : X.profile(n));
    return JSON.parse(m != null ? m : "[]");
  }
  async listenWorker() {
    var n, m, X;
    for (; (n = this.worker) != null && n.workerContext.worker; ) {
      const { name: S, data: C } = await ((m = this.worker) == null ? void 0 : m.onMediaProcessorEvent());
      switch (S) {
        case "error":
        case "warn":
          this.emit(S, C);
          break;
        case "pipelineInfo":
          switch (this.emit(S, C), C) {
            case "pipeline_ended":
            case "pipeline_ended_with_error":
              await ((X = this.worker) == null ? void 0 : X.terminate());
              return;
          }
          break;
      }
    }
  }
};
let di = _o;
Zt(di, "initCount", 0);
class b3 {
  constructor(r) {
    this.queries = r;
  }
  async downloadSpeedscope() {
    this.download(await this.convertToSpeedscope());
  }
  download(r) {
    const n = document.createElement("a");
    n.href = URL.createObjectURL(
      new Blob([r], { type: "application/json" })
    ), n.download = `profile-${+new Date()}.speedscope.json`, document.body.appendChild(n), n.click(), document.body.removeChild(n);
  }
  convertToSpeedscope() {
    const r = [], n = {}, m = [];
    let X = 0;
    for (const C of this.queries) {
      const T = [];
      for (const B of C)
        n[B.name] === void 0 && (n[B.name] = r.length, r.push({
          name: B.name
        })), T.push({
          type: B.action == kl.PUSH ? "O" : "C",
          frame: n[B.name],
          at: B.timestamp
        }), X = Math.max(X, B.timestamp + B.duration);
      m.push({
        events: T,
        type: "evented",
        name: "GPU Profile",
        unit: "nanoseconds",
        startValue: 0,
        endValue: X
      });
    }
    const S = {
      $schema: "https://www.speedscope.app/file-format-schema.json",
      shared: {
        frames: r
      },
      profiles: m
    };
    return JSON.stringify(S, null, 2);
  }
}
class Bl extends ws {
  constructor() {
    super();
    Zt(this, "worker", new di());
    Zt(this, "connector", new Y2(this.worker));
  }
  async init(n) {
    await this.worker.init(n), this.worker.onAny(
      (m, X) => this.emit(m, X)
    );
  }
  async setBackgroundOptions(n) {
    await this.worker.setBackgroundOptions(n);
  }
  setTrackExpectedRate(n) {
    this.worker.setTrackExpectedRate(n);
  }
  getConnector() {
    return this.connector;
  }
  async profile(n) {
    return this.worker.profile(n);
  }
  static async profile(n) {
    const m = await Promise.all(
      this.instances.map((X) => X.profile(n))
    );
    return new b3(m);
  }
  static async create(n) {
    const m = new this();
    return await m.init(n), this.instances.push(m), m;
  }
}
Zt(Bl, "instances", []);
function v3() {
  return bi;
}
function G3() {
  return yi;
}
function X3() {
  return gi;
}
function W3() {
  return Zi;
}
function V3() {
  return vi;
}
function R3() {
  return Gi;
}
function x3() {
  return Xi;
}
async function I3(i) {
  return await Bl.create(i);
}
export {
  m3 as BackgroundTransformer,
  T2 as BackgroundTransformerType,
  ui as BlurRadius,
  W2 as ErrorFunction,
  Pi as MediapipeHelper,
  no as PipelineInfoData,
  pi as RenderingType,
  Bl as VonageMediaProcessor,
  X2 as WarningType,
  ro as WebglSelfieSegmentationType,
  I3 as createVonageMediaProcessor,
  k2 as getSupportedBrowserFeatures,
  W3 as getVonageFaceDetection,
  V3 as getVonageFaceMash,
  G3 as getVonageHands,
  X3 as getVonageHolistic,
  R3 as getVonageObjectron,
  x3 as getVonagePose,
  v3 as getVonageSelfieSegmentation,
  g3 as isSupported
};
